// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/****** Spreadsheet ********/
/********** Base **********/
/********** Colours **********/
/********** Pages **********/
/********** Modal **********/
/********** Button **********/
/******* Icons ********/
/******* Icons ********/
/******* Media Queries ********/
html {
  -moz-osx-font-smoothing: grayscale;
  font-size: 1rem;
  text-rendering: optimizelegibility;
}

body {
  font-size: 0.86rem;
  font-family: "Source Sans Pro", Helvetica, sans-serif;
  font-weight: 400;
  color: #505050;
  background: #ffffff;
  -webkit-text-size-adjust: none;
  margin: 0px;
  padding: 0;
}
body.no_scroll {
  height: 100%;
  overflow: hidden;
}

html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

h1,
h2,
h3,
h4,
h5 {
  margin: 0px;
  padding: 0px;
}

abbr {
  text-decoration: none;
}

a:link,
a:visited {
  color: #2b495e;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

a:hover {
  color: #72bf44;
}

p {
  margin: 0;
  padding: 0;
  padding-bottom: 10px;
  line-height: 140%;
}

*:focus {
  outline: none;
}

.clearfix::after {
  clear: both;
  content: "";
  display: block;
  height: 0;
  visibility: hidden;
}

.overflow {
  -webkit-overflow-scrolling: touch; /* lets it scroll lazy */
  overflow: auto;
}

.hidden_text {
  position: absolute !important;
  font-size: 0 !important;
}

.text_right {
  text-align: right !important;
}

.text_center {
  text-align: center !important;
}

.space_divider {
  height: 10px;
  display: block;
}
.space_divider.extra_padding {
  margin-top: 10px;
  margin-bottom: 10px;
}

.line_divider {
  background-color: rgba(0, 0, 0, 0.1);
  margin-top: 10px;
  margin-bottom: 10px;
  height: 1px;
  display: block;
}
.line_divider.extra_padding {
  margin-top: 30px;
  margin-bottom: 30px;
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.outcome_icon {
  font-size: 80px;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  margin: 20px auto 20px;
}
.outcome_icon.success {
  color: #72bf44;
}
.outcome_icon.error {
  color: #ea5441;
}

.outcome_title {
  font-size: 1.4rem;
  line-height: 30px;
  margin-bottom: 10px;
  text-align: center;
  font-weight: 400;
}
.outcome_title.success {
  color: #72bf44;
}
.outcome_title.error {
  color: #ea5441;
}

.outcome_text {
  text-align: center;
}

.lds-dual-ring {
  display: inline-block;
  width: 64px;
  height: 64px;
}

.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 20px;
  height: 20px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #000000;
  border-color: #000000 transparent #000000 transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}

@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
#vp {
  border-top: 0px solid #dfe0e1;
}

.chevron_toggle_icon {
  font-size: 2em;
  font-style: normal;
  cursor: pointer;
}
.chevron_toggle_icon:before {
  content: "\\e900";
  font-family: "empyrean_icons";
  font-size: 10px;
  height: 10px;
  width: 10px;
  position: absolute;
  top: 10px;
  left: 0px;
  line-height: 10px;
}
.chevron_toggle_icon.expanded:before {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}

.icon_spinner {
  display: inline-block;
  margin-right: 5px;
  animation: rotate-center 0.6s ease-in infinite both;
}

/**
 * ----------------------------------------
 * animation rotate-center
 * ----------------------------------------
 */
@keyframes rotate-center {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*
* Global Styles goes here
*/
#page_container_outer {
  height: 100vh;
  overflow: hidden;
}

.page_inner_container {
  width: 100%;
  display: block;
}
.page_inner_container:not(.footer-bar-component) {
  overflow: hidden;
}

#page_container {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
  flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
  align-items: stretch;
  -webkit-align-items: stretch;
  width: 100%;
  min-height: 0;
}
#page_container #page_header {
  position: relative;
  box-sizing: border-box;
}
#page_container #page_content {
  width: 100%;
  flex-grow: 1;
  flex: 1 1 auto;
  -webkit-flex: 1 1 auto;
  position: relative;
  height: 100%;
  display: flex;
  box-sizing: border-box;
  overflow: auto;
}
#page_container #page_content:after {
  content: "\\e905";
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: rgba(43, 73, 94, 0.1);
  font-family: "empyrean_icons";
  font-size: 200px;
  z-index: -1;
}
#page_container #page_content.no_logo:after {
  display: none;
}
#page_container #page_content #page_content_inner {
  padding: 0px;
}
#page_container #page_content #page_content_inner .input-structure {
  height: calc(100vh - 153px);
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
  align-items: stretch;
  -webkit-align-items: stretch;
  width: 100%;
  min-height: 0;
}
#page_container #page_content #page_content_inner .input-structure #results {
  width: 100%;
  flex-grow: 1;
  flex: 1 1 auto;
  -webkit-flex: 1 1 auto;
  position: relative;
}
#page_container #page_footer {
  box-sizing: border-box;
  position: relative;
}

a.text_link {
  cursor: pointer;
}

input, .add-scenario-container .add-scenario-body input,
button,
textarea,
.add-scenario-container .add-scenario-body .add-scenario-body-second textarea {
  font-size: 1rem;
  font-family: "Source Sans Pro", Helvetica, sans-serif !important;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.btn_normal, .notification-banner-message .banner-actions a,
.notification-banner-message .banner-actions .link,
.notification-banner-message .banner-actions .banner-action-button,
.notification-banner-message .banner-actions button, .success-button {
  width: auto;
  background-color: transparent;
  position: relative;
  color: #505050;
  line-height: 20px;
  margin: 0px;
  padding: 5px 10px;
  overflow: visible;
  border-radius: 3px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  -webkit-appearance: none;
  box-sizing: border-box;
  display: inline-block;
  border: 0px solid;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 20px;
  box-sizing: border-box;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 0.76rem;
}
.btn_normal:hover, .notification-banner-message .banner-actions a:hover,
.notification-banner-message .banner-actions .link:hover,
.notification-banner-message .banner-actions .banner-action-button:hover,
.notification-banner-message .banner-actions button:hover, .success-button:hover, .btn_normal:focus, .notification-banner-message .banner-actions a:focus,
.notification-banner-message .banner-actions .link:focus,
.notification-banner-message .banner-actions .banner-action-button:focus,
.notification-banner-message .banner-actions button:focus, .success-button:focus {
  color: #51738b;
}
.btn_normal:disabled, .notification-banner-message .banner-actions a:disabled,
.notification-banner-message .banner-actions .link:disabled,
.notification-banner-message .banner-actions .banner-action-button:disabled,
.notification-banner-message .banner-actions button:disabled, .success-button:disabled {
  color: #cccccc !important;
  cursor: default !important;
  background-color: rgba(245, 246, 247, 0.2) !important;
  border: 0px solid !important;
  padding: 5px 10px;
}
.btn_normal:disabled:hover, .notification-banner-message .banner-actions a:disabled:hover,
.notification-banner-message .banner-actions .link:disabled:hover,
.notification-banner-message .banner-actions .banner-action-button:disabled:hover,
.notification-banner-message .banner-actions button:disabled:hover, .success-button:disabled:hover, .btn_normal:disabled:focus, .notification-banner-message .banner-actions a:disabled:focus,
.notification-banner-message .banner-actions .link:disabled:focus,
.notification-banner-message .banner-actions .banner-action-button:disabled:focus,
.notification-banner-message .banner-actions button:disabled:focus, .success-button:disabled:focus {
  border-color: #dfe0e1 !important;
  background-color: rgba(245, 246, 247, 0.2) !important;
  color: #cccccc !important;
}
.btn_normal.btn_green, .notification-banner-message .banner-actions a.btn_green,
.notification-banner-message .banner-actions .btn_green.link,
.notification-banner-message .banner-actions .btn_green.banner-action-button,
.notification-banner-message .banner-actions button.btn_green, .success-button {
  background-color: #72bf44;
  color: #ffffff;
}
.btn_normal.btn_green:focus, .notification-banner-message .banner-actions a.btn_green:focus,
.notification-banner-message .banner-actions .btn_green.link:focus,
.notification-banner-message .banner-actions .btn_green.banner-action-button:focus,
.notification-banner-message .banner-actions button.btn_green:focus, .success-button:focus, .btn_normal.btn_green:hover, .notification-banner-message .banner-actions a.btn_green:hover,
.notification-banner-message .banner-actions .btn_green.link:hover,
.notification-banner-message .banner-actions .btn_green.banner-action-button:hover,
.notification-banner-message .banner-actions button.btn_green:hover, .success-button:hover {
  background-color: #5b9b35;
  color: #ffffff;
}
.btn_normal.btn_green:disabled, .notification-banner-message .banner-actions a.btn_green:disabled,
.notification-banner-message .banner-actions .btn_green.link:disabled,
.notification-banner-message .banner-actions .btn_green.banner-action-button:disabled,
.notification-banner-message .banner-actions button.btn_green:disabled, .success-button:disabled {
  color: #cccccc !important;
  cursor: default !important;
  background-color: rgba(245, 246, 247, 0.2) !important;
}
.btn_normal.btn_green:disabled:hover, .notification-banner-message .banner-actions a.btn_green:disabled:hover,
.notification-banner-message .banner-actions .btn_green.link:disabled:hover,
.notification-banner-message .banner-actions .btn_green.banner-action-button:disabled:hover,
.notification-banner-message .banner-actions button.btn_green:disabled:hover, .success-button:disabled:hover, .btn_normal.btn_green:disabled:focus, .notification-banner-message .banner-actions a.btn_green:disabled:focus,
.notification-banner-message .banner-actions .btn_green.link:disabled:focus,
.notification-banner-message .banner-actions .btn_green.banner-action-button:disabled:focus,
.notification-banner-message .banner-actions button.btn_green:disabled:focus, .success-button:disabled:focus {
  background-color: rgba(245, 246, 247, 0.2) !important;
  color: #cccccc !important;
}
.btn_normal.btn_blue, .notification-banner-message .banner-actions a.btn_blue,
.notification-banner-message .banner-actions .btn_blue.link,
.notification-banner-message .banner-actions .btn_blue.banner-action-button,
.notification-banner-message .banner-actions button.btn_blue, .btn_blue.success-button {
  background-color: #51738b;
  color: #ffffff;
}
.btn_normal.btn_blue:focus, .notification-banner-message .banner-actions a.btn_blue:focus,
.notification-banner-message .banner-actions .btn_blue.link:focus,
.notification-banner-message .banner-actions .btn_blue.banner-action-button:focus,
.notification-banner-message .banner-actions button.btn_blue:focus, .btn_blue.success-button:focus, .btn_normal.btn_blue:hover, .notification-banner-message .banner-actions a.btn_blue:hover,
.notification-banner-message .banner-actions .btn_blue.link:hover,
.notification-banner-message .banner-actions .btn_blue.banner-action-button:hover,
.notification-banner-message .banner-actions button.btn_blue:hover, .btn_blue.success-button:hover {
  background-color: #3e586b;
  color: #ffffff;
}
.btn_normal.btn_blue:disabled, .notification-banner-message .banner-actions a.btn_blue:disabled,
.notification-banner-message .banner-actions .btn_blue.link:disabled,
.notification-banner-message .banner-actions .btn_blue.banner-action-button:disabled,
.notification-banner-message .banner-actions button.btn_blue:disabled, .btn_blue.success-button:disabled {
  color: #cccccc !important;
  cursor: default !important;
  background-color: rgba(245, 246, 247, 0.2) !important;
}
.btn_normal.btn_blue:disabled:hover, .notification-banner-message .banner-actions a.btn_blue:disabled:hover,
.notification-banner-message .banner-actions .btn_blue.link:disabled:hover,
.notification-banner-message .banner-actions .btn_blue.banner-action-button:disabled:hover,
.notification-banner-message .banner-actions button.btn_blue:disabled:hover, .btn_blue.success-button:disabled:hover, .btn_normal.btn_blue:disabled:focus, .notification-banner-message .banner-actions a.btn_blue:disabled:focus,
.notification-banner-message .banner-actions .btn_blue.link:disabled:focus,
.notification-banner-message .banner-actions .btn_blue.banner-action-button:disabled:focus,
.notification-banner-message .banner-actions button.btn_blue:disabled:focus, .btn_blue.success-button:disabled:focus {
  background-color: rgba(245, 246, 247, 0.2) !important;
  color: #cccccc !important;
}
.btn_normal.btn_white, .notification-banner-message .banner-actions a.btn_white,
.notification-banner-message .banner-actions .btn_white.link,
.notification-banner-message .banner-actions .btn_white.banner-action-button,
.notification-banner-message .banner-actions button.btn_white, .btn_white.success-button {
  background-color: transparent;
  color: #ffffff;
}
.btn_normal.btn_white:focus, .notification-banner-message .banner-actions a.btn_white:focus,
.notification-banner-message .banner-actions .btn_white.link:focus,
.notification-banner-message .banner-actions .btn_white.banner-action-button:focus,
.notification-banner-message .banner-actions button.btn_white:focus, .btn_white.success-button:focus, .btn_normal.btn_white:hover, .notification-banner-message .banner-actions a.btn_white:hover,
.notification-banner-message .banner-actions .btn_white.link:hover,
.notification-banner-message .banner-actions .btn_white.banner-action-button:hover,
.notification-banner-message .banner-actions button.btn_white:hover, .btn_white.success-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}
.btn_normal.btn_white:disabled, .notification-banner-message .banner-actions a.btn_white:disabled,
.notification-banner-message .banner-actions .btn_white.link:disabled,
.notification-banner-message .banner-actions .btn_white.banner-action-button:disabled,
.notification-banner-message .banner-actions button.btn_white:disabled, .btn_white.success-button:disabled {
  color: #cccccc !important;
  cursor: default !important;
  background-color: rgba(245, 246, 247, 0.2) !important;
}
.btn_normal.btn_white:disabled:hover, .notification-banner-message .banner-actions a.btn_white:disabled:hover,
.notification-banner-message .banner-actions .btn_white.link:disabled:hover,
.notification-banner-message .banner-actions .btn_white.banner-action-button:disabled:hover,
.notification-banner-message .banner-actions button.btn_white:disabled:hover, .btn_white.success-button:disabled:hover, .btn_normal.btn_white:disabled:focus, .notification-banner-message .banner-actions a.btn_white:disabled:focus,
.notification-banner-message .banner-actions .btn_white.link:disabled:focus,
.notification-banner-message .banner-actions .btn_white.banner-action-button:disabled:focus,
.notification-banner-message .banner-actions button.btn_white:disabled:focus, .btn_white.success-button:disabled:focus {
  background-color: rgba(245, 246, 247, 0.2) !important;
  color: #cccccc !important;
}
.btn_normal.btn_notification, .notification-banner-message .banner-actions a.btn_notification,
.notification-banner-message .banner-actions .btn_notification.link,
.notification-banner-message .banner-actions .btn_notification.banner-action-button,
.notification-banner-message .banner-actions button.btn_notification, .btn_notification.success-button {
  background-color: #ff9d00;
  color: #ffffff;
}
.btn_normal.btn_notification:focus, .notification-banner-message .banner-actions a.btn_notification:focus,
.notification-banner-message .banner-actions .btn_notification.link:focus,
.notification-banner-message .banner-actions .btn_notification.banner-action-button:focus,
.notification-banner-message .banner-actions button.btn_notification:focus, .btn_notification.success-button:focus, .btn_normal.btn_notification:hover, .notification-banner-message .banner-actions a.btn_notification:hover,
.notification-banner-message .banner-actions .btn_notification.link:hover,
.notification-banner-message .banner-actions .btn_notification.banner-action-button:hover,
.notification-banner-message .banner-actions button.btn_notification:hover, .btn_notification.success-button:hover {
  background-color: #cc7e00;
  color: #ffffff;
}
.btn_normal.btn_notification:disabled, .notification-banner-message .banner-actions a.btn_notification:disabled,
.notification-banner-message .banner-actions .btn_notification.link:disabled,
.notification-banner-message .banner-actions .btn_notification.banner-action-button:disabled,
.notification-banner-message .banner-actions button.btn_notification:disabled, .btn_notification.success-button:disabled {
  color: #cccccc !important;
  cursor: default !important;
  background-color: rgba(245, 246, 247, 0.2) !important;
}
.btn_normal.btn_notification:disabled:hover, .notification-banner-message .banner-actions a.btn_notification:disabled:hover,
.notification-banner-message .banner-actions .btn_notification.link:disabled:hover,
.notification-banner-message .banner-actions .btn_notification.banner-action-button:disabled:hover,
.notification-banner-message .banner-actions button.btn_notification:disabled:hover, .btn_notification.success-button:disabled:hover, .btn_normal.btn_notification:disabled:focus, .notification-banner-message .banner-actions a.btn_notification:disabled:focus,
.notification-banner-message .banner-actions .btn_notification.link:disabled:focus,
.notification-banner-message .banner-actions .btn_notification.banner-action-button:disabled:focus,
.notification-banner-message .banner-actions button.btn_notification:disabled:focus, .btn_notification.success-button:disabled:focus {
  background-color: rgba(245, 246, 247, 0.2) !important;
  color: #cccccc !important;
}
.btn_normal.btn_outline_white, .notification-banner-message .banner-actions a.btn_outline_white,
.notification-banner-message .banner-actions .btn_outline_white.link,
.notification-banner-message .banner-actions .btn_outline_white.banner-action-button,
.notification-banner-message .banner-actions button.btn_outline_white, .btn_outline_white.success-button {
  background-color: transparent;
  color: #ffffff;
  padding: 4px 9px;
  border: 1px solid #ffffff;
  transition: all 0s ease;
}
.btn_normal.btn_outline_white:focus, .notification-banner-message .banner-actions a.btn_outline_white:focus,
.notification-banner-message .banner-actions .btn_outline_white.link:focus,
.notification-banner-message .banner-actions .btn_outline_white.banner-action-button:focus,
.notification-banner-message .banner-actions button.btn_outline_white:focus, .btn_outline_white.success-button:focus, .btn_normal.btn_outline_white:hover, .notification-banner-message .banner-actions a.btn_outline_white:hover,
.notification-banner-message .banner-actions .btn_outline_white.link:hover,
.notification-banner-message .banner-actions .btn_outline_white.banner-action-button:hover,
.notification-banner-message .banner-actions button.btn_outline_white:hover, .btn_outline_white.success-button:hover {
  background-color: #ffffff;
  color: #505050;
  border: 0px solid #ffffff;
  padding: 5px 10px;
}
.btn_normal.btn_outline_white.btn_no_border, .notification-banner-message .banner-actions a.btn_outline_white.btn_no_border,
.notification-banner-message .banner-actions .btn_outline_white.btn_no_border.link,
.notification-banner-message .banner-actions .btn_outline_white.btn_no_border.banner-action-button,
.notification-banner-message .banner-actions button.btn_outline_white.btn_no_border, .btn_outline_white.btn_no_border.success-button {
  padding: 5px 10px;
}
.btn_normal.btn_outline_white:disabled, .notification-banner-message .banner-actions a.btn_outline_white:disabled,
.notification-banner-message .banner-actions .btn_outline_white.link:disabled,
.notification-banner-message .banner-actions .btn_outline_white.banner-action-button:disabled,
.notification-banner-message .banner-actions button.btn_outline_white:disabled, .btn_outline_white.success-button:disabled {
  color: #cccccc !important;
  cursor: default !important;
  background-color: rgba(245, 246, 247, 0.2) !important;
  border: 0px solid !important;
  padding: 5px 10px;
}
.btn_normal.btn_outline_white:disabled:hover, .notification-banner-message .banner-actions a.btn_outline_white:disabled:hover,
.notification-banner-message .banner-actions .btn_outline_white.link:disabled:hover,
.notification-banner-message .banner-actions .btn_outline_white.banner-action-button:disabled:hover,
.notification-banner-message .banner-actions button.btn_outline_white:disabled:hover, .btn_outline_white.success-button:disabled:hover, .btn_normal.btn_outline_white:disabled:focus, .notification-banner-message .banner-actions a.btn_outline_white:disabled:focus,
.notification-banner-message .banner-actions .btn_outline_white.link:disabled:focus,
.notification-banner-message .banner-actions .btn_outline_white.banner-action-button:disabled:focus,
.notification-banner-message .banner-actions button.btn_outline_white:disabled:focus, .btn_outline_white.success-button:disabled:focus {
  border-color: #dfe0e1 !important;
  background-color: rgba(245, 246, 247, 0.2) !important;
  color: #cccccc !important;
}
.btn_normal.btn_negative, .notification-banner-message .banner-actions a.btn_negative,
.notification-banner-message .banner-actions .btn_negative.link,
.notification-banner-message .banner-actions .btn_negative.banner-action-button,
.notification-banner-message .banner-actions button.btn_negative, .btn_negative.success-button {
  background-color: transparent;
  color: #2b495e;
  padding: 4px 9px;
  border: 1px solid #2b495e;
  transition: all 0s ease;
}
.btn_normal.btn_negative:focus, .notification-banner-message .banner-actions a.btn_negative:focus,
.notification-banner-message .banner-actions .btn_negative.link:focus,
.notification-banner-message .banner-actions .btn_negative.banner-action-button:focus,
.notification-banner-message .banner-actions button.btn_negative:focus, .btn_negative.success-button:focus, .btn_normal.btn_negative:hover, .notification-banner-message .banner-actions a.btn_negative:hover,
.notification-banner-message .banner-actions .btn_negative.link:hover,
.notification-banner-message .banner-actions .btn_negative.banner-action-button:hover,
.notification-banner-message .banner-actions button.btn_negative:hover, .btn_negative.success-button:hover {
  background-color: #2b495e;
  color: #ffffff;
  border: 0px solid #2b495e;
  padding: 5px 10px;
}
.btn_normal.btn_negative:disabled, .notification-banner-message .banner-actions a.btn_negative:disabled,
.notification-banner-message .banner-actions .btn_negative.link:disabled,
.notification-banner-message .banner-actions .btn_negative.banner-action-button:disabled,
.notification-banner-message .banner-actions button.btn_negative:disabled, .btn_negative.success-button:disabled {
  color: #cccccc !important;
  cursor: default !important;
  background-color: rgba(245, 246, 247, 0.2) !important;
  border: 0px solid !important;
  padding: 5px 10px;
}
.btn_normal.btn_negative:disabled:hover, .notification-banner-message .banner-actions a.btn_negative:disabled:hover,
.notification-banner-message .banner-actions .btn_negative.link:disabled:hover,
.notification-banner-message .banner-actions .btn_negative.banner-action-button:disabled:hover,
.notification-banner-message .banner-actions button.btn_negative:disabled:hover, .btn_negative.success-button:disabled:hover, .btn_normal.btn_negative:disabled:focus, .notification-banner-message .banner-actions a.btn_negative:disabled:focus,
.notification-banner-message .banner-actions .btn_negative.link:disabled:focus,
.notification-banner-message .banner-actions .btn_negative.banner-action-button:disabled:focus,
.notification-banner-message .banner-actions button.btn_negative:disabled:focus, .btn_negative.success-button:disabled:focus {
  border-color: #dfe0e1 !important;
  background-color: rgba(245, 246, 247, 0.2) !important;
  color: #cccccc !important;
}
.btn_normal.btn_negative.no_focus:focus, .notification-banner-message .banner-actions a.btn_negative.no_focus:focus,
.notification-banner-message .banner-actions .btn_negative.no_focus.link:focus,
.notification-banner-message .banner-actions .btn_negative.no_focus.banner-action-button:focus,
.notification-banner-message .banner-actions button.btn_negative.no_focus:focus, .btn_negative.no_focus.success-button:focus {
  background-color: transparent;
  color: #2b495e;
  padding: 4px 9px;
  border: 1px solid #2b495e;
}
.btn_normal.btn_green_outline, .notification-banner-message .banner-actions a.btn_green_outline,
.notification-banner-message .banner-actions .btn_green_outline.link,
.notification-banner-message .banner-actions .btn_green_outline.banner-action-button,
.notification-banner-message .banner-actions button.btn_green_outline, .btn_green_outline.success-button {
  background-color: transparent;
  color: #72bf44;
  padding: 4px 9px;
  border: 1px solid #72bf44;
  transition: all 0s ease;
}
.btn_normal.btn_green_outline:focus, .notification-banner-message .banner-actions a.btn_green_outline:focus,
.notification-banner-message .banner-actions .btn_green_outline.link:focus,
.notification-banner-message .banner-actions .btn_green_outline.banner-action-button:focus,
.notification-banner-message .banner-actions button.btn_green_outline:focus, .btn_green_outline.success-button:focus, .btn_normal.btn_green_outline:hover, .notification-banner-message .banner-actions a.btn_green_outline:hover,
.notification-banner-message .banner-actions .btn_green_outline.link:hover,
.notification-banner-message .banner-actions .btn_green_outline.banner-action-button:hover,
.notification-banner-message .banner-actions button.btn_green_outline:hover, .btn_green_outline.success-button:hover {
  background-color: #72bf44;
  color: #ffffff;
  border: 0px solid #72bf44;
  padding: 5px 10px;
}
.btn_normal.btn_green_outline:disabled, .notification-banner-message .banner-actions a.btn_green_outline:disabled,
.notification-banner-message .banner-actions .btn_green_outline.link:disabled,
.notification-banner-message .banner-actions .btn_green_outline.banner-action-button:disabled,
.notification-banner-message .banner-actions button.btn_green_outline:disabled, .btn_green_outline.success-button:disabled {
  color: #cccccc !important;
  cursor: default !important;
  background-color: rgba(245, 246, 247, 0.2) !important;
  border: 0px solid !important;
  padding: 5px 10px;
}
.btn_normal.btn_green_outline:disabled:hover, .notification-banner-message .banner-actions a.btn_green_outline:disabled:hover,
.notification-banner-message .banner-actions .btn_green_outline.link:disabled:hover,
.notification-banner-message .banner-actions .btn_green_outline.banner-action-button:disabled:hover,
.notification-banner-message .banner-actions button.btn_green_outline:disabled:hover, .btn_green_outline.success-button:disabled:hover, .btn_normal.btn_green_outline:disabled:focus, .notification-banner-message .banner-actions a.btn_green_outline:disabled:focus,
.notification-banner-message .banner-actions .btn_green_outline.link:disabled:focus,
.notification-banner-message .banner-actions .btn_green_outline.banner-action-button:disabled:focus,
.notification-banner-message .banner-actions button.btn_green_outline:disabled:focus, .btn_green_outline.success-button:disabled:focus {
  border-color: #dfe0e1 !important;
  background-color: rgba(245, 246, 247, 0.2) !important;
  color: #cccccc !important;
}
.btn_normal.btn_add_item, .notification-banner-message .banner-actions a.btn_add_item,
.notification-banner-message .banner-actions .btn_add_item.link,
.notification-banner-message .banner-actions .btn_add_item.banner-action-button,
.notification-banner-message .banner-actions button.btn_add_item, .btn_add_item.success-button {
  background-color: transparent;
  color: #2b495e;
  padding: 5px 0px;
  border: 0px solid #2b495e;
  transition: all 0s ease;
}
.btn_normal.btn_add_item:focus, .notification-banner-message .banner-actions a.btn_add_item:focus,
.notification-banner-message .banner-actions .btn_add_item.link:focus,
.notification-banner-message .banner-actions .btn_add_item.banner-action-button:focus,
.notification-banner-message .banner-actions button.btn_add_item:focus, .btn_add_item.success-button:focus, .btn_normal.btn_add_item:hover, .notification-banner-message .banner-actions a.btn_add_item:hover,
.notification-banner-message .banner-actions .btn_add_item.link:hover,
.notification-banner-message .banner-actions .btn_add_item.banner-action-button:hover,
.notification-banner-message .banner-actions button.btn_add_item:hover, .btn_add_item.success-button:hover {
  background-color: transparent;
  color: #72bf44;
  border: 0px solid #72bf44;
  padding: 5px 0px;
}
.btn_normal.btn_add_item:disabled, .notification-banner-message .banner-actions a.btn_add_item:disabled,
.notification-banner-message .banner-actions .btn_add_item.link:disabled,
.notification-banner-message .banner-actions .btn_add_item.banner-action-button:disabled,
.notification-banner-message .banner-actions button.btn_add_item:disabled, .btn_add_item.success-button:disabled {
  color: #cccccc !important;
  cursor: default !important;
  background-color: rgba(245, 246, 247, 0) !important;
  border: 0px solid !important;
  padding: 5px 0px;
}
.btn_normal.btn_add_item:disabled:hover, .notification-banner-message .banner-actions a.btn_add_item:disabled:hover,
.notification-banner-message .banner-actions .btn_add_item.link:disabled:hover,
.notification-banner-message .banner-actions .btn_add_item.banner-action-button:disabled:hover,
.notification-banner-message .banner-actions button.btn_add_item:disabled:hover, .btn_add_item.success-button:disabled:hover, .btn_normal.btn_add_item:disabled:focus, .notification-banner-message .banner-actions a.btn_add_item:disabled:focus,
.notification-banner-message .banner-actions .btn_add_item.link:disabled:focus,
.notification-banner-message .banner-actions .btn_add_item.banner-action-button:disabled:focus,
.notification-banner-message .banner-actions button.btn_add_item:disabled:focus, .btn_add_item.success-button:disabled:focus {
  border-color: #dfe0e1 !important;
  background-color: rgba(245, 246, 247, 0) !important;
  color: #cccccc !important;
}
.btn_normal.btn_icon_only, .notification-banner-message .banner-actions a.btn_icon_only,
.notification-banner-message .banner-actions .btn_icon_only.link,
.notification-banner-message .banner-actions .btn_icon_only.banner-action-button,
.notification-banner-message .banner-actions button.btn_icon_only, .btn_icon_only.success-button {
  padding: 4px 4px;
}
.btn_normal.btn_icon_only.btn_no_border, .notification-banner-message .banner-actions a.btn_icon_only.btn_no_border,
.notification-banner-message .banner-actions .btn_icon_only.btn_no_border.link,
.notification-banner-message .banner-actions .btn_icon_only.btn_no_border.banner-action-button,
.notification-banner-message .banner-actions button.btn_icon_only.btn_no_border, .btn_icon_only.btn_no_border.success-button {
  padding: 5px 5px;
}
.btn_normal.btn_icon_only.btn_icon_small .btn_icon span, .notification-banner-message .banner-actions a.btn_icon_only.btn_icon_small .btn_icon span,
.notification-banner-message .banner-actions .btn_icon_only.btn_icon_small.link .btn_icon span,
.notification-banner-message .banner-actions .btn_icon_only.btn_icon_small.banner-action-button .btn_icon span,
.notification-banner-message .banner-actions button.btn_icon_only.btn_icon_small .btn_icon span, .btn_icon_only.btn_icon_small.success-button .btn_icon span,
.btn_normal.btn_icon_only.btn_icon_small .btn_status span,
.notification-banner-message .banner-actions a.btn_icon_only.btn_icon_small .btn_status span,
.notification-banner-message .banner-actions .btn_icon_only.btn_icon_small.link .btn_status span,
.notification-banner-message .banner-actions .btn_icon_only.btn_icon_small.banner-action-button .btn_status span,
.notification-banner-message .banner-actions button.btn_icon_only.btn_icon_small .btn_status span,
.btn_icon_only.btn_icon_small.success-button .btn_status span {
  font-size: 12px;
}
.btn_normal.btn_icon_only .btn_icon, .notification-banner-message .banner-actions a.btn_icon_only .btn_icon,
.notification-banner-message .banner-actions .btn_icon_only.link .btn_icon,
.notification-banner-message .banner-actions .btn_icon_only.banner-action-button .btn_icon,
.notification-banner-message .banner-actions button.btn_icon_only .btn_icon, .btn_icon_only.success-button .btn_icon,
.btn_normal.btn_icon_only .btn_status,
.notification-banner-message .banner-actions a.btn_icon_only .btn_status,
.notification-banner-message .banner-actions .btn_icon_only.link .btn_status,
.notification-banner-message .banner-actions .btn_icon_only.banner-action-button .btn_status,
.notification-banner-message .banner-actions button.btn_icon_only .btn_status,
.btn_icon_only.success-button .btn_status {
  font-size: 16px;
  height: 20px;
  line-height: 20px;
  width: 20px;
  text-align: center;
  display: block;
  vertical-align: text-bottom;
}
.btn_normal.btn_icon_only .btn_icon span, .notification-banner-message .banner-actions a.btn_icon_only .btn_icon span,
.notification-banner-message .banner-actions .btn_icon_only.link .btn_icon span,
.notification-banner-message .banner-actions .btn_icon_only.banner-action-button .btn_icon span,
.notification-banner-message .banner-actions button.btn_icon_only .btn_icon span, .btn_icon_only.success-button .btn_icon span,
.btn_normal.btn_icon_only .btn_status span,
.notification-banner-message .banner-actions a.btn_icon_only .btn_status span,
.notification-banner-message .banner-actions .btn_icon_only.link .btn_status span,
.notification-banner-message .banner-actions .btn_icon_only.banner-action-button .btn_status span,
.notification-banner-message .banner-actions button.btn_icon_only .btn_status span,
.btn_icon_only.success-button .btn_status span {
  display: block;
  line-height: 20px;
  width: 20px;
  font-size: 16px;
}
.btn_normal.btn_icon_small, .notification-banner-message .banner-actions a.btn_icon_small,
.notification-banner-message .banner-actions .btn_icon_small.link,
.notification-banner-message .banner-actions .btn_icon_small.banner-action-button,
.notification-banner-message .banner-actions button.btn_icon_small, .btn_icon_small.success-button {
  padding: 4px 4px;
}
.btn_normal.btn_icon_small.btn_no_border, .notification-banner-message .banner-actions a.btn_icon_small.btn_no_border,
.notification-banner-message .banner-actions .btn_icon_small.btn_no_border.link,
.notification-banner-message .banner-actions .btn_icon_small.btn_no_border.banner-action-button,
.notification-banner-message .banner-actions button.btn_icon_small.btn_no_border, .btn_icon_small.btn_no_border.success-button {
  padding: 5px 5px;
}
.btn_normal.btn_icon_small .btn_icon, .notification-banner-message .banner-actions a.btn_icon_small .btn_icon,
.notification-banner-message .banner-actions .btn_icon_small.link .btn_icon,
.notification-banner-message .banner-actions .btn_icon_small.banner-action-button .btn_icon,
.notification-banner-message .banner-actions button.btn_icon_small .btn_icon, .btn_icon_small.success-button .btn_icon,
.btn_normal.btn_icon_small .btn_status,
.notification-banner-message .banner-actions a.btn_icon_small .btn_status,
.notification-banner-message .banner-actions .btn_icon_small.link .btn_status,
.notification-banner-message .banner-actions .btn_icon_small.banner-action-button .btn_status,
.notification-banner-message .banner-actions button.btn_icon_small .btn_status,
.btn_icon_small.success-button .btn_status {
  font-size: 12px;
  height: 20px;
  width: 20px;
  text-align: center;
  display: block;
}
.btn_normal.btn_wide, .notification-banner-message .banner-actions a.btn_wide,
.notification-banner-message .banner-actions .btn_wide.link,
.notification-banner-message .banner-actions .btn_wide.banner-action-button,
.notification-banner-message .banner-actions button.btn_wide, .btn_wide.success-button {
  min-width: 100px;
}
.btn_normal.btn_select, .notification-banner-message .banner-actions a.btn_select,
.notification-banner-message .banner-actions .btn_select.link,
.notification-banner-message .banner-actions .btn_select.banner-action-button,
.notification-banner-message .banner-actions button.btn_select, .btn_select.success-button {
  min-width: 100px;
  border: 1px solid #dfe0e1;
  padding: 4px 9px;
}
.btn_normal.btn_form_input, .notification-banner-message .banner-actions a.btn_form_input,
.notification-banner-message .banner-actions .btn_form_input.link,
.notification-banner-message .banner-actions .btn_form_input.banner-action-button,
.notification-banner-message .banner-actions button.btn_form_input, .btn_form_input.success-button {
  border: 1px solid #ababab;
  border-radius: 0px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  background-clip: padding-box;
  padding: 4px;
  background-color: #ffffff;
}
.btn_normal.btn_form_input:hover, .notification-banner-message .banner-actions a.btn_form_input:hover,
.notification-banner-message .banner-actions .btn_form_input.link:hover,
.notification-banner-message .banner-actions .btn_form_input.banner-action-button:hover,
.notification-banner-message .banner-actions button.btn_form_input:hover, .btn_form_input.success-button:hover, .btn_normal.btn_form_input:focus, .notification-banner-message .banner-actions a.btn_form_input:focus,
.notification-banner-message .banner-actions .btn_form_input.link:focus,
.notification-banner-message .banner-actions .btn_form_input.banner-action-button:focus,
.notification-banner-message .banner-actions button.btn_form_input:focus, .btn_form_input.success-button:focus {
  color: #72bf44;
  border-color: #72bf44;
}
.btn_normal.btn_no_border, .notification-banner-message .banner-actions a.btn_no_border,
.notification-banner-message .banner-actions .btn_no_border.link,
.notification-banner-message .banner-actions .btn_no_border.banner-action-button,
.notification-banner-message .banner-actions button.btn_no_border, .btn_no_border.success-button {
  border: 0 solid !important;
  padding-top: 5px;
  padding-bottom: 5px;
}
.btn_normal.btn_no_padding, .notification-banner-message .banner-actions a.btn_no_padding,
.notification-banner-message .banner-actions .btn_no_padding.link,
.notification-banner-message .banner-actions .btn_no_padding.banner-action-button,
.notification-banner-message .banner-actions button.btn_no_padding, .btn_no_padding.success-button {
  padding: 4px 0px;
}
.btn_normal.btn_no_padding.btn_no_border, .notification-banner-message .banner-actions a.btn_no_padding.btn_no_border,
.notification-banner-message .banner-actions .btn_no_padding.btn_no_border.link,
.notification-banner-message .banner-actions .btn_no_padding.btn_no_border.banner-action-button,
.notification-banner-message .banner-actions button.btn_no_padding.btn_no_border, .btn_no_padding.btn_no_border.success-button {
  padding: 5px 0;
}
.btn_normal.btn_extra_padding, .notification-banner-message .banner-actions a.btn_extra_padding,
.notification-banner-message .banner-actions .btn_extra_padding.link,
.notification-banner-message .banner-actions .btn_extra_padding.banner-action-button,
.notification-banner-message .banner-actions button.btn_extra_padding, .btn_extra_padding.success-button {
  padding: 4px 9px;
}
.btn_normal.btn_extra_padding.btn_no_border, .notification-banner-message .banner-actions a.btn_extra_padding.btn_no_border,
.notification-banner-message .banner-actions .btn_extra_padding.btn_no_border.link,
.notification-banner-message .banner-actions .btn_extra_padding.btn_no_border.banner-action-button,
.notification-banner-message .banner-actions button.btn_extra_padding.btn_no_border, .btn_extra_padding.btn_no_border.success-button {
  padding: 5px 10px;
}
.btn_normal.btn_offset_margin, .notification-banner-message .banner-actions a.btn_offset_margin,
.notification-banner-message .banner-actions .btn_offset_margin.link,
.notification-banner-message .banner-actions .btn_offset_margin.banner-action-button,
.notification-banner-message .banner-actions button.btn_offset_margin, .btn_offset_margin.success-button {
  margin: -5px 0;
}
.btn_normal.btn_min_width, .notification-banner-message .banner-actions a.btn_min_width,
.notification-banner-message .banner-actions .btn_min_width.link,
.notification-banner-message .banner-actions .btn_min_width.banner-action-button,
.notification-banner-message .banner-actions button.btn_min_width, .btn_min_width.success-button {
  display: inline-block;
  width: 80px;
}
.btn_normal.btn_table, .notification-banner-message .banner-actions a.btn_table,
.notification-banner-message .banner-actions .btn_table.link,
.notification-banner-message .banner-actions .btn_table.banner-action-button,
.notification-banner-message .banner-actions button.btn_table, .btn_table.success-button {
  margin-top: -5px;
  margin-bottom: -5px;
}
.btn_normal.btn_hidden, .notification-banner-message .banner-actions a.btn_hidden,
.notification-banner-message .banner-actions .btn_hidden.link,
.notification-banner-message .banner-actions .btn_hidden.banner-action-button,
.notification-banner-message .banner-actions button.btn_hidden, .btn_hidden.success-button {
  display: none;
}
.btn_normal > .btn_text, .notification-banner-message .banner-actions a > .btn_text,
.notification-banner-message .banner-actions .link > .btn_text,
.notification-banner-message .banner-actions .banner-action-button > .btn_text,
.notification-banner-message .banner-actions button > .btn_text, .success-button > .btn_text {
  line-height: 20px;
  display: inline-block;
}
.btn_normal > .btn_text.hidden_text, .notification-banner-message .banner-actions a > .btn_text.hidden_text,
.notification-banner-message .banner-actions .link > .btn_text.hidden_text,
.notification-banner-message .banner-actions .banner-action-button > .btn_text.hidden_text,
.notification-banner-message .banner-actions button > .btn_text.hidden_text, .success-button > .btn_text.hidden_text {
  position: absolute;
  font-size: 0 !important;
}
.btn_normal > .btn_icon, .notification-banner-message .banner-actions a > .btn_icon,
.notification-banner-message .banner-actions .link > .btn_icon,
.notification-banner-message .banner-actions .banner-action-button > .btn_icon,
.notification-banner-message .banner-actions button > .btn_icon, .success-button > .btn_icon,
.btn_normal > .btn_status,
.notification-banner-message .banner-actions a > .btn_status,
.notification-banner-message .banner-actions .link > .btn_status,
.notification-banner-message .banner-actions .banner-action-button > .btn_status,
.notification-banner-message .banner-actions button > .btn_status,
.success-button > .btn_status {
  position: relative;
  pointer-events: none;
  display: inline-block;
  vertical-align: text-bottom;
  color: inherit;
  line-height: 20px;
}
.btn_normal > .btn_icon span, .notification-banner-message .banner-actions a > .btn_icon span,
.notification-banner-message .banner-actions .link > .btn_icon span,
.notification-banner-message .banner-actions .banner-action-button > .btn_icon span,
.notification-banner-message .banner-actions button > .btn_icon span, .success-button > .btn_icon span,
.btn_normal > .btn_status span,
.notification-banner-message .banner-actions a > .btn_status span,
.notification-banner-message .banner-actions .link > .btn_status span,
.notification-banner-message .banner-actions .banner-action-button > .btn_status span,
.notification-banner-message .banner-actions button > .btn_status span,
.success-button > .btn_status span {
  font-size: 16px;
  display: block;
}
.btn_normal > .btn_icon.big_icon span, .notification-banner-message .banner-actions a > .btn_icon.big_icon span,
.notification-banner-message .banner-actions .link > .btn_icon.big_icon span,
.notification-banner-message .banner-actions .banner-action-button > .btn_icon.big_icon span,
.notification-banner-message .banner-actions button > .btn_icon.big_icon span, .success-button > .btn_icon.big_icon span,
.btn_normal > .btn_status.big_icon span,
.notification-banner-message .banner-actions a > .btn_status.big_icon span,
.notification-banner-message .banner-actions .link > .btn_status.big_icon span,
.notification-banner-message .banner-actions .banner-action-button > .btn_status.big_icon span,
.notification-banner-message .banner-actions button > .btn_status.big_icon span,
.success-button > .btn_status.big_icon span {
  font-size: 20px;
}
.btn_normal > .btn_status.status_invalid, .notification-banner-message .banner-actions a > .btn_status.status_invalid,
.notification-banner-message .banner-actions .link > .btn_status.status_invalid,
.notification-banner-message .banner-actions .banner-action-button > .btn_status.status_invalid,
.notification-banner-message .banner-actions button > .btn_status.status_invalid, .success-button > .btn_status.status_invalid {
  color: #ea5441;
}
.btn_normal > .btn_helper, .notification-banner-message .banner-actions a > .btn_helper,
.notification-banner-message .banner-actions .link > .btn_helper,
.notification-banner-message .banner-actions .banner-action-button > .btn_helper,
.notification-banner-message .banner-actions button > .btn_helper, .success-button > .btn_helper {
  float: right;
  margin-left: 5px;
  line-height: 20px;
}
.btn_normal > .btn_helper span, .notification-banner-message .banner-actions a > .btn_helper span,
.notification-banner-message .banner-actions .link > .btn_helper span,
.notification-banner-message .banner-actions .banner-action-button > .btn_helper span,
.notification-banner-message .banner-actions button > .btn_helper span, .success-button > .btn_helper span {
  font-size: 10px;
  display: block;
  line-height: 20px;
}
.btn_normal > .btn_icon_arrow, .notification-banner-message .banner-actions a > .btn_icon_arrow,
.notification-banner-message .banner-actions .link > .btn_icon_arrow,
.notification-banner-message .banner-actions .banner-action-button > .btn_icon_arrow,
.notification-banner-message .banner-actions button > .btn_icon_arrow, .success-button > .btn_icon_arrow {
  float: right;
  margin-left: 5px;
  line-height: 20px;
}
.btn_normal > .btn_icon_arrow span, .notification-banner-message .banner-actions a > .btn_icon_arrow span,
.notification-banner-message .banner-actions .link > .btn_icon_arrow span,
.notification-banner-message .banner-actions .banner-action-button > .btn_icon_arrow span,
.notification-banner-message .banner-actions button > .btn_icon_arrow span, .success-button > .btn_icon_arrow span {
  font-size: 16px;
  display: block;
  line-height: 20px;
}

button::-moz-focus-inner {
  padding: 0;
  border: 0;
}

.btn_group .btn_group_left {
  float: left;
  padding: 4px;
  border-right: 0px solid !important;
  border-radius: 4px 0 0 4px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
}
.btn_group .btn_group_left.btn_no_border {
  padding: 5px;
}
.btn_group .btn_group_left.btn_grey {
  padding: 4px;
  border: 1px solid #eceef3 !important;
}
.btn_group .btn_group_left.btn_grey:focus, .btn_group .btn_group_left.btn_grey:hover {
  border: 1px solid #525b6b !important;
}
.btn_group .btn_group_left.btn_grey:disabled {
  color: #cccccc !important;
  cursor: default !important;
  background-color: #f5f6f7 !important;
  border-color: #f5f6f7 !important;
}
.btn_group .btn_group_left.btn_grey:disabled:hover, .btn_group .btn_group_left.btn_grey:disabled:focus {
  border-color: #f5f6f7 !important;
  background-color: #f5f6f7 !important;
  color: #cccccc !important;
}
.btn_group .btn_group_right {
  float: left;
  padding: 4px;
  border-radius: 0 4px 4px 0;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
}
.btn_group .btn_group_right.btn_no_border {
  padding: 5px;
}
.btn_group .btn_group_right.btn_grey {
  padding: 4px;
  border: 1px solid #eceef3 !important;
}
.btn_group .btn_group_right.btn_grey:focus, .btn_group .btn_group_right.btn_grey:hover {
  border: 1px solid #525b6b !important;
}
.btn_group .btn_group_right.btn_grey:disabled {
  color: #cccccc !important;
  cursor: default !important;
  background-color: #f5f6f7 !important;
  border-color: #f5f6f7 !important;
}
.btn_group .btn_group_right.btn_grey:disabled:hover, .btn_group .btn_group_right.btn_grey:disabled:focus {
  border-color: #f5f6f7 !important;
  background-color: #f5f6f7 !important;
  color: #cccccc !important;
}

fieldset.form_row {
  margin-bottom: 5px;
  position: relative;
}
fieldset.form_row.no_padding {
  margin-bottom: 0;
}
fieldset.form_row.inline {
  position: relative;
}
fieldset.form_row.inline legend {
  width: 35%;
  position: absolute;
  left: 0;
  top: 0;
}
fieldset.form_row.inline > .form_group {
  width: 65%;
  margin-left: 35%;
}
fieldset.form_row.inline.auto_width {
  display: inline-block;
}
fieldset.form_row.inline.auto_width legend {
  width: auto;
  margin-right: 10px;
  position: relative;
  left: auto;
  top: auto;
}
fieldset.form_row.inline.auto_width > .form_group {
  display: inline-block;
  width: auto;
  margin-left: auto;
  white-space: nowrap;
}
fieldset.form_row.inline.split_50 > .data_label {
  float: left;
  width: 50%;
}
fieldset.form_row.inline.split_50 > .data_value {
  float: left;
  width: 50%;
}
fieldset.form_row.layout_horizontal > .form_group > .form_row {
  width: auto;
  display: inline-block;
  float: left;
  margin-right: 10px;
}
fieldset.form_row.layout_horizontal > .form_group > .form_row:last-of-type {
  margin-right: 0;
}
fieldset.form_row.layout_stacked > .form_group.split_2 > .form_row {
  width: 50%;
  float: left;
}
fieldset.form_row.layout_stacked > .form_group.split_2 > .form_row label {
  display: block;
}
fieldset.form_row.layout_stacked > .form_group > .form_row {
  width: auto;
  display: block;
}
fieldset.form_row .form_row {
  margin-bottom: 0;
}

.form_row {
  margin-bottom: 5px;
  position: relative;
}
.form_row:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
  visibility: hidden;
}
.form_row.no_padding {
  margin-bottom: 0;
}
.form_row.align_center {
  text-align: center;
}
.form_row.align_to_label {
  padding-left: 35%;
}
.form_row.align_to_label_50 {
  padding-left: 50%;
}
.form_row.inline > .form_label {
  float: left;
  width: 35%;
}
.form_row.inline > .form_input {
  float: left;
  width: 65%;
}
.form_row.inline.split_50 > .form_label {
  float: left;
  width: 50%;
}
.form_row.inline.split_50 > .form_input {
  float: left;
  width: 50%;
}
.form_row > .form_label {
  display: block;
}
.form_row > .form_label.hidden_label {
  position: absolute;
  font-size: 0;
  opacity: 0;
  filter: alpha(opacity=0);
}
.form_row > .form_label.hidden_label label {
  padding: 0;
}
.form_row > .form_label label {
  line-height: 20px;
  padding: 5px 5px 5px 0;
  display: block;
}
.form_row > .form_label label .label_right {
  float: right;
}
.form_row > .form_input {
  display: block;
}
.form_row .form_input.readonly {
  position: relative;
}
.form_row .form_input.readonly .inputbox, .form_row .form_input.readonly .add-scenario-container .add-scenario-body .add-scenario-body-second textarea, .add-scenario-container .add-scenario-body .add-scenario-body-second .form_row .form_input.readonly textarea, .form_row .form_input.readonly .add-scenario-container .add-scenario-body input, .add-scenario-container .add-scenario-body .form_row .form_input.readonly input {
  padding-right: 25px !important;
}
.form_row .form_input.input_has_button {
  position: relative;
}
.form_row .form_input.input_has_button .inputbox, .form_row .form_input.input_has_button .add-scenario-container .add-scenario-body .add-scenario-body-second textarea, .add-scenario-container .add-scenario-body .add-scenario-body-second .form_row .form_input.input_has_button textarea, .form_row .form_input.input_has_button .add-scenario-container .add-scenario-body input, .add-scenario-container .add-scenario-body .form_row .form_input.input_has_button input {
  padding-right: 35px !important;
}
.form_row .form_input.input_has_button .form_input_button {
  position: absolute;
  right: 0;
  top: 0;
}
.form_row .form_input.input_has_helper {
  position: relative;
  padding-right: 30px;
  box-sizing: border-box;
}
.form_row .form_input.input_has_helper .form_input_helper {
  position: absolute;
  line-height: 20px;
  top: 5px;
  right: 0;
  min-width: 25px;
  text-align: left;
}
.form_row .form_input .inputbox_inline_text {
  margin-left: 5px;
  display: inline-block;
}
.form_row .form_error {
  display: block;
  color: #ea5441;
  line-height: 20px;
  padding: 5px 0;
}
.form_row.auto_width {
  display: inline-block;
}

.flex_group {
  display: flex;
  flex-direction: rows;
  width: 100%;
  justify-content: flex-start;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  margin-top: 5px;
}
.flex_group.flex_end {
  justify-content: flex-end;
}
.flex_group:first-of-type {
  margin-top: 0;
}
.flex_group.flex_no_wrap {
  flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
}
.flex_group .flex_row:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
  visibility: hidden;
}
.flex_group .flex_row > .form_label {
  width: auto;
}
.flex_group .flex_row > .form_input {
  width: auto;
}
.flex_group .flex_row.flex_grow {
  flex-grow: 1;
  flex: 1 1 auto;
  -webkit-flex: 1 1 auto;
}
.flex_group .flex_row_action {
  margin-left: auto;
}

.form_helper_txt {
  line-height: 20px;
  padding: 5px 0;
  display: block;
}

.form_supplementary_text {
  line-height: 20px;
  padding: 5px 0;
  display: block;
  font-style: italic;
  color: #7e8c99;
}

/* Data Rows */
.data_row {
  display: block;
  margin-bottom: 5px;
  position: relative;
}
.data_row:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
  visibility: hidden;
}
.data_row.no_padding {
  margin-bottom: 0;
}
.data_row.inline > .data_label {
  float: left;
  width: 35%;
}
.data_row.inline > .data_value {
  float: left;
  width: 65%;
}
.data_row.inline.split_50 > .data_label {
  float: left;
  width: 50%;
}
.data_row.inline.split_50 > .data_value {
  float: left;
  width: 50%;
}
.data_row > .data_label {
  display: block;
  line-height: 20px;
  display: block;
  box-sizing: border-box;
}
.data_row > .data_label.hidden_label {
  position: absolute;
  font-size: 0;
  opacity: 0;
  filter: alpha(opacity=0);
}
.data_row > .data_value {
  display: block;
  line-height: 20px;
  display: block;
  box-sizing: border-box;
}
.data_row.mimic_form_row > .data_label {
  padding: 5px 0;
}
.data_row.mimic_form_row > .data_value {
  padding: 5px 0;
}

.panel_title {
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 20px;
  padding: 5px 0;
}
.panel_title.inline {
  display: inline-block;
}

.login_title {
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 20px;
  padding: 5px 0;
}

.context_title {
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 20px;
  padding: 5px 0;
  color: #2b495e;
  text-transform: capitalize;
}

.dropdown_title {
  font-size: 1.2rem;
  font-weight: 300;
  line-height: 20px;
  padding: 5px 0;
  margin-bottom: 10px;
}

.notification_title {
  font-weight: 600;
  text-transform: uppercase;
  line-height: 20px;
  font-size: 0.8rem;
}

#page_header {
  background-color: #2b495e;
  color: #ffffff;
}
#page_header .page_inner_container {
  padding: 10px;
  box-sizing: border-box;
}
#page_header .page_inner_container #header_left {
  float: left;
}
#page_header .page_inner_container #header_left #header_logo {
  float: left;
  line-height: 30px;
  margin-right: 20px;
}
#page_header .page_inner_container #header_left #header_logo #header_logo_icon {
  float: left;
}
#page_header .page_inner_container #header_left #header_logo #header_logo_icon a {
  display: block;
  color: #ffffff;
  text-decoration: none;
  line-height: 30px;
  font-size: 30px;
}
#page_header .page_inner_container #header_left #header_logo #header_logo_product {
  float: left;
  margin-left: 10px;
}
#page_header .page_inner_container #header_left #header_logo #header_logo_product span {
  display: block;
  letter-spacing: 0.1rem;
  text-transform: uppercase;
  color: #ffffff;
}
#page_header .page_inner_container #header_left #header_create_simulation {
  float: left;
}
#page_header .page_inner_container #header_left #header_create_simulation button {
  margin-right: 5px;
  float: left;
}
#page_header .page_inner_container #header_left #header_create_simulation #save_status {
  float: left;
  margin-left: 10px;
  line-height: 20px;
  padding: 5px 0;
  opacity: 0.5;
  filter: alpha(opacity=50);
}
#page_header .page_inner_container #header_right {
  float: right;
}
#page_header .page_inner_container #header_right #header_model_data {
  float: left;
  margin-right: 10px;
}
#page_header .page_inner_container #header_right #header_model_structure {
  float: left;
  margin-right: 20px;
}
#page_header .page_inner_container #header_right #header_quick_links {
  float: left;
  margin-right: 10px;
}
#page_header .page_inner_container #header_right #header_user {
  float: left;
}
#page_header .page_inner_container #header_right #header_guide {
  float: left;
}

.header33 {
  width: 50%;
}

#page_header_alt {
  text-align: center;
}
#page_header_alt .page_inner_container {
  padding: 10px;
  box-sizing: border-box;
}
#page_header_alt .page_inner_container #header_logo_center {
  margin: 40px auto 0;
  height: 100px;
}
#page_header_alt .page_inner_container #header_logo_center img {
  height: 100%;
}

#page_footer {
  background-color: #eceef3;
  color: #7e8c99;
}
#page_footer .page_inner_container {
  padding: 10px;
  box-sizing: border-box;
}
#page_footer .page_inner_container.no_padding {
  padding: 0;
}
#page_footer .page_inner_container .footer_text {
  text-align: center;
  line-height: 20px;
  padding: 5px;
}

.col_group:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
  visibility: hidden;
}
.col_group .col_item {
  float: left;
  box-sizing: border-box;
  padding: 5px;
  width: 100%;
  position: relative;
}
.col_group .col_item.no_padding {
  padding: 0;
}
.col_group.split_4 .col_item {
  width: 25%;
}
@media (min-width: 768px) and (max-width: 1024px) {
  .col_group.split_4 .col_item {
    width: 50%;
  }
}
@media (min-width: 0px) and (max-width: 767px) {
  .col_group.split_4 .col_item {
    width: 100%;
  }
}
.col_group.split_4.max_height .col_item {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
}
.col_group.split_4.max_height .col_item .panel_container {
  height: 100%;
}
.col_group.split_4.max_height .col_item:nth-child(2) {
  left: 25%;
}
.col_group.split_4.max_height .col_item:nth-child(3) {
  left: 50%;
}
.col_group.split_4.max_height .col_item:nth-child(4) {
  left: 75%;
}
.col_group.split_3 .col_item {
  width: 33.3333333333%;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .col_group.split_3 .col_item {
    width: 33.3333333333%;
  }
}
@media (min-width: 0px) and (max-width: 767px), (min-width: 768px) and (max-width: 1023px) and (orientation: portrait) {
  .col_group.split_3 .col_item {
    width: 100%;
  }
}
.col_group.split_3.max_height .col_item {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
}
.col_group.split_3.max_height .col_item .panel_container {
  height: 100%;
}
.col_group.split_3.max_height .col_item:nth-child(2) {
  left: 33.3333333333%;
}
.col_group.split_3.max_height .col_item:nth-child(3) {
  left: 66.6666666667%;
}
.col_group.split_2 .col_item {
  width: 50%;
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .col_group.split_2 .col_item {
    width: 50%;
  }
}
@media (min-width: 0px) and (max-width: 767px), (min-width: 768px) and (max-width: 1023px) and (orientation: portrait) {
  .col_group.split_2 .col_item {
    width: 100%;
  }
}
.col_group.split_2 .col_item.extra_space {
  padding-right: 15px;
}
.col_group.split_2 .col_item.extra_space:last-of-type {
  padding-right: 0;
  padding-left: 15px;
}
.col_group.split_2.max_height .col_item {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
}
.col_group.split_2.max_height .col_item .panel_container {
  height: 100%;
}
.col_group.split_2.max_height .col_item:nth-child(2) {
  left: 50%;
}
.col_group.max_height {
  position: fixed;
  left: 65px;
  top: 65px;
  bottom: 5px;
  right: 5px;
}
@media all and (-ms-high-contrast: none) {
  .column_content.column_content_inner.column_section {
    display: flex;
    flex-direction: column;
    min-height: 1px;
  } /* IE10 */
  *::-ms-backdrop,
  .column_content.column_content_inner.column_section {
    display: flex;
    flex-direction: column;
    min-height: 1px;
  } /* IE11 */
}
.grid_container {
  display: flex;
  justify-content: space-around;
  align-items: stretch;
  flex-flow: wrap;
  flex-direction: row;
  height: 100%;
  max-width: 1440px;
  margin: 0px auto;
  min-height: 0;
  -webkit-justify-content: space-around;
  -webkit-align-items: stretch;
}
.grid_container.auto_height {
  height: auto;
}
.grid_container.fixed_height {
  height: 100%;
  display: flex;
}
@media (max-width: 1279px) {
  .grid_container.fixed_height {
    display: flex;
    height: 100%;
  }
}
@media (max-width: 1279px) {
  .grid_container {
    display: block;
    height: auto;
  }
}
.grid_container.columns_3 .col {
  width: calc(33.3333333333% - 20px);
}
@media (max-width: 1279px) {
  .grid_container.columns_3 .col {
    width: calc(100% - 20px);
  }
}
.grid_container.columns_2 .col {
  width: calc(50% - 20px);
}
@media (max-width: 1279px) {
  .grid_container.columns_2 .col {
    width: calc(100% - 20px);
  }
}
.grid_container.columns_1 .col {
  width: calc(100% - 20px);
}
@media (max-width: 1279px) {
  .grid_container.columns_1 .col {
    width: calc(100% - 20px);
  }
}
.grid_container .col {
  box-sizing: border-box;
  margin: 10px auto;
  height: 100%;
}
@media (max-width: 1279px) {
  .grid_container .col {
    width: inherit;
    margin: 10px auto;
  }
}

/****** Spreadsheet ********/
/********** Base **********/
/********** Colours **********/
/********** Pages **********/
/********** Modal **********/
/********** Button **********/
/******* Icons ********/
/******* Icons ********/
/******* Media Queries ********/
.fadein, .panel-left-body .tree ul,
.panel-left-body .tree .tree-nodes,
.panel-right-body .tree ul,
.panel-right-body .tree .tree-nodes, .periodequations-tree .has_changes,
.lookup-tree .has_changes, .periodequations-tree .star,
.lookup-tree .star {
  animation: fadein 0.3s;
}

.fadeout {
  animation: fadeout 0.3s;
}

@keyframes fadein {
  from {
    opacity: 0;
    transform: translate3d(0, -0.5rem, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
/*

  Modal Dialog Layout

*/
/*

  TODO(mdc-migration): The following rule targets internal classes of dialog that may no longer apply for the MDC version.

*/
html {
  --mdc-filled-text-field-container-color: white;
}

.mat-mdc-form-field {
  font-size: inherit;
  font-weight: 400;
  line-height: 1.125;
  font-family: Roboto, "Helvetica Neue", sans-serif;
  letter-spacing: normal;
}

/*

  TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.

*/
.mat-form-field-appearance-legacy .mat-form-field-wrapper {
  padding-bottom: 1.25em;
}

/*

  TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.

*/
.mat-form-field-appearance-legacy .mat-form-field-infix {
  padding: 0.4375em 0;
}

/*

  TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.

*/
.mat-form-field-appearance-legacy .mat-form-field-subscript-wrapper {
  margin-top: 0.5416666667em;
  top: calc(100% - 1.6666666667em);
}

.dialog-model {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
  align-items: stretch;
  -webkit-align-items: stretch;
  height: 100%;
  width: 100%;
  padding: 0 !important;
  max-width: 100vw;
  border-radius: 5px;
}
.dialog-model .modal-header-left, .dialog-model .modal-header-center, .dialog-model .modal-header-right,
.dialog-model .modal-footer-left,
.dialog-model .modal-footer-center,
.dialog-model .modal-footer-right,
.dialog-model .modal-body-left,
.dialog-model .modal-body-center,
.dialog-model .modal-body-right {
  position: relative;
  display: flex;
  flex-direction: row;
  flex: 1 auto;
  align-items: stretch;
}
.dialog-model .modal-header-left,
.dialog-model .modal-footer-left,
.dialog-model .modal-body-left {
  justify-content: flex-start;
}
.dialog-model .modal-header-center,
.dialog-model .modal-footer-center,
.dialog-model .modal-body-center {
  justify-content: center;
}
.dialog-model .modal-header-right,
.dialog-model .modal-footer-right,
.dialog-model .modal-body-right {
  justify-content: flex-end;
}
.dialog-model *[class\$=-left],
.dialog-model *[class\$=-center],
.dialog-model *[class\$=-right] {
  position: relative;
  display: flex;
  flex-direction: row;
  flex: 1 auto;
  align-items: stretch;
}
.dialog-model *[class\$=-left] {
  justify-content: flex-start;
}
.dialog-model *[class\$=-center] {
  justify-content: center;
}
.dialog-model *[class\$=-right] {
  justify-content: flex-end;
}
.dialog-model .scrollable-y {
  overflow: hidden;
  overflow-y: auto;
}
.dialog-model .scrollable-x {
  overflow: hidden;
  overflow-x: auto;
}
.dialog-model .scrollable:not(-y):not(-x) {
  overflow: auto;
}
.dialog-model .panel-left,
.dialog-model .panel-right {
  position: relative;
}
.dialog-model .panel-left.with_dragbar:before,
.dialog-model .panel-right.with_dragbar:before {
  content: "";
  position: absolute;
  left: -5px;
  top: 50%;
  width: 10px;
  height: 30px;
  margin-top: -15px;
  border: 1px solid #dfe0e1;
  border-radius: 5px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  background-color: #ffffff;
  box-sizing: border-box;
}
.dialog-model .panel-left .dragbar,
.dialog-model .panel-right .dragbar {
  background-color: black;
  height: 100%;
  position: absolute;
  top: 0;
  left: -2px;
  width: 5px;
  cursor: col-resize;
  opacity: 0;
  filter: alpha(opacity=0);
}
.dialog-model .panel-left .dragbar:hover, .dialog-model .panel-left .dragbar:focus,
.dialog-model .panel-right .dragbar:hover,
.dialog-model .panel-right .dragbar:focus {
  opacity: 0.5;
  filter: alpha(opacity=50);
}
.dialog-model .panel-right {
  border-left: 1px solid #dfe0e1;
}
.dialog-model .panel-left {
  border-right: 1px solid #dfe0e1;
}
.dialog-model .panel-left-actions,
.dialog-model .panel-right-actions {
  padding: 15px;
  border-bottom: 1px solid #dfe0e1;
}

.modal-header {
  background-color: #51738b;
  position: relative;
  display: flex;
  flex-direction: row;
  min-height: 40px;
}

.modal-body {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
  align-items: stretch;
  -webkit-align-items: stretch;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  position: relative;
}
.modal-body .component-header,
.modal-body .component-body,
.modal-body .panel-main-header,
.modal-body .panel-left,
.modal-body .panel-main,
.modal-body .panel-right,
.modal-body .panel-main-header-left,
.modal-body .panel-main-header-center,
.modal-body .panel-main-header-right,
.modal-body .modal-header-left,
.modal-body .modal-header-center,
.modal-body .modal-header-right,
.modal-body .modal-footer-left,
.modal-body .modal-footer-center,
.modal-body .modal-footer-right,
.modal-body .modal-header-left,
.modal-body .modal-header-center,
.modal-body .modal-header-right {
  position: relative;
  display: flex;
  flex-direction: row;
}
.modal-body .component-header,
.modal-body .panel-main-header {
  position: relative;
  min-height: -moz-fit-content;
  min-height: fit-content;
}
.modal-body .panel-main-header.min-height {
  min-height: 48px;
}
.modal-body .panel-main-header-center,
.modal-body .modal-header-center,
.modal-body .modal-footer-center {
  margin: 0 auto;
  align-items: center;
}
.modal-body .modal-header-right,
.modal-body .panel-main-header-right,
.modal-body .modal-footer-right {
  margin: 0 0 0 auto;
  align-items: flex-end;
}
.modal-body .panel-left,
.modal-body .modal-header-left,
.modal-body .panel-main-header-left,
.modal-body .modal-footer-left {
  order: 0;
}
.modal-body .panel-main,
.modal-body .modal-header-center,
.modal-body .panel-main-header-center,
.modal-body .modal-footer-center {
  order: 1;
}
.modal-body .panel-right,
.modal-body .modal-header-right,
.modal-body .panel-main-header-right,
.modal-body .modal-footer-right {
  order: 2;
}
.modal-body .panel-main-header-left,
.modal-body .panel-main-header-center,
.modal-body .panel-main-header-right {
  padding: 0.5rem;
}
.modal-body .panel-main-header-left:empty,
.modal-body .panel-main-header-center:empty,
.modal-body .panel-main-header-right:empty {
  padding: 0;
}
.modal-body .panel-left-actions:empty,
.modal-body .panel-right-actions:empty {
  padding: 0;
}
.modal-body .component-header {
  position: relative;
  height: auto;
  width: 100%;
}
.modal-body .component-body {
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
  align-items: stretch;
  -webkit-align-items: stretch;
  height: 100%;
  width: 100%;
  min-height: 0;
  flex-flow: nowrap;
  margin: 0px;
}
.modal-body .component-body .panel-left,
.modal-body .component-body .panel-right {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
  align-items: stretch;
  -webkit-align-items: stretch;
  min-height: 0;
  flex-grow: 1;
}
.modal-body .component-body .panel-main {
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
  align-items: stretch;
  -webkit-align-items: stretch;
  height: 100%;
  width: 100%;
  min-height: 0;
}
.modal-body .component-body .panel-main-body,
.modal-body .component-body .panel-left-body,
.modal-body .component-body .panel-right-body {
  flex-grow: 1;
}
.modal-body .component-body .panel-left:empty,
.modal-body .component-body .panel-left-header:empty,
.modal-body .component-body .panel-left-body:empty,
.modal-body .component-body .panel-left-footer:empty,
.modal-body .component-body .panel-right:empty,
.modal-body .component-body .panel-right-header:empty,
.modal-body .component-body .panel-right-body:empty,
.modal-body .component-body .panel-right-footer:empty {
  width: 0;
  height: 0;
}
.modal-body .component-body .panel-left-body,
.modal-body .component-body .panel-right-body {
  margin: 0;
  padding: 1rem;
}
.modal-body .component-body .panel-main-body {
  margin: 0;
  padding: 0;
  height: 100%;
  display: flex;
}

.modal-footer, .dialog_actions {
  position: relative;
  padding: 15px;
  border-top: 1px solid #dfe0e1;
  display: flex;
  flex-direction: row;
}
.modal-footer .modal-footer-right, .dialog_actions .modal-footer-right {
  margin: 0 0 0 auto;
}
.modal-footer .modal-footer-right .btn_normal, .modal-footer .modal-footer-right .notification-banner-message .banner-actions a, .notification-banner-message .banner-actions .modal-footer .modal-footer-right a,
.modal-footer .modal-footer-right .notification-banner-message .banner-actions .link,
.notification-banner-message .banner-actions .modal-footer .modal-footer-right .link,
.modal-footer .modal-footer-right .notification-banner-message .banner-actions .banner-action-button,
.notification-banner-message .banner-actions .modal-footer .modal-footer-right .banner-action-button,
.modal-footer .modal-footer-right .notification-banner-message .banner-actions button,
.notification-banner-message .banner-actions .modal-footer .modal-footer-right button, .dialog_actions .modal-footer-right .btn_normal, .dialog_actions .modal-footer-right .notification-banner-message .banner-actions a, .notification-banner-message .banner-actions .dialog_actions .modal-footer-right a,
.dialog_actions .modal-footer-right .notification-banner-message .banner-actions .link,
.notification-banner-message .banner-actions .dialog_actions .modal-footer-right .link,
.dialog_actions .modal-footer-right .notification-banner-message .banner-actions .banner-action-button,
.notification-banner-message .banner-actions .dialog_actions .modal-footer-right .banner-action-button,
.dialog_actions .modal-footer-right .notification-banner-message .banner-actions button,
.notification-banner-message .banner-actions .dialog_actions .modal-footer-right button, .modal-footer .modal-footer-right .success-button, .dialog_actions .modal-footer-right .success-button {
  margin: 0 0 0 1rem;
}
.modal-footer .modal-footer-right .btn_normal:first-of-type, .modal-footer .modal-footer-right .notification-banner-message .banner-actions a:first-of-type, .notification-banner-message .banner-actions .modal-footer .modal-footer-right a:first-of-type,
.modal-footer .modal-footer-right .notification-banner-message .banner-actions .link:first-of-type,
.notification-banner-message .banner-actions .modal-footer .modal-footer-right .link:first-of-type,
.modal-footer .modal-footer-right .notification-banner-message .banner-actions .banner-action-button:first-of-type,
.notification-banner-message .banner-actions .modal-footer .modal-footer-right .banner-action-button:first-of-type,
.modal-footer .modal-footer-right .notification-banner-message .banner-actions button:first-of-type,
.notification-banner-message .banner-actions .modal-footer .modal-footer-right button:first-of-type, .dialog_actions .modal-footer-right .btn_normal:first-of-type, .dialog_actions .modal-footer-right .notification-banner-message .banner-actions a:first-of-type, .notification-banner-message .banner-actions .dialog_actions .modal-footer-right a:first-of-type,
.dialog_actions .modal-footer-right .notification-banner-message .banner-actions .link:first-of-type,
.notification-banner-message .banner-actions .dialog_actions .modal-footer-right .link:first-of-type,
.dialog_actions .modal-footer-right .notification-banner-message .banner-actions .banner-action-button:first-of-type,
.notification-banner-message .banner-actions .dialog_actions .modal-footer-right .banner-action-button:first-of-type,
.dialog_actions .modal-footer-right .notification-banner-message .banner-actions button:first-of-type,
.notification-banner-message .banner-actions .dialog_actions .modal-footer-right button:first-of-type, .modal-footer .modal-footer-right .success-button:first-of-type, .dialog_actions .modal-footer-right .success-button:first-of-type {
  margin: 0;
}

.content_container {
  padding: 0px;
  box-sizing: border-box;
}
.content_container.padding--all {
  padding: 15px;
}
.content_container.padding--left {
  padding-left: 15px;
}
.content_container.padding--right {
  padding-right: 15px;
}
.content_container.padding--top {
  padding-top: 15px;
}
.content_container.padding--bottom {
  padding-bottom: 15px;
}
.content_container.padding--vertical {
  padding-top: 15px;
  padding-bottom: 15px;
}
.content_container.padding--horizontal {
  padding-left: 15px;
  padding-right: 15px;
}

.structure-col {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  align-items: stretch;
  -webkit-align-items: stretch;
  height: 100%;
  width: 100%;
  min-height: 0;
}
.structure-col .structure-col--left {
  flex-grow: 1;
  text-align: left;
  font-size: 0;
}
.structure-col .structure-col--left * {
  font-size: 0.86rem;
}
.structure-col .structure-col--left button,
.structure-col .structure-col--left input[type=button] {
  display: inline-block;
  margin-right: 5px;
}
.structure-col .structure-col--left button .btn_text,
.structure-col .structure-col--left input[type=button] .btn_text {
  font-size: 0.76rem;
  display: block;
}
.structure-col .structure-col--left button:last-of-type,
.structure-col .structure-col--left input[type=button]:last-of-type {
  margin-right: 0;
}
.structure-col .structure-col--middle {
  flex-grow: 1;
  text-align: center;
  font-size: 0;
}
.structure-col .structure-col--middle * {
  font-size: 0.86rem;
}
.structure-col .structure-col--middle button,
.structure-col .structure-col--middle input[type=button] {
  display: inline-block;
  margin-right: 5px;
}
.structure-col .structure-col--middle button .btn_text,
.structure-col .structure-col--middle input[type=button] .btn_text {
  font-size: 0.76rem;
  display: block;
}
.structure-col .structure-col--middle button:last-of-type,
.structure-col .structure-col--middle input[type=button]:last-of-type {
  margin-right: 0;
}
.structure-col .structure-col--right {
  flex-grow: 1;
  text-align: right;
  font-size: 0;
}
.structure-col .structure-col--right * {
  font-size: 0.86rem;
}
.structure-col .structure-col--right button,
.structure-col .structure-col--right input[type=button] {
  display: inline-block;
  font-size: 0;
  margin-left: 5px;
}
.structure-col .structure-col--right button .btn_text,
.structure-col .structure-col--right input[type=button] .btn_text {
  font-size: 0.76rem;
  display: block;
}
.structure-col .structure-col--right button:first-of-type,
.structure-col .structure-col--right input[type=button]:first-of-type {
  margin-left: 0;
}

.show_labels .page-container,
.show_labels .modal-header,
.show_labels .modal-body,
.show_labels .modal-footer,
.show_labels .dialog_actions,
.show_labels .component-header,
.show_labels .component-body,
.show_labels .panel-left,
.show_labels .panel-left-header,
.show_labels .panel-left-actions,
.show_labels .panel-left-body,
.show_labels .panel-right,
.show_labels .panel-right-header,
.show_labels .panel-right-actions,
.show_labels .panel-right-body,
.show_labels .panel-main-header-left,
.show_labels .panel-main-header-center,
.show_labels .panel-main-header-right,
.show_labels .modal-header-left,
.show_labels .modal-header-center,
.show_labels .modal-header-right,
.show_labels .modal-footer-left,
.show_labels .modal-footer-center,
.show_labels .modal-footer-right,
.show_labels .panel-main,
.show_labels .panel-main-header,
.show_labels .panel-main-actions,
.show_labels .panel-main-body {
  border-width: 2px;
  border-style: solid;
  position: relative;
  padding: 20px;
  box-sizing: border-box;
}
.show_labels .page-container:before,
.show_labels .modal-header:before,
.show_labels .modal-body:before,
.show_labels .modal-footer:before,
.show_labels .dialog_actions:before,
.show_labels .component-header:before,
.show_labels .component-body:before,
.show_labels .panel-left:before,
.show_labels .panel-left-header:before,
.show_labels .panel-left-actions:before,
.show_labels .panel-left-body:before,
.show_labels .panel-right:before,
.show_labels .panel-right-header:before,
.show_labels .panel-right-actions:before,
.show_labels .panel-right-body:before,
.show_labels .panel-main-header-left:before,
.show_labels .panel-main-header-center:before,
.show_labels .panel-main-header-right:before,
.show_labels .modal-header-left:before,
.show_labels .modal-header-center:before,
.show_labels .modal-header-right:before,
.show_labels .modal-footer-left:before,
.show_labels .modal-footer-center:before,
.show_labels .modal-footer-right:before,
.show_labels .panel-main:before,
.show_labels .panel-main-header:before,
.show_labels .panel-main-actions:before,
.show_labels .panel-main-body:before {
  content: attr(id);
  background-color: attr(border-color);
  position: absolute;
  left: 0;
  top: 0;
  padding: 0 5px;
  font-size: 12px;
  line-height: 20px;
  display: block;
}
.show_labels > div {
  border-color: red;
}
.show_labels > div:before {
  color: white;
  background-color: red;
}
.show_labels > div > div {
  border-color: blue;
}
.show_labels > div > div:before {
  color: white;
  background-color: blue;
}
.show_labels > div > div > div {
  border-color: #ff00fb;
}
.show_labels > div > div > div:before {
  color: white;
  background-color: #ff00fb;
}
.show_labels > div > div > div > div {
  border-color: #7cbd22;
}
.show_labels > div > div > div > div:before {
  color: white;
  background-color: #7cbd22;
}

.modal-body {
  overflow: hidden;
  height: 100%;
}

/* Lookup tables tree & Period Equations */
.tree {
  overflow: hidden;
  padding: 0;
  margin: 0;
  width: auto;
}
.tree button {
  cursor: pointer;
  display: inline-block;
}
.tree .drawer_container .drawer_header {
  padding: 0;
}
.tree .tree-node-parent .drawer_container {
  padding-top: 0.5rem;
}
.tree .drawer_content {
  display: block;
}

.view_all_tables.node_all .tree_link {
  border: 0;
}

.drawer_container {
  /* Drawer Content (Hidden by Default) */
}
.drawer_container .drawer_header {
  position: relative;
  padding-left: 30px;
}
.drawer_container .drawer_header .drawer_header_toggle {
  position: absolute;
  left: 0;
  top: 0;
}
.drawer_container .drawer_header .drawer_header_title .drawer_content {
  margin-left: 30px;
}
.drawer_container .drawer_header .drawer_header_title .drawer_content .tree_link {
  width: 100%;
  display: block;
  box-sizing: border-box;
}
.drawer_container .drawer_header .drawer_header_title a {
  font-weight: 600;
}
.drawer_container .drawer_content {
  display: none;
  position: relative;
}
.drawer_container .drawer_content.drawer_active {
  display: block;
}

.periodequations-tree .star,
.lookup-tree .star {
  color: darkorange;
  filter: blur(0.5px);
  transition: all 200ms;
  margin-left: 0.382em;
  text-decoration: none;
  line-height: 0.5rem;
}
.periodequations-tree .has_changes,
.lookup-tree .has_changes {
  color: darkorange;
  filter: blur(0.5px);
  transition: all 200ms;
  margin-left: 0.382em;
  text-decoration: none;
  line-height: 0.5rem;
}
.periodequations-tree .tree-node-parent .drawer_content,
.lookup-tree .tree-node-parent .drawer_content {
  display: block;
}
.periodequations-tree .tree_link,
.lookup-tree .tree_link {
  text-decoration: none !important;
}
.periodequations-tree .tree_link:before,
.lookup-tree .tree_link:before {
  display: none;
}
.periodequations-tree .tree_link.category,
.lookup-tree .tree_link.category {
  text-decoration: none;
  font-weight: bold;
  color: #72bf44;
  padding-left: 0;
}

app-lookup-setup .panel-main-header,
app-liquidity-sources .panel-main-header,
app-exogenous-lines .panel-main-header {
  min-height: 50px !important;
  height: 50px !important;
}

app-equation-bar kendo-window,
app-balance-sheet kendo-window {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 1px 20px rgba(0, 0, 0, 0.3);
}
app-equation-bar kendo-window-titlebar,
app-equation-bar .k-dialog-titlebar,
app-equation-bar .k-window-titlebar,
app-balance-sheet kendo-window-titlebar,
app-balance-sheet .k-dialog-titlebar,
app-balance-sheet .k-window-titlebar {
  background-color: #51738b !important;
  padding: 0.25rem 0.5rem !important;
}

app-input-structure select,
app-lookup-setup select,
app-liquidity-sources select,
app-exogenous-lines select {
  animation: fadein 0.3s;
}

#data_set_container {
  position: relative;
  height: 100%;
  min-width: 9.37rem;
  padding: 0 1rem;
  display: flex;
  flex: 1 auto;
  flex-direction: column;
  justify-content: center;
  color: #ffffff;
  text-align: right;
  z-index: 1;
}
#data_set_container #data_set_filename a {
  color: #ffffff;
  display: inline_block;
  font-weight: 300;
}
#data_set_container #data_set_filename a:hover, #data_set_container #data_set_filename a:focus {
  text-decoration: none;
}
#data_set_container #data_set_timestamp {
  display: block;
  opacity: 0.5;
  filter: alpha(opacity=50);
  font-weight: 300;
}

.fadein, .panel-left-body .tree ul,
.panel-left-body .tree .tree-nodes,
.panel-right-body .tree ul,
.panel-right-body .tree .tree-nodes, .periodequations-tree .star,
.lookup-tree .star, .periodequations-tree .has_changes,
.lookup-tree .has_changes {
  animation: fadein 0.3s;
}

.fadeout {
  animation: fadeout 0.3s;
}

@keyframes fadein {
  from {
    opacity: 0;
    transform: translate3d(0, -0.5rem, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.panel-left-body,
.panel-right-body {
  overflow: hidden auto;
  height: auto;
}
.panel-left-body .tree-warning,
.panel-right-body .tree-warning {
  background-color: #ff9d00;
  color: #ffffff;
  padding: 0.618rem;
}
.panel-left-body .tree-nodes,
.panel-right-body .tree-nodes {
  overflow: hidden auto;
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.panel-left-body .tree ul,
.panel-left-body .tree .tree-nodes,
.panel-right-body .tree ul,
.panel-right-body .tree .tree-nodes {
  overflow: hidden auto;
  padding: 0;
  margin: 0 0 0 15px;
  list-style: none;
}
.panel-left-body .tree .tree_link,
.panel-right-body .tree .tree_link {
  display: block;
  text-decoration: underline;
  line-height: 20px;
  padding: 5px 5px 5px 20px;
  position: relative;
  display: block;
  width: 100%;
  background-color: transparent;
  position: relative;
  color: #505050;
  line-height: 20px;
  margin: 0px;
  padding: 5px 5px;
  text-align: left;
  overflow: visible;
  border-radius: 4px;
  background-clip: padding-box;
  -webkit-appearance: none;
  box-sizing: border-box;
  border: 0px solid;
  cursor: pointer;
  transition: all 0.3s ease;
  box-sizing: border-box;
  font-size: 0.86rem;
  color: #2b495e;
  -webkit-tap-highlight-color: transparent;
  padding-left: 1rem;
}
.panel-left-body .tree .tree_link:before,
.panel-right-body .tree .tree_link:before {
  content: "\\e902";
  font-family: "empyrean_icons";
  font-size: 10px;
  height: 10px;
  width: 10px;
  position: absolute;
  top: 10px;
  left: 0px;
  line-height: 10px;
}
.panel-left-body .tree .tree_link.tree_link_active:before,
.panel-right-body .tree .tree_link.tree_link_active:before {
  transform: rotate(90deg);
}
.panel-left-body .tree .tree_text,
.panel-right-body .tree .tree_text {
  display: block;
  line-height: 20px;
  padding: 5px 5px 5px 20px;
  position: relative;
}
.panel-left-body .tree .tree_text:before,
.panel-right-body .tree .tree_text:before {
  content: "";
  height: 4px;
  width: 4px;
  background-color: #2b495e;
  border-radius: 20px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  position: absolute;
  top: 13px;
  left: 5px;
}

#sim_group,
.sim_group {
  width: calc(100% - 30px);
  padding: 15px;
}
#sim_group #sim_header,
.sim_group #sim_header {
  border-bottom: 1px solid #505050;
}
#sim_group #sim_header > div .sim_header_label,
.sim_group #sim_header > div .sim_header_label {
  text-transform: capitalize;
  font-weight: 600;
  font-size: 0.8rem;
}
#sim_group .sim_scenario,
#sim_group .sim_mnemonic,
#sim_group .sim_description,
.sim_group .sim_scenario,
.sim_group .sim_mnemonic,
.sim_group .sim_description {
  float: left;
  min-height: 30px;
  padding: 5px;
  box-sizing: border-box;
}
#sim_group .sim_scenario .is_invalid_mnemonic,
#sim_group .sim_mnemonic .is_invalid_mnemonic,
#sim_group .sim_description .is_invalid_mnemonic,
.sim_group .sim_scenario .is_invalid_mnemonic,
.sim_group .sim_mnemonic .is_invalid_mnemonic,
.sim_group .sim_description .is_invalid_mnemonic {
  line-height: 20px;
  margin: 0;
  width: 100%;
  box-sizing: border-box;
}
#sim_group .sim_scenario .is_invalid_mnemonic .idle-component,
#sim_group .sim_mnemonic .is_invalid_mnemonic .idle-component,
#sim_group .sim_description .is_invalid_mnemonic .idle-component,
.sim_group .sim_scenario .is_invalid_mnemonic .idle-component,
.sim_group .sim_mnemonic .is_invalid_mnemonic .idle-component,
.sim_group .sim_description .is_invalid_mnemonic .idle-component {
  border: 1px solid #ea5441;
  border-radius: 4px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
}
#sim_group .sim_scenario .is_invalid_mnemonic .invalid-message,
#sim_group .sim_mnemonic .is_invalid_mnemonic .invalid-message,
#sim_group .sim_description .is_invalid_mnemonic .invalid-message,
.sim_group .sim_scenario .is_invalid_mnemonic .invalid-message,
.sim_group .sim_mnemonic .is_invalid_mnemonic .invalid-message,
.sim_group .sim_description .is_invalid_mnemonic .invalid-message {
  white-space: normal;
}
#sim_group .sim_scenario:hover .inner_cell_text .inline-edit,
#sim_group .sim_mnemonic:hover .inner_cell_text .inline-edit,
#sim_group .sim_description:hover .inner_cell_text .inline-edit,
.sim_group .sim_scenario:hover .inner_cell_text .inline-edit,
.sim_group .sim_mnemonic:hover .inner_cell_text .inline-edit,
.sim_group .sim_description:hover .inner_cell_text .inline-edit {
  text-decoration: underline;
}
#sim_group .sim_scenario .inner_cell_text,
#sim_group .sim_mnemonic .inner_cell_text,
#sim_group .sim_description .inner_cell_text,
.sim_group .sim_scenario .inner_cell_text,
.sim_group .sim_mnemonic .inner_cell_text,
.sim_group .sim_description .inner_cell_text {
  line-height: 20px;
  padding: 0px 0px;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
#sim_group .sim_scenario .inner_cell_text .inline-edit,
#sim_group .sim_mnemonic .inner_cell_text .inline-edit,
#sim_group .sim_description .inner_cell_text .inline-edit,
.sim_group .sim_scenario .inner_cell_text .inline-edit,
.sim_group .sim_mnemonic .inner_cell_text .inline-edit,
.sim_group .sim_description .inner_cell_text .inline-edit {
  line-height: 20px;
  padding: 5px;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
#sim_group .sim_scenario .inner_cell_text .inline-edit.force_multiline_text,
#sim_group .sim_mnemonic .inner_cell_text .inline-edit.force_multiline_text,
#sim_group .sim_description .inner_cell_text .inline-edit.force_multiline_text,
.sim_group .sim_scenario .inner_cell_text .inline-edit.force_multiline_text,
.sim_group .sim_mnemonic .inner_cell_text .inline-edit.force_multiline_text,
.sim_group .sim_description .inner_cell_text .inline-edit.force_multiline_text {
  white-space: normal !important;
}
#sim_group .sim_scenario .inner_cell_text input,
#sim_group .sim_mnemonic .inner_cell_text input,
#sim_group .sim_description .inner_cell_text input,
.sim_group .sim_scenario .inner_cell_text input,
.sim_group .sim_mnemonic .inner_cell_text input,
.sim_group .sim_description .inner_cell_text input {
  line-height: 20px;
  margin: 0;
  padding: 4px 5px;
  border: 1px solid #ababab;
  border-radius: 4px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  width: 100%;
  box-sizing: border-box;
}
#sim_group .sim_row_toggle,
#sim_group .sim_last_updated,
#sim_group .sim_dataset,
#sim_group .sim_delete,
#sim_group .sim_notifications,
#sim_group .sim_action,
.sim_group .sim_row_toggle,
.sim_group .sim_last_updated,
.sim_group .sim_dataset,
.sim_group .sim_delete,
.sim_group .sim_notifications,
.sim_group .sim_action {
  float: left;
  min-height: 30px;
  padding: 5px 5px;
  box-sizing: border-box;
}
#sim_group .inner_cell_text,
.sim_group .inner_cell_text {
  line-height: 20px;
  padding: 5px 0px;
  display: block;
  box-sizing: border-box;
  vertical-align: top;
}
#sim_group .inner_cell_text a,
.sim_group .inner_cell_text a {
  color: #2b495e;
}
#sim_group .inner_cell_text a:hover, #sim_group .inner_cell_text a:focus,
.sim_group .inner_cell_text a:hover,
.sim_group .inner_cell_text a:focus {
  color: #72bf44;
}
#sim_group .sim_scenario .inner_cell_text,
.sim_group .sim_scenario .inner_cell_text {
  font-weight: 600;
}
#sim_group .sim_row_toggle,
.sim_group .sim_row_toggle {
  width: 40px;
}
#sim_group .sim_scenario,
.sim_group .sim_scenario {
  width: 15%;
}
#sim_group .sim_mnemonic,
.sim_group .sim_mnemonic {
  width: 15%;
}
#sim_group .sim_description,
.sim_group .sim_description {
  width: calc(70% - 370px);
}
#sim_group .manage_resultsets_table .sim_description,
.sim_group .manage_resultsets_table .sim_description {
  width: calc(70% - 370px + 40px);
}
#sim_group .sim_last_updated,
.sim_group .sim_last_updated {
  width: 130px;
}
#sim_group .sim_dataset,
.sim_group .sim_dataset {
  width: 160px;
}
#sim_group .sim_delete,
.sim_group .sim_delete {
  width: 40px;
}
#sim_group .sim_notifications,
.sim_group .sim_notifications {
  width: 40px;
}
#sim_group .sim_action,
.sim_group .sim_action {
  width: 120px;
}
#sim_group .sim_notifications .icon_notification,
.sim_group .sim_notifications .icon_notification {
  color: #ff9d00;
}
#sim_group .sim_delete button,
.sim_group .sim_delete button {
  opacity: 0.1;
  filter: alpha(opacity=10);
}
#sim_group .sim_description .inner_cell_text.wrap_text,
.sim_group .sim_description .inner_cell_text.wrap_text {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  width: calc(100% - 30px);
}
#sim_group .sim_description .more_link,
#sim_group .sim_description .less_link,
.sim_group .sim_description .more_link,
.sim_group .sim_description .less_link {
  line-height: 20px;
  padding: 5px 0px;
  display: inline-block;
  box-sizing: border-box;
  vertical-align: top;
}
#sim_group .sim_description .more_link a,
#sim_group .sim_description .less_link a,
.sim_group .sim_description .more_link a,
.sim_group .sim_description .less_link a {
  color: #2b495e;
}
#sim_group .sim_description .more_link a:hover, #sim_group .sim_description .more_link a:focus,
#sim_group .sim_description .less_link a:hover,
#sim_group .sim_description .less_link a:focus,
.sim_group .sim_description .more_link a:hover,
.sim_group .sim_description .more_link a:focus,
.sim_group .sim_description .less_link a:hover,
.sim_group .sim_description .less_link a:focus {
  text-decoration: underline;
}
#sim_group .sim_row_container,
.sim_group .sim_row_container {
  padding: 10px 0;
  border-bottom: 1px solid #dfe0e1;
}
#sim_group .sim_row_container:last-of-type,
.sim_group .sim_row_container:last-of-type {
  padding: 10px 0;
  border-bottom: 1px solid #dfe0e1;
}
#sim_group .sim_row_container.show_children .sim_row .sim_row_toggle button,
.sim_group .sim_row_container.show_children .sim_row .sim_row_toggle button {
  font-size: 12px;
  position: relative;
  transform: rotate(90deg);
}
#sim_group .sim_row_container.show_children .sim_row .sim_row_toggle button .btn_icon span,
.sim_group .sim_row_container.show_children .sim_row .sim_row_toggle button .btn_icon span {
  font-size: 12px;
}
#sim_group .sim_row_container .sim_row .sim_row_toggle button,
.sim_group .sim_row_container .sim_row .sim_row_toggle button {
  font-size: 12px;
}
#sim_group .sim_row_container .sim_row .sim_row_toggle button .btn_icon span,
.sim_group .sim_row_container .sim_row .sim_row_toggle button .btn_icon span {
  font-size: 12px;
}
#sim_group .sim_row_container .sim_row:hover,
.sim_group .sim_row_container .sim_row:hover {
  background-color: #f4f6f7;
}
#sim_group .sim_row_container .sim_row:hover .sim_delete button,
.sim_group .sim_row_container .sim_row:hover .sim_delete button {
  opacity: 1;
  filter: alpha(opacity=100);
}
#sim_group .sim_row_container .sim_row.sim_baseline .sim_scenario,
.sim_group .sim_row_container .sim_row.sim_baseline .sim_scenario {
  padding-left: 20px;
  box-sizing: border-box;
  position: relative;
}
#sim_group .sim_row_container .sim_row.sim_baseline .sim_scenario .color-dot,
.sim_group .sim_row_container .sim_row.sim_baseline .sim_scenario .color-dot {
  margin: auto 0;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  background-color: #cccccc;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
#sim_group .sim_row_container .sim_row.sim_stress .sim_scenario,
.sim_group .sim_row_container .sim_row.sim_stress .sim_scenario {
  padding-left: 35px;
  box-sizing: border-box;
  position: relative;
}
#sim_group .sim_row_container .sim_row.sim_stress .sim_scenario .color-line,
.sim_group .sim_row_container .sim_row.sim_stress .sim_scenario .color-line {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: 0 auto;
  width: 4px;
  height: 100%;
  margin-left: -1em;
  background-color: #cccccc;
}
#sim_group .sim_row_container .sim_stress_add .sim_scenario,
.sim_group .sim_row_container .sim_stress_add .sim_scenario {
  padding-left: 35px;
  box-sizing: border-box;
  position: relative;
}
#sim_group .sim_row_container .sim_baseline_add .sim_scenario,
.sim_group .sim_row_container .sim_baseline_add .sim_scenario {
  padding-left: 20px;
  box-sizing: border-box;
  position: relative;
}
#sim_group .sim_row_container .sim_baseline_add .sim_scenario .color-dot,
.sim_group .sim_row_container .sim_baseline_add .sim_scenario .color-dot {
  margin: auto 0;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  background-color: #cccccc;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
.is_invalid_dataset {
  border: 1px solid red !important;
  border-radius: 4px;
  padding: 5px;
  font-size: 0.8rem;
}

#assumption_container {
  position: relative;
  height: calc(100vh - 242px);
  display: flex;
  justify-content: space-around;
  align-items: stretch;
  flex-flow: nowrap;
  flex-direction: row;
  margin: 0px auto;
  min-height: 0;
  -webkit-justify-content: space-around;
  -webkit-align-items: stretch;
}
#assumption_container #assumption_lookup_list {
  transition: all 0.3s ease;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 250px;
  padding: 15px;
}
#assumption_container #assumption_lookup_list:after {
  content: "";
  position: absolute;
  right: 0px;
  top: 0;
  bottom: 0;
  width: 1px;
  background: #dfe0e1;
}
#assumption_container #assumption_lookup_viewer {
  transition: all 0.3s ease;
  flex: 1;
  margin-left: 270px;
  display: block;
}
#assumption_container #assumption_lookup_viewer #toggle_list_btn_container {
  position: absolute;
  left: -15px;
  top: 0;
  display: none;
  z-index: 1;
  margin-top: auto;
  margin-bottom: auto;
}
#assumption_container #assumption_lookup_viewer #toggle_list_btn_container button {
  background-color: #ffffff;
}

#footer_bar {
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: flex-start;
  flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
  align-items: stretch;
  -webkit-align-items: stretch;
  width: 100%;
  min-height: 0;
  position: relative;
  overflow: visible !important;
}
#footer_bar:before {
  content: "";
  height: 1px;
  background-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
}
#footer_bar #footer_result_set {
  box-sizing: border-box;
  padding: 10px;
  padding-right: 0;
}
#footer_bar #footer_quick_link {
  box-sizing: border-box;
  padding: 10px;
  padding-left: 0;
  position: relative;
  overflow: visible !important;
}
#footer_bar #footer_report_summary {
  box-sizing: border-box;
  padding: 0 10px;
  padding-left: 0;
}
#footer_bar #footer_report_summary button.btn_sheet {
  min-width: 3rem;
  background-color: #ffffff;
  border-radius: 0;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
  background-clip: padding-box;
  padding: 10px;
  position: relative;
  color: rgba(80, 80, 80, 0.5);
  text-transform: inherit;
  font-size: 0.86rem;
  font-weight: 400;
}
#footer_bar #footer_report_summary button.btn_sheet:before {
  content: "";
  height: 3px;
  background-color: rgba(0, 0, 0, 0.05);
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
}
#footer_bar #footer_report_summary button.btn_sheet:after {
  content: "";
  height: 1px;
  background-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
}
#footer_bar #footer_report_summary button.btn_sheet:hover, #footer_bar #footer_report_summary button.btn_sheet:focus {
  color: #2b495e;
}
#footer_bar #footer_report_summary button.btn_sheet.btn_sheet_active {
  color: #505050;
  font-weight: 600;
}
#footer_bar #footer_report_summary button.btn_sheet.btn_sheet_active:before {
  display: none;
}
#footer_bar #footer_report_summary button.btn_sheet.btn_sheet_active:after {
  display: none;
}
#footer_bar #footer_tabs {
  width: 100%;
  flex-grow: 1;
  flex: 1 1 auto;
  -webkit-flex: 1 1 auto;
  position: relative;
  box-sizing: border-box;
  overflow: auto;
  box-sizing: border-box;
  padding: 0 0 5px;
}
#footer_bar #footer_controls {
  box-sizing: border-box;
  padding: 10px;
}
#footer_bar #footer_controls.hide_controls {
  display: none;
}
#footer_bar #footer_controls #pan_controls {
  width: 60px;
}
#footer_bar #footer_controls #pan_controls button {
  float: left;
}
#footer_bar #footer_export {
  box-sizing: border-box;
  padding: 10px;
}

#result_tab_container > ul {
  margin: 0px 0 0;
  padding: 0;
  list-style: none;
  display: inline-block;
  font-size: 0;
  white-space: nowrap;
}
#result_tab_container > ul > li {
  display: inline-block;
  font-size: 0;
  margin-right: 10px;
  position: relative;
}
#result_tab_container > ul > li:last-child {
  margin-right: 0;
}
#result_tab_container > ul > li > ul {
  margin: 0;
  padding: 0;
  list-style: none;
  width: 100%;
  white-space: nowrap;
  display: inline-block;
  font-size: 0;
}
#result_tab_container > ul > li > ul > li {
  display: inline-block;
  font-size: 0;
  margin-right: 2px;
  position: relative;
  overflow: hidden;
}
#result_tab_container > ul > li > ul > li button.btn_sheet {
  min-width: 6rem;
  background-color: #ffffff;
  background: linear-gradient(to bottom, rgb(246, 246, 246) 10%, white 50%, white);
  border-radius: 0;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
  background-clip: padding-box;
  padding: 10px 10px 7px 10px;
  position: relative;
  border-width: 0 0 3px 0;
  border-style: solid;
  color: rgba(80, 80, 80, 0.5);
  text-transform: inherit;
  font-size: 0.86rem;
  font-weight: 600;
}
#result_tab_container > ul > li > ul > li button.btn_sheet:before {
  content: "";
  height: 3px;
  background-color: rgba(0, 0, 0, 0.05);
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
}
#result_tab_container > ul > li > ul > li button.btn_sheet:after {
  content: "";
  height: 1px;
  background-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
}
#result_tab_container > ul > li > ul > li button.btn_sheet:hover, #result_tab_container > ul > li > ul > li button.btn_sheet:focus {
  color: #2b495e;
}
#result_tab_container > ul > li > ul > li button.btn_sheet.btn_sheet_active {
  color: #505050;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
#result_tab_container > ul > li > ul > li button.btn_sheet.btn_sheet_active:before {
  display: none;
}
#result_tab_container > ul > li > ul > li button.btn_sheet.btn_sheet_active:after {
  display: none;
}
#result_tab_container > ul > li > ul > li button.btn_sheet .btn_status span {
  color: #ff9d00;
}
#result_tab_container > ul > li > ul > li button.btn_sheet_hide {
  position: absolute;
  right: -40px;
  top: 5px;
  z-index: 1;
  background-color: #ffffff;
  overflow: hidden;
  margin-left: 5px;
  padding-left: 0;
  padding-right: 5px;
}
#result_tab_container > ul > li > ul > li button.btn_sheet_hide .btn_icon span {
  font-size: 10px;
  background-color: #f5f6f7;
  border-radius: 30px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  padding: 3px;
}
#result_tab_container > ul > li > ul > li button.btn_sheet_hide:before {
  content: "";
  position: absolute;
  left: -10px;
  top: 0;
  bottom: 0;
  width: 10px;
  background: rgb(255, 255, 255);
  background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 100%);
}
#result_tab_container > ul > li > ul > li:hover button.btn_sheet_hide {
  right: 0;
}

#context_bar {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-flow: nowrap;
  flex-direction: row;
  margin: 0px auto;
  min-height: 0;
  -webkit-justify-content: space-between;
  -webkit-align-items: stretch;
  background-color: #f5f6f7;
}
#context_bar #context_bar_left {
  flex: 1;
  padding: 10px;
  box-sizing: border-box;
}
#context_bar #context_bar_left #context_source {
  float: left;
  line-height: 30px;
  padding-right: 15px;
  margin-right: 5px;
  position: relative;
}
#context_bar #context_bar_left #context_source:after {
  content: "\\e910";
  font-family: "empyrean_icons";
  line-height: 30px;
  font-size: 10px;
  position: absolute;
  right: 0;
  top: 0;
}
#context_bar #context_bar_left #context_source .source_file span {
  display: block;
  vertical-align: middle;
  font-size: 16px;
  line-height: 30px;
}
#context_bar #context_bar_left #context_title {
  float: left;
  padding-right: 10px;
}
#context_bar #context_bar_left #context_edit_assumptions {
  float: left;
  padding-right: 10px;
  cursor: pointer;
}
#context_bar #context_bar_left #context_edit_assumptions .edit_asumptions_link {
  display: block;
  line-height: 20px;
  padding: 5px 0px 5px 0;
  text-decoration: underline;
}
#context_bar #context_bar_middle {
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
}
#context_bar #context_bar_middle #view_controller {
  display: inline-block;
  width: 160px;
}
#context_bar #context_bar_middle #view_controller .toggle_switch_option {
  width: 80px;
}
#context_bar #context_bar_middle #access_controller {
  display: inline-block;
  color: dark_grey;
  line-height: 20px;
  padding: 5px 0;
  margin-left: 10px;
}
#context_bar #context_bar_middle #access_controller .access_text {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 0.8rem;
}
#context_bar #context_bar_right {
  text-align: right;
  flex: 1;
  padding: 10px;
  box-sizing: border-box;
}
#context_bar #context_bar_right #sheet_status {
  display: inline-block;
  opacity: 0.5;
  filter: alpha(opacity=50);
}
#context_bar #context_bar_right #notifications_container {
  display: inline-block;
  margin-left: 10px;
}

.footer_quick_link {
  position: relative;
  overflow: visible !important;
}

#sheet_list {
  position: fixed;
  bottom: 45px;
  left: 50px;
  width: 400px;
  z-index: 1000010 !important;
  margin-bottom: 10px;
  background: #ffffff;
  padding: 15px;
  border-radius: 3px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 1px 20px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
}
#sheet_list > ul {
  margin: 0;
  padding: 0;
  list-style: none;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}
#sheet_list > ul > li {
  margin-bottom: 20px;
}
#sheet_list > ul > li:last-child {
  margin-bottom: 0;
}
#sheet_list > ul > li > ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
#sheet_list > ul > li > ul > li a {
  display: block;
  color: inherit;
  text-decoration: none;
  padding: 0;
}
#sheet_list > ul > li > ul > li a:hover, #sheet_list > ul > li > ul > li a:focus {
  background-color: #f5f6f7;
  color: #505050;
}
#sheet_list > ul > li > ul > li a:hover .sheet_name, #sheet_list > ul > li > ul > li a:focus .sheet_name {
  text-decoration: underline;
}
#sheet_list > ul > li > ul > li a:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
  visibility: hidden;
}
#sheet_list > ul > li > ul > li a .sheet_name {
  width: 70%;
  display: block;
  vertical-align: top;
  float: left;
  word-wrap: break-word;
  box-sizing: border-box;
  padding: 5px 0 5px 20px;
  line-height: 20px;
  cursor: pointer;
  position: relative;
}
#sheet_list > ul > li > ul > li a .sheet_dataset {
  padding: 5px 0;
  line-height: 20px;
  width: 30%;
  display: block;
  vertical-align: right;
  float: left;
  text-align: right;
  word-wrap: break-word;
}
#sheet_list > ul > li > ul > li a.sheet_baseline .sheet_name:before {
  content: "";
  position: absolute;
  left: 5px;
  top: 10px;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
}
#sheet_list > ul > li > ul > li a.sheet_stress .sheet_name {
  padding-left: 40px;
}
#sheet_list > ul > li > ul > li a.sheet_stress .sheet_name:before {
  content: "";
  position: absolute;
  left: 20px;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 4px;
}

ul#notifications_list {
  margin: 0;
  padding: 0;
  list-style: none;
}
ul#notifications_list > li {
  padding: 10px 0;
  border-bottom: 1px solid #dfe0e1;
}
ul#notifications_list > li:last-child {
  border-bottom: 0px solid #dfe0e1;
}
ul#notifications_list > li p {
  line-height: 20px;
  color: #525b6b;
}
ul#notifications_list > li p:last-of-type {
  padding-bottom: 0;
  margin-bottom: 0;
}
ul#notifications_list > li p a {
  color: #ff9d00;
  text-decoration: none;
}
ul#notifications_list > li p a:hover, ul#notifications_list > li p a:focus {
  text-decoration: underline;
}

#notification_container {
  font-size: 0.76rem;
  background-color: #ff9d00;
  color: #525b6b;
  padding: 5px;
  text-align: center;
  display: block;
  margin: 0 auto;
  position: relative;
  padding-left: 10px;
  padding-right: 10px;
  z-index: 1;
}
#notification_container p {
  line-height: 15px;
}
#notification_container p:last-child {
  padding: 0;
  margin: 0;
}
#notification_container [class^=icon_], #notification_container [class*=" icon_"] {
  vertical-align: middle;
}

app-hover-notification {
  display: contents;
}

.hover-notification-container {
  background-color: white;
  color: #525b6b;
  transition: all 0.3s ease-in-out;
  border-radius: 3px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 1px 20px rgba(0, 0, 0, 0.3);
  display: grid;
  font-family: "Source Sans Pro", Helvetica, sans-serif;
  font-size: 0.86rem;
  grid-template-rows: auto 1fr;
  grid-gap: 0.4rem;
  min-width: 100px;
  max-width: 300px;
  padding: 0.7rem;
  position: absolute;
  top: 0.5rem;
  width: auto;
  z-index: 999;
  border-left: 6px solid;
  border-left-color: #ff9d00;
}
.hover-notification-container.notificationright {
  right: 0.5rem;
}
.hover-notification-container.notificationleft {
  left: 0.5rem;
}
.hover-notification-container.info {
  border-left-color: #51738b !important;
}
.hover-notification-container.info .title,
.hover-notification-container.info .value {
  color: #51738b !important;
}
.hover-notification-container.success {
  border-left-color: #72bf44 !important;
}
.hover-notification-container.success .title,
.hover-notification-container.success .value {
  color: #72bf44 !important;
}
.hover-notification-container.error {
  border-left-color: #ea5441 !important;
}
.hover-notification-container.error .title,
.hover-notification-container.error .value {
  color: #ea5441 !important;
}
.hover-notification-container.warning {
  border-left-color: #ff9d00 !important;
}
.hover-notification-container.warning .title,
.hover-notification-container.warning .value {
  color: #ff9d00 !important;
}
.hover-notification-container .header {
  display: grid;
  grid-template-columns: 1fr auto;
}
.hover-notification-container .header .title,
.hover-notification-container .header .value {
  font-weight: 600;
}
.hover-notification-container .header .value {
  margin-left: 1rem;
}
.hover-notification-container .body {
  white-space: pre-wrap;
  font-weight: 400;
}

app-multi-notification {
  margin: auto !important;
  padding: 0.5rem;
  width: auto;
  max-width: 90%;
  display: grid;
  /* grid-auto-flow: column; */
  grid-template-columns: repeat(3, auto);
  grid-gap: 0.5rem;
}

.multi-notification-container {
  padding: 0.5rem;
  border: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 1px 6px rgba(0, 0, 0, 0.3);
  display: grid;
  grid-template-columns: 1fr auto;
}
.multi-notification-container .title {
  font-weight: 600;
  text-transform: uppercase;
  line-height: 20px;
  font-size: 0.8rem;
  color: #525b6b;
}
.multi-notification-container .body {
  color: #525b6b;
  font-size: 0.86rem;
  font-family: "Source Sans Pro", Helvetica, sans-serif;
  font-weight: 400;
}
.multi-notification-container .actions {
  margin-top: auto;
}
.multi-notification-container .actions button {
  margin-left: 0.5rem;
}

.component-header {
  overflow: hidden;
  transition: all 1s cubic-bezier(0.65, 0.05, 0.36, 1);
  transition: max-height 1s cubic-bezier(0.65, 0.05, 0.36, 1);
  height: auto;
  max-height: 600px;
}

.component-header.slide-up {
  max-height: 0;
  display: none;
}

ul#application_list {
  width: 100%;
  float: left;
  margin: 0;
  padding: 0;
  list-style: none;
}
ul#application_list > li {
  float: left;
  width: 33.3333333333%;
  text-align: center;
}
ul#application_list > li a.application_link {
  display: block;
  text-decoration: none;
  border-radius: 4px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  text-align: center;
  padding: 10px 4px;
  color: inherit;
}
ul#application_list > li a.application_link:hover, ul#application_list > li a.application_link:focus {
  background-color: rgba(43, 73, 94, 0.1);
}
ul#application_list > li a.application_link:hover .application_icon, ul#application_list > li a.application_link:focus .application_icon {
  background-color: rgba(43, 73, 94, 0.3);
  color: #2b495e;
}
ul#application_list > li a.application_link:hover .application_name,
ul#application_list > li a.application_link:hover .application_subtitle, ul#application_list > li a.application_link:focus .application_name,
ul#application_list > li a.application_link:focus .application_subtitle {
  color: #2b495e;
}
ul#application_list > li a.application_link.disabled {
  opacity: 0.3;
  transition: opacity 0.6s;
}
ul#application_list > li a.application_link .application_icon {
  display: block;
  padding: 10px;
  border-radius: 50px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  background-color: rgba(0, 0, 0, 0.05);
  width: 50px;
  box-sizing: border-box;
  margin: 0 auto 10px;
}
ul#application_list > li a.application_link .application_icon span {
  line-height: 30px;
  width: 30px;
  text-align: center;
  font-size: 24px;
  display: block;
  vertical-align: top;
}
ul#application_list > li a.application_link .application_name {
  text-align: center;
  display: block;
  line-height: 15px;
  min-height: 30px;
  font-size: 0.8rem;
}
ul#application_list > li a.application_link .application_subtitle {
  text-align: center;
  display: block;
  font-size: 0.7rem;
}

.notification-banner-message {
  position: relative;
  width: 100%;
  color: #000000;
  background: #ffffff;
  cursor: default;
  overflow: hidden;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 157, 0, 0.25);
  padding-bottom: 1px;
}
.notification-banner-message .banner-title,
.notification-banner-message .banner-body,
.notification-banner-message .banner-actions {
  width: auto;
  text-align: center;
  max-width: 800px;
}
.notification-banner-message .banner-title,
.notification-banner-message .banner-body {
  padding: 0.618rem auto;
}
.notification-banner-message .banner-actions {
  padding-bottom: 0.618rem;
}
.notification-banner-message .banner-actions {
  display: flex;
  justify-content: center;
}
.notification-banner-message .banner-actions a,
.notification-banner-message .banner-actions .link,
.notification-banner-message .banner-actions .banner-action-button,
.notification-banner-message .banner-actions button {
  background: unset;
  color: unset;
  border: unset;
  flex: 1 auto;
  flex-wrap: wrap;
  text-transform: uppercase;
  color: #72bf44;
  width: auto;
  min-width: 7rem;
  min-height: 2rem;
  margin-left: 1rem;
  cursor: pointer;
}
.notification-banner-message .banner-actions a :first-of-type,
.notification-banner-message .banner-actions .link :first-of-type,
.notification-banner-message .banner-actions .banner-action-button :first-of-type,
.notification-banner-message .banner-actions button :first-of-type {
  margin-left: 0;
}
.notification-banner-message .banner-actions a.primary-action,
.notification-banner-message .banner-actions .link.primary-action,
.notification-banner-message .banner-actions .banner-action-button.primary-action,
.notification-banner-message .banner-actions button.primary-action {
  background: #2b495e;
  color: #ffffff;
}
.notification-banner-message .banner-actions a.secondary-action,
.notification-banner-message .banner-actions .link.secondary-action,
.notification-banner-message .banner-actions .banner-action-button.secondary-action,
.notification-banner-message .banner-actions button.secondary-action {
  background: transparent;
  border: 1px solid #2b495e;
  color: #2b495e;
}

app-notification-banner,
.app-notification-banner,
.notification-banner-message {
  width: 100%;
  padding: 0;
}

/*

  Spreadsheets

*/
.spread-container {
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 8;
}
.spread-container .spreadsheet {
  z-index: 9;
  position: relative;
  height: 100%;
  width: 100%;
}
.spread-container .spreadsheet--loading, .spread-container .spreadsheet--empty {
  z-index: 10;
  background-color: #f5f6f7;
  background-image: linear-gradient(to bottom, #f5f6f7 calc(100% - 40px), white);
  position: relative;
  min-height: 100%;
}
.spread-container .spreadsheet--loading:before, .spread-container .spreadsheet--empty:before {
  content: "\\e90d";
  font-family: "empyrean_icons";
  position: absolute;
  left: 50%;
  top: 50%;
  font-size: 80px;
  color: #cccccc;
  transform: translate(-50%, -50%);
  font-weight: 300;
}
.spread-container .spreadsheet--loading:after, .spread-container .spreadsheet--empty:after {
  content: "Loading Sheet...";
  position: absolute;
  left: 50%;
  top: 50%;
  font-size: 1rem;
  color: #cccccc;
  transform: translate(-50%, -50%);
  margin-top: 50px;
  text-align: center;
  font-weight: 300;
}
.spread-container .spreadsheet--empty:after {
  content: "No Data Available.";
}
.spread-container .spreadsheet--empty.empty_results:after {
  content: "No Results Available.";
}
.spread-container .spreadsheet--empty.empty_period_equations:after {
  content: "No Period Equations Available.";
}

.sheet-status .error {
  line-height: 20px;
  padding: 5px 0;
  color: #ea5441;
}
.sheet-status .error:after {
  margin-left: 5px;
  content: "\\e91f";
  font-family: "empyrean_icons";
  vertical-align: top;
}
.sheet-status .valid {
  line-height: 20px;
  padding: 5px 0;
}
.sheet-status .valid:after {
  color: #ea5441;
  margin-left: 5px;
  content: "\\e91f";
  font-family: "empyrean_icons";
  vertical-align: top;
}

.fadein, .periodequations-tree .star,
.lookup-tree .star, .periodequations-tree .has_changes,
.lookup-tree .has_changes, .panel-left-body .tree ul,
.panel-left-body .tree .tree-nodes,
.panel-right-body .tree ul,
.panel-right-body .tree .tree-nodes {
  animation: fadein 0.3s;
}

.fadeout {
  animation: fadeout 0.3s;
}

@keyframes fadein {
  from {
    opacity: 0;
    transform: translate3d(0, -0.5rem, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
form {
  margin: 0;
  padding: 0;
}

input, .add-scenario-container .add-scenario-body input,
select,
button {
  font-size: 1em;
  font-family: "Source Sans Pro", Helvetica, sans-serif !important;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

textarea, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea {
  font-size: 1em;
  font-family: "Source Sans Pro", Helvetica, sans-serif !important;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

label {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

fieldset {
  margin: 0;
  padding: 0;
  border: 0;
}
fieldset legend {
  display: block;
  box-sizing: border-box;
  line-height: 20px;
  padding: 5px 0 5px 0px;
}
fieldset legend.hidden_legend {
  position: absolute;
  font-size: 0;
}

/* Text Area */
textarea.inputbox, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea {
  width: 100%;
  resize: none;
  -webkit-overflow-scrolling: touch;
  overflow: auto;
  border: 1px solid #ababab;
  box-sizing: border-box;
  margin: 0;
  padding: 5px 5px;
  line-height: 20px;
  vertical-align: bottom;
  background: #ffffff none 0 0 no-repeat;
  border-radius: 4px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  color: #505050;
}
textarea.inputbox.no_border, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea.no_border {
  border: 1px solid transparent;
}
textarea.inputbox[readonly], .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[readonly] {
  border: 1px solid #cccccc;
  background-color: #eef0f1;
  padding-right: 25px;
}
textarea.inputbox:focus, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea:focus {
  border: 1px solid #505050;
}
textarea.inputbox:focus[readonly], .add-scenario-container .add-scenario-body .add-scenario-body-second textarea:focus[readonly] {
  border: 1px solid #f5f6f7;
}
textarea.inputbox:focus[readonly][disabled], .add-scenario-container .add-scenario-body .add-scenario-body-second textarea:focus[readonly][disabled] {
  border: 1px solid transparent;
}
textarea.inputbox.auto_width, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea.auto_width {
  width: initial;
}

@element "textarea.inputbox.required" and (max-characters: 0) {
  eq_this {
    /* input:empty */
    background-color: rgba(248, 231, 28, 0.3) !important;
  }
}
@element "textarea.inputbox.required" and (min-characters: 1) {
  eq_this {
    /* input:not(:empty) */
    background-color: #ffffff !important;
  }
}
/* Inputbox */
input.inputbox, .add-scenario-container .add-scenario-body input {
  width: 100%;
  line-height: 20px;
  margin: 0;
  padding: 4px 5px;
  border: 1px solid #ababab;
  -webkit-appearance: none;
  -moz-appearance: none;
  box-sizing: border-box;
  background: #ffffff none 0 0 no-repeat;
  -moz-background-size: 0% auto;
  text-indent: 0.01px;
  text-overflow: "";
  border-radius: 4px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  color: #505050;
}
input.inputbox.no_border, .add-scenario-container .add-scenario-body input.no_border {
  border: 1px solid transparent;
}
input.inputbox[readonly], .add-scenario-container .add-scenario-body input[readonly] {
  border: 1px solid #cccccc;
  background-color: #eef0f1;
}
input.inputbox:focus, .add-scenario-container .add-scenario-body input:focus {
  border: 1px solid #505050;
}
input.inputbox:focus[readonly], .add-scenario-container .add-scenario-body input:focus[readonly] {
  border: 1px solid #ababab;
}
input.inputbox:focus[readonly][disabled], .add-scenario-container .add-scenario-body input:focus[readonly][disabled] {
  border: 1px solid transparent;
}
input.inputbox.auto_width, .add-scenario-container .add-scenario-body input.auto_width {
  width: initial;
}

input[type=date], .add-scenario-container .add-scenario-body input[type=date] {
  -webkit-appearance: none;
}

input[type=number], .add-scenario-container .add-scenario-body input[type=number] {
  -webkit-appearance: none;
}

@element "input.inputbox.required" and (max-characters: 0) {
  eq_this {
    /* input:empty */
    background-color: rgba(248, 231, 28, 0.3) !important;
  }
}
@element "input.inputbox.required" and (min-characters: 1) {
  eq_this {
    /* input:not(:empty) */
    background-color: #ffffff !important;
  }
}
/* Select */
select.inputbox {
  width: 100%;
  line-height: 20px;
  margin: 0;
  padding: 4px 25px 4px 5px;
  border: 1px solid #ababab;
  color: #505050;
  -webkit-appearance: none;
  -moz-appearance: none;
  box-sizing: border-box;
  background: #ffffff url("/assets/images/select_dropdown.png") no-repeat;
  background-position: right center;
  -webkit-padding-end: 25px;
  -moz-padding-end: 25px;
  -moz-background-size: 0% auto;
  text-indent: 0.01px;
  text-overflow: "";
  padding-right: 25px\\9 ;
  cursor: pointer;
  border-radius: 4px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
}
@media (min-device-pixel-ratio: 1.3), (min-resolution: 1.3dppx) {
  select.inputbox {
    /* on retina, use image that's scaled by 2 */
    background-image: url("/assets/images/select_dropdown@2x.png");
    background-size: 20px 20px;
  }
}
select.inputbox.no_border {
  border: 1px solid transparent;
}
select.inputbox.no_dropdown {
  background: none !important;
  background-color: #ffffff !important;
  padding: 10px !important;
}
select.inputbox.add_item_select_box {
  opacity: 0.5;
  filter: alpha(opacity=50);
}
select.inputbox[readonly] {
  border: 1px solid #cccccc;
  background-color: #eef0f1;
}
select.inputbox.no_dropdown {
  -webkit-padding-end: 0px;
  -moz-padding-end: 0px;
  padding-right: 0px\\9 ;
  padding: 10px 0px 9px 0px;
}
select.inputbox:focus {
  border: 1px solid #505050;
  opacity: 1;
  filter: alpha(opacity=100);
}
select.inputbox.auto_width {
  width: initial;
}
select.inputbox option {
  color: #505050;
}
select.inputbox option[disabled] {
  color: #cccccc;
}

select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #000;
}

select::-ms-expand {
  display: none;
  text-indent: 0.01px;
  text-overflow: "";
}

select::-moz-focus-inner {
  padding: 0;
  border: 0;
  margin: 0px;
  background-image: none !important;
}

@-moz-document url-prefix() {
  select.inputbox {
    padding: 6px 25px 7px 5px;
  }
}
@element "select.inputbox.required" and (max-characters: 0) {
  eq_this {
    /* input:empty */
    background-color: rgba(248, 231, 28, 0.3) !important;
  }
}
@element "select.inputbox.required" and (min-characters: 1) {
  eq_this {
    /* input:not(:empty) */
    background-color: #ffffff !important;
  }
}
/* Disabled States */
input[disabled], .add-scenario-container .add-scenario-body input[disabled],
textarea[disabled],
.add-scenario-container .add-scenario-body .add-scenario-body-second textarea[disabled],
select[disabled] {
  -webkit-text-fill-color: #cccccc;
  -webkit-opacity: 1;
  color: #cccccc;
  background: transparent;
}

input.inputbox[disabled], .add-scenario-container .add-scenario-body input[disabled] {
  background-color: #f5f6f7;
  border: 1px solid #f5f6f7;
  color: #cccccc;
  cursor: default;
}

select.inputbox[disabled] {
  background-color: #f5f6f7;
  border: 1px solid #f5f6f7;
  color: #cccccc;
  cursor: default;
}

textarea[disabled], .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[disabled] {
  background-color: #f5f6f7;
  border: 1px solid #f5f6f7;
  color: #cccccc;
  cursor: default;
}

/* Placeholder Text */
.inputbox::-webkit-input-placeholder, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea::-webkit-input-placeholder, .add-scenario-container .add-scenario-body input::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: rgba(0, 0, 0, 0.4);
  opacity: 1;
}
.inputbox:-moz-placeholder, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea:-moz-placeholder, .add-scenario-container .add-scenario-body input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: rgba(0, 0, 0, 0.4);
  opacity: 1;
}
.inputbox::-moz-placeholder, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea::-moz-placeholder, .add-scenario-container .add-scenario-body input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: rgba(0, 0, 0, 0.4);
  opacity: 1;
}
.inputbox:placeholder-shown, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea:placeholder-shown, .add-scenario-container .add-scenario-body input:placeholder-shown {
  /* Standard (https://drafts.csswg.org/selectors-4/#placeholder) */
  color: rgba(0, 0, 0, 0.4);
  opacity: 1;
}

input[type=number]::-webkit-inner-spin-button, .add-scenario-container .add-scenario-body input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button,
.add-scenario-container .add-scenario-body input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number], .add-scenario-container .add-scenario-body input[type=number] {
  -moz-appearance: textfield;
}

/* Error States */
/* Datepicker */
.btn_icon_date {
  position: absolute;
  right: 0;
  top: 0;
  background-color: transparent;
  border: 0;
  padding: 7px;
  border-radius: 0px 4px 4px 0px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  cursor: pointer;
}

.btn_icon_date:focus,
.btn_icon_date:hover {
  color: #ffffff;
  background-color: #72bf44;
}

/* Inputbox Widths */
input.inputbox.width_x-small, .add-scenario-container .add-scenario-body input.width_x-small,
select.inputbox.width_x-small,
textarea.inputbox.width_x-small,
.add-scenario-container .add-scenario-body .add-scenario-body-second textarea.width_x-small {
  width: 60px;
  display: inline-block;
}
input.inputbox.width_small, .add-scenario-container .add-scenario-body input.width_small,
select.inputbox.width_small,
textarea.inputbox.width_small,
.add-scenario-container .add-scenario-body .add-scenario-body-second textarea.width_small {
  width: 80px;
  display: inline-block;
}

.inputbox.invalid, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea.invalid, .add-scenario-container .add-scenario-body input.invalid {
  border-color: #ea5441;
}

.invalid_message {
  display: inline-block;
  line-height: 20px;
  clear: both;
  color: #ea5441;
}

@media all and (-ms-high-contrast: none) {
  input.inputbox, .add-scenario-container .add-scenario-body input {
    height: 30px;
  } /* IE10 */
  *::-ms-backdrop,
  input.inputbox,
  .add-scenario-container .add-scenario-body input {
    height: 30px;
  } /* IE11 */
  select.inputbox {
    height: 30px;
  } /* IE10 */
  *::-ms-backdrop,
  select.inputbox {
    height: 30px;
  } /* IE11 */
  textarea.inputbox[readonly], .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[readonly] {
    overflow: auto;
    -ms-overflow-style: none;
  }
  *::-ms-backdrop,
  textarea.inputbox[readonly],
  .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[readonly] {
    overflow: auto;
    -ms-overflow-style: none;
  } /* IE11 */
}
.inputbox[type=checkbox]:checked, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=checkbox]:checked, .add-scenario-container .add-scenario-body input[type=checkbox]:checked,
.inputbox[type=checkbox]:not(:checked),
.add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=checkbox]:not(:checked),
.add-scenario-container .add-scenario-body input[type=checkbox]:not(:checked) {
  position: absolute;
  left: -9999px;
}

.inputbox[type=checkbox]:checked + label, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=checkbox]:checked + label, .add-scenario-container .add-scenario-body input[type=checkbox]:checked + label,
.inputbox[type=checkbox]:not(:checked) + label,
.add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=checkbox]:not(:checked) + label,
.add-scenario-container .add-scenario-body input[type=checkbox]:not(:checked) + label {
  position: relative;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #505050;
  padding: 5px 0 5px 20px !important;
}

.inputbox[type=checkbox]:checked + label:before, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=checkbox]:checked + label:before, .add-scenario-container .add-scenario-body input[type=checkbox]:checked + label:before,
.inputbox[type=checkbox]:not(:checked) + label:before,
.add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=checkbox]:not(:checked) + label:before,
.add-scenario-container .add-scenario-body input[type=checkbox]:not(:checked) + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 6px;
  width: 14px;
  height: 14px;
  border: 1px solid #ababab;
  background: #ffffff;
  border-radius: 3px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
}

.inputbox[type=checkbox]:checked + label:after, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=checkbox]:checked + label:after, .add-scenario-container .add-scenario-body input[type=checkbox]:checked + label:after,
.inputbox[type=checkbox]:not(:checked) + label:after,
.add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=checkbox]:not(:checked) + label:after,
.add-scenario-container .add-scenario-body input[type=checkbox]:not(:checked) + label:after {
  content: "";
  display: block;
  position: absolute;
  top: 8px;
  left: 6px;
  width: 3px;
  height: 8px;
  border: solid #2b495e;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.inputbox[type=checkbox]:hover + label, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=checkbox]:hover + label, .add-scenario-container .add-scenario-body input[type=checkbox]:hover + label,
.inputbox[type=checkbox]:focus + label,
.add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=checkbox]:focus + label,
.add-scenario-container .add-scenario-body input[type=checkbox]:focus + label {
  color: #505050;
}

.inputbox[type=checkbox]:hover + label:before, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=checkbox]:hover + label:before, .add-scenario-container .add-scenario-body input[type=checkbox]:hover + label:before,
.inputbox[type=checkbox]:focus + label:before,
.add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=checkbox]:focus + label:before,
.add-scenario-container .add-scenario-body input[type=checkbox]:focus + label:before {
  border: 1px solid #505050;
}

.inputbox[type=checkbox]:disabled:checked + label, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=checkbox]:disabled:checked + label, .add-scenario-container .add-scenario-body input[type=checkbox]:disabled:checked + label,
.inputbox[type=checkbox]:disabled:not(:checked) + label,
.add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=checkbox]:disabled:not(:checked) + label,
.add-scenario-container .add-scenario-body input[type=checkbox]:disabled:not(:checked) + label {
  position: relative;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #cccccc;
  padding: 5px 0 5px 20px;
}

.inputbox[type=checkbox]:disabled:checked + label:before, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=checkbox]:disabled:checked + label:before, .add-scenario-container .add-scenario-body input[type=checkbox]:disabled:checked + label:before,
.inputbox[type=checkbox]:disabled:not(:checked) + label:before,
.add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=checkbox]:disabled:not(:checked) + label:before,
.add-scenario-container .add-scenario-body input[type=checkbox]:disabled:not(:checked) + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 6px;
  width: 14px;
  height: 14px;
  border: 1px solid #cccccc;
  background: #eceef3;
}

.inputbox[type=checkbox]:disabled:checked + label:after, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=checkbox]:disabled:checked + label:after, .add-scenario-container .add-scenario-body input[type=checkbox]:disabled:checked + label:after,
.inputbox[type=checkbox]:disabled:not(:checked) + label:after,
.add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=checkbox]:disabled:not(:checked) + label:after,
.add-scenario-container .add-scenario-body input[type=checkbox]:disabled:not(:checked) + label:after {
  content: "";
  display: block;
  position: absolute;
  top: 8px;
  left: 6px;
  width: 3px;
  height: 8px;
  border: solid #525b6b;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.inputbox[type=checkbox]:not(:checked) + label:after, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=checkbox]:not(:checked) + label:after, .add-scenario-container .add-scenario-body input[type=checkbox]:not(:checked) + label:after {
  opacity: 0;
}

.inputbox[type=checkbox]:checked + label:after, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=checkbox]:checked + label:after, .add-scenario-container .add-scenario-body input[type=checkbox]:checked + label:after {
  opacity: 1;
  border-color: #ffffff;
}

.inputbox[type=checkbox]:checked + label:before, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=checkbox]:checked + label:before, .add-scenario-container .add-scenario-body input[type=checkbox]:checked + label:before {
  border-color: #2b495e;
  border-width: 0;
  height: 16px;
  width: 16px;
  background-color: #2b495e;
}

.inputbox[type=radio]:checked, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=radio]:checked, .add-scenario-container .add-scenario-body input[type=radio]:checked,
.inputbox[type=radio]:not(:checked),
.add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=radio]:not(:checked),
.add-scenario-container .add-scenario-body input[type=radio]:not(:checked) {
  position: absolute;
  left: -9999px;
}

.inputbox[type=radio]:checked + label, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=radio]:checked + label, .add-scenario-container .add-scenario-body input[type=radio]:checked + label,
.inputbox[type=radio]:not(:checked) + label,
.add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=radio]:not(:checked) + label,
.add-scenario-container .add-scenario-body input[type=radio]:not(:checked) + label {
  position: relative;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #505050;
  padding: 5px 0 5px 20px !important;
}

.inputbox[type=radio]:checked + label:before, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=radio]:checked + label:before, .add-scenario-container .add-scenario-body input[type=radio]:checked + label:before,
.inputbox[type=radio]:not(:checked) + label:before,
.add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=radio]:not(:checked) + label:before,
.add-scenario-container .add-scenario-body input[type=radio]:not(:checked) + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 6px;
  width: 14px;
  height: 14px;
  border: 1px solid #ababab;
  border-radius: 100%;
  background: #ffffff;
}

.inputbox[type=radio]:checked + label:after, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=radio]:checked + label:after, .add-scenario-container .add-scenario-body input[type=radio]:checked + label:after,
.inputbox[type=radio]:not(:checked) + label:after,
.add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=radio]:not(:checked) + label:after,
.add-scenario-container .add-scenario-body input[type=radio]:not(:checked) + label:after {
  content: "";
  width: 10px;
  height: 10px;
  background: #2b495e;
  position: absolute;
  top: 9px;
  left: 3px;
  border-radius: 100%;
  transition: all 0.2s ease;
}

.inputbox[type=radio]:focus + label, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=radio]:focus + label, .add-scenario-container .add-scenario-body input[type=radio]:focus + label,
.inputbox[type=radio]:hover + label,
.add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=radio]:hover + label,
.add-scenario-container .add-scenario-body input[type=radio]:hover + label {
  color: #505050;
}

.inputbox[type=radio]:focus + label:before, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=radio]:focus + label:before, .add-scenario-container .add-scenario-body input[type=radio]:focus + label:before,
.inputbox[type=radio]:hover + label:before,
.add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=radio]:hover + label:before,
.add-scenario-container .add-scenario-body input[type=radio]:hover + label:before {
  border: 1px solid #505050;
}

.inputbox[type=radio]:disabled:checked + label, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=radio]:disabled:checked + label, .add-scenario-container .add-scenario-body input[type=radio]:disabled:checked + label,
.inputbox[type=radio]:disabled:not(:checked) + label,
.add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=radio]:disabled:not(:checked) + label,
.add-scenario-container .add-scenario-body input[type=radio]:disabled:not(:checked) + label {
  position: relative;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #505050;
  padding: 5px 0 5px 20px;
}

.inputbox[type=radio]:disabled:checked + label:before, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=radio]:disabled:checked + label:before, .add-scenario-container .add-scenario-body input[type=radio]:disabled:checked + label:before,
.inputbox[type=radio]:disabled:not(:checked) + label:before,
.add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=radio]:disabled:not(:checked) + label:before,
.add-scenario-container .add-scenario-body input[type=radio]:disabled:not(:checked) + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 6px;
  width: 14px;
  height: 14px;
  border: 1px solid #cccccc;
  border-radius: 100%;
  background: #eceef3;
}

.inputbox[type=radio]:disabled:checked + label:after, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=radio]:disabled:checked + label:after, .add-scenario-container .add-scenario-body input[type=radio]:disabled:checked + label:after,
.inputbox[type=radio]:disabled:not(:checked) + label:after,
.add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=radio]:disabled:not(:checked) + label:after,
.add-scenario-container .add-scenario-body input[type=radio]:disabled:not(:checked) + label:after {
  content: "";
  width: 10px;
  height: 10px;
  background: #525b6b;
  position: absolute;
  top: 9px;
  left: 3px;
  border-radius: 100%;
  transition: all 0.2s ease;
}

.inputbox[type=radio]:not(:checked) + label:after, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=radio]:not(:checked) + label:after, .add-scenario-container .add-scenario-body input[type=radio]:not(:checked) + label:after {
  opacity: 0;
  transform: scale(0);
}

.inputbox[type=radio]:checked + label:after, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=radio]:checked + label:after, .add-scenario-container .add-scenario-body input[type=radio]:checked + label:after {
  opacity: 1;
  transform: scale(1);
}

.inputbox[type=radio]:checked + label:before, .add-scenario-container .add-scenario-body .add-scenario-body-second textarea[type=radio]:checked + label:before, .add-scenario-container .add-scenario-body input[type=radio]:checked + label:before {
  border-color: #2b495e;
}

/* Button Group */
ul.button_group {
  margin: 0;
  padding: 0;
  list-style: none;
}
ul.button_group > li {
  float: left;
  margin: 0 !important;
}
ul.button_group > li:first-child button {
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
  background-clip: padding-box;
  display: block;
  margin-left: 0;
}
ul.button_group > li:last-child button {
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  background-clip: padding-box;
  display: block;
}

button.btn_group {
  width: auto;
  background-color: transparent;
  position: relative;
  color: #505050;
  line-height: 20px;
  margin: 0px;
  padding: 4px 10px;
  overflow: visible;
  border-radius: 0px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  -webkit-appearance: none;
  box-sizing: border-box;
  display: inline-block;
  border: 1px solid #505050;
  cursor: pointer;
  min-width: 20px;
  box-sizing: border-box;
  position: relative;
  margin-left: -1px;
  min-width: 60px;
}
button.btn_group:hover, button.btn_group:focus {
  border-color: #72bf44;
  color: #72bf44;
  z-index: 1;
}
button.btn_group.btn_selected {
  border-color: #505050;
  background-color: #505050;
  color: #ffffff;
}
button.btn_group.btn_selected:hover, button.btn_group.btn_selected:focus {
  border-color: #505050;
  background-color: #505050;
  color: #ffffff;
}

button.btn_dropdown {
  border: none;
  text-align: left;
  border-color: #ababab;
}
button.btn_dropdown .btn_text,
button.btn_dropdown .btn_icon_arrow,
button.btn_dropdown .btn_icon,
button.btn_dropdown .pkg_icon,
button.btn_dropdown .pkg_name,
button.btn_dropdown .btn_indicator {
  pointer-events: none;
}
button.btn_dropdown .btn_text span,
button.btn_dropdown .btn_text div,
button.btn_dropdown .btn_icon_arrow span,
button.btn_dropdown .btn_icon_arrow div,
button.btn_dropdown .btn_icon span,
button.btn_dropdown .btn_icon div,
button.btn_dropdown .pkg_icon span,
button.btn_dropdown .pkg_icon div,
button.btn_dropdown .pkg_name span,
button.btn_dropdown .pkg_name div,
button.btn_dropdown .btn_indicator span,
button.btn_dropdown .btn_indicator div {
  pointer-events: none;
}
.dropdown_container {
  position: relative;
  display: inline-block;
}
.dropdown_container.full_width {
  display: block;
}
.dropdown_container.inline {
  display: inline-block;
  margin-left: 10px;
  vertical-align: bottom;
}

/* Dropdown Content (Hidden by Default) */
.dropdown_content {
  display: none;
  min-width: 180px;
  background: #ffffff;
  padding: 0px;
  border-radius: 3px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 1px 20px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  max-height: calc(50vh + 50px);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  position: fixed;
  width: 340px;
  z-index: 1000001;
  color: #505050;
  text-align: left;
}
.dropdown_content.no_scroll_bar {
  max-height: inherit;
}
.dropdown_content.has_padding {
  padding: 10px;
}
.dropdown_content.position_right {
  right: 0;
}
.dropdown_content.full_width {
  left: 0;
  right: 0;
  min-width: inherit;
}
.dropdown_content.min_width {
  min-width: 320px;
}
.dropdown_content .dropdown_content_body {
  padding: 10px;
}
.dropdown_content .dropdown_content_body p:last-of-type {
  margin: 0;
  padding: 0;
}
.dropdown_content .dropdown_footer {
  display: block;
  padding: 10px 10px;
  border-top: 1px solid #dfe0e1;
}
.dropdown_content .dropdown_footer button {
  width: 100%;
}
.dropdown_content .dropdown_footer.align_center {
  text-align: center;
}

/* Show the dropdown menu (use JS to add this class to the .dropdown_content container when the user clicks on the dropdown button) */
.dropdown_content.show {
  display: block;
}

.select-style mat-option {
  font-size: 12px !important;
  min-height: 28px !important; /* or your preferred value */
  height: 28px !important;
  line-height: 28px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.btn_drawer {
  border: none;
  display: block;
  cursor: pointer;
  position: relative;
  line-height: 20px;
  padding: 5px 0 5px 20px;
  width: 100%;
  text-align: left;
  border-radius: 4px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  background-color: transparent;
  color: #505050;
  margin: 0px;
  overflow: visible;
  -webkit-appearance: none;
  box-sizing: border-box;
  border: 0px solid;
  box-sizing: border-box;
}
.btn_drawer .btn_icon {
  transition: all 0.1s ease;
}
.btn_drawer:hover, .btn_drawer:focus {
  color: #51738b;
}
.btn_drawer:hover {
  background-color: #f5f6f7;
}
.btn_drawer.btn_drawer_active {
  color: #505050;
}
.btn_drawer.btn_drawer_active .btn_icon {
  transform: rotate(90deg);
}

.drawer_container {
  /* Drawer Content (Hidden by Default) */
}
.drawer_container .drawer_header {
  position: relative;
  padding-left: 30px;
}
.drawer_container .drawer_header .drawer_header_toggle {
  position: absolute;
  left: 0;
  top: 0;
}
.drawer_container .drawer_header .drawer_header_title .drawer_content {
  margin-left: 30px;
}
.drawer_container .drawer_header .drawer_header_title .drawer_content .tree_link {
  width: 100%;
  display: block;
  box-sizing: border-box;
}
.drawer_container .drawer_header .drawer_header_title a {
  font-weight: 600;
}
.drawer_container .drawer_content {
  display: none;
  position: relative;
}
.drawer_container .drawer_content.drawer_active {
  display: block;
}

.drawer_active {
  font-weight: bold !important;
  color: #72bf44 !important;
}

.margin_r-5 {
  margin-right: 5px;
}

.margin_r-10 {
  margin-right: 10px;
}

.margin_r-15 {
  margin-right: 15px;
}

.margin_r-20 {
  margin-right: 20px;
}

.margin_r-25 {
  margin-right: 25px;
}

.margin_r-30 {
  margin-right: 30px;
}

.margin_l-5 {
  margin-left: 5px;
}

.margin_l-10 {
  margin-left: 10px;
}

.margin_l-15 {
  margin-left: 15px;
}

.margin_l-20 {
  margin-left: 20px;
}

.margin_l-25 {
  margin-left: 25px;
}

.margin_l-30 {
  margin-left: 30px;
}

.margin_t-5 {
  margin-top: 5px;
}

.margin_t-10 {
  margin-top: 10px;
}

.margin_t-15 {
  margin-top: 15px;
}

.margin_t-20 {
  margin-top: 20px;
}

.margin_t-25 {
  margin-top: 25px;
}

.margin_t-30 {
  margin-top: 30px;
}

.margin_b-5 {
  margin-bottom: 5px;
}

.margin_b-10 {
  margin-bottom: 10px;
}

.margin_b-15 {
  margin-bottom: 15px;
}

.margin_b-20 {
  margin-bottom: 20px;
}

.margin_b-25 {
  margin-bottom: 25px;
}

.margin_b-30 {
  margin-bottom: 30px;
}

.margin_5 {
  margin: 5px;
}

.margin_10 {
  margin: 10px;
}

.margin_15 {
  margin: 15px;
}

.margin_20 {
  margin: 20px;
}

.margin_25 {
  margin: 25px;
}

.margin_30 {
  margin: 30px;
}

.margin_h-5 {
  margin-right: 5px;
  margin-left: 5px;
}

.margin_h-10 {
  margin-right: 10px;
  margin-left: 10px;
}

.margin_h-15 {
  margin-right: 15px;
  margin-left: 15px;
}

.margin_h-20 {
  margin-right: 20px;
  margin-left: 20px;
}

.margin_h-25 {
  margin-right: 25px;
  margin-left: 25px;
}

.margin_h-30 {
  margin-right: 30px;
  margin-left: 30px;
}

.margin_v-5 {
  margin-top: 5px;
  margin-bottom: 5px;
}

.margin_v-10 {
  margin-top: 10px;
  margin-bottom: 10px;
}

.margin_v-15 {
  margin-top: 15px;
  margin-bottom: 15px;
}

.margin_v-20 {
  margin-top: 20px;
  margin-bottom: 20px;
}

.margin_v-25 {
  margin-top: 25px;
  margin-bottom: 25px;
}

.margin_v-30 {
  margin-top: 30px;
  margin-bottom: 30px;
}

.padding_r-5 {
  padding-right: 5px;
}

.padding_r-10 {
  padding-right: 10px;
}

.padding_r-15 {
  padding-right: 15px;
}

.padding_r-20 {
  padding-right: 20px;
}

.padding_r-25 {
  padding-right: 25px;
}

.padding_r-30 {
  padding-right: 30px;
}

.padding_l-5 {
  padding-left: 5px;
}

.padding_l-10 {
  padding-left: 10px;
}

.padding_l-15 {
  padding-left: 15px;
}

.padding_l-20 {
  padding-left: 20px;
}

.padding_l-25 {
  padding-left: 25px;
}

.padding_l-30 {
  padding-left: 30px;
}

.padding_t-5 {
  padding-top: 5px;
}

.padding_t-10 {
  padding-top: 10px;
}

.padding_t-15 {
  padding-top: 15px;
}

.padding_t-20 {
  padding-top: 20px;
}

.padding_t-25 {
  padding-top: 25px;
}

.padding_t-30 {
  padding-top: 30px;
}

.padding_b-5 {
  padding-bottom: 5px;
}

.padding_b-10 {
  padding-bottom: 10px;
}

.padding_b-15 {
  padding-bottom: 15px;
}

.padding_b-20 {
  padding-bottom: 20px;
}

.padding_b-25 {
  padding-bottom: 25px;
}

.padding_b-30 {
  padding-bottom: 30px;
}

.padding_5 {
  padding: 5px;
}

.padding_10 {
  padding: 10px;
}

.padding_15 {
  padding: 15px;
}

.padding_20 {
  padding: 20px;
}

.padding_25 {
  padding: 25px;
}

.padding_30 {
  padding: 30px;
}

.padding_h-5 {
  padding-right: 5px;
  padding-left: 5px;
}

.padding_h-10 {
  padding-right: 10px;
  padding-left: 10px;
}

.padding_h-15 {
  padding-right: 15px;
  padding-left: 15px;
}

.padding_h-20 {
  padding-right: 20px;
  padding-left: 20px;
}

.padding_h-25 {
  padding-right: 25px;
  padding-left: 25px;
}

.padding_h-30 {
  padding-right: 30px;
  padding-left: 30px;
}

.padding_v-5 {
  padding-top: 5px;
  padding-bottom: 5px;
}

.padding_v-10 {
  padding-top: 10px;
  padding-bottom: 10px;
}

.padding_v-15 {
  padding-top: 15px;
  padding-bottom: 15px;
}

.padding_v-20 {
  padding-top: 20px;
  padding-bottom: 20px;
}

.padding_v-25 {
  padding-top: 25px;
  padding-bottom: 25px;
}

.padding_v-30 {
  padding-top: 30px;
  padding-bottom: 30px;
}

table.dataTable {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  empty-cells: show;
  background-color: #ffffff;
  box-sizing: border-box;
}
table.dataTable.hidden_header thead {
  position: absolute;
  font-size: 0;
  padding: 0;
  height: 0;
  width: 0;
  display: block;
}
table.dataTable.hidden_header thead tr td, table.dataTable.hidden_header thead tr th {
  font-size: 0 !important;
  padding: 0 !important;
  height: 0 !important;
  width: 0 !important;
  opacity: 0;
  filter: alpha(opacity=0);
}
table.dataTable.hidden_header tbody tr:first-child th, table.dataTable.hidden_header tbody tr:first-child td {
  border-top: 1px solid #dfe0e1;
}
table.dataTable thead tr th, table.dataTable thead tr td {
  text-align: left;
  border-bottom: 1px solid #dfe0e1;
  background-color: #eceef3;
  vertical-align: top;
  padding: 5px;
  line-height: 20px;
  min-height: 20px;
}
table.dataTable thead tr th.col_chbox, table.dataTable thead tr td.col_chbox {
  width: 20px;
  padding: 0 5px !important;
}
table.dataTable thead tr th.col_icon, table.dataTable thead tr td.col_icon {
  width: 20px;
}
table.dataTable thead tr th.col_coldchain, table.dataTable thead tr td.col_coldchain {
  width: 50px;
}
table.dataTable thead tr th [class^=icon_],
table.dataTable thead tr th [class*=" icon_"], table.dataTable thead tr td [class^=icon_],
table.dataTable thead tr td [class*=" icon_"] {
  font-size: 16px;
  display: inline-block;
  vertical-align: text-bottom;
}
table.dataTable thead tr th:empty, table.dataTable thead tr td:empty {
  height: 20px;
}
table.dataTable thead tr th.nowrap, table.dataTable thead tr td.nowrap {
  white-space: nowrap;
}
table.dataTable tbody tr th, table.dataTable tbody tr td {
  border-bottom: 1px solid #dfe0e1;
  vertical-align: top;
  padding: 5px;
  line-height: 20px;
  min-height: 20px;
}
table.dataTable tbody tr th.col_chbox, table.dataTable tbody tr td.col_chbox {
  width: 20px;
  padding: 0 5px !important;
}
table.dataTable tbody tr th.col_icon, table.dataTable tbody tr td.col_icon {
  width: 20px;
}
table.dataTable tbody tr th.col_coldchain, table.dataTable tbody tr td.col_coldchain {
  width: 50px;
}
table.dataTable tbody tr th:empty, table.dataTable tbody tr td:empty {
  height: 20px;
}
table.dataTable tbody tr th.nowrap, table.dataTable tbody tr td.nowrap {
  white-space: nowrap;
}
table.dataTable tbody tr th .table_btn_container, table.dataTable tbody tr td .table_btn_container {
  display: block;
  float: left;
  margin: 0px 0;
  vertical-align: top;
}
table.dataTable tbody tr th .table_btn_container button, table.dataTable tbody tr td .table_btn_container button {
  height: 30px;
  vertical-align: top;
}
table.dataTable tbody tr th [class^=icon_],
table.dataTable tbody tr th [class*=" icon_"], table.dataTable tbody tr td [class^=icon_],
table.dataTable tbody tr td [class*=" icon_"] {
  font-size: 16px;
  display: inline-block;
  vertical-align: text-bottom;
}
table.dataTable tbody tr:hover > td,
table.dataTable tbody tr:hover > th {
  background-color: rgba(81, 115, 139, 0.1);
}
table.dataTable tbody tr.row_swog > th:first-child,
table.dataTable tbody tr.row_swog > td:first-child {
  background-color: #f5f6f7;
}
table.dataTable tbody tr.row_multipiece > th,
table.dataTable tbody tr.row_multipiece > td {
  background-color: #ffffff;
}
table.dataTable tbody tr.selected_row > th,
table.dataTable tbody tr.selected_row > td {
  background-color: rgba(81, 115, 139, 0.2) !important;
}
table.dataTable tbody tr.selected_row > th a,
table.dataTable tbody tr.selected_row > td a {
  color: inherit;
}
table.dataTable tbody tr.row_hidden {
  display: none;
}
table.dataTable tbody tr.row_hidden.row_visible {
  display: table-row;
}
table.dataTable tbody tr.row_visible {
  display: table-row;
}

#table_selection_options {
  float: left;
  display: none;
  margin-left: 10px;
  border-left: 1px solid #cccccc;
  padding-left: 10px;
}

.ui-widget {
  font-family: "Source Sans Pro", Helvetica, sans-serif;
}

.hide_title_bar .ui-dialog-titlebar {
  display: none;
}

.ui-dialog {
  border: 0px solid !important;
  box-shadow: 0 14px 24px rgba(0, 0, 0, 0.14), 0 2px 6px rgba(0, 0, 0, 0.12), 0 2px 15px rgba(0, 0, 0, 0.2);
  padding: 0;
}
.ui-dialog .ui-dialog-content {
  padding: 0;
}
.ui-dialog .ui-dialog-content.maximized {
  width: 100% !important;
  height: calc(100% - 50px) !important;
  top: 50px !important;
  position: absolute !important;
}

.ui-widget-overlay {
  background: rgba(43, 73, 94, 0.3) !important;
  opacity: 1;
  filter: alpha(opacity=100);
}

.ui-widget button {
  font-size: 0.76rem;
}

.dialog_header {
  border-bottom: 0px solid #dfe0e1;
  padding: 15px 15px 0;
}
.dialog_header .dialog_back {
  position: absolute;
  left: 10px;
  top: 10px;
}
.dialog_header .dialog_close {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 1;
  background-color: #ffffff;
}
.dialog_header h1 {
  font-size: 1.2em;
  line-height: 20px;
  font-weight: 400;
  text-align: left;
  color: #2b495e;
}
.dialog_header .dialog_desc {
  text-align: center;
  color: #525b6b;
  margin: 10px 0;
  padding: 0;
}

/* Dialog Content */
.dialog_content {
  padding: 0px;
  box-sizing: border-box;
  /* Dialog Actions */
}
.dialog_content.padding--all {
  padding: 15px;
}
.dialog_content.padding--left {
  padding-left: 15px;
}
.dialog_content.padding--right {
  padding-right: 15px;
}
.dialog_content.padding--top {
  padding-top: 15px;
}
.dialog_content.padding--bottom {
  padding-bottom: 15px;
}
.dialog_content.padding--vertical {
  padding-top: 15px;
  padding-bottom: 15px;
}
.dialog_content.padding--horizontal {
  padding-left: 15px;
  padding-right: 15px;
}
.dialog_content .dialog_content_inner {
  padding: 15px;
  overflow: auto;
  position: relative;
}
.dialog_content .dialog_content_inner.no_padding {
  padding: 0;
}
@media (max-width: 767px) {
  .dialog_content .dialog_content_inner {
    padding: 15px 15px 10px;
  }
}
.dialog_content .dialog_content_inner:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
  visibility: hidden;
}
.dialog_content .dialog_inner_heading_below {
  width: 40%;
  margin-right: auto;
  margin-left: auto;
  margin-top: 1em;
  text-align: center;
}
.dialog_content .dialog_actions {
  padding: 15px;
  border-top: 1px solid #dfe0e1;
}
.dialog_content .dialog_actions.fixed_width {
  min-width: 480px;
  max-width: 480px;
}
@media (max-width: 767px) {
  .dialog_content .dialog_actions.fixed_width {
    min-width: 290px;
    max-width: 290px;
  }
}
.dialog_content .dialog_actions .actions_left {
  float: left;
}
.dialog_content .dialog_actions .actions_left button,
.dialog_content .dialog_actions .actions_left input[type=button] {
  margin-right: 10px;
  float: left;
}
.dialog_content .dialog_actions .actions_left button:last-of-type,
.dialog_content .dialog_actions .actions_left input[type=button]:last-of-type {
  margin-right: 0;
}
.dialog_content .dialog_actions .actions_right {
  float: right;
}
.dialog_content .dialog_actions .actions_right button,
.dialog_content .dialog_actions .actions_right input[type=button] {
  margin-left: 10px;
  float: left;
}
.dialog_content .dialog_actions .actions_right button:first-of-type,
.dialog_content .dialog_actions .actions_right input[type=button]:first-of-type {
  margin-left: 0;
}
.dialog_content .dialog_actions .actions_center {
  float: none;
  text-align: center;
}
.dialog_content .dialog_actions .actions_center button,
.dialog_content .dialog_actions .actions_center input[type=button] {
  margin: 0 5px;
}

/* Dialog Actions */
.dialog_actions {
  padding: 15px;
  position: relative;
}
.dialog_actions:before {
  content: "";
  background-color: rgba(0, 0, 0, 0.1);
  left: 0;
  top: 0;
  right: 0;
  height: 1px;
  position: absolute;
}
.dialog_actions.fixed_width {
  min-width: 480px;
  max-width: 480px;
}
@media (max-width: 767px) {
  .dialog_actions.fixed_width {
    min-width: 290px;
    max-width: 290px;
  }
}
.dialog_actions .actions_left {
  float: left;
}
.dialog_actions .actions_left button,
.dialog_actions .actions_left input[type=button] {
  margin-right: 10px;
  float: left;
}
.dialog_actions .actions_left button:last-of-type,
.dialog_actions .actions_left input[type=button]:last-of-type {
  margin-right: 0;
}
.dialog_actions .actions_right {
  float: right;
}
.dialog_actions .actions_right button,
.dialog_actions .actions_right input[type=button] {
  margin-left: 10px;
  float: left;
}
.dialog_actions .actions_right button:first-of-type,
.dialog_actions .actions_right input[type=button]:first-of-type {
  margin-left: 0;
}
.dialog_actions .actions_center {
  float: none;
  text-align: center;
}
.dialog_actions .actions_center button,
.dialog_actions .actions_center input[type=button] {
  margin: 0 5px;
}

/* Button Group for Adding Order */
.button_group > ul {
  margin: 0;
  padding: 0;
  list-style: none;
  float: left;
  width: 100%;
}
.button_group > ul > li {
  float: left;
  width: 33.3333333333%;
  margin: 0px 0;
}

.modal_footer_total {
  position: relative;
}
.modal_footer_total .modal_footer_total_value {
  line-height: 30px;
  font-size: 1.4rem;
  font-weight: 600;
  top: 0px;
  position: relative;
}

.dialog_tabs {
  position: relative;
}
.dialog_tabs .dialog_close {
  position: absolute;
  z-index: 1;
  right: 10px;
  top: 10px;
}
.dialog_tabs .dialog_close button {
  color: #ffffff;
}

#tab_nav {
  padding: 0px 0px 0;
  position: relative;
}
#tab_nav > ul {
  margin: 0;
  padding: 0;
  list-style: none;
  z-index: 1;
  position: relative;
  overflow: auto;
  white-space: nowrap;
  height: 40px;
}
#tab_nav > ul:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
  visibility: hidden;
}
#tab_nav > ul > li {
  display: block;
  float: left;
  height: 100%;
}

button.btn_tab {
  border-radius: 0;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  background-color: transparent;
  background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.03));
  position: relative;
  color: #ffffff;
  border-bottom: 0px solid #cccccc;
  text-transform: inherit;
  font-size: 1rem;
  font-weight: 400;
  height: 100%;
}
button.btn_tab.btn_text {
  line-height: 0;
}
button.btn_tab:hover, button.btn_tab:focus {
  color: #ffffff;
  background-color: rgba(0, 0, 0, 0.1);
}
button.btn_tab.btn_tab_active {
  background: transparent;
  background-color: #ffffff !important;
  color: #2b495e;
}
button.btn_tab.btn_tab_active:hover, button.btn_tab.btn_tab_active:focus {
  background: transparent;
  background-color: #ffffff !important;
  color: #2b495e;
}
button.btn_tab.btn_tab_active:after {
  display: none;
}

.tab_content {
  display: none;
  padding: 0px;
}
.tab_content.tab_content_active {
  display: block;
}

.panel_container {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  flex-flow: nowrap;
  flex-direction: column;
  height: 100%;
  margin: 0px;
  min-height: 0;
  width: 100%;
  -webkit-justify-content: flex-start;
  -webkit-align-items: stretch;
}
.panel_container .panel_header {
  position: relative;
  padding-bottom: 10px;
}
.panel_container .panel_header.no_padding {
  padding-bottom: 0;
}
.panel_container .panel_header .panel_header_actions {
  position: absolute;
  right: 0;
  top: 0;
}
.panel_container .panel_controls {
  padding-bottom: 10px;
}
.panel_container .panel_content {
  flex: 1;
  overflow: auto;
}
.panel_container .panel_content .panel_content_inner {
  overflow: auto;
}

.toggle_switch_radio[type=radio]:checked,
.toggle_switch_radio[type=radio]:not(:checked) {
  position: absolute;
  left: -9999px;
}

.toggle_switch_radio[type=radio]:checked + label {
  position: relative;
  cursor: pointer;
  line-height: 20px;
  display: block;
  color: #505050;
  background-color: #ffffff;
  padding: 4px 10px 4px 10px !important;
  text-align: center;
  border-radius: 20px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  box-sizing: border-box;
  border: 1px solid #dfe0e1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.toggle_switch_radio[type=radio]:not(:checked) + label {
  position: relative;
  cursor: pointer;
  line-height: 20px;
  display: block;
  color: rgba(80, 80, 80, 0.5);
  padding: 4px 10px 4px 10px !important;
  text-align: center;
  border-radius: 20px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  transition: all 0.3s ease;
  box-sizing: border-box;
  border: 1px solid #eceef3;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.toggle_switch_radio[type=radio]:focus + label,
.toggle_switch_radio[type=radio]:hover + label {
  color: #505050;
}

.toggle_switch_radio[type=radio]:disabled:checked + label {
  position: relative;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #cccccc;
  padding: 4px 0 4px 0px;
}

.toggle_switch_radio[type=radio]:disabled:not(:checked) + label {
  position: relative;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #cccccc;
  padding: 4px 0 4px 0px;
}

.toggle_switch {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
  align-items: stretch;
  -webkit-align-items: stretch;
  width: 100%;
  min-height: 0;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 20px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  box-sizing: border-box;
}
.toggle_switch .toggle_switch_option {
  flex-grow: 1;
}

.dropzone {
  padding-top: 5rem;
  box-sizing: border-box;
  padding: 4.5rem 1rem;
  position: relative;
  border: 3px dashed #dfe0e1;
}
.dropzone .dz-message {
  text-align: center;
}
.dropzone .dz-message .dz_msg_icon {
  color: #2b495e;
}
.dropzone .dz-message .dz_msg_icon span {
  vertical-align: text-bottom;
}
.dropzone .dz-message .dz_msg_instruction {
  color: #2b495e;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 140%;
}
.dropzone .dz-message .dz_msg_helper {
  line-height: 140%;
  margin-bottom: 10px;
}
.dropzone .dz-preview .dz-details {
  text-align: center;
}
.dropzone .dz-preview .dz-details .dz-filename {
  display: inline-block;
}
.dropzone .dz-preview .dz-details .dz-size {
  display: inline-block;
}
.dropzone .dz-preview .dz-details img {
  display: none;
}
.dropzone .dz-preview .dz-success-mark {
  display: inline-block;
  text-align: center;
  display: none;
}
.dropzone .dz-preview .dz-error-mark {
  display: inline-block;
  text-align: center;
  display: none;
}
.dropzone .dz-preview .dz-error-message {
  color: #ea5441;
  line-height: 140%;
  margin-top: 20px;
  text-align: center;
}

[tooltip] {
  position: relative;
}

[tooltip]::before {
  content: "";
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 4px 6px 0 6px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.9) transparent transparent transparent;
  z-index: 100;
  opacity: 0;
  filter: alpha(opacity=0);
}

[tooltip]::after {
  content: attr(tooltip);
  position: absolute;
  left: 50%;
  top: -6px;
  transform: translateX(-50%) translateY(-100%);
  background: rgba(0, 0, 0, 0.9);
  text-align: center;
  color: #ffffff;
  padding: 5px 5px;
  font-size: 0.8rem;
  line-height: 140%;
  min-width: 140px;
  border-radius: 4px;
  pointer-events: none;
  opacity: 0;
  filter: alpha(opacity=0);
  z-index: 101;
}

[tooltip-position=left]::before {
  left: 0%;
  top: 50%;
  margin-left: -12px;
  transform: translatey(-50%) rotate(-90deg);
}

[tooltip-position=top]::before {
  left: 50%;
}

[tooltip-position=bottom]::before {
  top: 100%;
  margin-top: 8px;
  transform: translateX(-50%) translatey(-100%) rotate(-180deg);
}

[tooltip-position=right]::before {
  left: 100%;
  top: 50%;
  margin-left: 1px;
  transform: translatey(-50%) rotate(90deg);
}

[tooltip-position=left]::after {
  left: 0%;
  top: 50%;
  margin-left: -8px;
  transform: translateX(-100%) translateY(-50%);
}

[tooltip-position=top]::after {
  left: 50%;
}

[tooltip-position=bottom]::after {
  top: 100%;
  margin-top: 8px;
  transform: translateX(-50%) translateY(0%);
}

[tooltip-position=right]::after {
  left: 100%;
  top: 50%;
  margin-left: 8px;
  transform: translateX(0%) translateY(-50%);
}

[tooltip]:hover::after,
[tooltip]:hover::before {
  opacity: 1;
  filter: alpha(opacity=100);
}

/*

    HELPERS

*/
.link {
  cursor: pointer;
}

.full-size, .modal-body .component-body .panel-left,
.modal-body .component-body .panel-right, app-account-tree,
app-equation-bar,
app-exogenous-lines-equations,
app-exogenous-lines,
app-hover-notification,
app-import-alm-dataset,
app-input-structure,
app-invalid-rows,
app-liquidity-sources,
app-liquity-equations,
app-lookup-data,
app-lookup-setup,
app-lookup-tree,
app-root,
app-balance-sheet,
app-scenario-list,
app-scenario-table,
app-simulation-set,
app-template,
gc-spread-sheets {
  height: 100%;
  width: 100%;
}

.display-content, app-account-tree,
app-lookup-tree,
app-manage-results {
  display: contents;
}

.page-container,
.fill {
  height: 100%;
  width: 100%;
  display: contents;
}

.bold {
  font-weight: bold;
}

.hidden,
.invisible {
  display: none;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.fixed {
  position: fixed;
}

.flex {
  display: flex;
}

.fill {
  min-height: 100%;
  height: 100%;
}

.border--left {
  border-left: 1px solid #dfe0e1;
}

.border--right {
  border-right: 1px solid #dfe0e1;
}

.border--bottom, .notification-banner-message {
  border-bottom: 1px solid #dfe0e1;
}

.border--top {
  border-top: 1px solid #dfe0e1;
}

.border--all {
  border: 1px solid #dfe0e1;
}

.shadow, .top-inner-shadow:before, .notification-banner-message:before {
  content: "";
  position: relative;
  display: inline-block;
  left: 0;
  width: 100%;
  height: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  z-index: 1000000;
  border: 0;
  overflow: hidden;
}

.top-inner-shadow:before, .notification-banner-message:before {
  top: -11px;
}

#login_container {
  max-width: 400px;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 3px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4), 0 0px 50px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  margin: 40px auto;
}

.product_suite_container {
  text-align: center;
  margin-top: 20px;
}

.product_suit_options {
  max-width: 720px;
  margin: 0 auto;
}

ul#product_suite {
  width: 100%;
  float: left;
  margin: 0;
  padding: 0;
  list-style: none;
}
ul#product_suite > li {
  float: left;
  width: 25%;
  text-align: center;
  padding: 10px;
  box-sizing: border-box;
}
ul#product_suite > li .btn_product {
  display: block;
  text-decoration: none;
  border-radius: 4px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  text-align: center;
  padding: 20px;
  color: inherit;
  width: 160px;
  background-color: #ffffff;
  box-sizing: border-box;
  border-radius: 3px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
}
ul#product_suite > li .btn_product:hover, ul#product_suite > li .btn_product:focus {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 1px 20px rgba(0, 0, 0, 0.3);
}
ul#product_suite > li .btn_product:hover .application_icon, ul#product_suite > li .btn_product:focus .application_icon {
  background-color: #51738b;
  color: #ffffff;
}
ul#product_suite > li .btn_product:hover .application_name, ul#product_suite > li .btn_product:focus .application_name {
  color: #51738b;
}
ul#product_suite > li .btn_product.btn_normal:disabled, ul#product_suite > li .btn_product.success-button:disabled, ul#product_suite > li .notification-banner-message .banner-actions a.btn_product:disabled, .notification-banner-message .banner-actions ul#product_suite > li a.btn_product:disabled,
ul#product_suite > li .notification-banner-message .banner-actions .btn_product.link:disabled,
.notification-banner-message .banner-actions ul#product_suite > li .btn_product.link:disabled,
ul#product_suite > li .notification-banner-message .banner-actions .btn_product.banner-action-button:disabled,
.notification-banner-message .banner-actions ul#product_suite > li .btn_product.banner-action-button:disabled,
ul#product_suite > li .notification-banner-message .banner-actions button.btn_product:disabled,
.notification-banner-message .banner-actions ul#product_suite > li button.btn_product:disabled {
  background-color: #f5f6f7 !important;
  opacity: 1;
  filter: alpha(opacity=100);
  box-shadow: none !important;
}
ul#product_suite > li .btn_product.btn_normal:disabled:hover, ul#product_suite > li .btn_product.success-button:disabled:hover, ul#product_suite > li .notification-banner-message .banner-actions a.btn_product:disabled:hover, .notification-banner-message .banner-actions ul#product_suite > li a.btn_product:disabled:hover,
ul#product_suite > li .notification-banner-message .banner-actions .btn_product.link:disabled:hover,
.notification-banner-message .banner-actions ul#product_suite > li .btn_product.link:disabled:hover,
ul#product_suite > li .notification-banner-message .banner-actions .btn_product.banner-action-button:disabled:hover,
.notification-banner-message .banner-actions ul#product_suite > li .btn_product.banner-action-button:disabled:hover,
ul#product_suite > li .notification-banner-message .banner-actions button.btn_product:disabled:hover,
.notification-banner-message .banner-actions ul#product_suite > li button.btn_product:disabled:hover, ul#product_suite > li .btn_product.btn_normal:disabled:focus, ul#product_suite > li .btn_product.success-button:disabled:focus, ul#product_suite > li .notification-banner-message .banner-actions a.btn_product:disabled:focus, .notification-banner-message .banner-actions ul#product_suite > li a.btn_product:disabled:focus,
ul#product_suite > li .notification-banner-message .banner-actions .btn_product.link:disabled:focus,
.notification-banner-message .banner-actions ul#product_suite > li .btn_product.link:disabled:focus,
ul#product_suite > li .notification-banner-message .banner-actions .btn_product.banner-action-button:disabled:focus,
.notification-banner-message .banner-actions ul#product_suite > li .btn_product.banner-action-button:disabled:focus,
ul#product_suite > li .notification-banner-message .banner-actions button.btn_product:disabled:focus,
.notification-banner-message .banner-actions ul#product_suite > li button.btn_product:disabled:focus {
  background-color: #f5f6f7 !important;
  opacity: 1;
  filter: alpha(opacity=100);
  box-shadow: none !important;
}
ul#product_suite > li .btn_product.btn_normal:disabled:hover .application_icon, ul#product_suite > li .btn_product.success-button:disabled:hover .application_icon, ul#product_suite > li .notification-banner-message .banner-actions a.btn_product:disabled:hover .application_icon, .notification-banner-message .banner-actions ul#product_suite > li a.btn_product:disabled:hover .application_icon,
ul#product_suite > li .notification-banner-message .banner-actions .btn_product.link:disabled:hover .application_icon,
.notification-banner-message .banner-actions ul#product_suite > li .btn_product.link:disabled:hover .application_icon,
ul#product_suite > li .notification-banner-message .banner-actions .btn_product.banner-action-button:disabled:hover .application_icon,
.notification-banner-message .banner-actions ul#product_suite > li .btn_product.banner-action-button:disabled:hover .application_icon,
ul#product_suite > li .notification-banner-message .banner-actions button.btn_product:disabled:hover .application_icon,
.notification-banner-message .banner-actions ul#product_suite > li button.btn_product:disabled:hover .application_icon, ul#product_suite > li .btn_product.btn_normal:disabled:focus .application_icon, ul#product_suite > li .btn_product.success-button:disabled:focus .application_icon, ul#product_suite > li .notification-banner-message .banner-actions a.btn_product:disabled:focus .application_icon, .notification-banner-message .banner-actions ul#product_suite > li a.btn_product:disabled:focus .application_icon,
ul#product_suite > li .notification-banner-message .banner-actions .btn_product.link:disabled:focus .application_icon,
.notification-banner-message .banner-actions ul#product_suite > li .btn_product.link:disabled:focus .application_icon,
ul#product_suite > li .notification-banner-message .banner-actions .btn_product.banner-action-button:disabled:focus .application_icon,
.notification-banner-message .banner-actions ul#product_suite > li .btn_product.banner-action-button:disabled:focus .application_icon,
ul#product_suite > li .notification-banner-message .banner-actions button.btn_product:disabled:focus .application_icon,
.notification-banner-message .banner-actions ul#product_suite > li button.btn_product:disabled:focus .application_icon {
  background-color: rgba(0, 0, 0, 0.05);
  color: inherit;
}
ul#product_suite > li .btn_product.btn_normal:disabled:hover .application_name, ul#product_suite > li .btn_product.success-button:disabled:hover .application_name, ul#product_suite > li .notification-banner-message .banner-actions a.btn_product:disabled:hover .application_name, .notification-banner-message .banner-actions ul#product_suite > li a.btn_product:disabled:hover .application_name,
ul#product_suite > li .notification-banner-message .banner-actions .btn_product.link:disabled:hover .application_name,
.notification-banner-message .banner-actions ul#product_suite > li .btn_product.link:disabled:hover .application_name,
ul#product_suite > li .notification-banner-message .banner-actions .btn_product.banner-action-button:disabled:hover .application_name,
.notification-banner-message .banner-actions ul#product_suite > li .btn_product.banner-action-button:disabled:hover .application_name,
ul#product_suite > li .notification-banner-message .banner-actions button.btn_product:disabled:hover .application_name,
.notification-banner-message .banner-actions ul#product_suite > li button.btn_product:disabled:hover .application_name, ul#product_suite > li .btn_product.btn_normal:disabled:focus .application_name, ul#product_suite > li .btn_product.success-button:disabled:focus .application_name, ul#product_suite > li .notification-banner-message .banner-actions a.btn_product:disabled:focus .application_name, .notification-banner-message .banner-actions ul#product_suite > li a.btn_product:disabled:focus .application_name,
ul#product_suite > li .notification-banner-message .banner-actions .btn_product.link:disabled:focus .application_name,
.notification-banner-message .banner-actions ul#product_suite > li .btn_product.link:disabled:focus .application_name,
ul#product_suite > li .notification-banner-message .banner-actions .btn_product.banner-action-button:disabled:focus .application_name,
.notification-banner-message .banner-actions ul#product_suite > li .btn_product.banner-action-button:disabled:focus .application_name,
ul#product_suite > li .notification-banner-message .banner-actions button.btn_product:disabled:focus .application_name,
.notification-banner-message .banner-actions ul#product_suite > li button.btn_product:disabled:focus .application_name {
  color: inherit;
}
ul#product_suite > li .btn_product .application_icon {
  display: block;
  padding: 10px;
  border-radius: 50px;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
  background-color: rgba(0, 0, 0, 0.05);
  width: 50px;
  box-sizing: border-box;
  margin: 0 auto 10px;
}
ul#product_suite > li .btn_product .application_icon span {
  line-height: 30px;
  width: 30px;
  text-align: center;
  font-size: 24px;
  display: block;
  vertical-align: top;
}
ul#product_suite > li .btn_product .application_name {
  text-align: center;
  display: block;
  line-height: 15px;
  min-height: 30px;
  font-size: 0.8rem;
}

[data-simplebar] {
  position: relative;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
  width: inherit;
  height: inherit;
  max-width: inherit;
  max-height: inherit;
}

.simplebar-wrapper {
  overflow: hidden;
  width: inherit;
  height: inherit;
  max-width: inherit;
  max-height: inherit;
}

.simplebar-mask {
  direction: inherit;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: auto !important;
  height: auto !important;
  z-index: 0;
}

.simplebar-offset {
  direction: inherit !important;
  box-sizing: inherit !important;
  resize: none !important;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch;
}

.simplebar-content {
  direction: inherit;
  box-sizing: border-box !important;
  position: relative;
  display: block;
  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */
  width: auto;
  visibility: visible;
  max-width: 100%; /* Not required for horizontal scroll to trigger */
  max-height: 100%; /* Needed for vertical scroll to trigger */
}

.simplebar-placeholder {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  pointer-events: none;
}

.simplebar-height-auto-observer-wrapper {
  box-sizing: inherit !important;
  height: 100%;
  width: inherit;
  max-width: 1px;
  position: relative;
  float: left;
  max-height: 1px;
  overflow: hidden;
  z-index: -1;
  padding: 0;
  margin: 0;
  pointer-events: none;
  flex-grow: inherit;
  flex-shrink: 0;
  flex-basis: 0;
}

.simplebar-height-auto-observer {
  box-sizing: inherit;
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 1000%;
  width: 1000%;
  min-height: 1px;
  min-width: 1px;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}

.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.simplebar-scrollbar {
  position: absolute;
  right: 2px;
  width: 7px;
  min-height: 10px;
}

.simplebar-scrollbar:before {
  position: absolute;
  content: "";
  background: #000000;
  border-radius: 7px;
  left: 0;
  right: 0;
  opacity: 0;
  transition: opacity 0.2s linear;
}

.simplebar-track .simplebar-scrollbar.simplebar-visible:before {
  /* When hovered, remove all transitions from drag handle */
  opacity: 0.5;
  transition: opacity 0s linear;
}

.simplebar-track.simplebar-vertical {
  top: 0;
  width: 11px;
}

.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
  top: 2px;
  bottom: 2px;
}

.simplebar-track.simplebar-horizontal {
  left: 0;
  height: 11px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {
  height: 100%;
  left: 2px;
  right: 2px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar {
  right: auto;
  left: 0;
  top: 8px;
  height: 3px;
  min-height: 0;
  min-width: 10px;
  width: auto;
}

/* Rtl support */
[data-simplebar-direction=rtl] .simplebar-track.simplebar-vertical {
  right: auto;
  left: 0;
}

.hs-dummy-scrollbar-size {
  direction: rtl;
  position: fixed;
  opacity: 0;
  visibility: hidden;
  height: 500px;
  width: 500px;
  overflow-y: hidden;
  overflow-x: scroll;
}

.add-scenario-container {
  padding: 1rem;
  border-radius: 4px;
  display: grid;
  grid-template-rows: auto 1fr;
  grid-gap: 0;
  overflow: hidden;
}
.add-scenario-container .add-scenario-body {
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-gap: 1rem;
}
.add-scenario-container .add-scenario-body .add-scenario-body-first {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  grid-gap: 1rem;
}
.add-scenario-container .add-scenario-body .add-scenario-body-second {
  display: grid;
  grid-template-columns: 1fr;
}
.add-scenario-container .add-scenario-body .add-scenario-body-third {
  padding: 0 !important;
  margin: 0 !important;
  display: grid;
  grid-template-columns: repeat(2, auto);
  grid-gap: 1rem;
  justify-content: end;
}`, "",{"version":3,"sources":["webpack://./src/app/styles/base/_variables.scss","webpack://./src/app/styles/base/_common.scss","webpack://./src/app/components/model-structure/scenarios/add-scenario-dialog/add-scenario-dialog.scss","webpack://./src/app/styles/base/_mixins.scss","webpack://./src/app/styles/base/_global.scss","webpack://./src/app/styles/base/_layout.scss","webpack://./src/app/styles/base/_buttons.scss","webpack://./src/app/styles/base/_forms.scss","webpack://./src/app/styles/base/_typography.scss","webpack://./src/app/styles/base/structure/_header.scss","webpack://./src/app/styles/base/structure/_header_alt.scss","webpack://./src/app/styles/base/structure/_footer.scss","webpack://./src/app/styles/base/structure/_columns.scss","webpack://./src/app/styles/base/structure/_flexgrid.scss","webpack://./src/app/styles/base/common/_animations.scss","webpack://./src/app/styles/base/structure/_modal_schema.scss","webpack://./src/app/styles/base/modules/_component_selectors.scss","webpack://./src/app/styles/base/modules/_modal_simulation.scss","webpack://./src/app/styles/base/modules/_modal_balance_sheet_structure.scss","webpack://./src/app/styles/base/modules/_sim_setup.scss","webpack://./src/app/styles/base/modules/_sim_assumptions.scss","webpack://./src/app/styles/base/modules/_footer_bar.scss","webpack://./src/app/styles/base/modules/_context_bar.scss","webpack://./src/app/styles/base/modules/_sheet_quicklinks.scss","webpack://./src/app/styles/base/modules/_notifications.scss","webpack://./src/app/styles/base/modules/_hover_notification.scss","webpack://./src/app/styles/base/modules/_multi_notification.scss","webpack://./src/app/styles/base/modules/_application_list.scss","webpack://./src/app/styles/base/modules/_notification-banner.scss","webpack://./src/app/styles/base/modules/_spreadsheet.scss","webpack://./src/app/styles/base/common/_inputs.scss","webpack://./src/app/styles/base/common/_checkbox.scss","webpack://./src/app/styles/base/common/_radio.scss","webpack://./src/app/styles/base/common/_button_group.scss","webpack://./src/app/styles/base/common/_dropdown.scss","webpack://./src/app/styles/base/common/_drawers.scss","webpack://./src/app/styles/base/common/_spacing.scss","webpack://./src/app/styles/base/common/_table_grid.scss","webpack://./src/app/styles/base/common/_modals.scss","webpack://./src/app/styles/base/common/_tabs.scss","webpack://./src/app/styles/base/common/_panel.scss","webpack://./src/app/styles/base/common/_toggle_switch.scss","webpack://./src/app/styles/base/common/_file_upload.scss","webpack://./src/app/styles/base/common/_tooltip.scss","webpack://./src/app/styles/base/common/_helpers.scss","webpack://./src/app/styles/base/pages/_login.scss","webpack://./src/app/styles/base/pages/_product_suite.scss","webpack://./src/app/styles/base/vendor/simplebar/_simplebar.scss"],"names":[],"mappings":"AAEA,4BAAA;AAOA,2BAAA;AAkBA,8BAAA;AAgDA,4BAAA;AAEA,4BAAA;AAGA,6BAAA;AAWA,uBAAA;AAgBA,uBAAA;AAEA,+BAAA;AC7GA;EACE,kCAAA;EACA,eAAA;EACA,kCAAA;ACUF;;ADNA;EACE,kBDMU;ECLV,qDDIU;ECHV,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,UAAA;ACSF;ADPE;EACE,YAAA;EACA,gBAAA;ACSJ;;ADLA;;EAEE,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;ACQF;;ADLA;;;;;EAKE,WAAA;EACA,YAAA;ACQF;;ADLA;EACE,qBAAA;ACQF;;ADLA;;EAEE,cDCK;ECAL,6CAAA;ACQF;;ADLA;EACE,cDtBc;AE8BhB;;ADLA;EACE,SAAA;EACA,UAAA;EACA,oBAAA;EACA,iBAAA;ACQF;;ADLA;EACE,aAAA;ACQF;;ADLA;EACE,WAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;ACQF;;ADLA;EACE,iCAAA,EAAA,wBAAA;EACA,cAAA;ACQF;;ADLA;EACE,6BAAA;EACA,uBAAA;ACQF;;ADLA;EACE,4BAAA;ACQF;;ADLA;EACE,6BAAA;ACQF;;ADLA;EACE,YAAA;EACA,cAAA;ACQF;ADNE;EACE,gBAAA;EACA,mBAAA;ACQJ;;ADJA;EACE,oCAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;ACOF;ADLE;EACE,gBAAA;EACA,mBAAA;ACOJ;;ADHA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;ACMF;;ADFA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;ACKF;ADHE;EACE,cDhFI;AEqFR;ADFE;EACE,cDrFE;AEyFN;;ADAA;EACE,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;ACGF;ADDE;EACE,cDhGI;AEmGR;ADAE;EACE,cDrGE;AEuGN;;ADEA;EACE,kBAAA;ACCF;;ADEA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;ACCF;;ADCA;EACE,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,qDAAA;EACA,6CAAA;ACEF;;ADAA;EACE;IACE,uBAAA;ECGF;EDDA;IACE,yBAAA;ECGF;AACF;ADCA;EACE,6BAAA;ACCF;;ADEA;EAEE,cAAA;EACA,kBAAA;EACA,eAAA;ACAF;AC3CE;EACE,gBHhDW;EGiDX,6BAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;AD6CJ;ADTE;EACE,gEAAA;EEtDF,yBAImB;ADkErB;;ADXA;EACE,qBAAA;EACA,iBAAA;EAEA,mDAAA;ACcF;;ADXA;;;;EAAA;AAeA;EACE;IAEE,oBAAA;ECcF;EDZA;IAEE,yBAAA;ECcF;AACF;AEpPA;;CAAA;ACAA;EACE,aAAA;EACA,gBAAA;AHyPF;;AGtPA;EAGE,WAAA;EACA,cAAA;AHuPF;AGtPE;EACE,gBAAA;AHwPJ;;AGpPA;EACE,aAAA;EACA,sBAAA;EAEA,YAAA;EACA,2BAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,4BAAA;EACA,WAAA;EACA,aAAA;AHuPF;AGrPE;EACE,kBAAA;EFmFF,sBEjFsB;AHwPxB;AGrPE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EFuEF,sBEtEsB;EACpB,cAAA;AHyPJ;AGtPI;EACE,gBL8CU;EK7CV,eAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,4BAAA;EACA,6BAAA;EACA,gBAAA;EACA,WAAA;AHwPN;AGpPM;EACE,aAAA;AHsPR;AGlPI;EAEE,YAAA;AHmPN;AGjPM;EACE,2BAAA;EACA,kBAAA;EAEA,aAAA;EACA,sBAAA;EAEA,2BAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,4BAAA;EACA,WAAA;EACA,aAAA;AHkPR;AG7OQ;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;AH+OV;AGtOE;EFYA,sBEXsB;EACpB,kBAAA;AH0OJ;;AIhVA;EACE,eAAA;AJmVF;;AIhVA;;;;EAGE,eAAA;EACA,gEAAA;EACA,6CAAA;AJoVF;;AIjVA;;;;EACE,WAAA;EACA,6BAAA;EACA,kBAAA;EACA,cNLW;EMMX,iBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EHVA,kBGWuB;EHVvB,4BAAA,EAAA,oDAAA;EGWA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EHrBA,yBGsBA;EACA,eAAA;EHoFA,sBGnFoB;EACpB,yBAAA;EACA,gBAAA;EACA,kBAAA;AJ+VF;AI7VE;;;;;;;EAEE,cNUG;AE0VP;AI9VE;;;;EACE,yBAAA;EACA,0BAAA;EACA,qDAAA;EACA,4BAAA;EACA,iBAAA;AJmWJ;AIjWI;;;;;;;EAEE,gCAAA;EACA,qDAAA;EACA,yBAAA;AJwWN;AIpWE;;;;EACE,yBNuBa;EMtBb,cNwBgB;AEiVpB;AIvWI;;;;;;;EAEE,yBNmBiB;EMlBjB,cNoBoB;AE0V1B;AI3WI;;;;EACE,yBAAA;EACA,0BAAA;EACA,qDAAA;AJgXN;AI9WM;;;;;;;EAEE,qDAAA;EACA,yBAAA;AJqXR;AIhXE;;;;EACE,yBNKe;EMJf,cNMkB;AE+WtB;AInXI;;;;;;;EAEE,yBNCmB;EMAnB,cNEsB;AEwX5B;AIvXI;;;;EACE,yBAAA;EACA,0BAAA;EACA,qDAAA;AJ4XN;AI1XM;;;;;;;EAEE,qDAAA;EACA,yBAAA;AJiYR;AI5XE;;;;EACE,6BAAA;EACA,cNzEI;AE0cR;AI/XI;;;;;;;EAEE,0CAAA;EACA,cN9EE;AEodR;AInYI;;;;EACE,yBAAA;EACA,0BAAA;EACA,qDAAA;AJwYN;AItYM;;;;;;;EAEE,qDAAA;EACA,yBAAA;AJ6YR;AIxYE;;;;EACE,yBNzDW;EM0DX,cNhGI;AE6eR;AI3YI;;;;;;;EAEE,yBAAA;EACA,cNrGE;AEufR;AI/YI;;;;EACE,yBAAA;EACA,0BAAA;EACA,qDAAA;AJoZN;AIlZM;;;;;;;EAEE,qDAAA;EACA,yBAAA;AJyZR;AIpZE;;;;EACE,6BAAA;EACA,cNvHI;EMwHJ,gBAAA;EACA,yBAAA;EHpJF,uBGqJE;AJ6ZJ;AI3ZI;;;;;;;EAEE,yBN9HE;EM+HF,cNpJO;EMqJP,yBAAA;EACA,iBAAA;AJkaN;AI/ZI;;;;EACE,iBAAA;AJoaN;AIjaI;;;;EACE,yBAAA;EACA,0BAAA;EACA,qDAAA;EACA,4BAAA;EACA,iBAAA;AJsaN;AIpaM;;;;;;;EAEE,gCAAA;EACA,qDAAA;EACA,yBAAA;AJ2aR;AItaE;;;;EACE,6BAAA;EACA,cN3IG;EM4IH,gBAAA;EACA,yBAAA;EHvLF,uBGwLE;AJ+aJ;AI7aI;;;;;;;EAEE,yBNlJC;EMmJD,cNlKE;EMmKF,yBAAA;EACA,iBAAA;AJobN;AIjbI;;;;EACE,yBAAA;EACA,0BAAA;EACA,qDAAA;EACA,4BAAA;EACA,iBAAA;AJsbN;AIpbM;;;;;;;EAEE,gCAAA;EACA,qDAAA;EACA,yBAAA;AJ2bR;AItbM;;;;EACE,6BAAA;EACA,cN1KD;EM2KC,gBAAA;EACA,yBAAA;AJ2bR;AItbE;;;;EACE,6BAAA;EACA,cNhLI;EMiLJ,gBAAA;EACA,yBAAA;EH/NF,uBGgOE;AJ+bJ;AI7bI;;;;;;;EAEE,yBNvLE;EMwLF,cN1ME;EM2MF,yBAAA;EACA,iBAAA;AJocN;AIjcI;;;;EACE,yBAAA;EACA,0BAAA;EACA,qDAAA;EACA,4BAAA;EACA,iBAAA;AJscN;AIpcM;;;;;;;EAEE,gCAAA;EACA,qDAAA;EACA,yBAAA;AJ2cR;AItcE;;;;EACE,6BAAA;EACA,cNlNG;EMmNH,gBAAA;EACA,yBAAA;EH9PF,uBG+PE;AJ+cJ;AI7cI;;;;;;;EAEE,6BAAA;EACA,cNvNE;EMwNF,yBAAA;EACA,gBAAA;AJodN;AIjdI;;;;EACE,yBAAA;EACA,0BAAA;EACA,mDAAA;EACA,4BAAA;EACA,gBAAA;AJsdN;AIpdM;;;;;;;EAEE,gCAAA;EACA,mDAAA;EACA,yBAAA;AJ2dR;AItdE;;;;EACE,gBAAA;AJ2dJ;AIzdI;;;;EACE,gBAAA;AJ8dN;AIxdQ;;;;;;;;;;EACE,eAAA;AJmeV;AI9dI;;;;;;;;;;EAEE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,2BAAA;AJweN;AIteM;;;;;;;;;;EACE,cAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;AJifR;AI5eE;;;;EACE,gBAAA;AJifJ;AI/eI;;;;EACE,gBAAA;AJofN;AIjfI;;;;;;;;;;EAEE,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AJ2fN;AIvfE;;;;EACE,gBAAA;AJ4fJ;AIzfE;;;;EACE,gBAAA;EACA,yBAAA;EACA,gBAAA;AJ8fJ;AI3fE;;;;EACE,yBAAA;EHnVF,kBGoVyB;EHnVzB,4BAAA,EAAA,oDAAA;EAkCA,+BGkT+B;EHhT/B,4BGgT+B;EH/S/B,4BAAA;EGgTE,YAAA;EACA,yBNjUI;AEu0BR;AIpgBI;;;;;;;EAEE,cNxUU;EMyUV,qBNzUU;AEo1BhB;AIvgBE;;;;EACE,0BAAA;EACA,gBAAA;EACA,mBAAA;AJ4gBJ;AIzgBE;;;;EACE,gBAAA;AJ8gBJ;AI5gBI;;;;EACE,cAAA;AJihBN;AI7gBE;;;;EACE,gBAAA;AJkhBJ;AIhhBI;;;;EACE,iBAAA;AJqhBN;AIjhBE;;;;EACE,cAAA;AJshBJ;AInhBE;;;;EACE,qBAAA;EACA,WAAA;AJwhBJ;AIrhBE;;;;EACE,gBAAA;EACA,mBAAA;AJ0hBJ;AIvhBE;;;;EACE,aAAA;AJ4hBJ;AIzhBE;;;;EACE,iBAAA;EACA,qBAAA;AJ8hBJ;AI5hBI;;;;EACE,kBAAA;EACA,uBAAA;AJiiBN;AI7hBE;;;;;;;;;;EAEE,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,2BAAA;EACA,cAAA;EACA,iBAAA;AJuiBJ;AIriBI;;;;;;;;;;EACE,eAAA;EACA,cAAA;AJgjBN;AI5iBM;;;;;;;;;;EACE,eAAA;AJujBR;AIjjBI;;;;EACE,cNlYA;AEw7BN;AIljBE;;;;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;AJujBJ;AIrjBI;;;;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AJ0jBN;AItjBE;;;;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;AJ2jBJ;AIzjBI;;;;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AJ8jBN;;AIzjBA;EACE,UAAA;EACA,SAAA;AJ4jBF;;AIxjBE;EACE,WAAA;EACA,YAAA;EACA,kCAAA;EH/cF,0BGgdyB;EH/czB,4BAAA,EAAA,oDAAA;AD4gCF;AI3jBI;EACE,YAAA;AJ6jBN;AI1jBI;EACE,YAAA;EACA,oCAAA;AJ4jBN;AI1jBM;EAEE,oCAAA;AJ2jBR;AIxjBM;EACE,yBAAA;EACA,0BAAA;EACA,oCAAA;EACA,gCAAA;AJ0jBR;AIxjBQ;EAEE,gCAAA;EACA,oCAAA;EACA,yBAAA;AJyjBV;AInjBE;EACE,WAAA;EACA,YAAA;EHjfF,0BGkfyB;EHjfzB,4BAAA,EAAA,oDAAA;ADwiCF;AIrjBI;EACE,YAAA;AJujBN;AIpjBI;EACE,YAAA;EACA,oCAAA;AJsjBN;AIpjBM;EAEE,oCAAA;AJqjBR;AIljBM;EACE,yBAAA;EACA,0BAAA;EACA,oCAAA;EACA,gCAAA;AJojBR;AIljBQ;EAEE,gCAAA;EACA,oCAAA;EACA,yBAAA;AJmjBV;;AKtkCA;EACC,kBAAA;EACA,kBAAA;ALykCD;AKvkCC;EACC,gBAAA;ALykCF;AKtkCC;EACC,kBAAA;ALwkCF;AKtkCE;EACC,UAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;ALwkCH;AKrkCE;EACC,UAAA;EACA,gBAAA;ALukCH;AKpkCE;EACC,qBAAA;ALskCH;AKpkCG;EACC,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;ALskCJ;AKnkCG;EACC,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;ALqkCJ;AKhkCG;EACC,WAAA;EACA,UAAA;ALkkCJ;AK9jCG;EACC,WAAA;EACA,UAAA;ALgkCJ;AKvjCG;EACC,WAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;ALyjCJ;AKvjCI;EACC,eAAA;ALyjCL;AKhjCI;EACC,UAAA;EACA,WAAA;ALkjCL;AKhjCK;EACC,cAAA;ALkjCN;AK7iCG;EACC,WAAA;EACA,cAAA;AL+iCJ;AKxiCC;EACC,gBAAA;AL0iCF;;AKriCA;EACC,kBAAA;EACA,kBAAA;ALwiCD;AKtiCC;EACI,WAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;ALwiCL;AKriCC;EACC,gBAAA;ALuiCF;AKpiCC;EACC,kBAAA;ALsiCF;AKniCC;EACC,iBAAA;ALqiCF;AKliCC;EACC,iBAAA;ALoiCF;AKhiCE;EACC,WAAA;EACA,UAAA;ALkiCH;AK/hCE;EACC,WAAA;EACA,UAAA;ALiiCH;AK7hCG;EACC,WAAA;EACA,UAAA;AL+hCJ;AK5hCG;EACC,WAAA;EACA,UAAA;AL8hCJ;AKzhCC;EACC,cAAA;AL2hCF;AKzhCE;EACC,kBAAA;EACA,YAAA;EJ3ED,UI4EmB;EJ1EnB,wBAAA;ADsmCF;AK1hCG;EACC,UAAA;AL4hCJ;AKxhCE;EACC,iBAAA;EACA,sBAAA;EACA,cAAA;AL0hCH;AKxhCG;EACC,YAAA;AL0hCJ;AKphCC;EACC,cAAA;ALshCF;AK/gCE;EACC,kBAAA;ALihCH;AK7gCG;EACC,8BAAA;AL+gCJ;AK1gCE;EACC,kBAAA;AL4gCH;AK1gCG;EACC,8BAAA;AL4gCJ;AKzgCG;EACC,kBAAA;EACA,QAAA;EACA,MAAA;AL2gCJ;AKtgCE;EACC,kBAAA;EACA,mBAAA;EJxGD,sBIyGqB;AL0gCvB;AKvgCG;EACC,kBAAA;EACA,iBAAA;EACA,QAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;ALygCJ;AKrgCE;EACC,gBAAA;EACA,qBAAA;ALugCH;AKngCC;EACC,cAAA;EACA,cP7LI;EO8LJ,iBAAA;EACA,cAAA;ALqgCF;AKlgCC;EACC,qBAAA;ALogCF;;AK9/BA;EACC,aAAA;EACA,oBAAA;EAEA,WAAA;EACA,2BAAA;EACA,eAAA;EACA,uBAAA;EACA,eAAA;ALigCD;AK//BC;EACC,yBAAA;ALigCF;AK9/BC;EACC,aAAA;ALggCF;AK7/BC;EACC,iBAAA;EACA,yBAAA;AL+/BF;AK1/BE;EACI,WAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;AL4/BN;AKz/BE;EACC,WAAA;AL2/BH;AKx/BE;EACC,WAAA;AL0/BH;AKv/BE;EACC,YAAA;EACA,cAAA;EACA,sBAAA;ALy/BH;AKr/BC;EACC,iBAAA;ALu/BF;;AKn/BA;EACC,iBAAA;EACA,cAAA;EACA,cAAA;ALs/BD;;AKn/BA;EACC,iBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,cPjRU;AEuwCX;;AKl/BA,cAAA;AAEA;EACC,cAAA;EACA,kBAAA;EACA,kBAAA;ALo/BD;AKl/BC;EACI,WAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;ALo/BL;AKj/BC;EACC,gBAAA;ALm/BF;AK/+BE;EACC,WAAA;EACA,UAAA;ALi/BH;AK7+BE;EACC,WAAA;EACA,UAAA;AL++BH;AK1+BG;EACC,WAAA;EACA,UAAA;AL4+BJ;AKx+BG;EACC,WAAA;EACA,UAAA;AL0+BJ;AKp+BC;EACC,cAAA;EACA,iBAAA;EACA,cAAA;EJhQA,sBIiQoB;ALw+BtB;AKt+BE;EACC,kBAAA;EACA,YAAA;EJhSD,UIiSmB;EJ/RnB,wBAAA;ADwwCF;AKl+BC;EACC,cAAA;EACA,iBAAA;EACA,cAAA;EJhRA,sBIiRoB;ALs+BtB;AKl+BE;EACC,cAAA;ALo+BH;AKj+BE;EACC,cAAA;ALm+BH;;AM72CA;EACC,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;ANg3CD;AM92CC;EACC,qBAAA;ANg3CF;;AM52CA;EACC,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AN+2CD;;AM52CA;EACC,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACC,cRwBK;EQvBL,0BAAA;AN+2CF;;AM52CA;EACC,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AN+2CD;;AM32CA;EACC,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;AN82CD;;AOt5CA;EACE,yBT8CK;ES7CL,cT8BM;AE23CR;AOv5CE;EACE,aAAA;EN2GF,sBM1GsB;AP25CxB;AOz5CI;EACE,WAAA;AP25CN;AO15CM;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;AP45CR;AO15CQ;EACE,WAAA;AP45CV;AO15CU;EACE,cAAA;EACA,cTYJ;ESXI,qBAAA;EACA,iBAAA;EACA,eAAA;AP45CZ;AOx5CQ;EACE,WAAA;EACA,iBAAA;AP05CV;AOx5CU;EACE,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,cTHJ;AE65CR;AOr5CM;EACE,WAAA;APu5CR;AOr5CQ;EACE,iBAAA;EACA,WAAA;APu5CV;AOp5CQ;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;ENiCR,YMhCyB;ENkCzB,yBAAA;ADq3CF;AOl5CI;EACE,YAAA;APo5CN;AOl5CM;EACE,WAAA;EACA,kBAAA;APo5CR;AOj5CM;EACE,WAAA;EACA,kBAAA;APm5CR;AOh5CM;EACE,WAAA;EACA,kBAAA;APk5CR;AO/4CM;EACE,WAAA;APi5CR;AO/4CM;EACE,WAAA;APi5CR;;AO34CA;EACE,UAAA;AP84CF;;AQr+CA;EACC,kBAAA;ARw+CD;AQt+CC;EACC,aAAA;EP4GA,sBO3G0B;AR0+C5B;AQx+CE;EACC,mBAAA;EACA,aAAA;AR0+CH;AQx+CG;EACC,YAAA;AR0+CJ;;ASt/CA;EACC,yBXsCY;EWrCZ,cXuCU;AEk9CX;ASv/CC;EACC,aAAA;ER2GA,sBQ1G0B;AT2/C5B;ASz/CQ;EACC,UAAA;AT2/CT;ASx/CE;EACC,kBAAA;EACA,iBAAA;EACA,YAAA;AT0/CH;;AUxgDC;EACI,WAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;AV2gDL;AUxgDC;EACC,WAAA;ETsGA,sBSrGoB;EACpB,YAAA;EACA,WAAA;EACA,kBAAA;AV4gDF;AU1gDE;EACC,UAAA;AV4gDH;AUngDE;EACC,UAAA;AVqgDH;AUngDG;EAHD;IAIE,UAAA;EVsgDF;AACF;AUpgDG;EAPD;IAQE,WAAA;EVugDF;AACF;AUlgDG;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;AVogDJ;AUlgDI;EACC,YAAA;AVogDL;AUjgDI;EACC,SAAA;AVmgDL;AUhgDI;EACC,SAAA;AVkgDL;AU//CI;EACC,SAAA;AVigDL;AUz/CE;EACC,qBAAA;AV2/CH;AUz/CG;EAHD;IAIE,qBAAA;EV4/CF;AACF;AU1/CG;EAPD;IAQE,WAAA;EV6/CF;AACF;AUx/CG;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;AV0/CJ;AUx/CI;EACC,YAAA;AV0/CL;AUv/CI;EACC,oBAAA;AVy/CL;AUt/CI;EACC,oBAAA;AVw/CL;AUh/CE;EACC,UAAA;AVk/CH;AUh/CG;EAHD;IAIE,UAAA;EVm/CF;AACF;AUj/CG;EAPD;IAQE,WAAA;EVo/CF;AACF;AUl/CG;EACC,mBAAA;AVo/CJ;AUl/CI;EACC,gBAAA;EACA,kBAAA;AVo/CL;AU7+CG;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;AV++CJ;AU7+CI;EACC,YAAA;AV++CL;AU5+CI;EACC,SAAA;AV8+CL;AUv+CC;EACC,eAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AVy+CF;AU99CC;EACK;IACC,aAAA;IACD,sBAAA;IACA,eAAA;EVg+CJ,EU/9CM,SAAA;EACF;;IAEC,aAAA;IAAe,sBAAA;IAAwB,eAAA;EVk+C5C,EUj+CM,SAAA;AVk+CR;AWvoDA;EACC,aAAA;EACA,6BAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,qCAAA;EACA,4BAAA;AX2oDD;AWvoDC;EACC,YAAA;AXyoDF;AWtoDC;EACC,YAAA;EACA,aAAA;AXwoDF;AWtoDE;EAJD;IAKE,aAAA;IACA,YAAA;EXyoDD;AACF;AWtoDC;EA7BD;IA8BK,cAAA;IACA,YAAA;EXyoDH;AACF;AWroDI;EACC,kCAzCS;AXgrDd;AWroDK;EAHD;IAIG,wBAAA;EXwoDL;AACF;AWnoDI;EACC,uBApDS;AXyrDd;AWnoDK;EAHD;IAIG,wBAAA;EXsoDL;AACF;AWjoDI;EACC,wBAAA;AXmoDL;AWjoDK;EAHD;IAIG,wBAAA;EXooDL;AACF;AWhoDC;EV0CC,sBUzCoB;EACpB,iBAAA;EACA,YAAA;AXooDF;AWloDE;EALD;IAMK,cAAA;IACA,iBAAA;EXqoDJ;AACF;;AFjtDA,4BAAA;AAOA,2BAAA;AAkBA,8BAAA;AAgDA,4BAAA;AAEA,4BAAA;AAGA,6BAAA;AAWA,uBAAA;AAgBA,uBAAA;AAEA,+BAAA;AchEA;;;;;;EACE,sBAAA;AZurDF;;AYrrDA;EACE,uBAAA;AZwrDF;;AYrrDA;EACE;IACE,UAAA;IACA,qCAAA;EZwrDF;EYtrDA;IACE,UAAA;IACA,+BAAA;EZwrDF;AACF;AYtrDA;EACE;IACE,UAAA;EZwrDF;EYtrDA;IACE,UAAA;EZwrDF;AACF;AazvDA;;;;CAAA;AAKA;;;;CAAA;AAMA;EAEE,8CAAA;AbyvDF;;AapvDA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iDAAA;EACA,sBAAA;AbuvDF;;AapvDA;;;;CAAA;AAKA;EACE,sBAAA;AbuvDF;;AapvDA;;;;CAAA;AAKA;EACE,mBAAA;AbuvDF;;AapvDA;;;;CAAA;AAKA;EACE,0BAAA;EACA,gCAAA;AbuvDF;;AapvDA;EACE,aAAA;EACA,sBAAA;EAEA,2BAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,4BAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AbuvDF;AalvDI;;;;;;;EAGE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;AbwvDN;AarvDI;;;EACE,2BAAA;AbyvDN;AatvDI;;;EACE,uBAAA;Ab0vDN;AavvDI;;;EACE,yBAAA;Ab2vDN;AatvDE;;;EAGE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;AbwvDJ;AarvDE;EACE,2BAAA;AbuvDJ;AapvDE;EACE,uBAAA;AbsvDJ;AanvDE;EACE,yBAAA;AbqvDJ;AajvDI;EACE,gBAAA;EACA,gBAAA;AbmvDN;AajvDI;EACE,gBAAA;EACA,gBAAA;AbmvDN;AajvDI;EACE,cAAA;AbmvDN;Aa/uDE;;EAEE,kBAAA;AbivDJ;Aa9uDI;;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EZ1IJ,kBY2I2B;EZ1I3B,4BAAA,EAAA,oDAAA;EY2II,yBftHE;EGgFN,sBYuCwB;AbqvD1B;AalvDI;;EAEE,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EZ7EJ,UY8EqB;EZ5ErB,wBAAA;ADi0DF;AanvDM;;;EZhFJ,YYkFuB;EZhFvB,yBAAA;ADu0DF;AalvDE;EACE,8BAAA;AbovDJ;AajvDE;EACE,+BAAA;AbmvDJ;AahvDE;;EAEE,aAAA;EACA,gCAAA;AbkvDJ;;Aa5uDA;EACE,yBfhJK;EeiJL,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;Ab+uDF;;Aa5uDA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EAEA,2BAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EAEA,kBAAA;Ab8uDF;Aa5uDE;;;;;;;;;;;;;;;;;;EAkBE,kBAAA;EACA,aAAA;EACA,mBAAA;Ab8uDJ;Aa3uDE;;EAEE,kBAAA;EACA,4BAAA;EAAA,uBAAA;Ab6uDJ;AazuDI;EACE,gBAAA;Ab2uDN;AavuDE;;;EAGE,cAAA;EACA,mBAAA;AbyuDJ;AatuDE;;;EAGE,kBAAA;EACA,qBAAA;AbwuDJ;AaruDE;;;;EAIE,QAAA;AbuuDJ;AapuDE;;;;EAIE,QAAA;AbsuDJ;AanuDE;;;;EAIE,QAAA;AbquDJ;AaluDE;;;EAGE,eAAA;AbouDJ;AanuDI;;;EACE,UAAA;AbuuDN;AajuDI;;EACE,UAAA;AbouDN;Aa/tDE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AbiuDJ;Aa7tDE;EACE,kBAAA;EAEA,YAAA;EACA,aAAA;EACA,mBAAA;EAEA,2BAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,4BAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;EAEA,WAAA;Ab8tDJ;Aa3tDI;;EAGE,aAAA;EACA,sBAAA;EAEA,2BAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,4BAAA;EACA,aAAA;EACA,YAAA;Ab4tDN;AaztDI;EACE,kBAAA;EACA,YAAA;EAEA,aAAA;EACA,sBAAA;EAGA,6BAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,4BAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;AbytDN;AattDI;;;EAGE,YAAA;AbwtDN;Aa7sDM;;;;;;;;EACE,QAAA;EACA,SAAA;AbstDR;AaltDI;;EAEE,SAAA;EACA,aAAA;AbotDN;AajtDI;EACE,SAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;AbmtDN;;Aa9sDA;EACE,kBAAA;EACA,aAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;AbitDF;Aa/sDE;EACE,kBAAA;AbitDJ;Aa/sDI;;;;;;;;;;;;;EACE,kBAAA;Ab6tDN;Aa3tDM;;;;;;;;;;;;;EACE,SAAA;AbyuDR;;AanuDA;EACE,YAAA;EZjTA,sBYkToB;AbwuDtB;AatuDE;EACE,aAAA;AbwuDJ;AaruDE;EACE,kBAAA;AbuuDJ;AapuDE;EACE,mBAAA;AbsuDJ;AanuDE;EACE,iBAAA;AbquDJ;AaluDE;EACE,oBAAA;AbouDJ;AajuDE;EACE,iBAAA;EACA,oBAAA;AbmuDJ;AahuDE;EACE,kBAAA;EACA,mBAAA;AbkuDJ;;Aa9tDA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EAEA,8BAAA;EACA,eAAA;EACA,uBAAA;EACA,oBAAA;EACA,4BAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;AbiuDF;Aa/tDE;EACE,YAAA;EACA,gBAAA;EACA,YAAA;AbiuDJ;Aa/tDI;EACE,kBfzcM;AE0qEZ;Aa9tDI;;EAEE,qBAAA;EACA,iBAAA;AbguDN;Aa9tDM;;EACE,kBfjdQ;EekdR,cAAA;AbiuDR;Aa9tDM;;EACE,eAAA;AbiuDR;Aa5tDE;EACE,YAAA;EACA,kBAAA;EACA,YAAA;Ab8tDJ;Aa5tDI;EACE,kBfleM;AEgsEZ;Aa3tDI;;EAEE,qBAAA;EACA,iBAAA;Ab6tDN;Aa3tDM;;EACE,kBf1eQ;Ee2eR,cAAA;Ab8tDR;Aa3tDM;;EACE,eAAA;Ab8tDR;AaztDE;EACE,YAAA;EACA,iBAAA;EACA,YAAA;Ab2tDJ;AaztDI;EACE,kBf3fM;AEstEZ;AaxtDI;;EAEE,qBAAA;EACA,YAAA;EACA,gBAAA;Ab0tDN;AaxtDM;;EACE,kBfpgBQ;EeqgBR,cAAA;Ab2tDR;AaxtDM;;EACE,cAAA;Ab2tDR;;AantDE;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA2BE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EZ9cF,sBY+csB;AbytDxB;AavtDI;;;;;;;;;;;;;;;;;;;;;;;;;;;;EACE,iBAAA;EACA,oCAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AbovDN;AazuDE;EACE,iBAAA;Ab2uDJ;AazuDI;EACE,YAAA;EACA,qBAAA;Ab2uDN;AaxuDI;EACE,kBAAA;Ab0uDN;AaxuDM;EACE,YAAA;EACA,sBAAA;Ab0uDR;AavuDM;EACE,qBAAA;AbyuDR;AavuDQ;EACE,YAAA;EACA,yBAAA;AbyuDV;AatuDQ;EACE,qBAAA;AbwuDV;AatuDU;EACE,YAAA;EACA,yBAAA;AbwuDZ;;Aa/tDA;EACE,gBAAA;EACA,YAAA;AbkuDF;;Aa1tDA,0CAAA;AACA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;Ab6tDF;Aa3tDE;EACE,eAAA;EACA,qBAAA;Ab6tDJ;Aa1tDE;EACE,UAAA;Ab4tDJ;AaztDE;EACE,mBAAA;Ab2tDJ;AaxtDE;EACE,cAAA;Ab0tDJ;;AattDA;EACE,SAAA;AbytDF;;AattDA;EA4BE,uCAAA;Ab8rDF;AaztDE;EACE,kBAAA;EACA,kBAAA;Ab2tDJ;AaztDI;EACE,kBAAA;EACA,OAAA;EACA,MAAA;Ab2tDN;AavtDM;EACE,iBAAA;AbytDR;AavtDQ;EACE,WAAA;EACA,cAAA;EAEA,sBAAA;AbwtDV;AaptDM;EACE,gBAAA;AbstDR;AajtDE;EACE,aAAA;EACA,kBAAA;AbmtDJ;AajtDI;EACE,cAAA;AbmtDN;;Aa5sDE;;EAEE,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;Ab+sDJ;Aa5sDE;;EAEE,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;Ab8sDJ;Aa3sDE;;EACE,cAAA;Ab8sDJ;Aa3sDE;;EACE,gCAAA;Ab8sDJ;Aa5sDI;;EACE,aAAA;Ab+sDN;Aa5sDI;;EACE,qBAAA;EACA,iBAAA;EACA,cfhtBU;EeitBV,eAAA;Ab+sDN;;Ac75EE;;;EACE,2BAAA;EACA,uBAAA;Adk6EJ;;Ac55EE;;EACE,uEAAA;Adg6EJ;Ac95EE;;;;;;EAGE,oCAAA;EACA,kCAAA;Adm6EJ;;Acz5EE;;;;EACE,sBAAA;Ad+5EJ;;Aez9EA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EAEA,cjBsBM;EiBrBN,iBAAA;EACA,UAAA;Af29EF;Aep9EI;EACE,cjBYE;EiBXF,qBAAA;EACA,gBAAA;Afs9EN;Aep9EM;EAEE,qBAAA;Afq9ER;Aeh9EE;EAEE,cAAA;EdoDF,YcnDmB;EdqDnB,yBAAA;EcpDE,gBAAA;Afk9EJ;;AYx8EA;;;;;;EACE,sBAAA;AZg9EF;;AY98EA;EACE,uBAAA;AZi9EF;;AY98EA;EACE;IACE,UAAA;IACA,qCAAA;EZi9EF;EY/8EA;IACE,UAAA;IACA,+BAAA;EZi9EF;AACF;AY/8EA;EACE;IACE,UAAA;EZi9EF;EY/8EA;IACE,UAAA;EZi9EF;AACF;AgBnhFA;;EAIE,qBAAA;EACA,YAAA;AhBmhFF;AgBjhFE;;EACE,yBlB4DW;EkB3DX,clBqBI;EkBpBJ,iBAAA;AhBohFJ;AgBjhFE;;EACE,qBAAA;EACA,qBAAA;EACA,UAAA;EACA,SAAA;AhBohFJ;AgBhhFI;;;;EAGE,qBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;AhBmhFN;AgBhhFI;;EAEE,cAAA;EACA,0BAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EAEA,cAAA;EACA,WAAA;EACA,6BAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,kBAAA;EACA,4BAAA;EACA,wBAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;EAKA,yBAAA;EAGA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,wCAAA;EACA,kBAAA;AhBihFN;AgB/gFM;;EACE,gBlB6BQ;EkB5BR,6BAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;AhBkhFR;AgB9gFQ;;Ef0DN,wBAImB;ADw9ErB;AgBhhFI;;EACE,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AhBmhFN;AgBjhFM;;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,yBlBpDD;EGrCL,mBe0F6B;EfzF7B,4BAAA,EAAA,oDAAA;Ee0FM,kBAAA;EACA,SAAA;EACA,SAAA;AhBshFR;;AiB7nFA;;EAEE,wBAAA;EACA,aAAA;AjBgoFF;AiB7nFE;;EACE,gCAAA;AjBgoFJ;AiB7nFM;;EACE,0BAAA;EACA,gBAAA;EACA,iBAAA;AjBgoFR;AiB5nFE;;;;;;EAGE,WAAA;EACA,gBAAA;EACA,YAAA;EhB0FF,sBgBzFsB;AjBmoFxB;AiBjoFI;;;;;;EACE,iBAAA;EACA,SAAA;EACA,WAAA;EhBoFJ,sBgBnFwB;AjB0oF1B;AiBxoFM;;;;;;EACE,yBAAA;EhBtBN,kBgBuB6B;EhBtB7B,4BAAA,EAAA,oDAAA;ADuqFF;AiB9oFM;;;;;;EACE,mBAAA;AjBqpFR;AiB/oFQ;;;;;;EACE,0BAAA;AjBspFV;AiBjpFI;;;;;;EACE,iBAAA;EACA,gBAAA;EACA,2BAAA;EACA,kCAAA;EACA,8BAAA;AjBwpFN;AiBtpFM;;;;;;EACE,iBAAA;EACA,YAAA;EACA,2BAAA;EACA,kCAAA;EACA,8BAAA;AjB6pFR;AiB3pFQ;;;;;;EACE,8BAAA;AjBkqFV;AiB9pFM;;;;;;EACE,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;EhB9DN,kBgB+D6B;EhB9D7B,4BAAA,EAAA,oDAAA;EgB+DM,WAAA;EhBsCN,sBgBrC0B;AjByqF5B;AiBpqFE;;;;;;;;;;;;EAME,WAAA;EACA,gBAAA;EACA,gBAAA;EhBwBF,sBgBvBsB;AjB8qFxB;AiB3qFE;;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EhBiBF,sBgBhBsB;EACpB,mBAAA;AjBgrFJ;AiB9qFI;;EACE,cnBrDC;AEsuFP;AiB/qFM;;;EAEE,cnBtDA;AEwuFR;AiB5qFI;;EACE,gBAAA;AjB+qFN;AiB3qFE;;EACE,WAAA;AjB8qFJ;AiB5qFE;;EACE,UAAA;AjB+qFJ;AiB7qFE;;EACE,UAAA;AjBgrFJ;AiB9qFE;;EACE,wBAAA;AjBirFJ;AiB7qFI;;EACE,+BAAA;AjBgrFN;AiB5qFE;;EACE,YAAA;AjB+qFJ;AiB7qFE;;EACE,YAAA;AjBgrFJ;AiB9qFE;;EACE,WAAA;AjBirFJ;AiB/qFE;;EACE,WAAA;AjBkrFJ;AiBhrFE;;EACE,YAAA;AjBmrFJ;AiB/qFI;;EACE,cnBlFS;AEowFf;AiB7qFI;;EhBxEF,YgByEqB;EhBvErB,yBAAA;ADwvFF;AiB3qFM;;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;AjB8qFR;AiB1qFI;;;;EAEE,iBAAA;EACA,gBAAA;EACA,qBAAA;EhBhEJ,sBgBiEwB;EACpB,mBAAA;AjBgrFN;AiB9qFM;;;;EACE,cnBtID;AEyzFP;AiBjrFQ;;;;;;;EAEE,0BAAA;AjBwrFV;AiBjrFE;;EACE,eAAA;EACA,gCAAA;AjBorFJ;AiBlrFI;;EACE,eAAA;EACA,gCAAA;AjBqrFN;AiB/qFU;;EACE,eAAA;EACA,kBAAA;EhBjEV,wBAImB;ADovFrB;AiBnrFc;;EACE,eAAA;AjBsrFhB;AiB5qFQ;;EACE,eAAA;AjB+qFV;AiB5qFY;;EACE,eAAA;AjB+qFd;AiBzqFM;;EACE,yBnB9KI;AE01FZ;AiBzqFU;;EhBvJR,UgBwJ2B;EhBtJ3B,0BAAA;ADm0FF;AiBtqFQ;;EACE,kBAAA;EhBrIR,sBgBsI4B;EACpB,kBAAA;AjB2qFV;AiBzqFU;;EhB1OR,cAAA;EACA,YAAA;EACA,WAAA;EAPA,kBAQuB;EAPvB,4BAAA,EAAA,oDAAA;EAQA,yBHqBK;EGnBL,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;ADw5FF;AiB7qFQ;;EACE,kBAAA;EhBrJR,sBgBsJ4B;EACpB,kBAAA;AjBkrFV;AiBhrFU;;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,yBnBzOL;AE45FP;AiBzqFM;;EACE,kBAAA;EhB5KN,sBgB6K0B;EACpB,kBAAA;AjB8qFR;AiBzqFM;;EACE,kBAAA;EhBpLN,sBgBqL0B;EACpB,kBAAA;AjB8qFR;AiB5qFQ;;EhBzRN,cAAA;EACA,YAAA;EACA,WAAA;EAPA,kBAQuB;EAPvB,4BAAA,EAAA,oDAAA;EAQA,yBHqBK;EGnBL,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AD08FF;AiBhrFA;EACE,gCAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AjBkrFF;;AkBz+FA;EACE,kBAAA;EACA,2BAAA;EAGA,aAAA;EACA,6BAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,qCAAA;EACA,4BAAA;AlB4+FF;AkBx+FE;EjBZA,yBiBaE;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;AlB8+FJ;AkB5+FI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,mBpBhBS;AE8/Ff;AkB1+FE;EjBhCA,yBiBiCE;EACA,OAAA;EACA,kBAAA;EACA,cAAA;AlBg/FJ;AkB9+FI;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,aAAA;EACA,UAAA;EAEA,gBAAA;EACA,mBAAA;AlB++FN;AkB7+FM;EACE,yBpBtBA;AEqgGR;;AmBriGA;EACE,aAAA;EACA,mBAAA;EAEA,YAAA;EACA,2BAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,4BAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,4BAAA;AnBwiGF;AmBtiGE;EACE,WAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;AnBwiGJ;AmBriGE;ElBuFA,sBkBtFsB;EACpB,aAAA;EACA,gBAAA;AnByiGJ;AmBtiGE;ElBiFA,sBkBhFsB;EACpB,aAAA;EACA,eAAA;EACA,kBAAA;EACA,4BAAA;AnB0iGJ;AmBviGE;ElByEA,sBkBxEsB;EACpB,eAAA;EACA,eAAA;AnB2iGJ;AmBxiGM;EACE,eAAA;EACA,yBrBfA;EGtBN,gBkBsC6B;ElBrC7B,4BAAA,EAAA,oDAAA;EAyCA,+BkBHoC;ElBKpC,8BkBLoC;ElBMpC,4BAAA;EkBLM,aAAA;EACA,kBAAA;EACA,4BAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AnBgjGR;AmB7iGQ;EACE,WAAA;EACA,WAAA;EACA,qCAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;AnB+iGV;AmB5iGQ;EACE,WAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;AnB8iGV;AmB3iGQ;EAEE,crBjCH;AE6kGP;AmBziGQ;EACE,crBzEG;EqB0EH,gBAAA;AnB2iGV;AmBziGU;EACE,aAAA;AnB2iGZ;AmBxiGU;EACE,aAAA;AnB0iGZ;AmBniGE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;ElBQF,sBkBPsB;EACpB,cAAA;ElBMF,sBkBLsB;EACpB,gBAAA;AnByiGJ;AmBtiGE;ElBCA,sBAAA;EkBCE,aAAA;AnB0iGJ;AmBxiGI;EACE,aAAA;AnB0iGN;AmBviGI;EACE,WAAA;AnByiGN;AmBviGM;EACE,WAAA;AnByiGR;AmBpiGE;ElBhBA,sBkBiBsB;EACpB,aAAA;AnBwiGJ;;AmBpiGA;EACE,eAAA;EACA,UAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;AnBuiGF;AmBriGE;EACE,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AnBuiGJ;AmBriGI;EACE,eAAA;AnBuiGN;AmBpiGI;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,YAAA;AnBsiGN;AmBpiGM;EACE,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AnBsiGR;AmBniGU;EACE,eAAA;EACA,yBrB3IJ;EqB4II,gFAAA;ElBlKV,gBkBoKiC;ElBnKjC,4BAAA,EAAA,oDAAA;EAyCA,+BkB2HwC;ElBzHxC,8BkByHwC;ElBxHxC,4BAAA;EkByHU,2BAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,4BAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AnB0iGZ;AmBxiGY;EACE,WAAA;EACA,WAAA;EACA,qCAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;AnB0iGd;AmBviGY;EACE,WAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;AnByiGd;AmBtiGY;EAEE,crBhKP;AEusGP;AmBpiGY;EACE,crBxMD;EGwFX,yCkBiHY;AnBwiGd;AmBtiGc;EACE,aAAA;AnBwiGhB;AmBriGc;EACE,aAAA;AnBuiGhB;AmBliGc;EACE,crB3JD;AE+rGf;AmB/hGU;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;EACA,yBrB3MJ;EqB4MI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AnBiiGZ;AmB9hGc;EACE,eAAA;EACA,yBrB9MD;EG5Bb,mBkB2OqC;ElB1OrC,4BAAA,EAAA,oDAAA;EkB2Oc,YAAA;AnBkiGhB;AmB1hGY;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,8BAAA;EAGA,yFAAA;AnB4hGd;AmBthGU;EACE,QAAA;AnBwhGZ;;AoBvyGA;EACE,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EAGA,gBAAA;EACA,aAAA;EACA,sCAAA;EACA,4BAAA;EAGA,yBtBwBa;AEgxGf;AoBtyGE;EACE,OAAA;EACA,aAAA;EnB8FF,sBmB7FsB;ApB0yGxB;AoBxyGI;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;ApB0yGN;AoBxyGM;EACE,gBtBkES;EsBjET,6BAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;ApB0yGR;AoBtyGQ;EACE,cAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;ApBwyGV;AoBnyGI;EACE,WAAA;EACA,mBAAA;ApBqyGN;AoBlyGI;EACE,WAAA;EACA,mBAAA;EACA,eAAA;ApBoyGN;AoBlyGM;EACE,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;ApBoyGR;AoB/xGE;EAEE,aAAA;EnB2CF,sBmB1CsB;EACpB,kBAAA;ApBkyGJ;AoBhyGI;EACE,qBAAA;EACA,YAAA;ApBkyGN;AoBhyGM;EACE,WAAA;ApBkyGR;AoB9xGI;EACE,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;ApBgyGN;AoB3xGM;EACE,yBAAA;EACA,gBAAA;EACA,iBAAA;ApB6xGR;AoBxxGE;EACE,iBAAA;EACA,OAAA;EACA,aAAA;EnBSF,sBmBRsB;ApB4xGxB;AoB1xGI;EACE,qBAAA;EnBtBJ,YmBuBqB;EnBrBrB,yBAAA;ADkzGF;AoB1xGI;EACE,qBAAA;EACA,iBAAA;ApB4xGN;;AqB74GA;EACE,kBAAA;EACA,4BAAA;ArBg5GF;;AqB74GA;EACE,eAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBvBoBM;EuBnBN,aAAA;EpBHA,kBoBIuB;EpBHvB,4BAAA,EAAA,oDAAA;EoBIA,uEAAA;EpBiGA,sBoBhGoB;ArBo5GtB;AqBl5GE;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,+BAAA;EACA,gBAAA;ArBo5GJ;AqBl5GI;EACE,mBAAA;ArBo5GN;AqBl5GM;EACE,gBAAA;ArBo5GR;AqBp2GM;EACE,SAAA;EACA,UAAA;EACA,gBAAA;ArBs2GR;AqBn2GU;EACE,cAAA;EACA,cAAA;EACA,qBAAA;EACA,UAAA;ArBq2GZ;AqBn2GY;EAEE,yBvBrDC;EuBsDD,cvBjFD;AEq7Gb;AqBl2Gc;EACE,0BAAA;ArBo2GhB;AqBh2GY;EACE,WAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;ArBk2Gd;AqB/1GY;EACE,UAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EpBAZ,sBoBCgC;EACpB,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;ArBm2Gd;AqBh2GY;EACE,cAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;ArBk2Gd;AqB71GgB;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EpBjIhB,kBoBkIuC;EpBjIvC,4BAAA,EAAA,oDAAA;ADk+GF;AqB31Gc;EACE,kBAAA;ArB61GhB;AqB31GgB;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;ArB61GlB;;AsBz/GA;EACC,SAAA;EACA,UAAA;EACA,gBAAA;AtB4/GD;AsB1/GC;EACC,eAAA;EACA,gCAAA;AtB4/GF;AsB1/GE;EACC,gCAAA;AtB4/GH;AsBv/GE;EACC,iBAAA;EACA,cxByBS;AEg+GZ;AsBv/GG;EACC,iBAAA;EACA,gBAAA;AtBy/GJ;AsBt/GG;EACC,cxB6CW;EwB5CX,qBAAA;AtBw/GJ;AsBt/GI;EACC,0BAAA;AtBw/GL;;AsB/+GA;EACC,kBxBxBe;EwByBf,yBxB8Bc;EwB7Bd,cxBCW;EwBAX,YAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EAGA,UAAA;AtBg/GD;AsB9+GC;EACC,iBAAA;AtBg/GF;AsB9+GE;EACC,UAAA;EACA,SAAA;AtBg/GH;AsB5+GC;EACC,sBAAA;AtB8+GF;;AuB7iHA;EACE,iBAAA;AvBgjHF;;AuB7iHA;EACE,uBAAA;EACA,czBoCU;EyBnCV,gCAAA;EACA,kBAAA;EACA,uEAAA;EACA,aAAA;EACA,qDAAA;EACA,kBAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EAGA,WAAA;EACA,WAAA;EACA,YAAA;EAIA,sBAAA;EACA,0BzB0Ca;AEigHf;AuBziHE;EACE,aAAA;AvB2iHJ;AuBziHE;EACE,YAAA;AvB2iHJ;AuBziHE;EACE,qCAAA;AvB2iHJ;AuBziHI;;EAEE,yBAHO;AvB8iHb;AuBxiHE;EACE,qCAAA;AvB0iHJ;AuBxiHI;;EAEE,yBAHO;AvB6iHb;AuBviHE;EACE,qCAAA;AvByiHJ;AuBviHI;;EAEE,yBAHO;AvB4iHb;AuBtiHE;EACE,qCAAA;AvBwiHJ;AuBtiHI;;EAEE,yBAHO;AvB2iHb;AuBpiHE;EACE,aAAA;EACA,+BAAA;AvBsiHJ;AuBpiHI;;EAEE,gBAAA;AvBsiHN;AuBpiHI;EACE,iBAAA;AvBsiHN;AuBliHE;EACE,qBAAA;EACA,gBAAA;AvBoiHJ;;AwBxnHA;EACE,uBAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,4BAAA;EACA,sCAAA;EACA,gBAAA;AxB2nHF;;AwBxnHA;EAGE,eAAA;EACA,0BAAA;EAEA,kBAAA;EACA,sEAAA;EAEA,aAAA;EACA,+BAAA;AxBunHF;AwBrnHE;EACE,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AxBunHJ;AwBrnHE;EACE,cAAA;EACA,kBAAA;EACA,qDAAA;EACA,gBAAA;AxBunHJ;AwBrnHE;EAIE,gBAAA;AxBonHJ;AwBnnHI;EACE,mBAAA;AxBqnHN;;AwBhnHA;EACE,gBAAA;EACA,oDAAA;EACA,2DAAA;EACA,YAAA;EACA,iBAAA;AxBmnHF;;AwBjnHA;EACE,aAAA;EACA,aAAA;AxBonHF;;AyB5qHA;EACE,WAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AzB+qHF;AyB7qHE;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;AzB+qHJ;AyB7qHI;EACE,cAAA;EACA,qBAAA;ExBJJ,kBwBK2B;ExBJ3B,4BAAA,EAAA,oDAAA;EwBKI,kBAAA;EACA,iBAAA;EACA,cAAA;AzBirHN;AyB/qHM;EAEE,uCAAA;AzBgrHR;AyB9qHQ;EACE,uCAAA;EACA,c3BqBH;AE2pHP;AyB7qHQ;;;EAEE,c3BgBH;AEgqHP;AyB5qHM;EACE,YAAA;EACA,wBAAA;AzB8qHR;AyB3qHM;EACE,cAAA;EACA,aAAA;ExBhCN,mBwBiC6B;ExBhC7B,4BAAA,EAAA,oDAAA;EwBiCM,qCAAA;EACA,WAAA;ExBmEN,sBwBlE0B;EACpB,mBAAA;AzBirHR;AyB/qHQ;EACE,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AzBirHV;AyB7qHM;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AzB+qHR;AyB5qHM;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;AzB8qHR;;A0BpvHA;EAKE,kBAAA;EACA,WAAA;EACA,c5BwBM;E4BvBN,mB5BwBM;E4BvBN,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mC5BwDmB;E4BvDnB,mBAAA;A1BmvHF;A0BjvHE;;;EAGE,WAAA;EACA,kBAAA;EACA,gBAAA;A1BmvHJ;A0BhvHE;;EAEE,sBAAA;A1BkvHJ;A0B/uHE;EACE,wBAAA;A1BivHJ;A0B9uHE;EACE,aAAA;EACA,uBAAA;A1BgvHJ;A0B9uHI;;;;EAKE,iBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,c5BrBU;E4BsBV,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;A1B+uHN;A0B7uHM;;;;EACE,cAAA;A1BkvHR;A0B/uHM;;;;EACE,mB5BfD;E4BgBC,c5B/BA;AEmxHR;A0BjvHM;;;;EACE,uBAAA;EACA,yBAAA;EACA,c5BtBD;AE4wHP;;A0BzuHA;;;EAGE,WAAA;EACA,UAAA;A1B4uHF;;A2Bl0HA;;;;CAAA;AAMA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,gB7BNoB;E6BOpB,YAAA;EACA,gBAAA;EACA,UAAA;A3Bo0HF;A2Bl0HE;EACE,UAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;A3Bo0HJ;A2Bh0HE;EACE,WAAA;EACA,yB7BYW;E6BXX,8EAAA;EACA,kBAAA;EACA,gB7BxBkB;AE01HtB;A2Bh0HI;EACE,gB7B8DS;E6B7DT,6BAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EACA,c7BEC;E6BDD,gCAAA;EACA,gBAAA;A3Bk0HN;A2B/zHI;EACE,2BAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EACA,c7BTC;E6BUD,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;A3Bi0HN;A2BxzHI;EACE,6BAAA;A3B0zHN;A2BvzHI;EACE,gCAAA;A3ByzHN;A2BvzHI;EACE,yCAAA;A3ByzHN;;A2BnzHE;EACE,iBAAA;EACA,cAAA;EACA,c7B9BE;AEo1HN;A2BpzHI;EACE,gBAAA;EACA,gB7BeE;E6BdF,6BAAA;EACA,mBAAA;A3BszHN;A2BlzHE;EACE,iBAAA;EACA,cAAA;A3BozHJ;A2BlzHI;EACE,c7B7CA;E6B8CA,gBAAA;EACA,gB7BEE;E6BDF,6BAAA;EACA,mBAAA;A3BozHN;;AYz2HA;;;;;;EACE,sBAAA;AZi3HF;;AY/2HA;EACE,uBAAA;AZk3HF;;AY/2HA;EACE;IACE,UAAA;IACA,qCAAA;EZk3HF;EYh3HA;IACE,UAAA;IACA,+BAAA;EZk3HF;AACF;AYh3HA;EACE;IACE,UAAA;EZk3HF;EYh3HA;IACE,UAAA;EZk3HF;AACF;A4Bt7HA;EACE,SAAA;EACA,UAAA;A5Bw7HF;;A4Br7HA;;;EAGE,cAAA;EACA,gEAAA;EACA,6CAAA;A5Bw7HF;;A4Br7HA;EACE,cAAA;EACA,gEAAA;EACA,6CAAA;A5Bw7HF;;A4Br7HA;EACE,6CAAA;A5Bw7HF;;A4Br7HA;EACE,SAAA;EACA,UAAA;EACA,SAAA;A5Bw7HF;A4Bt7HE;EACE,cAAA;EACA,sBAAA;EACA,iBAAA;EACA,sBAAA;A5Bw7HJ;A4Bt7HI;EACE,kBAAA;EACA,YAAA;A5Bw7HN;;A4Bn7HA,cAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,iCAAA;EACA,cAAA;EACA,yBAAA;E3BiEA,sB2BhEoB;EACpB,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,sCAAA;E3B3CA,kB2B4CuB;E3B3CvB,4BAAA,EAAA,oDAAA;E2B4CA,c9B5CW;AEs+Hb;A4Bx7HE;EACE,6BAAA;A5B07HJ;A4Bv7HE;EACE,yBAAA;EACA,yB9B1CwB;E8B2CxB,mBAAA;A5By7HJ;A4Bt7HE;EACE,yBAAA;A5Bw7HJ;A4Bt7HI;EACE,yBAAA;A5Bw7HN;A4Br7HI;EACE,6BAAA;A5Bu7HN;A4Bn7HE;EACE,cAAA;A5Bq7HJ;;A4Bj7HA;EACE;IACE,gBAAA;IACA,oDAAA;E5Bo7HF;AACF;A4Bj7HA;EACE;IACE,sBAAA;IACA,oCAAA;E5Bm7HF;AACF;A4Bh7HA,aAAA;AACA;EACE,WAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,wBAAA;EACA,qBAAA;E3BMA,sB2BLoB;EACpB,sCAAA;EACA,6BAAA;EACA,mBAAA;EACA,iBAAA;E3BrGA,kB2BsGuB;E3BrGvB,4BAAA,EAAA,oDAAA;E2BsGA,c9BtGW;AE4hIb;A4Bp7HE;EACE,6BAAA;A5Bs7HJ;A4Bn7HE;EACE,yBAAA;EACA,yB9BpGwB;AEyhI5B;A4Bl7HE;EACE,yBAAA;A5Bo7HJ;A4Bj7HI;EACE,yBAAA;A5Bm7HN;A4Bh7HI;EACE,6BAAA;A5Bk7HN;A4B96HE;EACE,cAAA;A5Bg7HJ;;A4B56HA;EACE,wBAAA;A5B+6HF;;A4B56HA;EACE,wBAAA;A5B+6HF;;A4B56HA;EACE;IACE,gBAAA;IACA,oDAAA;E5B+6HF;AACF;A4B56HA;EACE;IACE,sBAAA;IACA,oCAAA;E5B86HF;AACF;A4B36HA,WAAA;AACA;EACE,WAAA;EACA,iBAAA;EACA,SAAA;EACA,yBAAA;EACA,yBAAA;EACA,c9BhKW;E8BiKX,wBAAA;EACA,qBAAA;E3B7DA,sB2B8DoB;EAEpB,uEAAA;EAGA,iCAAA;EAEA,yBAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;E3BjLA,kB2BkLuB;E3BjLvB,4BAAA,EAAA,oDAAA;AD8lIF;ACj7HE;E2BnBF;I3BwBI,4CAAA;IACA,8DAAA;IACA,0BAAA;EDg7HF;AACF;A4Bl7HE;EACE,6BAAA;A5Bo7HJ;A4Bj7HE;EACE,2BAAA;EACA,oCAAA;EACA,wBAAA;A5Bm7HJ;A4Bh7HE;E3BnHA,Y2BoHmB;E3BlHnB,yBAAA;ADqiIF;A4Bh7HE;EACE,yBAAA;EACA,yB9BzLwB;AE2mI5B;A4B/6HE;EACE,wBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;A5Bi7HJ;A4B96HE;EACE,yBAAA;E3BpIF,U2BqImB;E3BnInB,0BAAA;ADojIF;A4B96HE;EACE,cAAA;A5Bg7HJ;A4B76HE;EACE,c9BvNS;AEsoIb;A4B76HI;EACE,c9B7LC;AE4mIP;;A4B16HA;EACE,kBAAA;EACA,uBAAA;A5B66HF;;A4B16HA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;A5B66HF;;A4B16HA;EACE,UAAA;EACA,SAAA;EACA,WAAA;EACA,iCAAA;A5B66HF;;A4Bz6HA;EACE;IACE,yBAAA;E5B46HF;AACF;A4Bx6HA;EACE;IACE,gBAAA;IACA,oDAAA;E5B06HF;AACF;A4Bv6HA;EACE;IACE,sBAAA;IACA,oCAAA;E5By6HF;AACF;A4Bt6HA,oBAAA;AAEA;;;;EAGE,gC9B/OK;E8BgPL,kBAAA;EACA,c9BjPK;E8BkPL,uBAAA;A5Bw6HF;;A4Br6HA;EACE,yB9BxPa;E8ByPb,yBAAA;EACA,c9BxPK;E8ByPL,eAAA;A5Bw6HF;;A4Br6HA;EACE,yB9B/Pa;E8BgQb,yBAAA;EACA,c9B/PK;E8BgQL,eAAA;A5Bw6HF;;A4Br6HA;EACE,yB9BtQa;E8BuQb,yBAAA;EACA,c9BtQK;E8BuQL,eAAA;A5Bw6HF;;A4Br6HA,qBAAA;AAEE;EACE,wBAAA;EACA,yB9BpSgB;E8BsShB,UAAA;A5Bs6HJ;A4Bp6HE;EACE,4BAAA;EACA,yB9B1SgB;E8B2ShB,UAAA;A5Bs6HJ;A4Bp6HE;EACE,wBAAA;EACA,yB9B/SgB;E8BgThB,UAAA;A5Bs6HJ;A4B/5HE;EACE,iEAAA;EACA,yB9BzTgB;E8B0ThB,UAAA;A5Bs6HJ;;A4Bl6HA;;;EAEE,wBAAA;EACA,SAAA;A5Bs6HF;;A4Bn6HA;EACE,0BAAA;A5Bs6HF;;A4Bn6HA,iBAAA;AAEA,eAAA;AAEA;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,6BAAA;EACA,SAAA;EACA,YAAA;E3B1VA,8B2B2VuB;E3B1VvB,4BAAA,EAAA,oDAAA;E2B2VA,eAAA;A5Bs6HF;;A4Bn6HA;;EAEE,c9B3UM;E8B4UN,yB9B/Uc;AEqvIhB;;A4Bn6HA,oBAAA;AAKE;;;;EACE,WAAA;EACA,qBAAA;A5Bq6HJ;A4Bl6HE;;;;EACE,WAAA;EACA,qBAAA;A5Bu6HJ;;A4Bn6HA;EACE,qB9B/UI;AEqvIN;;A4Bn6HA;EACE,qBAAA;EACA,iBAAA;EACA,WAAA;EACA,c9BtVI;AE4vIN;;A4Bj6HA;EACE;IACE,YAAA;E5Bo6HF,E4Bn6HE,SAAA;EACF;;;IAEE,YAAA;E5Bq6HF,E4Bp6HE,SAAA;EAEF;IACE,YAAA;E5Bo6HF,E4Bn6HE,SAAA;EACF;;IAEE,YAAA;E5Bo6HF,E4Bn6HE,SAAA;EAEF;IACE,cAAA;IACA,wBAAA;E5Bm6HF;E4Bj6HA;;;IAEE,cAAA;IACA,wBAAA;E5Bo6HF,E4Bn6HE,SAAA;A5Bo6HJ;A6Bz0IA;;;;EAEI,kBAAA;EACA,aAAA;A7B60IJ;;A6B10IA;;;;EAEI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,c/BDS;E+BET,kCAAA;A7B+0IJ;;A6B70IA;;;;EAEI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mB/BQI;EGtBN,kB4BeyB;E5BdzB,4BAAA,EAAA,oDAAA;ADk2IF;;A6Bj1IA;;;;EAEI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,wBAAA;A7Bs1IJ;;A6Bh1IA;;;;EAEI,c/BpCS;AEy3Ib;;A6Bn1IA;;;;EAEI,yBAAA;A7Bw1IJ;;A6B90IA;;;;EAEI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,c/B3BG;E+B4BH,uBAAA;A7Bm1IJ;;A6Bj1IA;;;;EAEI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mB/BxCS;AE83Ib;;A6Bn1IA;;;;EAEI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,wBAAA;A7Bw1IJ;;A6Bl1IA;EACI,UAAA;A7Bq1IJ;;A6Bl1IA;EACI,UAAA;EACA,qB/BzEI;AE85IR;;A6Bl1IA;EACI,qB/B9DG;E+B+DH,eAAA;EACA,YAAA;EACA,WAAA;EACA,yB/BlEG;AEu5IP;;A8Bt8IA;;;;EAEI,kBAAA;EACA,aAAA;A9B28IJ;;A8Bx8IA;;;;EAEI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,chCDS;EgCET,kCAAA;A9B68IJ;;A8B38IA;;;;EAEI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBhCOI;AEy8IR;;A8B78IA;;;;EAEI,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBhCcG;EgCbH,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EAEA,yBAAA;A9Bk9IJ;;A8B18IA;;;;EAEI,chCtCS;AEq/Ib;;A8B78IA;;;;EAEI,yBAAA;A9Bk9IJ;;A8Bx8IA;;;;EAEI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,chC1DS;EgC2DT,uBAAA;A9B68IJ;;A8B38IA;;;;EAEI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBhC3CS;AE2/Ib;;A8B78IA;;;;EAEI,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBhChDQ;EgCiDR,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EAEA,yBAAA;A9Bk9IJ;;A8B18IA;EACI,UAAA;EAEA,mBAAA;A9B68IJ;;A8B18IA;EACI,UAAA;EAEA,mBAAA;A9B68IJ;;A8B18IA;EACI,qBhCtEG;AEmhJP;;A+BlkJA,iBAAA;AAEC;EACC,SAAA;EACA,UAAA;EACA,gBAAA;A/BokJF;A+BhkJE;EACC,WAAA;EACA,oBAAA;A/BkkJH;A+B9jJI;E9B4CF,8B8B3CgC;E9B6ChC,2B8B7CgC;E9B8ChC,4BAAA;E8B7CG,cAAA;EACA,cAAA;A/BokJL;A+B/jJI;E9BsBF,+B8BrBiC;E9BuBjC,4B8BvBiC;E9BwBjC,4BAAA;E8BvBG,cAAA;A/BqkJL;;A+B9jJC;EACC,WAAA;EACA,6BAAA;EACA,kBAAA;EACE,cjCzBS;EiC0BX,iBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;E9B9BA,kB8B+BuB;E9B9BvB,4BAAA,EAAA,oDAAA;E8B+BA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;EAEA,eAAA;EACA,eAAA;E9BgEA,sB8B/DoB;EACpB,kBAAA;EACA,iBAAA;EACA,eAAA;A/BokJF;A+BlkJE;EAEC,qBjC3Ba;EiC4Bb,cjC5Ba;EiC6Bb,UAAA;A/BmkJH;A+B/jJE;EACC,qBjCpDU;EiCqDV,yBjCrDU;EiCsDV,cjCjCK;AEkmJR;A+B/jJG;EAEC,qBjC1DS;EiC2DT,yBjC3DS;EiC4DT,cjCvCI;AEumJR;;AgCvoJA;EACE,YAAA;EACA,gBAAA;EACA,qBlCmBa;AEunJf;AgCnoJE;;;;;;EAME,oBAAA;AhCqoJJ;AgCnoJI;;;;;;;;;;;;EAEE,oBAAA;AhC+oJN;AgCjoJA;EACE,kBAAA;EACA,qBAAA;AhCmoJF;AgCjoJE;EACE,cAAA;AhCmoJJ;AgChoJE;EACE,qBAAA;EACA,iBAAA;EACA,sBAAA;AhCkoJJ;;AgC9nJA,yCAAA;AACA;EACE,aAAA;EACA,gBAAA;EAEA,mBlCtBM;EkCuBN,YAAA;E/B7CA,kB+B8CuB;E/B7CvB,4BAAA,EAAA,oDAAA;E+B8CA,uEAAA;E/BuDA,sB+BtDoB;EACpB,6BAAA;EACA,cAAA;EACA,iCAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,clCtDW;EkCuDX,gBAAA;AhCooJF;AgCloJE;EACE,mBAAA;AhCooJJ;AgCjoJE;EACE,aAAA;AhCmoJJ;AgChoJE;EACE,QAAA;AhCkoJJ;AgC1nJE;EACE,OAAA;EACA,QAAA;EACA,kBAAA;AhC4nJJ;AgCznJE;EACE,gBAAA;AhC2nJJ;AgCxnJE;EACE,aAAA;AhC0nJJ;AgCvnJM;EACE,SAAA;EACA,UAAA;AhCynJR;AgCpnJE;EACE,cAAA;EACA,kBAAA;EACA,6BAAA;AhCsnJJ;AgCpnJI;EACE,WAAA;AhCsnJN;AgCnnJI;EACE,kBAAA;AhCqnJN;;AgChnJA,qIAAA;AACA;EACE,cAAA;AhCmnJF;;AgChnJA;EACE,0BAAA;EACA,2BAAA,EAAA,4BAAA;EACA,uBAAA;EACA,4BAAA;EACA,yBAAA;EACA,4BAAA;AhCmnJF;;AiCvvJA;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EhCEA,kBgCDuB;EhCEvB,4BAAA,EAAA,oDAAA;EgCAA,6BAAA;EACA,cnCDW;EmCEX,WAAA;EACA,iBAAA;EACA,wBAAA;EACA,sBAAA;EACA,iBAAA;EhC+FA,sBgC9FoB;AjC6vJtB;AiC3vJE;EhCfA,yBgCgBE;AjCiwJJ;AiC9vJE;EAEE,cnCoBG;AE2uJP;AiC5vJE;EACE,yBnCQW;AEsvJf;AiC3vJE;EACE,cnCvBS;AEoxJb;AiC3vJI;EhCyGF,wBAImB;ADqpJrB;;AiC5vJA;EA2BE,uCAAA;AjCquJF;AiC/vJE;EACE,kBAAA;EACA,kBAAA;AjCiwJJ;AiC/vJI;EACE,kBAAA;EACA,OAAA;EACA,MAAA;AjCiwJN;AiC7vJM;EACE,iBAAA;AjC+vJR;AiC9vJQ;EACE,WAAA;EACA,cAAA;EhCsDR,sBgCrD4B;AjCkwJ9B;AiC9vJM;EACE,gBAAA;AjCgwJR;AiC1vJE;EACE,aAAA;EACA,kBAAA;AjC4vJJ;AiC1vJI;EACE,cAAA;AjC4vJN;;AiCvvJA;EACE,4BAAA;EACA,yBAAA;AjC0vJF;;AkC30JA;EAAc,iBAAA;AlC+0Jd;;AkC90JA;EAAc,kBAAA;AlCk1Jd;;AkCj1JA;EAAc,kBAAA;AlCq1Jd;;AkCp1JA;EAAc,kBAAA;AlCw1Jd;;AkCv1JA;EAAc,kBAAA;AlC21Jd;;AkC11JA;EAAc,kBAAA;AlC81Jd;;AkC51JA;EAAc,gBAAA;AlCg2Jd;;AkC/1JA;EAAc,iBAAA;AlCm2Jd;;AkCl2JA;EAAc,iBAAA;AlCs2Jd;;AkCr2JA;EAAc,iBAAA;AlCy2Jd;;AkCx2JA;EAAc,iBAAA;AlC42Jd;;AkC32JA;EAAc,iBAAA;AlC+2Jd;;AkC72JA;EAAc,eAAA;AlCi3Jd;;AkCh3JA;EAAc,gBAAA;AlCo3Jd;;AkCn3JA;EAAc,gBAAA;AlCu3Jd;;AkCt3JA;EAAc,gBAAA;AlC03Jd;;AkCz3JA;EAAc,gBAAA;AlC63Jd;;AkC53JA;EAAc,gBAAA;AlCg4Jd;;AkC93JA;EAAc,kBAAA;AlCk4Jd;;AkCj4JA;EAAc,mBAAA;AlCq4Jd;;AkCp4JA;EAAc,mBAAA;AlCw4Jd;;AkCv4JA;EAAc,mBAAA;AlC24Jd;;AkC14JA;EAAc,mBAAA;AlC84Jd;;AkC74JA;EAAc,mBAAA;AlCi5Jd;;AkC/4JA;EAAY,WAAA;AlCm5JZ;;AkCl5JA;EAAY,YAAA;AlCs5JZ;;AkCr5JA;EAAY,YAAA;AlCy5JZ;;AkCx5JA;EAAY,YAAA;AlC45JZ;;AkC35JA;EAAY,YAAA;AlC+5JZ;;AkC95JA;EAAY,YAAA;AlCk6JZ;;AkCh6JA;EAAc,iBAAA;EAAmB,gBAAA;AlCq6JjC;;AkCp6JA;EAAc,kBAAA;EAAoB,iBAAA;AlCy6JlC;;AkCx6JA;EAAc,kBAAA;EAAoB,iBAAA;AlC66JlC;;AkC56JA;EAAc,kBAAA;EAAoB,iBAAA;AlCi7JlC;;AkCh7JA;EAAc,kBAAA;EAAoB,iBAAA;AlCq7JlC;;AkCp7JA;EAAc,kBAAA;EAAoB,iBAAA;AlCy7JlC;;AkCv7JA;EAAc,eAAA;EAAiB,kBAAA;AlC47J/B;;AkC37JA;EAAc,gBAAA;EAAkB,mBAAA;AlCg8JhC;;AkC/7JA;EAAc,gBAAA;EAAkB,mBAAA;AlCo8JhC;;AkCn8JA;EAAc,gBAAA;EAAkB,mBAAA;AlCw8JhC;;AkCv8JA;EAAc,gBAAA;EAAkB,mBAAA;AlC48JhC;;AkC38JA;EAAc,gBAAA;EAAkB,mBAAA;AlCg9JhC;;AkCx8JA;EAAe,kBAAA;AlC48Jf;;AkC38JA;EAAe,mBAAA;AlC+8Jf;;AkC98JA;EAAe,mBAAA;AlCk9Jf;;AkCj9JA;EAAe,mBAAA;AlCq9Jf;;AkCp9JA;EAAe,mBAAA;AlCw9Jf;;AkCv9JA;EAAe,mBAAA;AlC29Jf;;AkCz9JA;EAAe,iBAAA;AlC69Jf;;AkC59JA;EAAe,kBAAA;AlCg+Jf;;AkC/9JA;EAAe,kBAAA;AlCm+Jf;;AkCl+JA;EAAe,kBAAA;AlCs+Jf;;AkCr+JA;EAAe,kBAAA;AlCy+Jf;;AkCx+JA;EAAe,kBAAA;AlC4+Jf;;AkC1+JA;EAAe,gBAAA;AlC8+Jf;;AkC7+JA;EAAe,iBAAA;AlCi/Jf;;AkCh/JA;EAAe,iBAAA;AlCo/Jf;;AkCn/JA;EAAe,iBAAA;AlCu/Jf;;AkCt/JA;EAAe,iBAAA;AlC0/Jf;;AkCz/JA;EAAe,iBAAA;AlC6/Jf;;AkC3/JA;EAAe,mBAAA;AlC+/Jf;;AkC9/JA;EAAe,oBAAA;AlCkgKf;;AkCjgKA;EAAe,oBAAA;AlCqgKf;;AkCpgKA;EAAe,oBAAA;AlCwgKf;;AkCvgKA;EAAe,oBAAA;AlC2gKf;;AkC1gKA;EAAe,oBAAA;AlC8gKf;;AkC5gKA;EAAa,YAAA;AlCghKb;;AkC/gKA;EAAa,aAAA;AlCmhKb;;AkClhKA;EAAa,aAAA;AlCshKb;;AkCrhKA;EAAa,aAAA;AlCyhKb;;AkCxhKA;EAAa,aAAA;AlC4hKb;;AkC3hKA;EAAa,aAAA;AlC+hKb;;AkC7hKA;EAAe,kBAAA;EAAoB,iBAAA;AlCkiKnC;;AkCjiKA;EAAe,mBAAA;EAAqB,kBAAA;AlCsiKpC;;AkCriKA;EAAe,mBAAA;EAAqB,kBAAA;AlC0iKpC;;AkCziKA;EAAe,mBAAA;EAAqB,kBAAA;AlC8iKpC;;AkC7iKA;EAAe,mBAAA;EAAqB,kBAAA;AlCkjKpC;;AkCjjKA;EAAe,mBAAA;EAAqB,kBAAA;AlCsjKpC;;AkCpjKA;EAAe,gBAAA;EAAkB,mBAAA;AlCyjKjC;;AkCxjKA;EAAe,iBAAA;EAAmB,oBAAA;AlC6jKlC;;AkC5jKA;EAAe,iBAAA;EAAmB,oBAAA;AlCikKlC;;AkChkKA;EAAe,iBAAA;EAAmB,oBAAA;AlCqkKlC;;AkCpkKA;EAAe,iBAAA;EAAmB,oBAAA;AlCykKlC;;AkCxkKA;EAAe,iBAAA;EAAmB,oBAAA;AlC6kKlC;;AmCprKA;EACC,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;EACA,yBrC2BO;EGgFN,sBkC1GmB;AnCyrKrB;AmCtrKE;EACC,kBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;AnCwrKH;AmCrrKI;EACC,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;ElC+DH,UkC9DoB;ElCgEpB,wBAAA;ADwnKF;AmChrKK;EACC,6BAAA;AnCkrKN;AmCzqKG;EACC,gBAAA;EACA,gCAAA;EACA,yBrCLS;EqCMT,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AnC2qKJ;AmCzqKI;EACC,WAAA;EACA,yBAAA;AnC2qKL;AmCxqKI;EACC,WAAA;AnC0qKL;AmCvqKI;EACC,WAAA;AnCyqKL;AmCtqKI;;;EAEC,eAAA;EACA,qBAAA;EACA,2BAAA;AnCyqKL;AmCtqKI;EACC,YAAA;AnCwqKL;AmCrqKI;EACC,mBAAA;AnCuqKL;AmC9pKG;EACC,gCAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AnCgqKJ;AmC9pKI;EACC,WAAA;EACA,yBAAA;AnCgqKL;AmC7pKI;EACC,WAAA;AnC+pKL;AmC5pKI;EACC,WAAA;AnC8pKL;AmC3pKI;EACC,YAAA;AnC6pKL;AmC1pKI;EACC,mBAAA;AnC4pKL;AmCzpKI;EACC,cAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AnC2pKL;AmCzpKK;EACC,YAAA;EACA,mBAAA;AnC2pKN;AmCvpKI;;;EAEC,eAAA;EACA,qBAAA;EACA,2BAAA;AnC0pKL;AmCppKI;;EAEC,yCrClFS;AEwuKd;AmC7oKK;;EACC,yBrC5GS;AE4vKf;AmC1oKI;;EAEE,yBrC9IY;AE0xKlB;AmCvoKI;;EAEC,oDAAA;AnCyoKL;AmCvoKK;;EACC,cAAA;AnC0oKN;AmCroKG;EACC,aAAA;AnCuoKJ;AmCroKI;EACC,kBAAA;AnCuoKL;AmCnoKG;EACC,kBAAA;AnCqoKJ;;AmC3nKA;EACC,WAAA;EACA,aAAA;EACA,iBAAA;EACA,8BAAA;EACA,kBAAA;AnC8nKD;;AoC/zKA;EACE,qDtCYU;AEszKZ;;AoC9zKE;EACE,aAAA;ApCi0KJ;;AoC7zKA;EACE,4BAAA;EnCwFA,yGmCvFA;EACA,UAAA;ApCk0KF;AoC9zKE;EACE,UAAA;ApCg0KJ;AoC7zKI;EAEE,sBAAA;EACA,oCAAA;EACA,oBAAA;EACA,6BAAA;ApC8zKN;;AoCzzKA;EACE,4CAAA;EnCqDA,UmCpDiB;EnCsDjB,0BAAA;ADuwKF;;AoCrzKA;EACE,kBAAA;ApCwzKF;;AoCrzKA;EACE,gCAAA;EACA,oBAAA;ApCwzKF;AoCtzKE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;ApCwzKJ;AoCrzKE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,yBtC5BI;AEm1KR;AoCpzKE;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,ctCrBG;AE20KP;AoCnzKE;EACE,kBAAA;EACA,ctC/BQ;EsCgCR,cAAA;EACA,UAAA;ApCqzKJ;;AoCjzKA,mBAAA;AAEA;EACE,YAAA;EnC8BA,sBmC7BoB;EA+DpB,mBAAA;ApCuvKF;AoCpzKE;EACE,aAAA;ApCszKJ;AoCnzKE;EACE,kBAAA;ApCqzKJ;AoClzKE;EACE,mBAAA;ApCozKJ;AoCjzKE;EACE,iBAAA;ApCmzKJ;AoChzKE;EACE,oBAAA;ApCkzKJ;AoC/yKE;EACE,iBAAA;EACA,oBAAA;ApCizKJ;AoC9yKE;EACE,kBAAA;EACA,mBAAA;ApCgzKJ;AoC5yKE;EACE,aAAA;EACA,cAAA;EACA,kBAAA;ApC8yKJ;AoC5yKI;EACE,UAAA;ApC8yKN;AoC3yKI;EATF;IAUI,uBAAA;EpC8yKJ;AACF;AoC5yKI;EACE,WAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;ApC8yKN;AoC1yKE;EACE,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;ApC4yKJ;AoCxyKE;EACE,aAAA;EACA,6BAAA;ApC0yKJ;AoCxyKI;EACE,gBAAA;EACA,gBAAA;ApC0yKN;AoCxyKM;EAJF;IAKI,gBAAA;IACA,gBAAA;EpC2yKN;AACF;AoCxyKI;EACE,WAAA;ApC0yKN;AoCxyKM;;EAEE,kBAAA;EACA,WAAA;ApC0yKR;AoCxyKQ;;EACE,eAAA;ApC2yKV;AoCtyKI;EACE,YAAA;ApCwyKN;AoCtyKM;;EAEE,iBAAA;EACA,WAAA;ApCwyKR;AoCtyKQ;;EACE,cAAA;ApCyyKV;AoCpyKI;EACE,WAAA;EACA,kBAAA;ApCsyKN;AoCpyKM;;EAEE,aAAA;ApCsyKR;;AoChyKA,mBAAA;AACA;EACE,aAAA;EACA,kBAAA;ApCmyKF;AoCjyKE;EACE,WAAA;EACA,oCAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;ApCmyKJ;AoChyKE;EACE,gBAAA;EACA,gBAAA;ApCkyKJ;AoChyKI;EAJF;IAKI,gBAAA;IACA,gBAAA;EpCmyKJ;AACF;AoChyKE;EACE,WAAA;ApCkyKJ;AoChyKI;;EAEE,kBAAA;EACA,WAAA;ApCkyKN;AoChyKM;;EACE,eAAA;ApCmyKR;AoC9xKE;EACE,YAAA;ApCgyKJ;AoC9xKI;;EAEE,iBAAA;EACA,WAAA;ApCgyKN;AoC9xKM;;EACE,cAAA;ApCiyKR;AoC5xKE;EACE,WAAA;EACA,kBAAA;ApC8xKJ;AoC5xKI;;EAEE,aAAA;ApC8xKN;;AoCzxKA,kCAAA;AAGE;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;ApC0xKJ;AoCxxKI;EACE,WAAA;EACA,qBAAA;EACA,aAAA;ApC0xKN;;AoCrxKA;EACE,kBAAA;ApCwxKF;AoCtxKE;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,QAAA;EACA,kBAAA;ApCwxKJ;;AoCpxKA;EACE,kBAAA;ApCuxKF;AoCtxKE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;ApCwxKJ;AoCtxKI;EACE,ctChRE;AEwiLR;;AqCxkLA;EACE,kBAAA;EACA,kBAAA;ArC2kLF;AqCxkLE;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;ArC0kLJ;AqCxkLI;EACE,WAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;ArC0kLN;AqCvkLI;EACE,cAAA;EACA,WAAA;EACA,YAAA;ArCykLN;;AqCpkLA;EpCrBE,gBoCsBuB;EpCrBvB,4BAAA,EAAA,oDAAA;EoCsBA,6BAAA;EACA,4EAAA;EACA,kBAAA;EACA,cvCJM;EuCKN,gCAAA;EAGA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;ArCukLF;AqCrkLE;EACE,cAAA;ArCukLJ;AqCpkLE;EAEE,cvCnBI;EuCoBJ,oCAAA;ArCqkLJ;AqClkLE;EACE,uBAAA;EACA,oCAAA;EACA,cvCXG;AE+kLP;AqClkLI;EAEE,uBAAA;EACA,oCAAA;EACA,cvCjBC;AEolLP;AqChkLI;EACE,aAAA;ArCkkLN;;AqC7jLA;EACE,aAAA;EACA,YAAA;ArCgkLF;AqC9jLE;EACE,cAAA;ArCgkLJ;;AsC9oLA;EACE,aAAA;EACA,2BAAA;EACA,oBAAA;EACA,iBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,mCAAA;EACA,4BAAA;AtCmpLF;AsC/oLE;EACE,kBAAA;EACA,oBAAA;AtCipLJ;AsC/oLI;EACE,iBAAA;AtCipLN;AsC3oLI;EACE,kBAAA;EACA,QAAA;EACA,MAAA;AtC6oLN;AsCtoLE;EACE,oBAAA;AtCwoLJ;AsCroLE;EACE,OAAA;EACA,cAAA;AtCuoLJ;AsCroLI;EACE,cAAA;AtCuoLN;;AuCnrLA;;EAEI,kBAAA;EACA,aAAA;AvCsrLJ;;AuCnrLA;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,czCDS;EyCET,yBzCmBI;EyClBJ,qCAAA;EACA,kBAAA;EtCLF,mBsCMyB;EtCLzB,4BAAA,EAAA,oDAAA;EAqGA,sBsC/FmB;EACpB,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AvC0rLD;;AuCvrLA;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,4BAAA;EACA,qCAAA;EACA,kBAAA;EtCrBF,mBsCsByB;EtCrBzB,4BAAA,EAAA,oDAAA;EANA,yBsC4BD;EtC+EC,sBsC9EmB;EACpB,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AvCksLD;;AuC5rLA;;EAEI,czCnCS;AEkuLb;;AuCzrLA;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,czCjBG;EyCkBH,sBAAA;AvC4rLJ;;AuCzrLA;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,czC1BG;EyC2BH,sBAAA;AvC4rLJ;;AuClrLA;EACC,aAAA;EACG,mBAAA;EAEA,2BAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,4BAAA;EACA,WAAA;EACA,aAAA;EAEA,qCAAA;EtC/EF,mBsCgFyB;EtC/EzB,4BAAA,EAAA,oDAAA;EAqGA,sBsCrBmB;AvCwrLrB;AuCrrLC;EACC,YAAA;AvCurLF;;AwCtxLA;EAEE,iBAAA;EvC8GA,sBuC7GoB;EACpB,oBAAA;EACA,kBAAA;EACA,0BAAA;AxC0xLF;AwC3wLE;EACE,kBAAA;AxC6wLJ;AwC3wLI;EAEE,c1CqBC;AEuvLP;AwC3wLM;EACE,2BAAA;AxC6wLR;AwCxwLI;EACE,c1CaC;E0CZD,iBAAA;EACA,gBAAA;EACA,iBAAA;AxC0wLN;AwCtwLI;EACE,iBAAA;EACA,mBAAA;AxCwwLN;AwC9vLI;EACE,kBAAA;AxCgwLN;AwC/vLM;EACE,qBAAA;AxCiwLR;AwC9vLM;EACE,qBAAA;AxCgwLR;AwC7vLM;EACE,aAAA;AxC+vLR;AwCtvLI;EACE,qBAAA;EACA,kBAAA;EACA,aAAA;AxCwvLN;AwCrvLI;EACE,qBAAA;EACA,kBAAA;EACA,aAAA;AxCuvLN;AwCpvLI;EACE,c1CrCA;E0CsCA,iBAAA;EACA,gBAAA;EACA,kBAAA;AxCsvLN;;AyC/0LA;EACE,kBAAA;AzCk1LF;;AyC/0LA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,2BAAA;EACA,mBAAA;EACA,oEAAA;EACA,YAAA;ExCwEF,UwCvEmB;ExCyEnB,wBAAA;AD0wLF;;AyCj1LA;EACI,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,6CAAA;EACA,8BAAA;EACA,kBAAA;EACA,c3CQI;E2CPJ,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;ExCuDF,UwCtDmB;ExCwDnB,wBAAA;EwCvDE,YAAA;AzCq1LJ;;AyCj1LA;EACE,QAAA;EACA,QAAA;EACA,kBAAA;EACA,0CAAA;AzCo1LF;;AyCl1LA;EACE,SAAA;AzCq1LF;;AyCn1LA;EACE,SAAA;EACA,eAAA;EACA,6DAAA;AzCs1LF;;AyCp1LA;EACE,UAAA;EACA,QAAA;EACA,gBAAA;EACA,yCAAA;AzCu1LF;;AyCr1LA;EACE,QAAA;EACA,QAAA;EACA,iBAAA;EACA,6CAAA;AzCw1LF;;AyCt1LA;EACE,SAAA;AzCy1LF;;AyCv1LA;EACE,SAAA;EACA,eAAA;EACA,0CAAA;AzC01LF;;AyCx1LA;EACE,UAAA;EACA,QAAA;EACA,gBAAA;EACA,0CAAA;AzC21LF;;AyCt1LA;;ExCME,UwCJkB;ExCMlB,0BAAA;ADo1LF;;A0C36LA;;;;CAAA;AAMA;EACE,eAAA;A1C66LF;;A0C16LA;;;;;;;;;;;;;;;;;;;;;EACE,YAAA;EACA,WAAA;A1Ci8LF;;A0C97LA;;;EACE,iBAAA;A1Cm8LF;;A0Ch8LA;;EAEE,YAAA;EACA,WAAA;EACA,iBAAA;A1Cm8LF;;A0Ch8LA;EACE,iBAAA;A1Cm8LF;;A0Ch8LA;;EAEE,aAAA;A1Cm8LF;;A0Ch8LA;EACE,kBAAA;A1Cm8LF;;A0Ch8LA;EACE,kBAAA;A1Cm8LF;;A0Ch8LA;EACE,eAAA;A1Cm8LF;;A0Ch8LA;EACE,aAAA;A1Cm8LF;;A0Ch8LA;EACE,gBAAA;EACA,YAAA;A1Cm8LF;;A0C/7LA;EACE,8BAAA;A1Ck8LF;;A0C/7LA;EACE,+BAAA;A1Ck8LF;;A0C/7LA;EACE,gCAAA;A1Ck8LF;;A0C/7LA;EACE,6BAAA;A1Ck8LF;;A0C/7LA;EACE,yBAAA;A1Ck8LF;;A0C/7LA;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EAGA,2CAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;A1Ck8LF;;A0C97LE;EAEE,UAAA;A1Cg8LJ;;A2C/hMA;EACC,gBAAA;EACA,aAAA;E1C8GC,sB0C7GmB;E1COnB,kB0CNsB;E1COtB,4BAAA,EAAA,oDAAA;EAwFA,uE0C9FD;EACA,yB7C0BO;E6CzBP,iBAAA;A3CwiMD;;A4C/iMA;EACC,kBAAA;EACA,gBAAA;A5CkjMD;;A4ChjMA;EACC,gBAAA;EACA,cAAA;A5CmjMD;;A4C/iMA;EACC,WAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;A5CkjMD;A4ChjMC;EACC,WAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;E3C2FA,sB2C1FoB;A5CojMtB;A4CjjME;EACC,cAAA;EACA,qBAAA;E3CjBD,kB2CkBwB;E3CjBxB,4BAAA,EAAA,oDAAA;E2CkBC,kBAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;EACA,yB9CDK;EGgFN,sB2C9EqB;E3CxBrB,kB2CyB2B;E3CxB3B,4BAAA,EAAA,oDAAA;E2CyBI,wCAAA;A5CyjMN;A4CvjMG;EACI,uEAAA;A5CyjMP;A4CvjMI;EACC,yB9CIE;E8CHF,c9CXG;AEokMR;A4CtjMI;EACC,c9CDE;AEyjMP;A4CpjMG;;;;;;;EACC,oCAAA;E3CiCF,U2ChCmB;E3CkCnB,0BAAA;E2CjCE,2BAAA;A5C6jMJ;A4C3jMI;;;;;;;;;;;;;EAEC,oCAAA;E3C2BH,U2C1BoB;E3C4BpB,0BAAA;E2C3BG,2BAAA;A5CykML;A4CvkMK;;;;;;;;;;;;;EACC,qCAAA;EACA,cAAA;A5CqlMN;A4CllMK;;;;;;;;;;;;;EACC,cAAA;A5CgmMN;A4C3lMG;EACC,cAAA;EACA,aAAA;E3CjEF,mB2CkEyB;E3CjEzB,4BAAA,EAAA,oDAAA;E2CkEE,qCAAA;EACA,WAAA;E3CkCF,sB2CjCuB;EACrB,mBAAA;A5CimMJ;A4C/lMI;EACC,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;A5CimML;A4C7lMG;EACC,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;A5C+lMJ;;A6ChsMA;EACI,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;A7CmsMJ;;A6ChsMA;EACI,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;A7CmsMJ;;A6ChsMA;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;A7CmsMJ;;A6ChsMA;EACI,6BAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,iCAAA;A7CmsMJ;;A6ChsMA;EACI,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA,EAAA,mGAAA;EACA,WAAA;EACA,mBAAA;EAEA,eAAA,EAAA,kDAAA;EACA,gBAAA,EAAA,0CAAA;A7CksMJ;;A6C/rMA;EACI,gBAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;A7CksMJ;;A6C/rMA;EACI,8BAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;A7CksMJ;;A6C/rMA;EACI,mBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;A7CksMJ;;A6C/rMA;EACI,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;A7CksMJ;;A6C/rMA;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;A7CksMJ;;A6C/rMA;EACI,kBAAA;EACA,WAAA;EACA,mB/C3FI;E+C4FJ,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,+BAAA;A7CksMJ;;A6C/rMA;EACI,0DAAA;EACA,YAAA;EACA,6BAAA;A7CksMJ;;A6C/rMA;EACI,MAAA;EACA,WAAA;A7CksMJ;;A6C/rMA;EACI,QAAA;EACA,WAAA;A7CksMJ;;A6C/rMA;EACI,OAAA;EACA,YAAA;A7CksMJ;;A6C/rMA;EACI,YAAA;EACA,SAAA;EACA,UAAA;A7CksMJ;;A6C/rMA;EACI,WAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;A7CksMJ;;A6C/rMA,gBAAA;AACA;EACI,WAAA;EACA,OAAA;A7CksMJ;;A6C/rMA;EACI,cAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A7CksMJ;;AA/2MA;EACE,aAPQ;EAQR,kBAAA;EAGA,aAAA;EACA,4BAAA;EACA,WAAA;EACA,gBAAA;AAg3MF;AA52ME;EACE,aAAA;EACA,iCAAA;EACA,cArBM;AAm4MV;AAx2MI;EACE,aAAA;EACA,mCAAA;EACA,cA9BI;AAw4MV;AAx2MI;EACE,aAAA;EACA,0BAAA;AA02MN;AAr2MI;EACE,qBAAA;EACA,oBAAA;EACA,aAAA;EACA,sCAAA;EACA,cA5CI;EA6CJ,oBAAA;AAu2MN","sourcesContent":["// @import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,300i,400,400i,600,600i,700,700i');\r\n\r\n/****** Spreadsheet ********/\r\n\r\n// $spread-sheet-height: 67vh;\r\n$spread-sheet-height: 100%;\r\n$padding: 0.7rem;\r\n$tree-width: 18rem;\r\n\r\n/********** Base **********/\r\n\r\n$base_color: #505050;\r\n$body_background: #ffffff;\r\n$font_pack: 'Source Sans Pro', Helvetica, sans-serif;\r\n$font_size: 0.86rem;\r\n$btn_font_size: 0.76rem;\r\n$app_color: $base_color;\r\n$border_color: #dfe0e1;\r\n$placeholder-color: rgba(#000000, 0.4);\r\n$placeholder-color-white: #ffffff;\r\n$input_background: #ffffff;\r\n$input_background_readonly: #eef0f1; //#EEF0F1\r\n$input_border: #ababab;\r\n$input_border_focus: #505050;\r\n$input_border_expected: #ffcd40;\r\n$input_required: rgba(#f8e71c, 0.3);\r\n\r\n/********** Colours **********/\r\n\r\n$primary_color: #72bf44;\r\n\r\n$black: #000000;\r\n$white: #ffffff;\r\n\r\n$grey_1: #4a4a4a;\r\n$grey_2: #585d69;\r\n$grey_3: #5d6978;\r\n\r\n$lighter_grey: #f5f6f7;\r\n$light_grey: #eceef3;\r\n$grey: #cccccc;\r\n$mid_grey: #7e8c99;\r\n$dark_grey: #525b6b;\r\n$darker_grey: #464c59;\r\n\r\n$disabled_grey: #ababab;\r\n$blue: #51738b; //#04BBEE\r\n$navy: #2b495e;\r\n\r\n$red: #ea5441;\r\n$green: #72bf44;\r\n$orange: #f07d23;\r\n$yellow: #ffcd40;\r\n\r\n$state_hover: rgba($blue, 0.1);\r\n\r\n$shadow_1: rgba($grey_1, 0.2);\r\n$shadow_2: rgba($black, 0.2);\r\n\r\n$row_hover: #f4f6f7;\r\n\r\n$group_color_1: #a7c5e5;\r\n$group_color_2: #d39fe9;\r\n$group_color_3: #e9e19f;\r\n$group_color_4: #9a75ff;\r\n$group_color_5: #a7e5b4;\r\n$group_color_6: #adb1c7;\r\n$group_color_7: #fa8d8d;\r\n$group_color_8: #ffc375;\r\n\r\n$notification: #ff9d00;\r\n$notification_light: rgba($notification, 0.25);\r\n\r\n$tree_btn_hover: #f4f6f7;\r\n\r\n/********** Pages **********/\r\n\r\n/********** Modal **********/\r\n$modal_background: #ffffff;\r\n\r\n/********** Button **********/\r\n$btn_primary_bg: #72bf44;\r\n$btn_primary_bg_hover: darken($btn_primary_bg, 10%);\r\n$btn_primary_color: #ffffff;\r\n$btn_primary_color_hover: #ffffff;\r\n\r\n$btn_secondary_bg: #51738b;\r\n$btn_secondary_bg_hover: darken($btn_secondary_bg, 10%);\r\n$btn_secondary_color: #ffffff;\r\n$btn_secondary_color_hover: #ffffff;\r\n\r\n/******* Icons ********/\r\n\r\n$empyrean_logo: '\\e905';\r\n$sheet_loader: '\\e90d';\r\n$triangle_right: '\\e910';\r\n$valid: '\\e922';\r\n$warning: '\\e923';\r\n$error: '\\e91f';\r\n$chevron_left: '\\e901';\r\n$chevron_right: '\\e902';\r\n$chevron_up: '\\e903';\r\n$chevron_down: '\\e900';\r\n\r\n$x: -50%;\r\n$y: -50%;\r\n\r\n/******* Icons ********/\r\n\r\n/******* Media Queries ********/\r\n\r\n$mobile: '(min-width: 0px) and (max-width: 767px)';\r\n$mobile_portrait: '(min-width: 0px) and (max-width: 767px) and (orientation: portrait)';\r\n$mobile_landscape: '(min-width: 320px) and (max-width: 767px) and (orientation: landscape)';\r\n\r\n$tablet: '(min-width: 768px) and (max-width: 1024px)';\r\n$tablet_portrait: '(min-width: 768px) and (max-width: 1023px) and (orientation: portrait)';\r\n$tablet_landscape: '(min-width: 1024px) and (max-width: 1279px)';\r\n\r\n$desktop: '(min-width: 1025px) and (max-width: 1439px)';\r\n$desktop_wide: '(min-width: 1440px)';\r\n$desktop_extra_wide: '(min-width: 1680px)';\r\n$min_desktop_wide: '(min-width: 1280px)';\r\n\r\n$max_height: '(max-height: 760px)';\r\n","html {\r\n  -moz-osx-font-smoothing: grayscale;\r\n  font-size: 1rem;\r\n  text-rendering: optimizelegibility;\r\n  // overflow: hidden; // Remove Scroll bounce\r\n}\r\n\r\nbody {\r\n  font-size: $font_size;\r\n  font-family: $font_pack;\r\n  font-weight: 400;\r\n  color: $app_color;\r\n  background: $body_background;\r\n  -webkit-text-size-adjust: none;\r\n  margin: 0px;\r\n  padding: 0;\r\n\r\n  &.no_scroll {\r\n    height: 100%;\r\n    overflow: hidden;\r\n  }\r\n}\r\n\r\nhtml,\r\nbody {\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5 {\r\n  margin: 0px;\r\n  padding: 0px;\r\n}\r\n\r\nabbr {\r\n  text-decoration: none;\r\n}\r\n\r\na:link,\r\na:visited {\r\n  color: $navy;\r\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n}\r\n\r\na:hover {\r\n  color: $primary_color;\r\n}\r\n\r\np {\r\n  margin: 0;\r\n  padding: 0;\r\n  padding-bottom: 10px;\r\n  line-height: 140%;\r\n}\r\n\r\n*:focus {\r\n  outline: none;\r\n}\r\n\r\n.clearfix::after {\r\n  clear: both;\r\n  content: '';\r\n  display: block;\r\n  height: 0;\r\n  visibility: hidden;\r\n}\r\n\r\n.overflow {\r\n  -webkit-overflow-scrolling: touch; /* lets it scroll lazy */\r\n  overflow: auto;\r\n}\r\n\r\n.hidden_text {\r\n  position: absolute !important;\r\n  font-size: 0 !important;\r\n}\r\n\r\n.text_right {\r\n  text-align: right !important;\r\n}\r\n\r\n.text_center {\r\n  text-align: center !important;\r\n}\r\n\r\n.space_divider {\r\n  height: 10px;\r\n  display: block;\r\n\r\n  &.extra_padding {\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n  }\r\n}\r\n\r\n.line_divider {\r\n  background-color: rgba($black, 0.1);\r\n  margin-top: 10px;\r\n  margin-bottom: 10px;\r\n  height: 1px;\r\n  display: block;\r\n\r\n  &.extra_padding {\r\n    margin-top: 30px;\r\n    margin-bottom: 30px;\r\n  }\r\n}\r\n\r\n.truncate {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n// Outcome Modal Styling\r\n.outcome_icon {\r\n  font-size: 80px;\r\n  width: 80px;\r\n  height: 80px;\r\n  line-height: 80px;\r\n  text-align: center;\r\n  margin: 20px auto 20px;\r\n\r\n  &.success {\r\n    color: $green;\r\n  }\r\n\r\n  &.error {\r\n    color: $red;\r\n  }\r\n}\r\n\r\n.outcome_title {\r\n  font-size: 1.4rem;\r\n  line-height: 30px;\r\n  margin-bottom: 10px;\r\n  text-align: center;\r\n  font-weight: 400;\r\n\r\n  &.success {\r\n    color: $green;\r\n  }\r\n\r\n  &.error {\r\n    color: $red;\r\n  }\r\n}\r\n\r\n.outcome_text {\r\n  text-align: center;\r\n}\r\n\r\n.lds-dual-ring {\r\n  display: inline-block;\r\n  width: 64px;\r\n  height: 64px;\r\n}\r\n.lds-dual-ring:after {\r\n  content: ' ';\r\n  display: block;\r\n  width: 20px;\r\n  height: 20px;\r\n  margin: 1px;\r\n  border-radius: 50%;\r\n  border: 2px solid $black;\r\n  border-color: $black transparent $black transparent;\r\n  animation: lds-dual-ring 1.2s linear infinite;\r\n}\r\n@keyframes lds-dual-ring {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n// Styling for Spread Canvas\r\n#vp {\r\n  border-top: 0px solid $border_color;\r\n}\r\n\r\n.chevron_toggle_icon {\r\n  @include chevron-down();\r\n  font-size: 2em;\r\n  font-style: normal;\r\n  cursor: pointer;\r\n\r\n  &.expanded:before {\r\n    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\r\n    @include rotate(180);\r\n  }\r\n}\r\n\r\n.icon_spinner {\r\n  display: inline-block;\r\n  margin-right: 5px;\r\n  -webkit-animation: rotate-center 0.6s ease-in infinite both;\r\n  animation: rotate-center 0.6s ease-in infinite both;\r\n}\r\n\r\n/**\r\n * ----------------------------------------\r\n * animation rotate-center\r\n * ----------------------------------------\r\n */\r\n@-webkit-keyframes rotate-center {\r\n  0% {\r\n    -webkit-transform: rotate(0);\r\n    transform: rotate(0);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n@keyframes rotate-center {\r\n  0% {\r\n    -webkit-transform: rotate(0);\r\n    transform: rotate(0);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n","@import '../../../../styles/base/all';\r\n\r\n$padding: 1rem;\r\n\r\n@function mult-padding($mult) {\r\n  @return $padding * $mult;\r\n}\r\n\r\n.add-scenario-container {\r\n  padding: $padding;\r\n  border-radius: 4px;\r\n\r\n  \r\n  display: grid;\r\n  grid-template-rows: auto 1fr;\r\n  grid-gap: 0;\r\n  overflow: hidden;\r\n\r\n  .add-scenario-title {\r\n  }\r\n  .add-scenario-body {\r\n    display: grid;\r\n    grid-template-rows: auto 1fr auto;\r\n    grid-gap: $padding;\r\n\r\n    input {\r\n      @extend input, .inputbox;\r\n    }\r\n\r\n    .add-scenario-body-first {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr auto;\r\n      grid-gap: $padding;\r\n    }\r\n    .add-scenario-body-second {\r\n      display: grid;\r\n      grid-template-columns: 1fr;\r\n      textarea {\r\n        @extend textarea, .inputbox;\r\n      }\r\n    }\r\n    .add-scenario-body-third {\r\n      padding: 0 !important;\r\n      margin: 0 !important;\r\n      display: grid;\r\n      grid-template-columns: repeat(2, auto);\r\n      grid-gap: $padding;\r\n      justify-content: end;\r\n    }\r\n  }\r\n}\r\n","@mixin transition($args...) {\r\n  -webkit-transition: $args;\r\n  -moz-transition: $args;\r\n  -ms-transition: $args;\r\n  -o-transition: $args;\r\n  transition: $args;\r\n}\r\n\r\n@mixin border-radius($radius) {\r\n  -webkit-border-radius: $radius;\r\n  border-radius: $radius;\r\n  background-clip: padding-box; /* stops bg color from leaking outside the border: */\r\n}\r\n\r\n@mixin color-dot($color) {\r\n  margin: auto 0;\r\n  height: 10px;\r\n  width: 10px;\r\n  @include border-radius(50%);\r\n  background-color: $color;\r\n  // positioning\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  margin: auto;\r\n}\r\n\r\n@mixin centerer {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n// Single side border-radius\r\n@mixin border-top-radius($radius) {\r\n  -webkit-border-top-right-radius: $radius;\r\n  border-top-right-radius: $radius;\r\n  -webkit-border-top-left-radius: $radius;\r\n  border-top-left-radius: $radius;\r\n  background-clip: padding-box;\r\n}\r\n@mixin border-right-radius($radius) {\r\n  -webkit-border-bottom-right-radius: $radius;\r\n  border-bottom-right-radius: $radius;\r\n  -webkit-border-top-right-radius: $radius;\r\n  border-top-right-radius: $radius;\r\n  background-clip: padding-box;\r\n}\r\n@mixin border-bottom-radius($radius) {\r\n  -webkit-border-bottom-right-radius: $radius;\r\n  border-bottom-right-radius: $radius;\r\n  -webkit-border-bottom-left-radius: $radius;\r\n  border-bottom-left-radius: $radius;\r\n  background-clip: padding-box;\r\n}\r\n@mixin border-left-radius($radius) {\r\n  -webkit-border-bottom-left-radius: $radius;\r\n  border-bottom-left-radius: $radius;\r\n  -webkit-border-top-left-radius: $radius;\r\n  border-top-left-radius: $radius;\r\n  background-clip: padding-box;\r\n}\r\n\r\n@mixin border-top-left-radius($radius) {\r\n  -webkit-border-top-left-radius: $radius;\r\n  -moz-border-radius-topleft: $radius;\r\n  border-top-left-radius: $radius;\r\n}\r\n\r\n@mixin border-top-right-radius($radius) {\r\n  -webkit-border-top-right-radius: $radius;\r\n  -moz-border-radius-topright: $radius;\r\n  border-top-right-radius: $radius;\r\n}\r\n\r\n@mixin border-bottom-left-radius($radius) {\r\n  -webkit-border-bottom-left-radius: $radius;\r\n  -moz-border-radius-bottomleft: $radius;\r\n  border-bottom-left-radius: $radius;\r\n}\r\n\r\n// Opacity\r\n@mixin opacity($opacity) {\r\n  opacity: $opacity;\r\n  $opacity-ie: $opacity * 100;\r\n  filter: alpha(opacity=$opacity-ie); //IE8\r\n}\r\n\r\n// @mixin box-shadow($horizontal: 0px, $vertical: 1px, $blur: 2px, $color: #CCC) {\r\n//   -webkit-box-shadow: $horizontal $vertical $blur $color;\r\n//   -moz-box-shadow: $horizontal $vertical $blur $color;\r\n//   box-shadow: $horizontal $vertical $blur $color;\r\n// }\r\n\r\n@mixin box-shadow($params...) {\r\n  -webkit-box-shadow: $params;\r\n  -moz-box-shadow: $params;\r\n  box-shadow: $params;\r\n}\r\n\r\n@mixin inset-box-shadow($horizontal: 0px, $vertical: 1px, $blur: 2px, $color: #ccc) {\r\n  -webkit-box-shadow: inset $horizontal $vertical $blur $color;\r\n  -moz-box-shadow: inset $horizontal $vertical $blur $color;\r\n  box-shadow: inset $horizontal $vertical $blur $color;\r\n}\r\n\r\n//box sizing mixin\r\n@mixin box-sizing($box-model) {\r\n  -webkit-box-sizing: $box-model; // Safari <= 5\r\n  -moz-box-sizing: $box-model; // Firefox <= 19\r\n  box-sizing: $box-model;\r\n}\r\n\r\n//box shadow\r\n// @mixin box-shadow($top, $left, $blur, $color, $inset: false) {\r\n//   @if $inset {\r\n//     -webkit-box-shadow:inset $top $left $blur $color;\r\n//     -moz-box-shadow:inset $top $left $blur $color;\r\n//     box-shadow:inset $top $left $blur $color;\r\n//   } @else {\r\n//     -webkit-box-shadow: $top $left $blur $color;\r\n//     -moz-box-shadow: $top $left $blur $color;\r\n//     box-shadow: $top $left $blur $color;\r\n//   }\r\n// }\r\n\r\n//white panel\r\n@mixin panel() {\r\n  background-color: $white;\r\n  @include border-radius(5px);\r\n  margin-bottom: 10px;\r\n}\r\n\r\n// generic transform\r\n@mixin transform($transforms) {\r\n  -moz-transform: $transforms;\r\n  -o-transform: $transforms;\r\n  -ms-transform: $transforms;\r\n  -webkit-transform: $transforms;\r\n  transform: $transforms;\r\n}\r\n// rotate\r\n@mixin rotate($deg) {\r\n  @include transform(rotate(#{$deg}deg));\r\n}\r\n\r\n@mixin chevron-down() {\r\n  &:before {\r\n    content: $chevron_down;\r\n    font-family: 'empyrean_icons';\r\n    font-size: 10px;\r\n    height: 10px;\r\n    width: 10px;\r\n    position: absolute;\r\n    top: 10px;\r\n    left: 0px;\r\n    line-height: 10px;\r\n  }\r\n}\r\n\r\n// scale\r\n@mixin scale($scale) {\r\n  @include transform(scale($scale));\r\n}\r\n// translate\r\n@mixin translate($x, $y) {\r\n  @include transform(translate($x, $y));\r\n}\r\n// skew\r\n@mixin skew($x, $y) {\r\n  @include transform(skew(#{$x}deg, #{$y}deg));\r\n}\r\n//transform origin\r\n@mixin transform-origin($origin) {\r\n  moz-transform-origin: $origin;\r\n  -o-transform-origin: $origin;\r\n  -ms-transform-origin: $origin;\r\n  -webkit-transform-origin: $origin;\r\n  transform-origin: $origin;\r\n}\r\n\r\n@mixin image-2x($image, $width, $height) {\r\n  @media (min--moz-device-pixel-ratio: 1.3),\r\n    (-o-min-device-pixel-ratio: 2.6/2),\r\n    (-webkit-min-device-pixel-ratio: 1.3),\r\n    (min-device-pixel-ratio: 1.3),\r\n    (min-resolution: 1.3dppx) {\r\n    /* on retina, use image that's scaled by 2 */\r\n    background-image: url($image);\r\n    background-size: $width $height;\r\n  }\r\n}\r\n","/*\r\n* Global Styles goes here\r\n*/\r\n.success-button {\r\n  @extend .btn_normal;\r\n  @extend .btn_green;\r\n}\r\n","#page_container_outer {\r\n  height: 100vh;\r\n  overflow: hidden;\r\n}\r\n\r\n.page_inner_container {\r\n  // max-width: 1280px; // This controls the max-width for the page\r\n  // margin:0 auto;\r\n  width: 100%;\r\n  display: block;\r\n  &:not(.footer-bar-component) {\r\n    overflow: hidden;\r\n  }\r\n}\r\n\r\n#page_container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  -webkit-flex-direction: column;\r\n  height: 100%;\r\n  justify-content: flex-start;\r\n  flex-wrap: nowrap;\r\n  -webkit-flex-wrap: nowrap;\r\n  align-items: stretch;\r\n  -webkit-align-items: stretch;\r\n  width: 100%;\r\n  min-height: 0;\r\n\r\n  #page_header {\r\n    position: relative;\r\n    // min-height:0;\r\n    @include box-sizing(border-box);\r\n  }\r\n\r\n  #page_content {\r\n    width: 100%;\r\n    flex-grow: 1;\r\n    flex: 1 1 auto;\r\n    -webkit-flex: 1 1 auto;\r\n    position: relative;\r\n    height: 100%;\r\n    display: flex;\r\n    @include box-sizing(border-box);\r\n    overflow: auto;\r\n    // min-height:0;\r\n\r\n    &:after {\r\n      content: $empyrean_logo;\r\n      position: fixed;\r\n      left: 50%;\r\n      top: 50%;\r\n      transform: translate(-50%, -50%);\r\n      color: rgba($navy, 0.1);\r\n      font-family: 'empyrean_icons';\r\n      font-size: 200px;\r\n      z-index: -1;\r\n    }\r\n\r\n    &.no_logo {\r\n      &:after {\r\n        display: none;\r\n      }\r\n    }\r\n\r\n    #page_content_inner {\r\n      // padding: 10px;\r\n      padding: 0px;\r\n\r\n      .input-structure {\r\n        height: calc(100vh - 153px);\r\n        position: relative;\r\n\r\n        display: flex;\r\n        flex-direction: column;\r\n        -webkit-flex-direction: column;\r\n        justify-content: flex-start;\r\n        flex-wrap: nowrap;\r\n        -webkit-flex-wrap: nowrap;\r\n        align-items: stretch;\r\n        -webkit-align-items: stretch;\r\n        width: 100%;\r\n        min-height: 0;\r\n\r\n        #button-strip {\r\n        }\r\n\r\n        #results {\r\n          width: 100%;\r\n          flex-grow: 1;\r\n          flex: 1 1 auto;\r\n          -webkit-flex: 1 1 auto;\r\n          position: relative;\r\n        }\r\n      }\r\n\r\n      #page_body {\r\n      }\r\n    }\r\n  }\r\n\r\n  #page_footer {\r\n    @include box-sizing(border-box);\r\n    position: relative;\r\n    // min-height:0;\r\n  }\r\n}\r\n","a.text_link {\r\n  cursor: pointer;\r\n}\r\n\r\ninput,\r\nbutton,\r\ntextarea {\r\n  font-size: 1rem;\r\n  font-family: $font_pack !important;\r\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n}\r\n\r\n.btn_normal {\r\n  width: auto;\r\n  background-color: transparent;\r\n  position: relative;\r\n  color: $app_color;\r\n  line-height: 20px;\r\n  margin: 0px;\r\n  padding: 5px 10px;\r\n  overflow: visible;\r\n  @include border-radius(3px);\r\n  -webkit-appearance: none;\r\n  box-sizing: border-box;\r\n  display: inline-block;\r\n  border: 0px solid;\r\n  cursor: pointer;\r\n  @include transition(all 0.3s ease);\r\n  min-width: 20px;\r\n  @include box-sizing(border-box);\r\n  text-transform: uppercase;\r\n  font-weight: 600;\r\n  font-size: 0.76rem;\r\n\r\n  &:hover,\r\n  &:focus {\r\n    color: $blue;\r\n  }\r\n\r\n  &:active {\r\n  }\r\n\r\n  &:disabled {\r\n    color: $grey !important;\r\n    cursor: default !important;\r\n    background-color: rgba($lighter_grey, 0.2) !important;\r\n    border: 0px solid !important;\r\n    padding: 5px 10px;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      border-color: $border-color !important;\r\n      background-color: rgba($lighter_grey, 0.2) !important;\r\n      color: $grey !important;\r\n    }\r\n  }\r\n\r\n  &.btn_green {\r\n    background-color: $btn_primary_bg;\r\n    color: $btn_primary_color;\r\n\r\n    &:focus,\r\n    &:hover {\r\n      background-color: $btn_primary_bg_hover;\r\n      color: $btn_primary_color_hover;\r\n    }\r\n\r\n    &:disabled {\r\n      color: $grey !important;\r\n      cursor: default !important;\r\n      background-color: rgba($lighter_grey, 0.2) !important;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        background-color: rgba($lighter_grey, 0.2) !important;\r\n        color: $grey !important;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.btn_blue {\r\n    background-color: $btn_secondary_bg;\r\n    color: $btn_secondary_color;\r\n\r\n    &:focus,\r\n    &:hover {\r\n      background-color: $btn_secondary_bg_hover;\r\n      color: $btn_secondary_color_hover;\r\n    }\r\n\r\n    &:disabled {\r\n      color: $grey !important;\r\n      cursor: default !important;\r\n      background-color: rgba($lighter_grey, 0.2) !important;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        background-color: rgba($lighter_grey, 0.2) !important;\r\n        color: $grey !important;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.btn_white {\r\n    background-color: transparent;\r\n    color: $white;\r\n\r\n    &:focus,\r\n    &:hover {\r\n      background-color: rgba($white, 0.1);\r\n      color: $white;\r\n    }\r\n\r\n    &:disabled {\r\n      color: $grey !important;\r\n      cursor: default !important;\r\n      background-color: rgba($lighter_grey, 0.2) !important;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        background-color: rgba($lighter_grey, 0.2) !important;\r\n        color: $grey !important;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.btn_notification {\r\n    background-color: $notification;\r\n    color: $white;\r\n\r\n    &:focus,\r\n    &:hover {\r\n      background-color: darken($notification, 10%);\r\n      color: $white;\r\n    }\r\n\r\n    &:disabled {\r\n      color: $grey !important;\r\n      cursor: default !important;\r\n      background-color: rgba($lighter_grey, 0.2) !important;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        background-color: rgba($lighter_grey, 0.2) !important;\r\n        color: $grey !important;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.btn_outline_white {\r\n    background-color: transparent;\r\n    color: $white;\r\n    padding: 4px 9px;\r\n    border: 1px solid $white;\r\n    @include transition(all 0s ease);\r\n\r\n    &:focus,\r\n    &:hover {\r\n      background-color: $white;\r\n      color: $app_color;\r\n      border: 0px solid $white;\r\n      padding: 5px 10px;\r\n    }\r\n\r\n    &.btn_no_border {\r\n      padding: 5px 10px;\r\n    }\r\n\r\n    &:disabled {\r\n      color: $grey !important;\r\n      cursor: default !important;\r\n      background-color: rgba($lighter_grey, 0.2) !important;\r\n      border: 0px solid !important;\r\n      padding: 5px 10px;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        border-color: $border-color !important;\r\n        background-color: rgba($lighter_grey, 0.2) !important;\r\n        color: $grey !important;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.btn_negative {\r\n    background-color: transparent;\r\n    color: $navy;\r\n    padding: 4px 9px;\r\n    border: 1px solid $navy;\r\n    @include transition(all 0s ease);\r\n\r\n    &:focus,\r\n    &:hover {\r\n      background-color: $navy;\r\n      color: $white;\r\n      border: 0px solid $navy;\r\n      padding: 5px 10px;\r\n    }\r\n\r\n    &:disabled {\r\n      color: $grey !important;\r\n      cursor: default !important;\r\n      background-color: rgba($lighter_grey, 0.2) !important;\r\n      border: 0px solid !important;\r\n      padding: 5px 10px;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        border-color: $border-color !important;\r\n        background-color: rgba($lighter_grey, 0.2) !important;\r\n        color: $grey !important;\r\n      }\r\n    }\r\n\r\n    &.no_focus {\r\n      &:focus {\r\n        background-color: transparent;\r\n        color: $navy;\r\n        padding: 4px 9px;\r\n        border: 1px solid $navy;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.btn_green_outline {\r\n    background-color: transparent;\r\n    color: $green;\r\n    padding: 4px 9px;\r\n    border: 1px solid $green;\r\n    @include transition(all 0s ease);\r\n\r\n    &:focus,\r\n    &:hover {\r\n      background-color: $green;\r\n      color: $white;\r\n      border: 0px solid $green;\r\n      padding: 5px 10px;\r\n    }\r\n\r\n    &:disabled {\r\n      color: $grey !important;\r\n      cursor: default !important;\r\n      background-color: rgba($lighter_grey, 0.2) !important;\r\n      border: 0px solid !important;\r\n      padding: 5px 10px;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        border-color: $border-color !important;\r\n        background-color: rgba($lighter_grey, 0.2) !important;\r\n        color: $grey !important;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.btn_add_item {\r\n    background-color: transparent;\r\n    color: $navy;\r\n    padding: 5px 0px;\r\n    border: 0px solid $navy;\r\n    @include transition(all 0s ease);\r\n\r\n    &:focus,\r\n    &:hover {\r\n      background-color: transparent;\r\n      color: $green;\r\n      border: 0px solid $green;\r\n      padding: 5px 0px;\r\n    }\r\n\r\n    &:disabled {\r\n      color: $grey !important;\r\n      cursor: default !important;\r\n      background-color: rgba($lighter_grey, 0) !important;\r\n      border: 0px solid !important;\r\n      padding: 5px 0px;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        border-color: $border-color !important;\r\n        background-color: rgba($lighter_grey, 0) !important;\r\n        color: $grey !important;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.btn_icon_only {\r\n    padding: 4px 4px;\r\n\r\n    &.btn_no_border {\r\n      padding: 5px 5px;\r\n    }\r\n\r\n    &.btn_icon_small {\r\n      .btn_icon,\r\n      .btn_status {\r\n        span {\r\n          font-size: 12px;\r\n        }\r\n      }\r\n    }\r\n\r\n    .btn_icon,\r\n    .btn_status {\r\n      font-size: 16px;\r\n      height: 20px;\r\n      line-height: 20px;\r\n      width: 20px;\r\n      text-align: center;\r\n      display: block;\r\n      vertical-align: text-bottom; //text-bottom;\r\n\r\n      span {\r\n        display: block;\r\n        line-height: 20px;\r\n        width: 20px;\r\n        font-size: 16px;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.btn_icon_small {\r\n    padding: 4px 4px;\r\n\r\n    &.btn_no_border {\r\n      padding: 5px 5px;\r\n    }\r\n\r\n    .btn_icon,\r\n    .btn_status {\r\n      font-size: 12px;\r\n      height: 20px;\r\n      width: 20px;\r\n      text-align: center;\r\n      display: block;\r\n    }\r\n  }\r\n\r\n  &.btn_wide {\r\n    min-width: 100px;\r\n  }\r\n\r\n  &.btn_select {\r\n    min-width: 100px;\r\n    border: 1px solid $border_color;\r\n    padding: 4px 9px;\r\n  }\r\n\r\n  &.btn_form_input {\r\n    border: 1px solid $input_border;\r\n    @include border-radius(0px);\r\n    @include border-right-radius(4px);\r\n    padding: 4px;\r\n    background-color: $white;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      color: $primary_color;\r\n      border-color: $primary_color;\r\n    }\r\n  }\r\n\r\n  &.btn_no_border {\r\n    border: 0 solid !important;\r\n    padding-top: 5px;\r\n    padding-bottom: 5px;\r\n  }\r\n\r\n  &.btn_no_padding {\r\n    padding: 4px 0px;\r\n\r\n    &.btn_no_border {\r\n      padding: 5px 0;\r\n    }\r\n  }\r\n\r\n  &.btn_extra_padding {\r\n    padding: 4px 9px;\r\n\r\n    &.btn_no_border {\r\n      padding: 5px 10px;\r\n    }\r\n  }\r\n\r\n  &.btn_offset_margin {\r\n    margin: -5px 0; // This is useful for tables\r\n  }\r\n\r\n  &.btn_min_width {\r\n    display: inline-block;\r\n    width: 80px;\r\n  }\r\n\r\n  &.btn_table {\r\n    margin-top: -5px;\r\n    margin-bottom: -5px;\r\n  }\r\n\r\n  &.btn_hidden {\r\n    display: none;\r\n  }\r\n\r\n  > .btn_text {\r\n    line-height: 20px;\r\n    display: inline-block;\r\n\r\n    &.hidden_text {\r\n      position: absolute;\r\n      font-size: 0 !important;\r\n    }\r\n  }\r\n\r\n  > .btn_icon,\r\n  > .btn_status {\r\n    position: relative;\r\n    pointer-events: none;\r\n    display: inline-block;\r\n    vertical-align: text-bottom;\r\n    color: inherit;\r\n    line-height: 20px;\r\n\r\n    span {\r\n      font-size: 16px;\r\n      display: block;\r\n    }\r\n\r\n    &.big_icon {\r\n      span {\r\n        font-size: 20px;\r\n      }\r\n    }\r\n  }\r\n\r\n  > .btn_status {\r\n    &.status_invalid {\r\n      color: $red;\r\n    }\r\n  }\r\n\r\n  > .btn_helper {\r\n    float: right;\r\n    margin-left: 5px;\r\n    line-height: 20px;\r\n\r\n    span {\r\n      font-size: 10px;\r\n      display: block;\r\n      line-height: 20px;\r\n    }\r\n  }\r\n\r\n  > .btn_icon_arrow {\r\n    float: right;\r\n    margin-left: 5px;\r\n    line-height: 20px;\r\n\r\n    span {\r\n      font-size: 16px;\r\n      display: block;\r\n      line-height: 20px;\r\n    }\r\n  }\r\n}\r\n\r\nbutton::-moz-focus-inner {\r\n  padding: 0;\r\n  border: 0;\r\n}\r\n\r\n.btn_group {\r\n  .btn_group_left {\r\n    float: left;\r\n    padding: 4px;\r\n    border-right: 0px solid !important;\r\n    @include border-radius(4px 0 0 4px);\r\n\r\n    &.btn_no_border {\r\n      padding: 5px;\r\n    }\r\n\r\n    &.btn_grey {\r\n      padding: 4px;\r\n      border: 1px solid $light_grey !important;\r\n\r\n      &:focus,\r\n      &:hover {\r\n        border: 1px solid $dark_grey !important;\r\n      }\r\n\r\n      &:disabled {\r\n        color: $grey !important;\r\n        cursor: default !important;\r\n        background-color: $lighter_grey !important;\r\n        border-color: $lighter_grey !important;\r\n\r\n        &:hover,\r\n        &:focus {\r\n          border-color: $lighter_grey !important;\r\n          background-color: $lighter_grey !important;\r\n          color: $grey !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .btn_group_right {\r\n    float: left;\r\n    padding: 4px;\r\n    @include border-radius(0 4px 4px 0);\r\n\r\n    &.btn_no_border {\r\n      padding: 5px;\r\n    }\r\n\r\n    &.btn_grey {\r\n      padding: 4px;\r\n      border: 1px solid $light_grey !important;\r\n\r\n      &:focus,\r\n      &:hover {\r\n        border: 1px solid $dark_grey !important;\r\n      }\r\n\r\n      &:disabled {\r\n        color: $grey !important;\r\n        cursor: default !important;\r\n        background-color: $lighter_grey !important;\r\n        border-color: $lighter_grey !important;\r\n\r\n        &:hover,\r\n        &:focus {\r\n          border-color: $lighter_grey !important;\r\n          background-color: $lighter_grey !important;\r\n          color: $grey !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","\r\n// This structure is mainly used for Checkboxes and Radio Lists\r\nfieldset.form_row {\r\n\tmargin-bottom: 5px;\r\n\tposition: relative;\r\n\r\n\t&.no_padding {\r\n\t\tmargin-bottom: 0;\r\n\t}\r\n\r\n\t&.inline {\r\n\t\tposition: relative;\r\n\r\n\t\tlegend {\r\n\t\t\twidth: 35%;\r\n\t\t\tposition: absolute;\r\n\t\t\tleft: 0;\r\n\t\t\ttop: 0\r\n\t\t}\r\n\r\n\t\t>.form_group {\r\n\t\t\twidth: 65%;\r\n\t\t\tmargin-left: 35%;\r\n\t\t}\r\n\r\n\t\t&.auto_width {\r\n\t\t\tdisplay: inline-block;\r\n\r\n\t\t\tlegend {\r\n\t\t\t\twidth: auto;\r\n\t\t\t\tmargin-right: 10px;\r\n\t\t\t\tposition: relative;\r\n\t\t\t\tleft: auto;\r\n\t\t\t\ttop: auto;\r\n\t\t\t}\r\n\r\n\t\t\t>.form_group {\r\n\t\t\t\tdisplay: inline-block;\r\n\t\t\t\twidth: auto;\r\n\t\t\t\tmargin-left: auto;\r\n\t\t\t\twhite-space: nowrap;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&.split_50 {\r\n\t\t\t>.data_label {\r\n\t\t\t\tfloat: left;\r\n\t\t\t\twidth: 50%;\r\n\t\t\t\t// padding: 5px 5px 5px 0;\r\n\t\t\t}\r\n\r\n\t\t\t>.data_value {\r\n\t\t\t\tfloat: left;\r\n\t\t\t\twidth: 50%;\r\n\t\t\t\t// padding: 5px 5px 5px 0;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&.layout_horizontal {\r\n\t\t>.form_group {\r\n\r\n\t\t\t>.form_row {\r\n\t\t\t\twidth: auto;\r\n\t\t\t\tdisplay: inline-block;\r\n\t\t\t\tfloat: left;\r\n\t\t\t\tmargin-right: 10px;\r\n\t\t\t\t\r\n\t\t\t\t&:last-of-type {\r\n\t\t\t\t\tmargin-right:0;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&.layout_stacked {\r\n\t\t>.form_group {\r\n\t\t\t&.split_2 {\r\n\t\t\t\t>.form_row {\r\n\t\t\t\t\twidth: 50%;\r\n\t\t\t\t\tfloat: left;\r\n\r\n\t\t\t\t\tlabel {\r\n\t\t\t\t\t\tdisplay: block;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t>.form_row {\r\n\t\t\t\twidth: auto;\r\n\t\t\t\tdisplay: block;\r\n\r\n\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.form_row {\r\n\t\tmargin-bottom: 0;\r\n\t}\r\n}\r\n\r\n\r\n.form_row {\r\n\tmargin-bottom: 5px;\r\n\tposition: relative;\r\n\r\n\t&:after {\r\n\t    clear: both;\r\n\t    content: '';\r\n\t    display: block;\r\n\t    height: 0;\r\n\t    visibility: hidden;\r\n\t}\r\n\r\n\t&.no_padding {\r\n\t\tmargin-bottom: 0;\r\n\t}\r\n\r\n\t&.align_center {\r\n\t\ttext-align: center;\r\n\t}\r\n\r\n\t&.align_to_label {\r\n\t\tpadding-left: 35%;\r\n\t}\r\n\r\n\t&.align_to_label_50 {\r\n\t\tpadding-left: 50%;\r\n\t}\r\n\r\n\t&.inline {\r\n\t\t>.form_label {\r\n\t\t\tfloat: left;\r\n\t\t\twidth: 35%;\r\n\t\t}\r\n\r\n\t\t>.form_input {\r\n\t\t\tfloat: left;\r\n\t\t\twidth: 65%;\r\n\t\t}\r\n\r\n\t\t&.split_50 {\r\n\t\t\t>.form_label {\r\n\t\t\t\tfloat: left;\r\n\t\t\t\twidth: 50%;\r\n\t\t\t}\r\n\r\n\t\t\t>.form_input {\r\n\t\t\t\tfloat: left;\r\n\t\t\t\twidth: 50%;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t>.form_label {\r\n\t\tdisplay: block;\r\n\r\n\t\t&.hidden_label {\r\n\t\t\tposition: absolute;\r\n\t\t\tfont-size: 0;\r\n\t\t\t@include opacity (0);\r\n\r\n\t\t\tlabel {\r\n\t\t\t\tpadding:0;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\tlabel {\r\n\t\t\tline-height: 20px;\r\n\t\t\tpadding: 5px 5px 5px 0;\r\n\t\t\tdisplay: block;\r\n\r\n\t\t\t.label_right {\r\n\t\t\t\tfloat: right;\r\n\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t>.form_input {\r\n\t\tdisplay: block;\r\n\t}\r\n\r\n\t\r\n\r\n\t.form_input {\r\n\t\t// Readonly Lock Icon\r\n\t\t&.readonly {\r\n\t\t\tposition: relative;\r\n\r\n\t\t\t\r\n\r\n\t\t\t.inputbox {\r\n\t\t\t\tpadding-right: 25px !important;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t// Has Inline Button \r\n\t\t&.input_has_button {\r\n\t\t\tposition: relative;\r\n\r\n\t\t\t.inputbox {\r\n\t\t\t\tpadding-right: 35px !important;\r\n\t\t\t}\r\n\r\n\t\t\t.form_input_button {\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\tright: 0;\r\n\t\t\t\ttop: 0;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t// Has Helper Text\r\n\t\t&.input_has_helper {\r\n\t\t\tposition: relative;\r\n\t\t\tpadding-right: 30px;\r\n\t\t\t@include box-sizing(border-box);\r\n\r\n\r\n\t\t\t.form_input_helper {\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\tline-height: 20px;\r\n\t\t\t\ttop: 5px;\r\n\t\t\t\tright: 0;\r\n\t\t\t\tmin-width: 25px;\r\n\t\t\t\ttext-align: left;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.inputbox_inline_text {\r\n\t\t\tmargin-left: 5px;\r\n\t\t\tdisplay: inline-block;\r\n\t\t}\r\n\t}\r\n\r\n\t.form_error {\r\n\t\tdisplay: block;\r\n\t\tcolor: $red;\r\n\t\tline-height: 20px;\r\n\t\tpadding:5px 0;\r\n\t}\r\n\r\n\t&.auto_width {\r\n\t\tdisplay: inline-block;\r\n\t}\r\n}\r\n\r\n\r\n\r\n.flex_group {\r\n\tdisplay: flex;\r\n\tflex-direction: rows;\r\n\t-webkit-flex-direction: rows;\r\n\twidth: 100%;\r\n\tjustify-content: flex-start;\r\n\tflex-wrap:wrap;\r\n\t-webkit-flex-wrap: wrap;\r\n\tmargin-top: 5px;\r\n\r\n\t&.flex_end {\r\n\t\tjustify-content: flex-end;\r\n\t}\r\n\r\n\t&:first-of-type {\r\n\t\tmargin-top: 0;\r\n\t}\r\n\r\n\t&.flex_no_wrap {\r\n\t\tflex-wrap:nowrap;\r\n\t\t-webkit-flex-wrap: nowrap;\r\n\t}\r\n\t\r\n\r\n\t.flex_row {\r\n\t\t&:after {\r\n\t\t    clear: both;\r\n\t\t    content: '';\r\n\t\t    display: block;\r\n\t\t    height: 0;\r\n\t\t    visibility: hidden;\r\n\t\t}\r\n\r\n\t\t>.form_label {\r\n\t\t\twidth: auto;\r\n\t\t}\r\n\r\n\t\t>.form_input {\r\n\t\t\twidth: auto;\r\n\t\t}\r\n\r\n\t\t&.flex_grow {\r\n\t\t\tflex-grow:1; // modify\r\n\t\t\tflex: 1 1 auto;\r\n\t\t\t-webkit-flex: 1 1 auto;\r\n\t\t}\r\n\t}\r\n\r\n\t.flex_row_action {\r\n\t\tmargin-left: auto;\r\n\t}\r\n}\r\n\r\n.form_helper_txt {\r\n\tline-height: 20px;\r\n\tpadding: 5px 0;\r\n\tdisplay: block;\r\n}\r\n\r\n.form_supplementary_text {\r\n\tline-height: 20px;\r\n\tpadding: 5px 0;\r\n\tdisplay: block;\r\n\tfont-style: italic;\r\n\tcolor:$mid_grey;\r\n}\r\n\r\n\r\n/* Data Rows */\r\n\r\n.data_row {\r\n\tdisplay: block;\r\n\tmargin-bottom: 5px;\r\n\tposition: relative;\r\n\r\n\t&:after {\r\n\t    clear: both;\r\n\t    content: '';\r\n\t    display: block;\r\n\t    height: 0;\r\n\t    visibility: hidden;\r\n\t}\r\n\r\n\t&.no_padding {\r\n\t\tmargin-bottom: 0;\r\n\t}\r\n\r\n\t&.inline {\r\n\t\t>.data_label {\r\n\t\t\tfloat: left;\r\n\t\t\twidth: 35%;\r\n\t\t\t// padding: 5px 5px 5px 0;\r\n\t\t}\r\n\r\n\t\t>.data_value {\r\n\t\t\tfloat: left;\r\n\t\t\twidth: 65%;\r\n\t\t\t// padding: 5px 5px 5px 0;\r\n\t\t}\r\n\r\n\t\t&.split_50 {\r\n\t\t\t>.data_label {\r\n\t\t\t\tfloat: left;\r\n\t\t\t\twidth: 50%;\r\n\t\t\t\t// padding: 5px 5px 5px 0;\r\n\t\t\t}\r\n\r\n\t\t\t>.data_value {\r\n\t\t\t\tfloat: left;\r\n\t\t\t\twidth: 50%;\r\n\t\t\t\t// padding: 5px 5px 5px 0;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t>.data_label {\r\n\t\tdisplay: block;\r\n\t\tline-height: 20px;\r\n\t\tdisplay: block;\r\n\t\t@include box-sizing(border-box);\r\n\r\n\t\t&.hidden_label {\r\n\t\t\tposition: absolute;\r\n\t\t\tfont-size: 0;\r\n\t\t\t@include opacity (0);\r\n\t\t}\r\n\r\n\t\t&.no_padding {}\r\n\r\n\t}\r\n\r\n\t>.data_value {\r\n\t\tdisplay: block;\r\n\t\tline-height: 20px;\r\n\t\tdisplay: block;\r\n\t\t@include box-sizing(border-box);\r\n\t}\r\n\r\n\t&.mimic_form_row {\r\n\t\t>.data_label {\r\n\t\t\tpadding: 5px 0;\r\n\t\t}\r\n\r\n\t\t>.data_value {\r\n\t\t\tpadding: 5px 0;\r\n\t\t}\r\n\t}\r\n}",".panel_title {\r\n\tfont-size: 1.4rem;\r\n\tfont-weight: 400;\r\n\tline-height: 20px;\r\n\tpadding: 5px 0;\r\n\r\n\t&.inline {\r\n\t\tdisplay: inline-block;\t\t\t\r\n\t}\r\n}\r\n\r\n.login_title {\r\n\tfont-size: 1.4rem;\r\n\tfont-weight: 400;\r\n\tline-height: 20px;\r\n\tpadding: 5px 0;\r\n}\r\n\r\n.context_title {\r\n\tfont-size: 1.2rem; // 1.4rem;\r\n\tfont-weight: 400;\r\n\tline-height: 20px;\r\n\tpadding: 5px 0;\r\n  color: $navy;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.dropdown_title {\r\n\tfont-size: 1.2rem;\r\n\tfont-weight: 300;\r\n\tline-height: 20px;\r\n\tpadding: 5px 0;\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n\r\n.notification_title {\r\n\tfont-weight: 600;\r\n\ttext-transform: uppercase;\r\n\tline-height: 20px;\r\n\tfont-size: 0.8rem;\r\n}","#page_header {\r\n  background-color: $navy;\r\n  color: $white;\r\n\r\n  .page_inner_container {\r\n    padding: 10px;\r\n    @include box-sizing(border-box);\r\n\r\n    #header_left {\r\n      float: left;\r\n      #header_logo {\r\n        float: left;\r\n        line-height: 30px;\r\n        margin-right: 20px;\r\n\r\n        #header_logo_icon {\r\n          float: left;\r\n\r\n          a {\r\n            display: block;\r\n            color: $white;\r\n            text-decoration: none;\r\n            line-height: 30px;\r\n            font-size: 30px;\r\n          }\r\n        }\r\n\r\n        #header_logo_product {\r\n          float: left;\r\n          margin-left: 10px;\r\n\r\n          span {\r\n            display: block;\r\n            letter-spacing: 0.1rem;\r\n            text-transform: uppercase;\r\n            color: $white;\r\n          }\r\n        }\r\n      }\r\n\r\n      #header_create_simulation {\r\n        float: left;\r\n\r\n        button {\r\n          margin-right: 5px;\r\n          float: left;\r\n        }\r\n\r\n        #save_status {\r\n          float: left;\r\n          margin-left: 10px;\r\n          line-height: 20px;\r\n          padding: 5px 0;\r\n          @include opacity(0.5);\r\n        }\r\n      }\r\n    }\r\n\r\n    #header_right {\r\n      float: right;\r\n\r\n      #header_model_data {\r\n        float: left;\r\n        margin-right: 10px;\r\n      }\r\n\r\n      #header_model_structure {\r\n        float: left;\r\n        margin-right: 20px;\r\n      }\r\n\r\n      #header_quick_links {\r\n        float: left;\r\n        margin-right: 10px;\r\n      }\r\n\r\n      #header_user {\r\n        float: left;\r\n      }\r\n      #header_guide {\r\n        float: left;\r\n      }      \r\n    }\r\n  }\r\n}\r\n\r\n.header33 {\r\n  width: 50%;\r\n}\r\n","#page_header_alt {\r\n\ttext-align: center;\r\n\r\n\t.page_inner_container {\r\n\t\tpadding: 10px;\r\n        @include box-sizing(border-box);\r\n\r\n\t\t#header_logo_center {\r\n\t\t\tmargin: 40px auto 0;\r\n\t\t\theight: 100px;\r\n\r\n\t\t\timg {\r\n\t\t\t\theight: 100%;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n","#page_footer {\r\n\tbackground-color: $light_grey;\r\n\tcolor: $mid_grey;\r\n\r\n\t.page_inner_container {\r\n\t\tpadding: 10px;\r\n        @include box-sizing(border-box);\r\n\r\n        &.no_padding {\r\n        \tpadding: 0;\r\n        }\r\n\r\n\t\t.footer_text {\r\n\t\t\ttext-align: center;\r\n\t\t\tline-height: 20px;\r\n\t\t\tpadding: 5px;\r\n\t\t}\r\n\t}\r\n}",".col_group {\r\n\t&:after {\r\n\t    clear: both;\r\n\t    content: '';\r\n\t    display: block;\r\n\t    height: 0;\r\n\t    visibility: hidden;\r\n\t}\r\n\r\n\t.col_item {\r\n\t\tfloat: left;\r\n\t\t@include box-sizing(border-box);\r\n\t\tpadding: 5px;\r\n\t\twidth: 100%;\r\n\t\tposition: relative;\r\n\r\n\t\t&.no_padding {\r\n\t\t\tpadding: 0;\r\n\t\t}\r\n\r\n\t\t.panel_container {\r\n\t\t}\r\n\t}\r\n\r\n\t&.split_4 {\r\n\r\n\t\t.col_item {\r\n\t\t\twidth: 25%;\r\n\r\n\t\t\t@media #{$tablet} {\r\n\t\t\t\twidth: 50%;\r\n\t\t\t}\r\n\r\n\t\t\t@media #{$mobile} {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&.max_height {\r\n\r\n\t\t\t.col_item {\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\tleft: 0px;\r\n\t\t\t\ttop: 0px;\r\n\t\t\t\tbottom: 0px;\r\n\r\n\t\t\t\t.panel_container {\r\n\t\t\t\t\theight: 100%;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&:nth-child(2) {\r\n\t\t\t\t\tleft: calc(100% / 4);\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&:nth-child(3) {\r\n\t\t\t\t\tleft: calc((100% / 4)*2);\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&:nth-child(4) {\r\n\t\t\t\t\tleft: calc((100% / 4)*3);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&.split_3 {\r\n\r\n\t\t.col_item {\r\n\t\t\twidth: calc(100% / 3);\r\n\r\n\t\t\t@media #{$tablet_landscape} {\r\n\t\t\t\twidth: calc(100% / 3);\r\n\t\t\t}\r\n\r\n\t\t\t@media #{$mobile, $tablet_portrait} {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&.max_height {\r\n\r\n\t\t\t.col_item {\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\tleft: 0px;\r\n\t\t\t\ttop: 0px;\r\n\t\t\t\tbottom: 0px;\r\n\r\n\t\t\t\t.panel_container {\r\n\t\t\t\t\theight: 100%;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&:nth-child(2) {\r\n\t\t\t\t\tleft: calc(100% / 3);\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&:nth-child(3) {\r\n\t\t\t\t\tleft: calc((100% / 3)*2);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&.split_2 {\r\n\r\n\t\t.col_item {\r\n\t\t\twidth: 50%;\r\n\r\n\t\t\t@media #{$tablet_landscape} {\r\n\t\t\t\twidth: 50%;\r\n\t\t\t}\r\n\r\n\t\t\t@media #{$mobile, $tablet_portrait} {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t}\r\n\r\n\t\t\t&.extra_space {\r\n\t\t\t\tpadding-right: 15px;\r\n\r\n\t\t\t\t&:last-of-type {\r\n\t\t\t\t\tpadding-right: 0;\r\n\t\t\t\t\tpadding-left: 15px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&.max_height {\r\n\r\n\t\t\t.col_item {\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\tleft: 0px;\r\n\t\t\t\ttop: 0px;\r\n\t\t\t\tbottom: 0px;\r\n\r\n\t\t\t\t.panel_container {\r\n\t\t\t\t\theight: 100%;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&:nth-child(2) {\r\n\t\t\t\t\tleft: calc(100% / 2);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\r\n\t&.max_height {\r\n\t\tposition: fixed;\r\n\t\tleft: 65px;\r\n\t\ttop: 65px;\r\n\t\tbottom:5px;\r\n\t\tright: 5px;\r\n\r\n\t\t.col_item {\r\n\t\t}\r\n\t}\r\n}\r\n\r\n\r\n// IE 11 Overrides\r\n\r\n\r\n\t@media all and (-ms-high-contrast:none) {\r\n     \t.column_content.column_content_inner.column_section {\r\n     \t\tdisplay: flex; // IE11 Fix\r\n   \t\t\tflex-direction: column; // IE11 Fix\r\n   \t\t\tmin-height: 1px;\r\n     \t} /* IE10 */\r\n     \t*::-ms-backdrop, \r\n     \t.column_content.column_content_inner.column_section { \r\n     \t\tdisplay: flex; flex-direction: column; min-height: 1px;\r\n     \t} /* IE11 */\r\n\r\n    }\r\n","$col_width_2: calc((100% / 2) - 20px);\r\n$col_width_3: calc((100% / 3) - 20px);\r\n\r\n$base_max_width: 1279px;\r\n\r\n.grid_container {\r\n\tdisplay: flex;\r\n\tjustify-content: space-around;\r\n\talign-items: stretch;\r\n\tflex-flow: wrap;\r\n\tflex-direction: row;\r\n\theight: 100%;\r\n\tmax-width: 1440px; // Comment this out to force the page to go full width\r\n\tmargin:0px auto;\r\n\tmin-height:0;\r\n\t-webkit-justify-content: space-around;\r\n\t-webkit-align-items: stretch;\r\n\t-webkit-flex-flow: wrap;\r\n\t-webkit-flex-direction: row;\r\n\r\n\t&.auto_height {\r\n\t\theight: auto;\r\n\t}\r\n\r\n\t&.fixed_height {\r\n\t\theight: 100%;\r\n\t\tdisplay: flex;\r\n\r\n\t\t@media (max-width: $base_max_width) {\r\n\t\t\tdisplay: flex;\r\n\t\t\theight: 100%;\r\n\t\t}\r\n\t}\r\n\r\n\t@media (max-width: $base_max_width) {\r\n    \tdisplay: block;\r\n    \theight: auto;\r\n    }\r\n\r\n\r\n  \t&.columns_3 {\r\n  \t\t.col {\r\n  \t\t\twidth: $col_width_3;\r\n\r\n  \t\t\t@media (max-width: $base_max_width) {\r\n\t    \t\twidth: calc(100% - 20px);\r\n\t    \t}\r\n  \t\t}\r\n\t}\r\n\r\n\t&.columns_2 {\r\n  \t\t.col {\r\n  \t\t\twidth: $col_width_2;\r\n\r\n  \t\t\t@media (max-width: $base_max_width) {\r\n\t    \t\twidth: calc(100% - 20px);\r\n\t    \t}\r\n  \t\t}\r\n\t}\r\n\r\n\t&.columns_1 {\r\n  \t\t.col {\r\n  \t\t\twidth: calc(100% - 20px);\r\n\r\n  \t\t\t@media (max-width: $base_max_width) {\r\n\t    \t\twidth: calc(100% - 20px);\r\n\t    \t}\r\n  \t\t}\r\n\t}\r\n\r\n\t.col {\r\n\t\t@include box-sizing(border-box);\r\n\t\tmargin: 10px auto;\r\n\t\theight: 100%;\r\n\t\t\r\n\t\t@media (max-width: $base_max_width) {\r\n    \t\twidth: inherit;\r\n    \t\tmargin: 10px auto;\r\n    \t\t// margin-bottom: 5px;\r\n\t\t}\r\n\t}\r\n\r\n}\r\n\r\n\r\n\r\n\r\n","// // Common properties\r\n// .animation {\r\n//   animation-duration: 1s;\r\n//   animation-fill-mode: forwards;\r\n//   animation-timing-function: ease-in-out;\r\n// }\r\n\r\n// // APPEAR\r\n\r\n// .appear {\r\n//   @extend .animation;\r\n//   height: 100%;\r\n//   animation-name: appearAnimation;\r\n// }\r\n\r\n// @keyframes appearAnimation {\r\n//   0% {\r\n//     height: 0%;\r\n//     // top: -100%;\r\n//   }\r\n//   100% {\r\n//     height: 100%;\r\n//     // top: 0;\r\n//   }\r\n// }\r\n\r\n// // DISAPPEAR\r\n\r\n// .disappear {\r\n//   @extend .animation;\r\n//   height: 0%;\r\n//   animation-name: disappearAnimation;\r\n// }\r\n\r\n// @keyframes disappearAnimation {\r\n//   0% {\r\n//     // top: 0;\r\n//     height: 100%;\r\n//   }\r\n//   100% {\r\n//     // top: -100%;\r\n//     height: 0;\r\n//   }\r\n// }\r\n\r\n.fadein {\r\n  animation: fadein 0.3s;\r\n}\r\n.fadeout {\r\n  animation: fadeout 0.3s;\r\n}\r\n\r\n@keyframes fadein {\r\n  from {\r\n    opacity: 0;\r\n    transform: translate3d(0, -0.5rem, 0);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translate3d(0, 0, 0);\r\n  }\r\n}\r\n@keyframes fadeout {\r\n  from {\r\n    opacity: 1;\r\n  }\r\n  to {\r\n    opacity: 0;\r\n  }\r\n}\r\n","@import './../variables';\r\n@import './../common/animations';\r\n\r\n/*\r\n\r\n  Modal Dialog Layout\r\n\r\n*/\r\n/*\r\n\r\n  TODO(mdc-migration): The following rule targets internal classes of dialog that may no longer apply for the MDC version.\r\n\r\n*/\r\n\r\nhtml {\r\n\r\n  --mdc-filled-text-field-container-color: white;\r\n\r\n}\r\n\r\n\r\n.mat-mdc-form-field {\r\n  font-size: inherit;\r\n  font-weight: 400;\r\n  line-height: 1.125;\r\n  font-family: Roboto, \"Helvetica Neue\", sans-serif;\r\n  letter-spacing: normal;\r\n}\r\n\r\n/*\r\n\r\n  TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.\r\n\r\n*/\r\n.mat-form-field-appearance-legacy .mat-form-field-wrapper {\r\n  padding-bottom: 1.25em;\r\n}\r\n\r\n/*\r\n\r\n  TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.\r\n\r\n*/\r\n.mat-form-field-appearance-legacy .mat-form-field-infix {\r\n  padding: .4375em 0;\r\n}\r\n\r\n/*\r\n\r\n  TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.\r\n\r\n*/\r\n.mat-form-field-appearance-legacy .mat-form-field-subscript-wrapper {\r\n  margin-top: .5416666667em;\r\n  top: calc(100% - 1.6666666667em);\r\n}\r\n\r\n.dialog-model {\r\n  display: flex;\r\n  flex-direction: column;\r\n  -webkit-flex-direction: column;\r\n  justify-content: flex-start;\r\n  flex-wrap: nowrap;\r\n  -webkit-flex-wrap: nowrap;\r\n  align-items: stretch;\r\n  -webkit-align-items: stretch;\r\n  height: 100%;\r\n  width: 100%;\r\n  padding: 0 !important;\r\n  max-width: 100vw;\r\n  border-radius: 5px;\r\n\r\n  .modal-header,\r\n  .modal-footer,\r\n  .modal-body {\r\n    &-left,\r\n    &-center,\r\n    &-right {\r\n      position: relative;\r\n      display: flex;\r\n      flex-direction: row;\r\n      flex: 1 auto;\r\n      align-items: stretch;\r\n    }\r\n\r\n    &-left {\r\n      justify-content: flex-start;\r\n    }\r\n    // For all \"-center\" elements\r\n    &-center {\r\n      justify-content: center;\r\n    }\r\n    // For all \"-right\" elements\r\n    &-right {\r\n      justify-content: flex-end;\r\n    }\r\n  }\r\n\r\n  // For all \"-left\" elements\r\n  *[class$='-left'],\r\n  *[class$='-center'],\r\n  *[class$='-right'] {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex: 1 auto;\r\n    align-items: stretch;\r\n  }\r\n\r\n  *[class$='-left'] {\r\n    justify-content: flex-start;\r\n  }\r\n  // For all \"-center\" elements\r\n  *[class$='-center'] {\r\n    justify-content: center;\r\n  }\r\n  // For all \"-right\" elements\r\n  *[class$='-right'] {\r\n    justify-content: flex-end;\r\n  }\r\n\r\n  .scrollable {\r\n    &-y {\r\n      overflow: hidden;\r\n      overflow-y: auto;\r\n    }\r\n    &-x {\r\n      overflow: hidden;\r\n      overflow-x: auto;\r\n    }\r\n    &:not(-y):not(-x) {\r\n      overflow: auto;\r\n    }\r\n  }\r\n\r\n  .panel-left,\r\n  .panel-right {\r\n    position: relative;\r\n\r\n    // Dragbar UI\r\n    &.with_dragbar:before {\r\n      content: '';\r\n      position: absolute;\r\n      left: -5px;\r\n      top: 50%;\r\n      width: 10px;\r\n      height: 30px;\r\n      margin-top: -15px;\r\n      border: 1px solid $border_color;\r\n      @include border-radius(5px);\r\n      background-color: $white;\r\n      @include box-sizing(border-box);\r\n    }\r\n\r\n    .dragbar {\r\n      // His parent should have position: relative\r\n      background-color: black;\r\n      height: 100%;\r\n      position: absolute;\r\n      top: 0;\r\n      left: -2px;\r\n      width: 5px;\r\n      cursor: col-resize;\r\n      @include opacity(0);\r\n\r\n      &:hover,\r\n      &:focus {\r\n        @include opacity(0.5);\r\n      }\r\n    }\r\n  }\r\n\r\n  .panel-right {\r\n    border-left: 1px solid #dfe0e1;\r\n  }\r\n\r\n  .panel-left {\r\n    border-right: 1px solid #dfe0e1;\r\n  }\r\n\r\n  .panel-left-actions,\r\n  .panel-right-actions {\r\n    padding: 15px;\r\n    border-bottom: 1px solid #dfe0e1;\r\n  }\r\n}\r\n\r\n// Level 1 Structure\r\n// Modal Header\r\n.modal-header {\r\n  background-color: $blue;\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: row;\r\n  min-height: 40px;\r\n}\r\n// Modal Body\r\n.modal-body {\r\n  flex-grow: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  -webkit-flex-direction: column;\r\n  justify-content: flex-start;\r\n  flex-wrap: nowrap;\r\n  -webkit-flex-wrap: nowrap;\r\n  align-items: stretch;\r\n  -webkit-align-items: stretch;\r\n  width: 100%;\r\n  height: 100%;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n  // overflow-y: auto;\r\n  position: relative;\r\n\r\n  .component-header,\r\n  .component-body,\r\n  .panel-main-header,\r\n  .panel-left,\r\n  .panel-main,\r\n  .panel-right,\r\n  .panel-main-header-left,\r\n  .panel-main-header-center,\r\n  .panel-main-header-right,\r\n  .modal-header-left,\r\n  .modal-header-center,\r\n  .modal-header-right,\r\n  .modal-footer-left,\r\n  .modal-footer-center,\r\n  .modal-footer-right,\r\n  .modal-header-left,\r\n  .modal-header-center,\r\n  .modal-header-right {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: row;\r\n  }\r\n  // Component Header\r\n  .component-header,\r\n  .panel-main-header {\r\n    position: relative;\r\n    min-height: fit-content;\r\n  }\r\n\r\n  .panel-main-header {\r\n    &.min-height {\r\n      min-height: 48px;\r\n    }\r\n  }\r\n\r\n  .panel-main-header-center,\r\n  .modal-header-center,\r\n  .modal-footer-center {\r\n    margin: 0 auto;\r\n    align-items: center;\r\n  }\r\n\r\n  .modal-header-right,\r\n  .panel-main-header-right,\r\n  .modal-footer-right {\r\n    margin: 0 0 0 auto;\r\n    align-items: flex-end;\r\n  }\r\n\r\n  .panel-left,\r\n  .modal-header-left,\r\n  .panel-main-header-left,\r\n  .modal-footer-left {\r\n    order: 0;\r\n  }\r\n\r\n  .panel-main,\r\n  .modal-header-center,\r\n  .panel-main-header-center,\r\n  .modal-footer-center {\r\n    order: 1;\r\n  }\r\n\r\n  .panel-right,\r\n  .modal-header-right,\r\n  .panel-main-header-right,\r\n  .modal-footer-right {\r\n    order: 2;\r\n  }\r\n\r\n  .panel-main-header-left,\r\n  .panel-main-header-center,\r\n  .panel-main-header-right {\r\n    padding: 0.5rem;\r\n    &:empty {\r\n      padding: 0;\r\n    }\r\n  }\r\n\r\n  .panel-left-actions,\r\n  .panel-right-actions {\r\n    &:empty {\r\n      padding: 0;\r\n    }\r\n  }\r\n\r\n  // Component Header\r\n  .component-header {\r\n    position: relative;\r\n    height: auto;\r\n    width: 100%;\r\n  }\r\n\r\n  // Component Body\r\n  .component-body {\r\n    position: relative;\r\n    // height: 60vh;\r\n    flex-grow: 1;\r\n    display: flex;\r\n    flex-direction: row;\r\n    -webkit-flex-direction: row;\r\n    justify-content: flex-start;\r\n    flex-wrap: nowrap;\r\n    -webkit-flex-wrap: nowrap;\r\n    align-items: stretch;\r\n    -webkit-align-items: stretch;\r\n    height: 100%;\r\n    width: 100%;\r\n    min-height: 0;\r\n    flex-flow: nowrap;\r\n    -webkit-flex-flow: nowrap;\r\n    margin: 0px;\r\n\r\n    // Panel Side\r\n    .panel-left,\r\n    .panel-right {\r\n      @extend .full-size;\r\n      display: flex;\r\n      flex-direction: column;\r\n      -webkit-flex-direction: column;\r\n      justify-content: flex-start;\r\n      flex-wrap: nowrap;\r\n      -webkit-flex-wrap: nowrap;\r\n      align-items: stretch;\r\n      -webkit-align-items: stretch;\r\n      min-height: 0;\r\n      flex-grow: 1;\r\n    }\r\n    // Panel Main\r\n    .panel-main {\r\n      position: relative;\r\n      flex-grow: 1;\r\n      // overflow: auto;\r\n      display: flex;\r\n      flex-direction: column;\r\n      -webkit-flex-direction: column;\r\n      // justify-content: flex-start;\r\n      justify-content: space-evenly;\r\n      flex-wrap: nowrap;\r\n      -webkit-flex-wrap: nowrap;\r\n      align-items: stretch;\r\n      -webkit-align-items: stretch;\r\n      height: 100%;\r\n      width: 100%;\r\n      min-height: 0;\r\n    }\r\n\r\n    .panel-main-body,\r\n    .panel-left-body,\r\n    .panel-right-body {\r\n      flex-grow: 1;\r\n    }\r\n\r\n    .panel-left,\r\n    .panel-left-header,\r\n    .panel-left-body,\r\n    .panel-left-footer,\r\n    .panel-right,\r\n    .panel-right-header,\r\n    .panel-right-body,\r\n    .panel-right-footer {\r\n      &:empty {\r\n        width: 0;\r\n        height: 0;\r\n      }\r\n    }\r\n\r\n    .panel-left-body,\r\n    .panel-right-body {\r\n      margin: 0;\r\n      padding: 1rem;\r\n    }\r\n\r\n    .panel-main-body {\r\n      margin: 0;\r\n      padding: 0;\r\n      height: 100%;\r\n      display: flex;\r\n    }\r\n  }\r\n}\r\n// Modal Footer\r\n.modal-footer {\r\n  position: relative;\r\n  padding: 15px;\r\n  border-top: 1px solid #dfe0e1;\r\n  display: flex;\r\n  flex-direction: row;\r\n\r\n  .modal-footer-right {\r\n    margin: 0 0 0 auto;\r\n\r\n    .btn_normal {\r\n      margin: 0 0 0 1rem;\r\n\r\n      &:first-of-type {\r\n        margin: 0;\r\n      }\r\n    }\r\n  }\r\n}\r\n// Dialog Content\r\n.content_container {\r\n  padding: 0px;\r\n  @include box-sizing(border-box);\r\n\r\n  &.padding--all {\r\n    padding: 15px;\r\n  }\r\n\r\n  &.padding--left {\r\n    padding-left: 15px;\r\n  }\r\n\r\n  &.padding--right {\r\n    padding-right: 15px;\r\n  }\r\n\r\n  &.padding--top {\r\n    padding-top: 15px;\r\n  }\r\n\r\n  &.padding--bottom {\r\n    padding-bottom: 15px;\r\n  }\r\n\r\n  &.padding--vertical {\r\n    padding-top: 15px;\r\n    padding-bottom: 15px;\r\n  }\r\n\r\n  &.padding--horizontal {\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n  }\r\n}\r\n// Modal Structure\r\n.structure-col {\r\n  flex-grow: 1;\r\n  display: flex;\r\n  flex-direction: row;\r\n  -webkit-flex-direction: row;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n  -webkit-flex-wrap: wrap;\r\n  align-items: stretch;\r\n  -webkit-align-items: stretch;\r\n  height: 100%;\r\n  width: 100%;\r\n  min-height: 0;\r\n\r\n  .structure-col--left {\r\n    flex-grow: 1;\r\n    text-align: left;\r\n    font-size: 0;\r\n\r\n    * {\r\n      font-size: $font_size;\r\n    }\r\n\r\n    button,\r\n    input[type='button'] {\r\n      display: inline-block;\r\n      margin-right: 5px;\r\n\r\n      .btn_text {\r\n        font-size: $btn_font_size;\r\n        display: block;\r\n      }\r\n\r\n      &:last-of-type {\r\n        margin-right: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  .structure-col--middle {\r\n    flex-grow: 1;\r\n    text-align: center;\r\n    font-size: 0;\r\n\r\n    * {\r\n      font-size: $font_size;\r\n    }\r\n\r\n    button,\r\n    input[type='button'] {\r\n      display: inline-block;\r\n      margin-right: 5px;\r\n\r\n      .btn_text {\r\n        font-size: $btn_font_size;\r\n        display: block;\r\n      }\r\n\r\n      &:last-of-type {\r\n        margin-right: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  .structure-col--right {\r\n    flex-grow: 1;\r\n    text-align: right;\r\n    font-size: 0;\r\n\r\n    * {\r\n      font-size: $font_size;\r\n    }\r\n\r\n    button,\r\n    input[type='button'] {\r\n      display: inline-block;\r\n      font-size: 0;\r\n      margin-left: 5px;\r\n\r\n      .btn_text {\r\n        font-size: $btn_font_size;\r\n        display: block;\r\n      }\r\n\r\n      &:first-of-type {\r\n        margin-left: 0;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// NOT NEEDED FOR PRODUCTION\r\n.show_labels {\r\n  .page-container,\r\n  .modal-header,\r\n  .modal-body,\r\n  .modal-footer,\r\n  .component-header,\r\n  .component-body,\r\n  .panel-left,\r\n  .panel-left-header,\r\n  .panel-left-actions,\r\n  .panel-left-body,\r\n  .panel-right,\r\n  .panel-right-header,\r\n  .panel-right-actions,\r\n  .panel-right-body,\r\n  .panel-main-header-left,\r\n  .panel-main-header-center,\r\n  .panel-main-header-right,\r\n  .modal-header-left,\r\n  .modal-header-center,\r\n  .modal-header-right,\r\n  .modal-footer-left,\r\n  .modal-footer-center,\r\n  .modal-footer-right,\r\n  .panel-main,\r\n  .panel-main-header,\r\n  .panel-main-actions,\r\n  .panel-main-body {\r\n    border-width: 2px;\r\n    border-style: solid;\r\n    position: relative;\r\n    padding: 20px;\r\n    @include box-sizing(border-box);\r\n\r\n    &:before {\r\n      content: attr(id);\r\n      background-color: attr(border-color);\r\n      position: absolute;\r\n      left: 0;\r\n      top: 0;\r\n      padding: 0 5px;\r\n      font-size: 12px;\r\n      line-height: 20px;\r\n      display: block;\r\n    }\r\n\r\n    &:hover {\r\n      &:before {\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.show_labels {\r\n  > div {\r\n    border-color: red;\r\n\r\n    &:before {\r\n      color: white;\r\n      background-color: red;\r\n    }\r\n\r\n    > div {\r\n      border-color: blue;\r\n\r\n      &:before {\r\n        color: white;\r\n        background-color: blue;\r\n      }\r\n\r\n      > div {\r\n        border-color: #ff00fb;\r\n\r\n        &:before {\r\n          color: white;\r\n          background-color: #ff00fb;\r\n        }\r\n\r\n        > div {\r\n          border-color: #7cbd22;\r\n\r\n          &:before {\r\n            color: white;\r\n            background-color: #7cbd22;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Scrolls (needs a bit of work)\r\n.modal-body {\r\n  overflow: hidden;\r\n  height: 100%;\r\n}\r\n\r\n// To-Do: Deprecated. We are using it in the html and should be removed\r\n.dialog_actions {\r\n  @extend .modal-footer;\r\n}\r\n\r\n/* Lookup tables tree & Period Equations */\r\n.tree {\r\n  overflow: hidden;\r\n  padding: 0;\r\n  margin: 0;\r\n  width: auto;\r\n\r\n  button {\r\n    cursor: pointer;\r\n    display: inline-block;\r\n  }\r\n\r\n  .drawer_container .drawer_header {\r\n    padding: 0;\r\n  }\r\n\r\n  .tree-node-parent .drawer_container {\r\n    padding-top: 0.5rem;\r\n  }\r\n\r\n  .drawer_content {\r\n    display: block;\r\n  }\r\n}\r\n\r\n.view_all_tables.node_all .tree_link {\r\n  border: 0;\r\n}\r\n// *********************************\r\n.drawer_container {\r\n  .drawer_header {\r\n    position: relative;\r\n    padding-left: 30px;\r\n\r\n    .drawer_header_toggle {\r\n      position: absolute;\r\n      left: 0;\r\n      top: 0;\r\n    }\r\n\r\n    .drawer_header_title {\r\n      .drawer_content {\r\n        margin-left: 30px;\r\n\r\n        .tree_link {\r\n          width: 100%;\r\n          display: block;\r\n          // @include box-sizing(border-box);\r\n          box-sizing: border-box;\r\n        }\r\n      }\r\n\r\n      a {\r\n        font-weight: 600;\r\n      }\r\n    }\r\n  }\r\n  /* Drawer Content (Hidden by Default) */\r\n  .drawer_content {\r\n    display: none;\r\n    position: relative;\r\n\r\n    &.drawer_active {\r\n      display: block;\r\n    }\r\n  }\r\n}\r\n\r\n.periodequations-tree,\r\n.lookup-tree {\r\n  .star {\r\n    @extend .fadein;\r\n    color: darkorange;\r\n    filter: blur(0.5px);\r\n    transition: all 200ms;\r\n    margin-left: 0.382em;\r\n    text-decoration: none;\r\n    line-height: 0.5rem;\r\n  }\r\n\r\n  .has_changes {\r\n    @extend .fadein;\r\n    color: darkorange;\r\n    filter: blur(0.5px);\r\n    transition: all 200ms;\r\n    margin-left: 0.382em;\r\n    text-decoration: none;\r\n    line-height: 0.5rem;\r\n  }\r\n\r\n  .tree-node-parent .drawer_content {\r\n    display: block;\r\n  }\r\n\r\n  .tree_link {\r\n    text-decoration: none !important;\r\n\r\n    &:before {\r\n      display: none;\r\n    }\r\n\r\n    &.category {\r\n      text-decoration: none;\r\n      font-weight: bold;\r\n      color: $primary_color;\r\n      padding-left: 0;\r\n    }\r\n\r\n  }\r\n}\r\n","app-account-tree,\r\napp-equation-bar,\r\napp-exogenous-lines-equations,\r\napp-exogenous-lines,\r\napp-hover-notification,\r\napp-import-alm-dataset,\r\napp-input-structure,\r\napp-invalid-rows,\r\napp-liquidity-sources,\r\napp-liquity-equations,\r\napp-lookup-data,\r\napp-lookup-setup,\r\napp-lookup-tree,\r\napp-root,\r\napp-balance-sheet,\r\napp-scenario-list,\r\napp-scenario-table,\r\napp-simulation-set,\r\napp-template,\r\ngc-spread-sheets {\r\n  @extend .full-size;\r\n}\r\n\r\napp-account-tree,\r\napp-lookup-tree,\r\napp-manage-results {\r\n  @extend .display-content;\r\n}\r\n\r\napp-lookup-setup,\r\napp-liquidity-sources,\r\napp-exogenous-lines {\r\n  .panel-main-header {\r\n    min-height: 50px !important;\r\n    height: 50px !important;\r\n  }\r\n}\r\n\r\napp-equation-bar,\r\napp-balance-sheet {\r\n  kendo-window {\r\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 1px 20px rgba(0, 0, 0, 0.3);\r\n  }\r\n  kendo-window-titlebar,\r\n  .k-dialog-titlebar,\r\n  .k-window-titlebar {\r\n    background-color: #51738b !important;\r\n    padding: 0.25rem 0.5rem !important;\r\n  }\r\n}\r\n\r\n\r\n// Setup pages dropdowns\r\napp-input-structure,\r\napp-lookup-setup,\r\napp-liquidity-sources,\r\napp-exogenous-lines {\r\n  select {\r\n    animation: fadein 0.3s;\r\n  }\r\n}\r\n","#data_set_container {\r\n  position: relative;\r\n  height: 100%;\r\n  min-width: 9.37rem;\r\n  padding: 0 1rem;\r\n  display: flex;\r\n  flex: 1 auto;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n\r\n  color: $white;\r\n  text-align: right;\r\n  z-index: 1;\r\n\r\n  #data_set_filename {\r\n    // line-height: 20px;\r\n\r\n    // span {}\r\n\r\n    a {\r\n      color: $white;\r\n      display: inline_block;\r\n      font-weight: 300;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        text-decoration: none;\r\n      }\r\n    }\r\n  }\r\n\r\n  #data_set_timestamp {\r\n    // line-height: 20px;\r\n    display: block;\r\n    @include opacity(0.5);\r\n    font-weight: 300;\r\n  }\r\n}\r\n","@import './../common/_animations.scss';\r\n\r\n.panel-left-body,\r\n.panel-right-body {\r\n  // overflow: auto;\r\n  // max-height: 540px;\r\n  overflow: hidden auto;\r\n  height: auto;\r\n\r\n  .tree-warning {\r\n    background-color: $notification;\r\n    color: $white;\r\n    padding: 0.618rem;\r\n  }\r\n\r\n  .tree-nodes {\r\n    overflow: hidden auto;\r\n    list-style-type: none;\r\n    padding: 0;\r\n    margin: 0;\r\n  }\r\n\r\n  .tree {\r\n    ul,\r\n    .tree-nodes {\r\n      @extend .fadein;\r\n      overflow: hidden auto;\r\n      padding: 0;\r\n      margin: 0 0 0 15px;\r\n      list-style: none;\r\n    }\r\n\r\n    .tree_link {\r\n      // @extend .fadein;\r\n      display: block;\r\n      text-decoration: underline;\r\n      line-height: 20px;\r\n      padding: 5px 5px 5px 20px;\r\n      position: relative;\r\n      //\r\n      display: block;\r\n      width: 100%;\r\n      background-color: transparent;\r\n      position: relative;\r\n      color: #505050;\r\n      line-height: 20px;\r\n      margin: 0px;\r\n      padding: 5px 5px;\r\n      text-align: left;\r\n      overflow: visible;\r\n      -webkit-border-radius: 4px;\r\n      border-radius: 4px;\r\n      background-clip: padding-box;\r\n      -webkit-appearance: none;\r\n      box-sizing: border-box;\r\n      border: 0px solid;\r\n      cursor: pointer;\r\n      -webkit-transition: all 0.3s ease;\r\n      -moz-transition: all 0.3s ease;\r\n      -ms-transition: all 0.3s ease;\r\n      -o-transition: all 0.3s ease;\r\n      transition: all 0.3s ease;\r\n      -webkit-box-sizing: border-box;\r\n      -moz-box-sizing: border-box;\r\n      box-sizing: border-box;\r\n      font-size: 0.86rem;\r\n      color: #2b495e;\r\n      -webkit-tap-highlight-color: transparent;\r\n      padding-left: 1rem;\r\n\r\n      &:before {\r\n        content: $chevron_right;\r\n        font-family: 'empyrean_icons';\r\n        font-size: 10px;\r\n        height: 10px;\r\n        width: 10px;\r\n        position: absolute;\r\n        top: 10px;\r\n        left: 0px;\r\n        line-height: 10px;\r\n      }\r\n\r\n      &.tree_link_active {\r\n        &:before {\r\n          @include rotate(90);\r\n        }\r\n      }\r\n    }\r\n\r\n    .tree_text {\r\n      display: block;\r\n      line-height: 20px;\r\n      padding: 5px 5px 5px 20px;\r\n      position: relative;\r\n\r\n      &:before {\r\n        content: '';\r\n        height: 4px;\r\n        width: 4px;\r\n        background-color: $navy;\r\n        @include border-radius(20px);\r\n        position: absolute;\r\n        top: 13px;\r\n        left: 5px;\r\n      }\r\n    }\r\n  }\r\n}\r\n","#sim_group,\r\n.sim_group {\r\n  width: calc(100% - 30px);\r\n  padding: 15px;\r\n\r\n  // Sim Group Header\r\n  #sim_header {\r\n    border-bottom: 1px solid $app_color;\r\n\r\n    > div {\r\n      .sim_header_label {\r\n        text-transform: capitalize;\r\n        font-weight: 600;\r\n        font-size: 0.8rem;\r\n      }\r\n    }\r\n  }\r\n  .sim_scenario,\r\n  .sim_mnemonic,\r\n  .sim_description {\r\n    float: left;\r\n    min-height: 30px;\r\n    padding: 5px;\r\n    @include box-sizing(border-box);\r\n\r\n    .is_invalid_mnemonic {\r\n      line-height: 20px;\r\n      margin: 0;\r\n      width: 100%;\r\n      @include box-sizing(border-box);\r\n\r\n      .idle-component {\r\n        border: 1px solid $red;\r\n        @include border-radius(4px);\r\n      }\r\n\r\n      .invalid-message {\r\n        white-space: normal;\r\n      }\r\n    }\r\n\r\n    &:hover {\r\n      .inner_cell_text {\r\n        .inline-edit {\r\n          text-decoration: underline;\r\n        }\r\n      }\r\n    }\r\n\r\n    .inner_cell_text {\r\n      line-height: 20px;\r\n      padding: 0px 0px;\r\n      overflow: hidden !important;\r\n      text-overflow: ellipsis !important;\r\n      white-space: nowrap !important;\r\n\r\n      .inline-edit {\r\n        line-height: 20px;\r\n        padding: 5px;\r\n        overflow: hidden !important;\r\n        text-overflow: ellipsis !important;\r\n        white-space: nowrap !important;\r\n\r\n        &.force_multiline_text {\r\n          white-space: normal !important;\r\n        }\r\n      }\r\n\r\n      input {\r\n        line-height: 20px;\r\n        margin: 0;\r\n        padding: 4px 5px;\r\n        border: 1px solid $input_border;\r\n        @include border-radius(4px);\r\n        width: 100%;\r\n        @include box-sizing(border-box);\r\n      }\r\n    }\r\n  }\r\n\r\n  .sim_row_toggle,\r\n  .sim_last_updated,\r\n  .sim_dataset,\r\n  .sim_delete,\r\n  .sim_notifications,\r\n  .sim_action {\r\n    float: left;\r\n    min-height: 30px;\r\n    padding: 5px 5px;\r\n    @include box-sizing(border-box);\r\n  }\r\n\r\n  .inner_cell_text {\r\n    line-height: 20px;\r\n    padding: 5px 0px;\r\n    display: block;\r\n    @include box-sizing(border-box);\r\n    vertical-align: top;\r\n\r\n    a {\r\n      color: $navy;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        color: $green;\r\n      }\r\n    }\r\n  }\r\n\r\n  .sim_scenario {\r\n    .inner_cell_text {\r\n      font-weight: 600;\r\n    }\r\n  }\r\n\r\n  .sim_row_toggle {\r\n    width: 40px;\r\n  }\r\n  .sim_scenario {\r\n    width: 15%;\r\n  }\r\n  .sim_mnemonic {\r\n    width: 15%;\r\n  }\r\n  .sim_description {\r\n    width: calc(70% - 370px);\r\n  } // This is the width of all the fixed cells\r\n\r\n  .manage_resultsets_table {\r\n    .sim_description {\r\n      width: calc(70% - 370px + 40px);\r\n    } // This is the width of all the fixed cells\r\n  }\r\n\r\n  .sim_last_updated {\r\n    width: 130px;\r\n  }\r\n  .sim_dataset {\r\n    width: 160px;\r\n  }\r\n  .sim_delete {\r\n    width: 40px;\r\n  }\r\n  .sim_notifications {\r\n    width: 40px;\r\n  }\r\n  .sim_action {\r\n    width: 120px;\r\n  }\r\n\r\n  .sim_notifications {\r\n    .icon_notification {\r\n      color: $notification;\r\n    }\r\n  }\r\n\r\n  .sim_delete {\r\n    button {\r\n      @include opacity(0.1);\r\n    }\r\n  }\r\n\r\n  .sim_description {\r\n    .inner_cell_text {\r\n      &.wrap_text {\r\n        display: inline-block;\r\n        overflow: hidden;\r\n        white-space: nowrap;\r\n        width: calc(100% - 30px);\r\n      }\r\n    }\r\n\r\n    .more_link,\r\n    .less_link {\r\n      line-height: 20px;\r\n      padding: 5px 0px;\r\n      display: inline-block;\r\n      @include box-sizing(border-box);\r\n      vertical-align: top;\r\n\r\n      a {\r\n        color: $navy;\r\n\r\n        &:hover,\r\n        &:focus {\r\n          text-decoration: underline;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Sim Group Row\r\n  .sim_row_container {\r\n    padding: 10px 0;\r\n    border-bottom: 1px solid $border_color;\r\n\r\n    &:last-of-type {\r\n      padding: 10px 0;\r\n      border-bottom: 1px solid $border_color;\r\n    }\r\n\r\n    &.show_children {\r\n      .sim_row {\r\n        .sim_row_toggle {\r\n          button {\r\n            font-size: 12px;\r\n            position: relative;\r\n            @include rotate(90);\r\n\r\n            .btn_icon {\r\n              span {\r\n                font-size: 12px;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .sim_row {\r\n      .sim_row_toggle {\r\n        button {\r\n          font-size: 12px;\r\n\r\n          .btn_icon {\r\n            span {\r\n              font-size: 12px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      &:hover {\r\n        background-color: $row_hover;\r\n\r\n        .sim_delete {\r\n          button {\r\n            @include opacity(1);\r\n          }\r\n        }\r\n      }\r\n\r\n      // Baseline\r\n      &.sim_baseline {\r\n        .sim_scenario {\r\n          padding-left: 20px;\r\n          @include box-sizing(border-box);\r\n          position: relative;\r\n\r\n          .color-dot {\r\n            @include color-dot($grey); // color by default\r\n          }\r\n\r\n          select {\r\n          }\r\n        }\r\n      }\r\n\r\n      // Stress\r\n      &.sim_stress {\r\n        .sim_scenario {\r\n          padding-left: 35px;\r\n          @include box-sizing(border-box);\r\n          position: relative;\r\n\r\n          .color-line {\r\n            position: absolute;\r\n            top: 0;\r\n            bottom: 0;\r\n            margin: 0 auto;\r\n            width: 4px;\r\n            height: 100%;\r\n            margin-left: -1em;\r\n            background-color: $grey; // default\r\n          }\r\n\r\n          select {\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .sim_stress_add {\r\n      .sim_scenario {\r\n        padding-left: 35px;\r\n        @include box-sizing(border-box);\r\n        position: relative;\r\n      }\r\n    }\r\n\r\n    .sim_baseline_add {\r\n      .sim_scenario {\r\n        padding-left: 20px;\r\n        @include box-sizing(border-box);\r\n        position: relative;\r\n\r\n        .color-dot {\r\n          @include color-dot($grey);\r\n        }\r\n\r\n        select {\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.is_invalid_dataset {\r\n  border: 1px solid red !important;\r\n  border-radius: 4px;\r\n  padding: 5px;\r\n  font-size: 0.8rem;\r\n}\r\n","#assumption_container {\r\n  position: relative;\r\n  height: calc(100vh - 242px); // height: calc(100vh - 180px);\r\n  // max-height: 780px; Remove this as it cut off the lookup table in assumptions..\r\n\r\n  display: flex;\r\n  justify-content: space-around;\r\n  align-items: stretch;\r\n  flex-flow: nowrap;\r\n  flex-direction: row;\r\n  margin: 0px auto;\r\n  min-height: 0;\r\n  -webkit-justify-content: space-around;\r\n  -webkit-align-items: stretch;\r\n  -webkit-flex-flow: nowrap;\r\n  -webkit-flex-direction: row;\r\n\r\n  #assumption_lookup_list {\r\n    @include transition(all 0.3s ease);\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    width: 250px;\r\n    padding: 15px;\r\n\r\n    &:after {\r\n      content: '';\r\n      position: absolute;\r\n      right: 0px;\r\n      top: 0;\r\n      bottom: 0;\r\n      width: 1px;\r\n      background: $border_color;\r\n    }\r\n  }\r\n\r\n  #assumption_lookup_viewer {\r\n    @include transition(all 0.3s ease);\r\n    flex: 1;\r\n    margin-left: 270px;\r\n    display: block;\r\n\r\n    #toggle_list_btn_container {\r\n      position: absolute;\r\n      left: -15px;\r\n      top: 0;\r\n      display: none;\r\n      z-index: 1;\r\n\r\n      margin-top: auto;\r\n      margin-bottom: auto;\r\n\r\n      button {\r\n        background-color: $white;\r\n      }\r\n    }\r\n  }\r\n}\r\n","#footer_bar {\r\n  display: flex;\r\n  flex-direction: row;\r\n  -webkit-flex-direction: row;\r\n  height: 100%;\r\n  justify-content: flex-start;\r\n  flex-wrap: nowrap;\r\n  -webkit-flex-wrap: nowrap;\r\n  align-items: stretch;\r\n  -webkit-align-items: stretch;\r\n  width: 100%;\r\n  min-height: 0;\r\n  position: relative;\r\n  overflow: visible !important;\r\n\r\n  &:before {\r\n    content: '';\r\n    height: 1px;\r\n    background-color: rgba($black, 0.2);\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    right: 0;\r\n  }\r\n\r\n  #footer_result_set {\r\n    @include box-sizing(border-box);\r\n    padding: 10px;\r\n    padding-right: 0;\r\n  }\r\n\r\n  #footer_quick_link {\r\n    @include box-sizing(border-box);\r\n    padding: 10px;\r\n    padding-left: 0;\r\n    position: relative;\r\n    overflow: visible !important;\r\n  }\r\n\r\n  #footer_report_summary {\r\n    @include box-sizing(border-box);\r\n    padding: 0 10px;\r\n    padding-left: 0;\r\n\r\n    button {\r\n      &.btn_sheet {\r\n        min-width: 3rem;\r\n        background-color: $white;\r\n        @include border-radius(0);\r\n        @include border-bottom-radius(3px);\r\n        padding: 10px;\r\n        position: relative;\r\n        color: rgba($app_color, 0.5);\r\n        text-transform: inherit;\r\n        font-size: 0.86rem;\r\n        font-weight: 400;\r\n        // min-width: 100px;\r\n\r\n        &:before {\r\n          content: '';\r\n          height: 3px;\r\n          background-color: rgba($black, 0.05);\r\n          position: absolute;\r\n          left: 0;\r\n          top: 0;\r\n          right: 0;\r\n        }\r\n\r\n        &:after {\r\n          content: '';\r\n          height: 1px;\r\n          background-color: rgba($black, 0.2);\r\n          position: absolute;\r\n          left: 0;\r\n          top: 0;\r\n          right: 0;\r\n        }\r\n\r\n        &:hover,\r\n        &:focus {\r\n          color: $navy;\r\n        }\r\n\r\n        &.btn_sheet_active {\r\n          color: $app_color;\r\n          font-weight: 600;\r\n\r\n          &:before {\r\n            display: none;\r\n          }\r\n\r\n          &:after {\r\n            display: none;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  #footer_tabs {\r\n    width: 100%;\r\n    flex-grow: 1;\r\n    flex: 1 1 auto;\r\n    -webkit-flex: 1 1 auto;\r\n    position: relative;\r\n    @include box-sizing(border-box);\r\n    overflow: auto;\r\n    @include box-sizing(border-box);\r\n    padding: 0 0 5px;\r\n  }\r\n\r\n  #footer_controls {\r\n    @include box-sizing(border-box);\r\n    padding: 10px;\r\n\r\n    &.hide_controls {\r\n      display: none;\r\n    }\r\n\r\n    #pan_controls {\r\n      width: 60px;\r\n\r\n      button {\r\n        float: left;\r\n      }\r\n    }\r\n  }\r\n\r\n  #footer_export {\r\n    @include box-sizing(border-box);\r\n    padding: 10px;\r\n  }\r\n}\r\n\r\n#result_tab_container > ul {\r\n  margin: 0px 0 0;\r\n  padding: 0;\r\n  list-style: none;\r\n  display: inline-block;\r\n  font-size: 0;\r\n  white-space: nowrap;\r\n\r\n  > li {\r\n    display: inline-block;\r\n    font-size: 0;\r\n    margin-right: 10px;\r\n    position: relative;\r\n\r\n    &:last-child {\r\n      margin-right: 0;\r\n    }\r\n\r\n    > ul {\r\n      margin: 0;\r\n      padding: 0;\r\n      list-style: none;\r\n      width: 100%;\r\n      white-space: nowrap;\r\n      display: inline-block;\r\n      font-size: 0;\r\n\r\n      > li {\r\n        display: inline-block;\r\n        font-size: 0;\r\n        margin-right: 2px;\r\n        position: relative;\r\n        overflow: hidden;\r\n\r\n        button {\r\n          &.btn_sheet {\r\n            min-width: 6rem;\r\n            background-color: $white;\r\n            background: linear-gradient(to bottom, rgb(246, 246, 246) 10%, white 50%, white);\r\n\r\n            @include border-radius(0);\r\n            @include border-bottom-radius(3px);\r\n            padding: 10px 10px 7px 10px;\r\n            position: relative;\r\n            border-width: 0 0 3px 0;\r\n            border-style: solid;\r\n            color: rgba($app_color, 0.5);\r\n            text-transform: inherit;\r\n            font-size: 0.86rem;\r\n            font-weight: 600;\r\n\r\n            &:before {\r\n              content: '';\r\n              height: 3px;\r\n              background-color: rgba($black, 0.05);\r\n              position: absolute;\r\n              left: 0;\r\n              top: 0;\r\n              right: 0;\r\n            }\r\n\r\n            &:after {\r\n              content: '';\r\n              height: 1px;\r\n              background-color: rgba($black, 0.2);\r\n              position: absolute;\r\n              left: 0;\r\n              top: 0;\r\n              right: 0;\r\n            }\r\n\r\n            &:hover,\r\n            &:focus {\r\n              color: $navy;\r\n            }\r\n\r\n            &.btn_sheet_active {\r\n              color: $app_color;\r\n              @include box-shadow(0 2px 10px rgba($black, 0.1));\r\n\r\n              &:before {\r\n                display: none;\r\n              }\r\n\r\n              &:after {\r\n                display: none;\r\n              }\r\n            }\r\n\r\n            .btn_status {\r\n              span {\r\n                color: $notification;\r\n              }\r\n            }\r\n          }\r\n\r\n          &.btn_sheet_hide {\r\n            position: absolute;\r\n            right: -40px;\r\n            top: 5px;\r\n            z-index: 1;\r\n            background-color: $white;\r\n            overflow: hidden;\r\n            margin-left: 5px;\r\n            padding-left: 0;\r\n            padding-right: 5px;\r\n\r\n            .btn_icon {\r\n              span {\r\n                font-size: 10px;\r\n                background-color: $lighter_grey;\r\n                @include border-radius(30px);\r\n                padding: 3px;\r\n              }\r\n            }\r\n\r\n            // &:hover,\r\n            // &:focus {\r\n            // }\r\n\r\n            &:before {\r\n              content: '';\r\n              position: absolute;\r\n              left: -10px;\r\n              top: 0;\r\n              bottom: 0;\r\n              width: 10px;\r\n              background: rgb(255, 255, 255);\r\n              background: -webkit-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);\r\n              background: -o-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);\r\n              background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);\r\n            }\r\n          }\r\n        }\r\n\r\n        &:hover {\r\n          button.btn_sheet_hide {\r\n            right: 0;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    // ! Deprecated since task 3635\r\n    // &:nth-child(0) {\r\n    //   button.btn_sheet {\r\n    //     border-color: $group_color_1;\r\n    //   }\r\n    // }\r\n\r\n    // &:nth-child(1) {\r\n    //   button.btn_sheet {\r\n    //     border-color: $group_color_2;\r\n    //   }\r\n    // }\r\n\r\n    // &:nth-child(2) {\r\n    //   button.btn_sheet {\r\n    //     border-color: $group_color_3;\r\n    //   }\r\n    // }\r\n\r\n    // &:nth-child(3) {\r\n    //   button.btn_sheet {\r\n    //     border-color: $group_color_4;\r\n    //   }\r\n    // }\r\n    // &:nth-child(4) {\r\n    //   button.btn_sheet {\r\n    //     border-color: $group_color_5;\r\n    //   }\r\n    // }\r\n    // &:nth-child(5) {\r\n    //   button.btn_sheet {\r\n    //     border-color: $group_color_6;\r\n    //   }\r\n    // }\r\n    // &:nth-child(6) {\r\n    //   button.btn_sheet {\r\n    //     border-color: $group_color_7;\r\n    //   }\r\n    // }\r\n    // &:nth-child(7) {\r\n    //   button.btn_sheet {\r\n    //     border-color: $group_color_8;\r\n    //   }\r\n    // }\r\n  }\r\n}\r\n","#context_bar {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: stretch;\r\n  flex-flow: nowrap;\r\n  flex-direction: row;\r\n  // height: 100%;\r\n  // max-width: 1440px; // Comment this out to force the page to go full width\r\n  margin: 0px auto;\r\n  min-height: 0;\r\n  -webkit-justify-content: space-between;\r\n  -webkit-align-items: stretch;\r\n  -webkit-flex-flow: nowrap;\r\n  -webkit-flex-direction: row;\r\n  background-color: $lighter_grey;\r\n  // Left Context Bar\r\n  #context_bar_left {\r\n    flex: 1;\r\n    padding: 10px;\r\n    @include box-sizing(border-box);\r\n\r\n    #context_source {\r\n      float: left;\r\n      line-height: 30px;\r\n      padding-right: 15px;\r\n      margin-right: 5px;\r\n      position: relative;\r\n\r\n      &:after {\r\n        content: $triangle_right;\r\n        font-family: 'empyrean_icons';\r\n        line-height: 30px;\r\n        font-size: 10px;\r\n        position: absolute;\r\n        right: 0;\r\n        top: 0;\r\n      }\r\n\r\n      .source_file {\r\n        span {\r\n          display: block;\r\n          vertical-align: middle;\r\n          font-size: 16px;\r\n          line-height: 30px;\r\n        }\r\n      }\r\n    }\r\n\r\n    #context_title {\r\n      float: left;\r\n      padding-right: 10px;\r\n    }\r\n\r\n    #context_edit_assumptions {\r\n      float: left;\r\n      padding-right: 10px;\r\n      cursor: pointer;\r\n\r\n      .edit_asumptions_link {\r\n        display: block;\r\n        line-height: 20px;\r\n        padding: 5px 0px 5px 0;\r\n        text-decoration: underline;\r\n      }\r\n    }\r\n  }\r\n  // Middle Context Bar\r\n  #context_bar_middle {\r\n    // flex:1;\r\n    padding: 10px;\r\n    @include box-sizing(border-box);\r\n    text-align: center;\r\n\r\n    #view_controller {\r\n      display: inline-block;\r\n      width: 160px;\r\n\r\n      .toggle_switch_option {\r\n        width: 80px;\r\n      }\r\n    }\r\n\r\n    #access_controller {\r\n      display: inline-block;\r\n      color: dark_grey;\r\n      line-height: 20px;\r\n      padding: 5px 0;\r\n      margin-left: 10px;\r\n\r\n      .icon_lock {\r\n      }\r\n\r\n      .access_text {\r\n        text-transform: uppercase;\r\n        font-weight: 600;\r\n        font-size: 0.8rem;\r\n      }\r\n    }\r\n  }\r\n  // Right Context Bar\r\n  #context_bar_right {\r\n    text-align: right;\r\n    flex: 1;\r\n    padding: 10px;\r\n    @include box-sizing(border-box);\r\n\r\n    #sheet_status {\r\n      display: inline-block;\r\n      @include opacity(0.5);\r\n    }\r\n\r\n    #notifications_container {\r\n      display: inline-block;\r\n      margin-left: 10px;\r\n    }\r\n  }\r\n}\r\n",".footer_quick_link {\r\n  position: relative;  \r\n  overflow: visible !important;\r\n}\r\n\r\n#sheet_list {\r\n  position: fixed;\r\n  bottom: 45px;\r\n  left: 50px;\r\n  width: 400px;\r\n  z-index: 1000010 !important;\r\n  margin-bottom: 10px;\r\n  background: $white;\r\n  padding: 15px;\r\n  @include border-radius(3px);\r\n  box-shadow: 0 1px 4px rgba($black, 0.3), 0 1px 20px rgba($black, 0.3);\r\n  @include box-sizing(border-box);\r\n\r\n  > ul {\r\n    margin: 0;\r\n    padding: 0;\r\n    list-style: none;\r\n    max-height: calc(100vh - 200px);\r\n    overflow-y: auto;\r\n    \r\n    > li {\r\n      margin-bottom: 20px;\r\n\r\n      &:last-child {\r\n        margin-bottom: 0;\r\n      }\r\n\r\n      // ! DEPRECATED since task 3635\r\n      // &:nth-child(1) {\r\n      //   .sheet_name:before {\r\n      //     background-color: $group_color_1;\r\n      //   }\r\n      // }\r\n\r\n      // &:nth-child(2) {\r\n      //   .sheet_name:before {\r\n      //     background-color: $group_color_2;\r\n      //   }\r\n      // }\r\n\r\n      // &:nth-child(3) {\r\n      //   .sheet_name:before {\r\n      //     background-color: $group_color_3;\r\n      //   }\r\n      // }\r\n\r\n      // &:nth-child(4) {\r\n      //   .sheet_name:before {\r\n      //     background-color: $group_color_4;\r\n      //   }\r\n      // }\r\n      // &:nth-child(5) {\r\n      //   .sheet_name:before {\r\n      //     background-color: $group_color_5;\r\n      //   }\r\n      // }\r\n      // &:nth-child(6) {\r\n      //   .sheet_name:before {\r\n      //     background-color: $group_color_6;\r\n      //   }\r\n      // }\r\n      // &:nth-child(7) {\r\n      //   .sheet_name:before {\r\n      //     background-color: $group_color_7;\r\n      //   }\r\n      // }\r\n      // &:nth-child(8) {\r\n      //   .sheet_name:before {\r\n      //     background-color: $group_color_8;\r\n      //   }\r\n      // }\r\n\r\n      > ul {\r\n        margin: 0;\r\n        padding: 0;\r\n        list-style: none;\r\n\r\n        > li {\r\n          a {\r\n            display: block;\r\n            color: inherit;\r\n            text-decoration: none;\r\n            padding: 0;\r\n\r\n            &:hover,\r\n            &:focus {\r\n              background-color: $lighter_grey;\r\n              color: $app_color;\r\n\r\n              .sheet_name {\r\n                text-decoration: underline;\r\n              }\r\n            }\r\n\r\n            &:after {\r\n              clear: both;\r\n              content: '';\r\n              display: block;\r\n              height: 0;\r\n              visibility: hidden;\r\n            }\r\n\r\n            .sheet_name {\r\n              width: 70%;\r\n              display: block;\r\n              vertical-align: top;\r\n              float: left;\r\n              word-wrap: break-word;\r\n              @include box-sizing(border-box);\r\n              padding: 5px 0 5px 20px;\r\n              line-height: 20px;\r\n              cursor: pointer;\r\n              position: relative;\r\n            }\r\n\r\n            .sheet_dataset {\r\n              padding: 5px 0;\r\n              line-height: 20px;\r\n              width: 30%;\r\n              display: block;\r\n              vertical-align: right;\r\n              float: left;\r\n              text-align: right;\r\n              word-wrap: break-word;\r\n            }\r\n\r\n            &.sheet_baseline {\r\n              .sheet_name {\r\n                &:before {\r\n                  content: '';\r\n                  position: absolute;\r\n                  left: 5px;\r\n                  top: 10px;\r\n                  height: 10px;\r\n                  width: 10px;\r\n                  @include border-radius(50%);\r\n                }\r\n              }\r\n            }\r\n\r\n            &.sheet_stress {\r\n              .sheet_name {\r\n                padding-left: 40px;\r\n\r\n                &:before {\r\n                  content: '';\r\n                  position: absolute;\r\n                  left: 20px;\r\n                  top: 0;\r\n                  bottom: 0;\r\n                  height: 100%;\r\n                  width: 4px;\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","ul#notifications_list {\r\n\tmargin:0;\r\n\tpadding:0;\r\n\tlist-style: none;\r\n\r\n\t>li {\r\n\t\tpadding: 10px 0;\r\n\t\tborder-bottom: 1px solid $border_color;\r\n\r\n\t\t&:last-child {\r\n\t\t\tborder-bottom: 0px solid $border_color;\r\n\t\t}\r\n\r\n\t\t.notification_title {}\r\n\r\n\t\tp {\r\n\t\t\tline-height: 20px;\r\n\t\t\tcolor: $dark_grey;\r\n\r\n\t\t\t&:last-of-type {\r\n\t\t\t\tpadding-bottom: 0;\r\n\t\t\t\tmargin-bottom: 0;\r\n\t\t\t}\r\n\r\n\t\t\ta {\r\n\t\t\t\tcolor: $notification;\r\n\t\t\t\ttext-decoration: none;\r\n\r\n\t\t\t\t&:hover, &:focus {\r\n\t\t\t\t\ttext-decoration: underline;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t}\r\n}\r\n\r\n\r\n#notification_container {\r\n\tfont-size: $btn_font_size;\r\n\tbackground-color: $notification;\r\n\tcolor: $dark_grey;\r\n\tpadding: 5px;\r\n\ttext-align: center;\r\n\tdisplay: block;\r\n\tmargin:0 auto;\r\n\tposition: relative;\r\n\tpadding-left: 10px;\r\n\tpadding-right: 10px;\r\n\t// @include transform(translate(-50%,0));\r\n\t// @include border-bottom-radius(4px);\r\n\tz-index: 1;\r\n\r\n\tp {\r\n\t\tline-height: 15px;\r\n\r\n\t\t&:last-child {\r\n\t\t\tpadding:0;\r\n\t\t\tmargin:0;\r\n\t\t}\r\n\t}\r\n\r\n\t[class^=\"icon_\"], [class*=\" icon_\"] {\r\n\t\tvertical-align: middle;\r\n\t}\r\n}","app-hover-notification {\r\n  display: contents;\r\n}\r\n\r\n.hover-notification-container {\r\n  background-color: white;\r\n  color: $dark_grey;\r\n  transition: all 0.3s ease-in-out;\r\n  border-radius: 3px;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 1px 20px rgba(0, 0, 0, 0.3);\r\n  display: grid;\r\n  font-family: 'Source Sans Pro', Helvetica, sans-serif;\r\n  font-size: 0.86rem;\r\n  grid-template-rows: auto 1fr;\r\n  grid-gap: 0.4rem;\r\n  min-width: 100px;\r\n  max-width: 300px;\r\n  padding: 0.7rem;\r\n  position: absolute;\r\n  // right: -100px;\r\n\r\n  top: 0.5rem;\r\n  width: auto;\r\n  z-index: 999;\r\n\r\n  $accent: $notification;\r\n\r\n  border-left: 6px solid;\r\n  border-left-color: $notification; // default\r\n\r\n  &.notificationright {\r\n    right: 0.5rem;\r\n  }\r\n  &.notificationleft {\r\n    left: 0.5rem;\r\n  }\r\n  &.info {\r\n    border-left-color: $blue !important;\r\n    $accent: $blue !important;\r\n    .title,\r\n    .value {\r\n      color: $accent;\r\n    }\r\n  }\r\n  &.success {\r\n    border-left-color: $green !important;\r\n    $accent: $green !important;\r\n    .title,\r\n    .value {\r\n      color: $accent;\r\n    }\r\n  }\r\n  &.error {\r\n    border-left-color: $red !important;\r\n    $accent: $red !important;\r\n    .title,\r\n    .value {\r\n      color: $accent;\r\n    }\r\n  }\r\n  &.warning {\r\n    border-left-color: $notification !important;\r\n    $accent: $notification !important;\r\n    .title,\r\n    .value {\r\n      color: $accent;\r\n    }\r\n  }\r\n\r\n  .header {\r\n    display: grid;\r\n    grid-template-columns: 1fr auto;\r\n\r\n    .title,\r\n    .value {\r\n      font-weight: 600;\r\n    }\r\n    .value {\r\n      margin-left: 1rem;\r\n    }\r\n  }\r\n\r\n  .body {\r\n    white-space: pre-wrap;\r\n    font-weight: 400;\r\n  }\r\n}\r\n","app-multi-notification {\r\n  margin: auto !important;\r\n  padding: 0.5rem;\r\n  width: auto;\r\n  max-width: 90%;\r\n  display: grid;\r\n  /* grid-auto-flow: column; */\r\n  grid-template-columns: repeat(3, auto);\r\n  grid-gap: 0.5rem;\r\n}\r\n\r\n.multi-notification-container {\r\n  // width: 100%;\r\n  // height: 100%;\r\n  padding: 0.5rem;\r\n  border: rgba($color: #000000, $alpha: 0.2);\r\n  // background-color: rgba($color: #000000, $alpha: 0.05);\r\n  border-radius: 3px;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 1px 6px rgba(0, 0, 0, 0.3);\r\n\r\n  display: grid;\r\n  grid-template-columns: 1fr auto;\r\n\r\n  .title {\r\n    font-weight: 600;\r\n    text-transform: uppercase;\r\n    line-height: 20px;\r\n    font-size: 0.8rem;\r\n    color: #525b6b;\r\n  }\r\n  .body {\r\n    color: #525b6b;\r\n    font-size: 0.86rem;\r\n    font-family: 'Source Sans Pro', Helvetica, sans-serif;\r\n    font-weight: 400;\r\n  }\r\n  .actions {\r\n    // display: flex;\r\n    // justify-content: flex-end;\r\n    // height: fit-content;\r\n    margin-top: auto;\r\n    button {\r\n      margin-left: 0.5rem;\r\n    }\r\n  }\r\n}\r\n\r\n.component-header {\r\n  overflow: hidden;\r\n  transition: all 1s cubic-bezier(0.65, 0.05, 0.36, 1);\r\n  transition: max-height 1s cubic-bezier(0.65, 0.05, 0.36, 1);\r\n  height: auto;\r\n  max-height: 600px;\r\n}\r\n.component-header.slide-up {\r\n  max-height: 0;\r\n  display: none;\r\n}\r\n","ul#application_list {\r\n  width: 100%;\r\n  float: left;\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n\r\n  > li {\r\n    float: left;\r\n    width: calc(100% / 3);\r\n    text-align: center;\r\n\r\n    a.application_link {\r\n      display: block;\r\n      text-decoration: none;\r\n      @include border-radius(4px);\r\n      text-align: center;\r\n      padding: 10px 4px;\r\n      color: inherit;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        background-color: rgba($navy, 0.1);\r\n\r\n        .application_icon {\r\n          background-color: rgba($navy, 0.3);\r\n          color: $navy;\r\n        }\r\n\r\n        .application_name,\r\n        .application_subtitle {\r\n          color: $navy;\r\n        }\r\n      }\r\n\r\n      &.disabled {\r\n        opacity: 0.3;\r\n        transition: opacity 0.6s;\r\n      }\r\n\r\n      .application_icon {\r\n        display: block;\r\n        padding: 10px;\r\n        @include border-radius(50px);\r\n        background-color: rgba($black, 0.05);\r\n        width: 50px;\r\n        @include box-sizing(border-box);\r\n        margin: 0 auto 10px;\r\n\r\n        span {\r\n          line-height: 30px;\r\n          width: 30px;\r\n          text-align: center;\r\n          font-size: 24px;\r\n          display: block;\r\n          vertical-align: top;\r\n        }\r\n      }\r\n\r\n      .application_name {\r\n        text-align: center;\r\n        display: block;\r\n        line-height: 15px;\r\n        min-height: 30px;\r\n        font-size: 0.8rem;\r\n      }\r\n\r\n      .application_subtitle {\r\n        text-align: center;\r\n        display: block;\r\n        font-size: 0.7rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n",".notification-banner-message {\r\n  @extend .top-inner-shadow;\r\n  @extend .border--bottom;\r\n  // @extend .border--top;\r\n  // @extend .bottom-inner-shadow;\r\n  position: relative;\r\n  width: 100%;\r\n  color: $black;\r\n  background: $white;\r\n  cursor: default;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-flow: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: $notification_light;\r\n  padding-bottom: 1px;\r\n\r\n  .banner-title,\r\n  .banner-body,\r\n  .banner-actions {\r\n    width: auto;\r\n    text-align: center;\r\n    max-width: 800px;\r\n  }\r\n\r\n  .banner-title,\r\n  .banner-body {\r\n    padding: 0.618rem auto;\r\n  }\r\n\r\n  .banner-actions {\r\n    padding-bottom: 0.618rem;\r\n  }\r\n\r\n  .banner-actions {\r\n    display: flex;\r\n    justify-content: center;\r\n\r\n    a,\r\n    .link,\r\n    .banner-action-button,\r\n    button {\r\n      @extend .btn_normal;\r\n      background: unset;\r\n      color: unset;\r\n      border: unset;\r\n      flex: 1 auto;\r\n      flex-wrap: wrap;\r\n      text-transform: uppercase;\r\n      color: $primary_color;\r\n      width: auto;\r\n      min-width: 7rem;\r\n      min-height: 2rem;\r\n      margin-left: 1rem;\r\n      cursor: pointer;\r\n\r\n      :first-of-type {\r\n        margin-left: 0;\r\n      }\r\n\r\n      &.primary-action {\r\n        background: $navy;\r\n        color: $white;\r\n      }\r\n\r\n      &.secondary-action {\r\n        background: transparent;\r\n        border: 1px solid $navy;\r\n        color: $navy;\r\n      }\r\n    }\r\n\r\n    // .toast-close-button {\r\n    //   &,\r\n    //   button {\r\n    //     color: $black;\r\n    //   }\r\n    // }\r\n  }\r\n}\r\n\r\napp-notification-banner,\r\n.app-notification-banner,\r\n.notification-banner-message {\r\n  width: 100%;\r\n  padding: 0;\r\n}\r\n\r\n// Overwrites the default toast-container styles If they include the class \"banner-like-message\"\r\n// toaster-container.notification-banner-message {\r\n//   @extend .notification-banner-message;\r\n\r\n//   #toast-container {\r\n//     position: relative;\r\n\r\n//     .toast {\r\n//       position: relative;\r\n//       box-sizing: border-box;\r\n//       width: 100%;\r\n//       margin: 0;\r\n//       padding: 0;\r\n//       border-radius: 0; // border-radius: 3px;\r\n//       background: unset;\r\n//       background-position: unset;\r\n//       background-repeat: unset;\r\n//       box-shadow: unset;\r\n//       color: unset;\r\n//       opacity: 1;\r\n//       // opacity: 0.8;\r\n//       // -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=80);\r\n//       // filter: alpha(opacity=80);\r\n//       transform: translate(0px, 0px);\r\n\r\n//       .toaster-icon {\r\n//         display: none;\r\n//       }\r\n//     }\r\n//   }\r\n// }\r\n","/*\r\n\r\n  Spreadsheets\r\n\r\n*/\r\n\r\n.spread-container {\r\n  position: relative;\r\n  margin: 0;\r\n  padding: 0;\r\n  width: 100%;\r\n  min-height: $spread-sheet-height;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  z-index: 8;\r\n\r\n  .spreadsheet {\r\n    z-index: 9;\r\n    position: relative;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  // Custom spreadsheet loading placeholder\r\n  .spreadsheet--loading {\r\n    z-index: 10;\r\n    background-color: $lighter_grey;\r\n    background-image: linear-gradient(to bottom, #f5f6f7 calc(100% - 40px), white);\r\n    position: relative;\r\n    min-height: $spread-sheet-height;\r\n\r\n    &:before {\r\n      content: $sheet_loader;\r\n      font-family: 'empyrean_icons';\r\n      position: absolute;\r\n      left: 50%;\r\n      top: 50%;\r\n      font-size: 80px;\r\n      color: $grey;\r\n      transform: translate(-50%, -50%);\r\n      font-weight: 300;\r\n    }\r\n\r\n    &:after {\r\n      content: 'Loading Sheet...';\r\n      position: absolute;\r\n      left: 50%;\r\n      top: 50%;\r\n      font-size: 1rem;\r\n      color: $grey;\r\n      transform: translate(-50%, -50%);\r\n      margin-top: 50px;\r\n      text-align: center;\r\n      font-weight: 300;\r\n    }\r\n  }\r\n\r\n  // No data spreadsheet placeholder\r\n  .spreadsheet--empty {\r\n    @extend .spreadsheet--loading;\r\n\r\n    // Generic message\r\n    &:after {\r\n      content: 'No Data Available.';\r\n    }\r\n    // Different messages depending of the page\r\n    &.empty_results:after {\r\n      content: 'No Results Available.';\r\n    }\r\n    &.empty_period_equations:after {\r\n      content: 'No Period Equations Available.';\r\n    }\r\n  }\r\n}\r\n\r\n.sheet-status {\r\n  .error {\r\n    line-height: 20px;\r\n    padding: 5px 0;\r\n    color: $red;\r\n\r\n    &:after {\r\n      margin-left: 5px;\r\n      content: $error;\r\n      font-family: 'empyrean_icons';\r\n      vertical-align: top;\r\n    }\r\n  }\r\n\r\n  .valid {\r\n    line-height: 20px;\r\n    padding: 5px 0;\r\n\r\n    &:after {\r\n      color: $red;\r\n      margin-left: 5px;\r\n      content: $error;\r\n      font-family: 'empyrean_icons';\r\n      vertical-align: top;\r\n    }\r\n  }\r\n}\r\n","form {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\ninput,\r\nselect,\r\nbutton {\r\n  font-size: 1em;\r\n  font-family: $font_pack !important;\r\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n}\r\n\r\ntextarea {\r\n  font-size: 1em;\r\n  font-family: $font_pack !important;\r\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n}\r\n\r\nlabel {\r\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n}\r\n\r\nfieldset {\r\n  margin: 0;\r\n  padding: 0;\r\n  border: 0;\r\n\r\n  legend {\r\n    display: block;\r\n    box-sizing: border-box;\r\n    line-height: 20px;\r\n    padding: 5px 0 5px 0px;\r\n\r\n    &.hidden_legend {\r\n      position: absolute;\r\n      font-size: 0;\r\n    }\r\n  }\r\n}\r\n\r\n/* Text Area */\r\ntextarea.inputbox {\r\n  width: 100%;\r\n  resize: none;\r\n  -webkit-overflow-scrolling: touch;\r\n  overflow: auto;\r\n  border: 1px solid $input_border;\r\n  @include box-sizing(border-box);\r\n  margin: 0;\r\n  padding: 5px 5px;\r\n  line-height: 20px;\r\n  vertical-align: bottom;\r\n  background: $input_background none 0 0 no-repeat;\r\n  @include border-radius(4px);\r\n  color: $app_color;\r\n\r\n  &.no_border {\r\n    border: 1px solid transparent;\r\n  }\r\n\r\n  &[readonly] {\r\n    border: 1px solid $grey;\r\n    background-color: $input_background_readonly;\r\n    padding-right: 25px;\r\n  }\r\n\r\n  &:focus {\r\n    border: 1px solid $input_border_focus;\r\n\r\n    &[readonly] {\r\n      border: 1px solid $lighter_grey;\r\n    }\r\n\r\n    &[readonly][disabled] {\r\n      border: 1px solid transparent;\r\n    }\r\n  }\r\n\r\n  &.auto_width {\r\n    width: initial;\r\n  }\r\n}\r\n\r\n@element 'textarea.inputbox.required' and (max-characters: 0) {\r\n  eq_this {\r\n    /* input:empty */\r\n    background-color: $input_required !important;\r\n  }\r\n}\r\n\r\n@element 'textarea.inputbox.required' and (min-characters: 1) {\r\n  eq_this {\r\n    /* input:not(:empty) */\r\n    background-color: $white !important;\r\n  }\r\n}\r\n\r\n/* Inputbox */\r\ninput.inputbox {\r\n  width: 100%;\r\n  line-height: 20px;\r\n  margin: 0;\r\n  padding: 4px 5px;\r\n  border: 1px solid $input_border;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  @include box-sizing(border-box);\r\n  background: $input_background none 0 0 no-repeat;\r\n  -moz-background-size: 0% auto;\r\n  text-indent: 0.01px;\r\n  text-overflow: '';\r\n  @include border-radius(4px);\r\n  color: $app_color;\r\n\r\n  &.no_border {\r\n    border: 1px solid transparent;\r\n  }\r\n\r\n  &[readonly] {\r\n    border: 1px solid $grey;\r\n    background-color: $input_background_readonly;\r\n  }\r\n\r\n  &:focus {\r\n    border: 1px solid $input_border_focus;\r\n    // box-shadow: 0 0 4px 1px $input_border_focus;\r\n\r\n    &[readonly] {\r\n      border: 1px solid $input_border;\r\n    }\r\n\r\n    &[readonly][disabled] {\r\n      border: 1px solid transparent;\r\n    }\r\n  }\r\n\r\n  &.auto_width {\r\n    width: initial;\r\n  }\r\n}\r\n\r\ninput[type='date'] {\r\n  -webkit-appearance: none;\r\n}\r\n\r\ninput[type='number'] {\r\n  -webkit-appearance: none;\r\n}\r\n\r\n@element 'input.inputbox.required' and (max-characters: 0) {\r\n  eq_this {\r\n    /* input:empty */\r\n    background-color: $input_required !important;\r\n  }\r\n}\r\n\r\n@element 'input.inputbox.required' and (min-characters: 1) {\r\n  eq_this {\r\n    /* input:not(:empty) */\r\n    background-color: $white !important;\r\n  }\r\n}\r\n\r\n/* Select */\r\nselect.inputbox {\r\n  width: 100%;\r\n  line-height: 20px;\r\n  margin: 0;\r\n  padding: 4px 25px 4px 5px;\r\n  border: 1px solid $input_border;\r\n  color: $app_color;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  @include box-sizing(border-box);\r\n\r\n  background: $input_background url('/assets/images/select_dropdown.png') no-repeat;\r\n  @include image-2x('/assets/images/select_dropdown@2x.png', 20px, 20px);\r\n\r\n  background-position: right center;\r\n\r\n  -webkit-padding-end: 25px;\r\n  -moz-padding-end: 25px;\r\n  -moz-background-size: 0% auto;\r\n  text-indent: 0.01px;\r\n  text-overflow: '';\r\n  padding-right: 25px\\9;\r\n  cursor: pointer;\r\n  @include border-radius(4px);\r\n\r\n  &.no_border {\r\n    border: 1px solid transparent;\r\n  }\r\n\r\n  &.no_dropdown {\r\n    background: none !important;\r\n    background-color: $input_background !important;\r\n    padding: 10px !important;\r\n  }\r\n\r\n  &.add_item_select_box {\r\n    @include opacity(0.5);\r\n  }\r\n\r\n  &[readonly] {\r\n    border: 1px solid $grey;\r\n    background-color: $input_background_readonly;\r\n  }\r\n\r\n  &.no_dropdown {\r\n    -webkit-padding-end: 0px;\r\n    -moz-padding-end: 0px;\r\n    padding-right: 0px\\9;\r\n    padding: 10px 0px 9px 0px;\r\n  }\r\n\r\n  &:focus {\r\n    border: 1px solid $input_border_focus;\r\n    @include opacity(1);\r\n  }\r\n\r\n  &.auto_width {\r\n    width: initial;\r\n  }\r\n\r\n  option {\r\n    color: $app_color;\r\n\r\n    &[disabled] {\r\n      color: $grey;\r\n    }\r\n  }\r\n}\r\n\r\nselect:-moz-focusring {\r\n  color: transparent;\r\n  text-shadow: 0 0 0 #000;\r\n}\r\n\r\nselect::-ms-expand {\r\n  display: none;\r\n  text-indent: 0.01px;\r\n  text-overflow: '';\r\n}\r\n\r\nselect::-moz-focus-inner {\r\n  padding: 0;\r\n  border: 0;\r\n  margin: 0px;\r\n  background-image: none !important;\r\n}\r\n\r\n// Style CSS for Firefox Only\r\n@-moz-document url-prefix() {\r\n  select.inputbox {\r\n    padding: 6px 25px 7px 5px;\r\n  }\r\n}\r\n\r\n// Use EQCSS to determin if there is a value in the select - This will most likely always show a complete state\r\n@element 'select.inputbox.required' and (max-characters: 0) {\r\n  eq_this {\r\n    /* input:empty */\r\n    background-color: $input_required !important;\r\n  }\r\n}\r\n\r\n@element 'select.inputbox.required' and (min-characters: 1) {\r\n  eq_this {\r\n    /* input:not(:empty) */\r\n    background-color: $white !important;\r\n  }\r\n}\r\n\r\n/* Disabled States */\r\n\r\ninput[disabled],\r\ntextarea[disabled],\r\nselect[disabled] {\r\n  -webkit-text-fill-color: $grey;\r\n  -webkit-opacity: 1;\r\n  color: $grey;\r\n  background: transparent;\r\n}\r\n\r\ninput.inputbox[disabled] {\r\n  background-color: $lighter_grey;\r\n  border: 1px solid $lighter_grey;\r\n  color: $grey;\r\n  cursor: default;\r\n}\r\n\r\nselect.inputbox[disabled] {\r\n  background-color: $lighter_grey;\r\n  border: 1px solid $lighter_grey;\r\n  color: $grey;\r\n  cursor: default;\r\n}\r\n\r\ntextarea[disabled] {\r\n  background-color: $lighter_grey;\r\n  border: 1px solid $lighter_grey;\r\n  color: $grey;\r\n  cursor: default;\r\n}\r\n\r\n/* Placeholder Text */\r\n.inputbox {\r\n  &::-webkit-input-placeholder {\r\n    /* WebKit, Blink, Edge */\r\n    color: $placeholder-color;\r\n    // -webkit-text-fill-color: transparent !important;\r\n    opacity: 1;\r\n  }\r\n  &:-moz-placeholder {\r\n    /* Mozilla Firefox 4 to 18 */\r\n    color: $placeholder-color;\r\n    opacity: 1;\r\n  }\r\n  &::-moz-placeholder {\r\n    /* Mozilla Firefox 19+ */\r\n    color: $placeholder-color;\r\n    opacity: 1;\r\n  }\r\n  &:-ms-input-placeholder {\r\n    /* Internet Explorer 10-11 */\r\n    color: $placeholder-color;\r\n    opacity: 1;\r\n  }\r\n  &:placeholder-shown {\r\n    /* Standard (https://drafts.csswg.org/selectors-4/#placeholder) */\r\n    color: $placeholder-color;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\ninput[type='number']::-webkit-inner-spin-button,\r\ninput[type='number']::-webkit-outer-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\ninput[type='number'] {\r\n  -moz-appearance: textfield;\r\n}\r\n\r\n/* Error States */\r\n\r\n/* Datepicker */\r\n\r\n.btn_icon_date {\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n  background-color: transparent;\r\n  border: 0;\r\n  padding: 7px;\r\n  @include border-radius(0px 4px 4px 0px);\r\n  cursor: pointer;\r\n}\r\n\r\n.btn_icon_date:focus,\r\n.btn_icon_date:hover {\r\n  color: $white;\r\n  background-color: $primary-color;\r\n}\r\n\r\n/* Inputbox Widths */\r\n\r\ninput.inputbox,\r\nselect.inputbox,\r\ntextarea.inputbox {\r\n  &.width_x-small {\r\n    width: 60px;\r\n    display: inline-block;\r\n  }\r\n\r\n  &.width_small {\r\n    width: 80px;\r\n    display: inline-block;\r\n  }\r\n}\r\n\r\n.inputbox.invalid {\r\n  border-color: $red;\r\n}\r\n\r\n.invalid_message {\r\n  display: inline-block;\r\n  line-height: 20px;\r\n  clear: both;\r\n  color: $red;\r\n}\r\n\r\n// IE 11 Overrides\r\n\r\n@media all and (-ms-high-contrast: none) {\r\n  input.inputbox {\r\n    height: 30px;\r\n  } /* IE10 */\r\n  *::-ms-backdrop,\r\n  input.inputbox {\r\n    height: 30px;\r\n  } /* IE11 */\r\n\r\n  select.inputbox {\r\n    height: 30px;\r\n  } /* IE10 */\r\n  *::-ms-backdrop,\r\n  select.inputbox {\r\n    height: 30px;\r\n  } /* IE11 */\r\n\r\n  textarea.inputbox[readonly] {\r\n    overflow: auto;\r\n    -ms-overflow-style: none;\r\n  }\r\n  *::-ms-backdrop,\r\n  textarea.inputbox[readonly] {\r\n    overflow: auto;\r\n    -ms-overflow-style: none;\r\n  } /* IE11 */\r\n}\r\n",".inputbox[type=\"checkbox\"]:checked,\r\n.inputbox[type=\"checkbox\"]:not(:checked) {\r\n    position: absolute;\r\n    left: -9999px;\r\n}\r\n\r\n.inputbox[type=\"checkbox\"]:checked + label,\r\n.inputbox[type=\"checkbox\"]:not(:checked) + label {\r\n    position: relative;\r\n    cursor: pointer;\r\n    line-height: 20px;\r\n    display: inline-block;\r\n    color: $app_color;\r\n    padding: 5px 0 5px 20px !important;\r\n}\r\n.inputbox[type=\"checkbox\"]:checked + label:before,\r\n.inputbox[type=\"checkbox\"]:not(:checked) + label:before {\r\n    content: '';\r\n    position: absolute;\r\n    left: 0;\r\n    top: 6px;\r\n    width: 14px;\r\n    height: 14px;\r\n    border: 1px solid $input_border;\r\n    background: $white;\r\n    @include border-radius(3px);\r\n}\r\n\r\n.inputbox[type=\"checkbox\"]:checked + label:after,\r\n.inputbox[type=\"checkbox\"]:not(:checked) + label:after {\r\n    content: '';\r\n    display: block;\r\n    position: absolute;\r\n    top: 8px;\r\n    left: 6px;\r\n    width: 3px;\r\n    height: 8px;\r\n    border: solid $navy;\r\n    border-width: 0 2px 2px 0;\r\n    transform: rotate(45deg);\r\n}\r\n\r\n\r\n// Hover & Focus State\r\n\r\n.inputbox[type=\"checkbox\"]:hover + label,\r\n.inputbox[type=\"checkbox\"]:focus + label {\r\n    color: $app_color;\r\n}\r\n.inputbox[type=\"checkbox\"]:hover + label:before,\r\n.inputbox[type=\"checkbox\"]:focus + label:before {\r\n    border: 1px solid $input_border_focus;\r\n}\r\n\r\n.inputbox[type=\"checkbox\"]:hover + label:after,\r\n.inputbox[type=\"checkbox\"]:focus + label:after {\r\n}\r\n\r\n\r\n// Disabled State\r\n\r\n.inputbox[type=\"checkbox\"]:disabled:checked + label,\r\n.inputbox[type=\"checkbox\"]:disabled:not(:checked) + label {\r\n    position: relative;\r\n    cursor: pointer;\r\n    line-height: 20px;\r\n    display: inline-block;\r\n    color: $grey;\r\n    padding: 5px 0 5px 20px;\r\n}\r\n.inputbox[type=\"checkbox\"]:disabled:checked + label:before,\r\n.inputbox[type=\"checkbox\"]:disabled:not(:checked) + label:before {\r\n    content: '';\r\n    position: absolute;\r\n    left: 0;\r\n    top: 6px;\r\n    width: 14px;\r\n    height: 14px;\r\n    border: 1px solid $grey;\r\n    background: $light_grey;\r\n}\r\n\r\n.inputbox[type=\"checkbox\"]:disabled:checked + label:after,\r\n.inputbox[type=\"checkbox\"]:disabled:not(:checked) + label:after {\r\n    content: '';\r\n    display: block;\r\n    position: absolute;\r\n    top: 8px;\r\n    left: 6px;\r\n    width: 3px;\r\n    height: 8px;\r\n    border: solid $dark_grey;\r\n    border-width: 0 2px 2px 0;\r\n    transform: rotate(45deg);\r\n}\r\n\r\n\r\n// Checked & Unchecked State\r\n\r\n.inputbox[type=\"checkbox\"]:not(:checked) + label:after {\r\n    opacity: 0;\r\n}\r\n\r\n.inputbox[type=\"checkbox\"]:checked + label:after {\r\n    opacity: 1;\r\n    border-color: $white;\r\n}\r\n\r\n.inputbox[type=\"checkbox\"]:checked + label:before {\r\n    border-color: $navy;\r\n    border-width: 0;\r\n    height: 16px;\r\n    width: 16px;\r\n    background-color: $navy;\r\n}\r\n\r\n",".inputbox[type=\"radio\"]:checked,\r\n.inputbox[type=\"radio\"]:not(:checked) {\r\n    position: absolute;\r\n    left: -9999px;\r\n}\r\n\r\n.inputbox[type=\"radio\"]:checked + label,\r\n.inputbox[type=\"radio\"]:not(:checked) + label {\r\n    position: relative;\r\n    cursor: pointer;\r\n    line-height: 20px;\r\n    display: inline-block;\r\n    color: $app_color;\r\n    padding: 5px 0 5px 20px !important;\r\n}\r\n.inputbox[type=\"radio\"]:checked + label:before,\r\n.inputbox[type=\"radio\"]:not(:checked) + label:before {\r\n    content: '';\r\n    position: absolute;\r\n    left: 0;\r\n    top: 6px;\r\n    width: 14px;\r\n    height: 14px;\r\n    border: 1px solid $input_border;\r\n    border-radius: 100%;\r\n    background: $white;\r\n}\r\n\r\n.inputbox[type=\"radio\"]:checked + label:after,\r\n.inputbox[type=\"radio\"]:not(:checked) + label:after {\r\n    content: '';\r\n    width: 10px;\r\n    height: 10px;\r\n    background: $navy;\r\n    position: absolute;\r\n    top: 9px;\r\n    left: 3px;\r\n    border-radius: 100%;\r\n    -webkit-transition: all 0.2s ease;\r\n    transition: all 0.2s ease;\r\n}\r\n\r\n\r\n\r\n\r\n// Hover & Focus States\r\n\r\n.inputbox[type=\"radio\"]:focus + label,\r\n.inputbox[type=\"radio\"]:hover + label {\r\n    color: $app_color;\r\n}\r\n.inputbox[type=\"radio\"]:focus + label:before,\r\n.inputbox[type=\"radio\"]:hover + label:before {\r\n    border: 1px solid $input_border_focus;\r\n}\r\n\r\n.inputbox[type=\"radio\"]:focus + label:after,\r\n.inputbox[type=\"radio\"]:hover + label:after {\r\n}\r\n\r\n\r\n// Disabled State\r\n\r\n.inputbox[type=\"radio\"]:disabled:checked + label,\r\n.inputbox[type=\"radio\"]:disabled:not(:checked) + label {\r\n    position: relative;\r\n    cursor: pointer;\r\n    line-height: 20px;\r\n    display: inline-block;\r\n    color: $app_color;\r\n    padding: 5px 0 5px 20px;\r\n}\r\n.inputbox[type=\"radio\"]:disabled:checked + label:before,\r\n.inputbox[type=\"radio\"]:disabled:not(:checked) + label:before {\r\n    content: '';\r\n    position: absolute;\r\n    left: 0;\r\n    top: 6px;\r\n    width: 14px;\r\n    height: 14px;\r\n    border: 1px solid $grey;\r\n    border-radius: 100%;\r\n    background: $light_grey;\r\n}\r\n\r\n.inputbox[type=\"radio\"]:disabled:checked + label:after,\r\n.inputbox[type=\"radio\"]:disabled:not(:checked) + label:after {\r\n    content: '';\r\n    width: 10px;\r\n    height: 10px;\r\n    background: $dark_grey;\r\n    position: absolute;\r\n    top: 9px;\r\n    left: 3px;\r\n    border-radius: 100%;\r\n    -webkit-transition: all 0.2s ease;\r\n    transition: all 0.2s ease;\r\n}\r\n\r\n\r\n\r\n// Checked & Not Checked State\r\n\r\n\r\n.inputbox[type=\"radio\"]:not(:checked) + label:after {\r\n    opacity: 0;\r\n    -webkit-transform: scale(0);\r\n    transform: scale(0);\r\n}\r\n\r\n.inputbox[type=\"radio\"]:checked + label:after {\r\n    opacity: 1;\r\n    -webkit-transform: scale(1);\r\n    transform: scale(1);\r\n}\r\n\r\n.inputbox[type=\"radio\"]:checked + label:before {\r\n    border-color: $navy;\r\n}\r\n","/* Button Group */\r\n\r\n\tul.button_group {\r\n\t\tmargin:0;\r\n\t\tpadding: 0;\r\n\t\tlist-style:none;\r\n\t\t// float: left;\r\n\t\t// width:100%;\r\n\r\n\t\t>li {\r\n\t\t\tfloat: left;\r\n\t\t\tmargin:0 !important;\r\n\t\t\t// width: 50%;\r\n\r\n\t\t\t&:first-child {\r\n\t\t\t\tbutton {\r\n\t\t\t\t\t@include border-left-radius (4px);\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t\tmargin-left: 0;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t&:last-child {\r\n\t\t\t\tbutton {\r\n\t\t\t\t\t@include border-right-radius (4px);\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t\t// border-right: 1px solid $base_color;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\tbutton.btn_group {\r\n\t\twidth:auto;\r\n\t\tbackground-color:transparent;\r\n\t\tposition: relative;\r\n\t  \tcolor: $app_color;\r\n\t\tline-height:20px;\r\n\t\tmargin:0px;\r\n\t\tpadding:4px 10px;\r\n\t\toverflow:visible;\r\n\t\t@include border-radius(0px);\r\n\t\t-webkit-appearance:none;\r\n\t\tbox-sizing:border-box;\r\n\t\tdisplay: inline-block;\r\n\t\tborder:1px solid $base_color;\r\n\t\t// border-right:0px solid;\r\n\t\tcursor:pointer;\r\n\t\tmin-width:20px;\r\n\t\t@include box-sizing(border-box);\r\n\t\tposition: relative;\r\n\t\tmargin-left: -1px;\r\n\t\tmin-width: 60px; \r\n\r\n\t\t&:hover,\r\n\t\t&:focus {\r\n\t\t\tborder-color:$primary_color;\r\n\t\t\tcolor: $primary_color;\r\n\t\t\tz-index: 1;\r\n\t\t}\r\n\r\n\r\n\t\t&.btn_selected {\r\n\t\t\tborder-color: $base_color;\r\n\t\t\tbackground-color: $base_color;\r\n\t\t\tcolor: $white;\r\n\r\n\t\t\t&:hover,\r\n\t\t\t&:focus {\r\n\t\t\t\tborder-color: $base_color;\r\n\t\t\t\tbackground-color: $base_color;\r\n\t\t\t\tcolor: $white;\r\n\t\t\t}\t\t\t\t\r\n\t\t}\r\n\t}","button.btn_dropdown {\r\n  border: none;\r\n  text-align: left;\r\n  border-color: $input_border;\r\n\r\n  &.btn_secondary {\r\n    // border-color: $input_border;\r\n  }\r\n\r\n  // This is to allow the click event to be passed through to the button\r\n  .btn_text,\r\n  .btn_icon_arrow,\r\n  .btn_icon,\r\n  .pkg_icon,\r\n  .pkg_name,\r\n  .btn_indicator {\r\n    pointer-events: none;\r\n\r\n    span,\r\n    div {\r\n      pointer-events: none;\r\n    }\r\n  }\r\n\r\n  .btn_indicator {\r\n  }\r\n\r\n  &:active {\r\n    .btn_indicator {\r\n      // transform: rotate(180deg);\r\n    }\r\n  }\r\n}\r\n\r\n.dropdown_container {\r\n  position: relative;\r\n  display: inline-block;\r\n\r\n  &.full_width {\r\n    display: block;\r\n  }\r\n\r\n  &.inline {\r\n    display: inline-block;\r\n    margin-left: 10px;\r\n    vertical-align: bottom;\r\n  }\r\n}\r\n\r\n/* Dropdown Content (Hidden by Default) */\r\n.dropdown_content {\r\n  display: none;\r\n  min-width: 180px;\r\n  // top: calc(100% + 10px);\r\n  background: $white;\r\n  padding: 0px;\r\n  @include border-radius(3px);\r\n  box-shadow: 0 1px 4px rgba($black, 0.3), 0 1px 20px rgba($black, 0.3);\r\n  @include box-sizing(border-box);\r\n  max-height: calc(50vh + 50px);\r\n  overflow: auto;\r\n  -webkit-overflow-scrolling: touch;\r\n  position: fixed;\r\n  width: 340px;\r\n  z-index: 1000001; // ! To show up over the main banner message shadow\r\n  color: $app_color;\r\n  text-align: left;\r\n\r\n  &.no_scroll_bar {\r\n    max-height: inherit;\r\n  }\r\n\r\n  &.has_padding {\r\n    padding: 10px;\r\n  }\r\n\r\n  &.position_right {\r\n    right: 0;\r\n  }\r\n\r\n  // &.position_top {\r\n  //     top: auto;\r\n  //     bottom:-100%;\r\n  // }\r\n\r\n  &.full_width {\r\n    left: 0;\r\n    right: 0;\r\n    min-width: inherit;\r\n  }\r\n\r\n  &.min_width {\r\n    min-width: 320px;\r\n  }\r\n\r\n  .dropdown_content_body {\r\n    padding: 10px;\r\n\r\n    p {\r\n      &:last-of-type {\r\n        margin: 0;\r\n        padding: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  .dropdown_footer {\r\n    display: block;\r\n    padding: 10px 10px;\r\n    border-top: 1px solid $border_color;\r\n\r\n    button {\r\n      width: 100%;\r\n    }\r\n\r\n    &.align_center {\r\n      text-align: center;\r\n    }\r\n  }\r\n}\r\n\r\n/* Show the dropdown menu (use JS to add this class to the .dropdown_content container when the user clicks on the dropdown button) */\r\n.dropdown_content.show {\r\n  display: block;\r\n}\r\n\r\n.select-style mat-option{\r\n  font-size: 12px !important;\r\n  min-height: 28px !important;  /* or your preferred value */\r\n  height: 28px !important;\r\n  line-height: 28px !important;\r\n  padding-top: 0 !important;\r\n  padding-bottom: 0 !important;  \r\n}",".btn_drawer {\r\n  border: none;\r\n  display: block;\r\n  cursor: pointer;\r\n  position: relative;\r\n  line-height: 20px;\r\n  padding: 5px 0 5px 20px;\r\n  width: 100%;\r\n  text-align: left;\r\n  @include border-radius(4px);\r\n\r\n  background-color: transparent;\r\n  color: $app_color;\r\n  margin: 0px;\r\n  overflow: visible;\r\n  -webkit-appearance: none;\r\n  box-sizing: border-box;\r\n  border: 0px solid;\r\n  @include box-sizing(border-box);\r\n\r\n  .btn_icon {\r\n    @include transition(all 0.1s ease);\r\n  }\r\n\r\n  &:hover,\r\n  &:focus {\r\n    color: $blue;\r\n  }\r\n\r\n  &:hover {\r\n    background-color: $lighter_grey;\r\n  }\r\n\r\n  &.btn_drawer_active {\r\n    color: $app_color;\r\n\r\n    .btn_icon {\r\n      @include rotate(90);\r\n    }\r\n  }\r\n}\r\n\r\n.drawer_container {\r\n  .drawer_header {\r\n    position: relative;\r\n    padding-left: 30px;\r\n\r\n    .drawer_header_toggle {\r\n      position: absolute;\r\n      left: 0;\r\n      top: 0;\r\n    }\r\n\r\n    .drawer_header_title {\r\n      .drawer_content {\r\n        margin-left: 30px;\r\n        .tree_link {\r\n          width: 100%;\r\n          display: block;\r\n          @include box-sizing(border-box);\r\n        }\r\n      }\r\n\r\n      a {\r\n        font-weight: 600;\r\n      }\r\n    }\r\n  }\r\n\r\n  /* Drawer Content (Hidden by Default) */\r\n  .drawer_content {\r\n    display: none;\r\n    position: relative;\r\n\r\n    &.drawer_active {\r\n      display: block;\r\n    }\r\n  }\r\n}\r\n\r\n.drawer_active {\r\n  font-weight: bold !important;\r\n  color: $green !important;\r\n}\r\n","\r\n.margin_r-5  {margin-right: 5px;}\r\n.margin_r-10 {margin-right: 10px;}\r\n.margin_r-15 {margin-right: 15px;}\r\n.margin_r-20 {margin-right: 20px;}\r\n.margin_r-25 {margin-right: 25px;}\r\n.margin_r-30 {margin-right: 30px;}\r\n\r\n.margin_l-5  {margin-left: 5px;}\r\n.margin_l-10 {margin-left: 10px;}\r\n.margin_l-15 {margin-left: 15px;}\r\n.margin_l-20 {margin-left: 20px;}\r\n.margin_l-25 {margin-left: 25px;}\r\n.margin_l-30 {margin-left: 30px;}\r\n\r\n.margin_t-5  {margin-top: 5px;}\r\n.margin_t-10 {margin-top: 10px;}\r\n.margin_t-15 {margin-top: 15px;}\r\n.margin_t-20 {margin-top: 20px;}\r\n.margin_t-25 {margin-top: 25px;}\r\n.margin_t-30 {margin-top: 30px;}\r\n\r\n.margin_b-5  {margin-bottom: 5px;}\r\n.margin_b-10 {margin-bottom: 10px;}\r\n.margin_b-15 {margin-bottom: 15px;}\r\n.margin_b-20 {margin-bottom: 20px;}\r\n.margin_b-25 {margin-bottom: 25px;}\r\n.margin_b-30 {margin-bottom: 30px;}\r\n\r\n.margin_5  {margin: 5px;}\r\n.margin_10 {margin: 10px;}\r\n.margin_15 {margin: 15px;}\r\n.margin_20 {margin: 20px;}\r\n.margin_25 {margin: 25px;}\r\n.margin_30 {margin: 30px;}\r\n\r\n.margin_h-5  {margin-right: 5px; margin-left: 5px;}\r\n.margin_h-10 {margin-right: 10px; margin-left: 10px;}\r\n.margin_h-15 {margin-right: 15px; margin-left: 15px;}\r\n.margin_h-20 {margin-right: 20px; margin-left: 20px;}\r\n.margin_h-25 {margin-right: 25px; margin-left: 25px;}\r\n.margin_h-30 {margin-right: 30px; margin-left: 30px;}\r\n\r\n.margin_v-5  {margin-top: 5px; margin-bottom: 5px; }\r\n.margin_v-10 {margin-top: 10px; margin-bottom: 10px; }\r\n.margin_v-15 {margin-top: 15px; margin-bottom: 15px; }\r\n.margin_v-20 {margin-top: 20px; margin-bottom: 20px; }\r\n.margin_v-25 {margin-top: 25px; margin-bottom: 25px; }\r\n.margin_v-30 {margin-top: 30px; margin-bottom: 30px; }\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.padding_r-5  {padding-right: 5px;}\r\n.padding_r-10 {padding-right: 10px;}\r\n.padding_r-15 {padding-right: 15px;}\r\n.padding_r-20 {padding-right: 20px;}\r\n.padding_r-25 {padding-right: 25px;}\r\n.padding_r-30 {padding-right: 30px;}\r\n\r\n.padding_l-5  {padding-left: 5px;}\r\n.padding_l-10 {padding-left: 10px;}\r\n.padding_l-15 {padding-left: 15px;}\r\n.padding_l-20 {padding-left: 20px;}\r\n.padding_l-25 {padding-left: 25px;}\r\n.padding_l-30 {padding-left: 30px;}\r\n\r\n.padding_t-5  {padding-top: 5px;}\r\n.padding_t-10 {padding-top: 10px;}\r\n.padding_t-15 {padding-top: 15px;}\r\n.padding_t-20 {padding-top: 20px;}\r\n.padding_t-25 {padding-top: 25px;}\r\n.padding_t-30 {padding-top: 30px;}\r\n\r\n.padding_b-5  {padding-bottom: 5px;}\r\n.padding_b-10 {padding-bottom: 10px;}\r\n.padding_b-15 {padding-bottom: 15px;}\r\n.padding_b-20 {padding-bottom: 20px;}\r\n.padding_b-25 {padding-bottom: 25px;}\r\n.padding_b-30 {padding-bottom: 30px;}\r\n\r\n.padding_5  {padding: 5px;}\r\n.padding_10 {padding: 10px;}\r\n.padding_15 {padding: 15px;}\r\n.padding_20 {padding: 20px;}\r\n.padding_25 {padding: 25px;}\r\n.padding_30 {padding: 30px;}\r\n\r\n.padding_h-5  {padding-right: 5px; padding-left: 5px;}\r\n.padding_h-10 {padding-right: 10px; padding-left: 10px;}\r\n.padding_h-15 {padding-right: 15px; padding-left: 15px;}\r\n.padding_h-20 {padding-right: 20px; padding-left: 20px;}\r\n.padding_h-25 {padding-right: 25px; padding-left: 25px;}\r\n.padding_h-30 {padding-right: 30px; padding-left: 30px;}\r\n\r\n.padding_v-5  {padding-top: 5px; padding-bottom: 5px; }\r\n.padding_v-10 {padding-top: 10px; padding-bottom: 10px; }\r\n.padding_v-15 {padding-top: 15px; padding-bottom: 15px; }\r\n.padding_v-20 {padding-top: 20px; padding-bottom: 20px; }\r\n.padding_v-25 {padding-top: 25px; padding-bottom: 25px; }\r\n.padding_v-30 {padding-top: 30px; padding-bottom: 30px; }","table.dataTable {\r\n\tborder-collapse: collapse;\r\n\tborder-spacing: 0;\r\n\twidth: 100%;\r\n\tempty-cells: show;\r\n\tbackground-color: $white;\r\n\t@include box-sizing(border-box);\r\n\t\r\n\t&.hidden_header {\r\n\t\tthead {\r\n\t\t\tposition: absolute;\r\n\t\t\tfont-size: 0;\r\n\t\t\tpadding: 0;\r\n\t\t\theight: 0;\r\n\t\t\twidth: 0;\r\n\t\t\tdisplay: block;\r\n\r\n\t\t\ttr {\r\n\t\t\t\ttd,th {\r\n\t\t\t\t\tfont-size: 0 !important;\r\n\t\t\t\t\tpadding: 0 !important;\r\n\t\t\t\t\theight: 0 !important;\r\n\t\t\t\t\twidth: 0 !important;\r\n\t\t\t\t\t@include opacity(0);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\ttbody {\r\n\t\t\ttr {\r\n\t\t\t\t&:first-child {\r\n\t\t\t\t\tth,td {\r\n\t\t\t\t\t\tborder-top: 1px solid $border_color;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\t\r\n\tthead {\r\n\t\ttr {\r\n\t\t\tth,td {\r\n\t\t\t\ttext-align: left;\r\n\t\t\t\tborder-bottom: 1px solid $border_color;\r\n\t\t\t\tbackground-color: $light_grey;\r\n\t\t\t\tvertical-align: top;\r\n\t\t\t\tpadding: 5px;\r\n\t\t\t\tline-height: 20px;\r\n\t\t\t\tmin-height: 20px;\r\n\r\n\t\t\t\t&.col_chbox {\r\n\t\t\t\t\twidth: 20px;\r\n\t\t\t\t\tpadding: 0 5px !important;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&.col_icon {\r\n\t\t\t\t\twidth: 20px;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&.col_coldchain {\r\n\t\t\t\t\twidth: 50px;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t[class^=\"icon_\"], \r\n\t\t\t\t[class*=\" icon_\"] {\r\n\t\t\t\t\tfont-size: 16px;\r\n\t\t\t\t\tdisplay: inline-block;\r\n\t\t\t\t\tvertical-align: text-bottom;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&:empty {\r\n\t\t\t\t\theight: 20px;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&.nowrap {\r\n\t\t\t\t\twhite-space: nowrap;\r\n\t\t\t\t}\r\n\t\t\t\t\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\t\r\n\ttbody {\r\n\t\ttr {\r\n\t\t\tth,td {\r\n\t\t\t\tborder-bottom: 1px solid $border_color;\r\n\t\t\t\tvertical-align: top;\r\n\t\t\t\tpadding: 5px;\r\n\t\t\t\tline-height: 20px;\r\n\t\t\t\tmin-height: 20px;\r\n\r\n\t\t\t\t&.col_chbox {\r\n\t\t\t\t\twidth: 20px;\r\n\t\t\t\t\tpadding: 0 5px !important;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&.col_icon {\r\n\t\t\t\t\twidth: 20px;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&.col_coldchain {\r\n\t\t\t\t\twidth: 50px;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&:empty {\r\n\t\t\t\t\theight: 20px;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&.nowrap {\r\n\t\t\t\t\twhite-space: nowrap;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.table_btn_container {\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t\tfloat: left;\r\n\t\t\t\t\tmargin: 0px 0;\r\n\t\t\t\t\tvertical-align: top;\r\n\r\n\t\t\t\t\tbutton {\r\n\t\t\t\t\t\theight: 30px;\r\n\t\t\t\t\t\tvertical-align: top;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\r\n\t\t\t\t[class^=\"icon_\"], \r\n\t\t\t\t[class*=\" icon_\"] {\r\n\t\t\t\t\tfont-size: 16px;\r\n\t\t\t\t\tdisplay: inline-block;\r\n\t\t\t\t\tvertical-align: text-bottom;\r\n\t\t\t\t}\r\n\r\n\t\t\t}\r\n\r\n\t\t\t&:hover {\r\n\t\t\t\t>td,\r\n\t\t\t\t>th {\r\n\t\t\t\t\tbackground-color: $state_hover;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t&.row_swog {\r\n\t\t\t\t>th,\r\n\t\t\t\t>td {\r\n\t\t\t\t\t// \r\n\r\n\t\t\t\t\t&:first-child {\r\n\t\t\t\t\t\tbackground-color: $lighter_grey;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t&.row_multipiece {\r\n\t\t\t\t>th,\r\n\t\t\t\t>td {\r\n\t\t\t\t\t\tbackground-color: $body_background;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t&.selected_row {\r\n\t\t\t\t>th,\r\n\t\t\t\t>td {\r\n\t\t\t\t\tbackground-color: rgba($blue, 0.2) !important;\r\n\r\n\t\t\t\t\ta {\r\n\t\t\t\t\t\tcolor: inherit;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t&.row_hidden {\r\n\t\t\t\tdisplay: none;\r\n\r\n\t\t\t\t&.row_visible {\r\n\t\t\t\t\tdisplay: table-row;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t&.row_visible {\r\n\t\t\t\tdisplay: table-row;\r\n\t\t\t}\r\n\r\n\t\t}\r\n\t}\r\n}\r\n\r\n\r\n// Button Options for Selected Table Row\r\n\r\n#table_selection_options {\r\n\tfloat: left;\r\n\tdisplay: none;\r\n\tmargin-left: 10px;\r\n\tborder-left: 1px solid $grey;\r\n\tpadding-left: 10px;\r\n}\r\n",".ui-widget {\r\n  font-family: $font_pack;\r\n}\r\n\r\n.hide_title_bar {\r\n  .ui-dialog-titlebar {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.ui-dialog {\r\n  border: 0px solid !important;\r\n  @include box-shadow(0 14px 24px rgba($black, 0.14), 0 2px 6px rgba($black, 0.12), 0 2px 15px rgba($black, 0.2));\r\n  padding: 0;\r\n  // max-width: 1400px;\r\n  // min-height: 90vh; \r\n\r\n  .ui-dialog-content {\r\n    padding: 0;\r\n    // min-height: 120px !important;\r\n\r\n    &.maximized {\r\n      // WiP\r\n      width: 100% !important;\r\n      height: calc(100% - 50px) !important;\r\n      top: 50px !important;\r\n      position: absolute !important;\r\n    }\r\n  }\r\n}\r\n\r\n.ui-widget-overlay {\r\n  background: rgba($navy, 0.3) !important;\r\n  @include opacity(1);\r\n}\r\n\r\n.ui-widget input,\r\n.ui-widget select,\r\n.ui-widget textarea {\r\n}\r\n\r\n.ui-widget button {\r\n  font-size: 0.76rem;\r\n}\r\n\r\n.dialog_header {\r\n  border-bottom: 0px solid $border-color;\r\n  padding: 15px 15px 0;\r\n\r\n  .dialog_back {\r\n    position: absolute;\r\n    left: 10px;\r\n    top: 10px;\r\n  }\r\n\r\n  .dialog_close {\r\n    position: absolute;\r\n    right: 10px;\r\n    top: 10px;\r\n    z-index: 1;\r\n    background-color: $white;\r\n  }\r\n\r\n  h1 {\r\n    font-size: 1.2em;\r\n    line-height: 20px;\r\n    font-weight: 400;\r\n    text-align: left;\r\n    color: $navy;\r\n  }\r\n\r\n  .dialog_desc {\r\n    text-align: center;\r\n    color: $dark_grey;\r\n    margin: 10px 0;\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n/* Dialog Content */\r\n\r\n.dialog_content {\r\n  padding: 0px;\r\n  @include box-sizing(border-box);\r\n\r\n  &.padding--all {\r\n    padding: 15px;\r\n  }\r\n\r\n  &.padding--left {\r\n    padding-left: 15px;\r\n  }\r\n\r\n  &.padding--right {\r\n    padding-right: 15px;\r\n  }\r\n\r\n  &.padding--top {\r\n    padding-top: 15px;\r\n  }\r\n\r\n  &.padding--bottom {\r\n    padding-bottom: 15px;\r\n  }\r\n\r\n  &.padding--vertical {\r\n    padding-top: 15px;\r\n    padding-bottom: 15px;\r\n  }\r\n\r\n  &.padding--horizontal {\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n  }\r\n\r\n\r\n  .dialog_content_inner {\r\n    padding: 15px;\r\n    overflow: auto;\r\n    position: relative;\r\n\r\n    &.no_padding {\r\n      padding: 0;\r\n    }\r\n\r\n    @media (max-width: 767px) {\r\n      padding: 15px 15px 10px;\r\n    }\r\n\r\n    &:after {\r\n      clear: both;\r\n      content: '';\r\n      display: block;\r\n      height: 0;\r\n      visibility: hidden;\r\n    }\r\n  }\r\n\r\n  .dialog_inner_heading_below{\r\n    width:40%;\r\n    margin-right:auto;\r\n    margin-left:auto;\r\n    margin-top:1em;\r\n    text-align: center;\r\n  }\r\n\r\n  /* Dialog Actions */\r\n  .dialog_actions {\r\n    padding: 15px;\r\n    border-top: 1px solid $border-color;\r\n\r\n    &.fixed_width {\r\n      min-width: 480px;\r\n      max-width: 480px;\r\n\r\n      @media (max-width: 767px) {\r\n        min-width: 290px;\r\n        max-width: 290px;\r\n      }\r\n    }\r\n\r\n    .actions_left {\r\n      float: left;\r\n\r\n      button,\r\n      input[type='button'] {\r\n        margin-right: 10px;\r\n        float: left;\r\n\r\n        &:last-of-type {\r\n          margin-right: 0;\r\n        }\r\n      }\r\n    }\r\n\r\n    .actions_right {\r\n      float: right;\r\n\r\n      button,\r\n      input[type='button'] {\r\n        margin-left: 10px;\r\n        float: left;\r\n\r\n        &:first-of-type {\r\n          margin-left: 0;\r\n        }\r\n      }\r\n    }\r\n\r\n    .actions_center {\r\n      float: none;\r\n      text-align: center;\r\n\r\n      button,\r\n      input[type='button'] {\r\n        margin: 0 5px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n/* Dialog Actions */\r\n.dialog_actions {\r\n  padding: 15px;\r\n  position: relative;\r\n\r\n  &:before {\r\n    content: '';\r\n    background-color: rgba($black, 0.1);\r\n    left: 0;\r\n    top: 0;\r\n    right: 0;\r\n    height: 1px;\r\n    position: absolute;\r\n  }\r\n\r\n  &.fixed_width {\r\n    min-width: 480px;\r\n    max-width: 480px;\r\n\r\n    @media (max-width: 767px) {\r\n      min-width: 290px;\r\n      max-width: 290px;\r\n    }\r\n  }\r\n\r\n  .actions_left {\r\n    float: left;\r\n\r\n    button,\r\n    input[type='button'] {\r\n      margin-right: 10px;\r\n      float: left;\r\n\r\n      &:last-of-type {\r\n        margin-right: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  .actions_right {\r\n    float: right;\r\n\r\n    button,\r\n    input[type='button'] {\r\n      margin-left: 10px;\r\n      float: left;\r\n\r\n      &:first-of-type {\r\n        margin-left: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  .actions_center {\r\n    float: none;\r\n    text-align: center;\r\n\r\n    button,\r\n    input[type='button'] {\r\n      margin: 0 5px;\r\n    }\r\n  }\r\n}\r\n\r\n/* Button Group for Adding Order */\r\n\r\n.button_group {\r\n  > ul {\r\n    margin: 0;\r\n    padding: 0;\r\n    list-style: none;\r\n    float: left;\r\n    width: 100%;\r\n\r\n    > li {\r\n      float: left;\r\n      width: calc(100% / 3);\r\n      margin: 0px 0;\r\n    }\r\n  }\r\n}\r\n\r\n.modal_footer_total {\r\n  position: relative;\r\n\r\n  .modal_footer_total_value {\r\n    line-height: 30px;\r\n    font-size: 1.4rem;\r\n    font-weight: 600;\r\n    top: 0px;\r\n    position: relative;\r\n  }\r\n}\r\n\r\n.dialog_tabs {\r\n  position: relative;\r\n  .dialog_close {\r\n    position: absolute;\r\n    z-index: 1;\r\n    right: 10px;\r\n    top: 10px;\r\n\r\n    button {\r\n      color: $white;\r\n    }\r\n  }\r\n}\r\n","#tab_nav {\r\n  padding: 0px 0px 0;\r\n  position: relative;\r\n  // background-color: $blue;\r\n\r\n  > ul {\r\n    margin: 0;\r\n    padding: 0;\r\n    list-style: none;\r\n    z-index: 1;\r\n    position: relative;\r\n    overflow: auto;\r\n    white-space: nowrap;\r\n    height: 40px;\r\n\r\n    &:after {\r\n      clear: both;\r\n      content: '';\r\n      display: block;\r\n      height: 0;\r\n      visibility: hidden;\r\n    }\r\n\r\n    > li {\r\n      display: block;\r\n      float: left;\r\n      height: 100%;\r\n    }\r\n  }\r\n}\r\n\r\nbutton.btn_tab {\r\n  @include border-radius(0);\r\n  background-color: transparent;\r\n  background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.03));\r\n  position: relative;\r\n  color: $white;\r\n  border-bottom: 0px solid $grey;\r\n  // padding: 15px;\r\n  // line-height: 20px;\r\n  text-transform: inherit;\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  height: 100%;\r\n\r\n  &.btn_text {\r\n    line-height: 0;\r\n  }\r\n\r\n  &:hover,\r\n  &:focus {\r\n    color: $white;\r\n    background-color: rgba($black, 0.1);\r\n  }\r\n\r\n  &.btn_tab_active {\r\n    background: transparent;\r\n    background-color: $white !important;\r\n    color: $navy;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      background: transparent;\r\n      background-color: $white !important;\r\n      color: $navy;\r\n    }\r\n\r\n    &:after {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n.tab_content {\r\n  display: none;\r\n  padding: 0px;\r\n\r\n  &.tab_content_active {\r\n    display: block;\r\n  }\r\n}\r\n",".panel_container {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: stretch;\r\n  flex-flow: nowrap;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  margin: 0px;\r\n  min-height: 0;\r\n  width: 100%;\r\n  -webkit-justify-content: flex-start;\r\n  -webkit-align-items: stretch;\r\n  -webkit-flex-flow: nowrap;\r\n  -webkit-flex-direction: column;\r\n\r\n  .panel_header {\r\n    position: relative;\r\n    padding-bottom: 10px;\r\n\r\n    &.no_padding {\r\n      padding-bottom: 0;\r\n    }\r\n\r\n    .panel_header_title {\r\n    }\r\n\r\n    .panel_header_actions {\r\n      position: absolute;\r\n      right: 0;\r\n      top: 0;\r\n\r\n      button {\r\n      }\r\n    }\r\n  }\r\n\r\n  .panel_controls {\r\n    padding-bottom: 10px;\r\n  }\r\n\r\n  .panel_content {\r\n    flex: 1;\r\n    overflow: auto;\r\n\r\n    .panel_content_inner {\r\n      overflow: auto;\r\n    }\r\n\r\n    // &.spread_container {\r\n    //   background-color: $lighter_grey;\r\n    //   position: relative;\r\n    //   min-height: 400px;\r\n\r\n    //   &:before {\r\n    //     content: $sheet_loader;\r\n    //     font-family: 'empyrean_icons';\r\n    //     position: absolute;\r\n    //     left: 50%;\r\n    //     top: 50%;\r\n    //     font-size: 80px;\r\n    //     color: $grey;\r\n    //     transform: translate(-50%, -50%);\r\n    //     font-weight: 300;\r\n    //   }\r\n\r\n    //   &:after {\r\n    //     content: 'Loading Sheet...';\r\n    //     position: absolute;\r\n    //     left: 50%;\r\n    //     top: 50%;\r\n    //     font-size: 1rem;\r\n    //     color: $grey;\r\n    //     transform: translate(-50%, -50%);\r\n    //     margin-top: 50px;\r\n    //     text-align: center;\r\n    //     font-weight: 300;\r\n    //   }\r\n\r\n    //   .panel_content_inner {\r\n    //   }\r\n    // }\r\n  }\r\n}\r\n","\r\n.toggle_switch_radio[type=\"radio\"]:checked,\r\n.toggle_switch_radio[type=\"radio\"]:not(:checked) {\r\n    position: absolute;\r\n    left: -9999px;\r\n}\r\n\r\n.toggle_switch_radio[type=\"radio\"]:checked + label {\r\n    position: relative;\r\n    cursor: pointer;\r\n    line-height: 20px;\r\n    display: block;\r\n    color: $app_color;\r\n    background-color: $white;\r\n    padding: 4px 10px 4px 10px !important;\r\n    text-align: center;\r\n    @include border-radius(20px);\r\n\t@include box-sizing(border-box);\r\n\tborder:1px solid $border_color;\r\n\toverflow: hidden;\r\n\twhite-space: nowrap;\r\n\ttext-overflow: ellipsis;\r\n}\r\n\r\n.toggle_switch_radio[type=\"radio\"]:not(:checked) + label {\r\n    position: relative;\r\n    cursor: pointer;\r\n    line-height: 20px;\r\n    display: block;\r\n    color: rgba($app_color,0.5);\r\n    padding: 4px 10px 4px 10px !important;\r\n    text-align: center;\r\n    @include border-radius(20px);\r\n\t@include transition(all .3s ease);\r\n\t@include box-sizing(border-box);\r\n\tborder:1px solid $light_grey;\r\n\toverflow: hidden;\r\n\twhite-space: nowrap;\r\n\ttext-overflow: ellipsis;\r\n}\r\n\r\n\r\n// Hover & Focus States\r\n\r\n.toggle_switch_radio[type=\"radio\"]:focus + label,\r\n.toggle_switch_radio[type=\"radio\"]:hover + label {\r\n    color: $app_color;\r\n}\r\n\r\n\r\n// Disabled State\r\n\r\n.toggle_switch_radio[type=\"radio\"]:disabled:checked + label {\r\n    position: relative;\r\n    cursor: pointer;\r\n    line-height: 20px;\r\n    display: inline-block;\r\n    color: $grey;\r\n    padding: 4px 0 4px 0px;\r\n}\r\n\r\n.toggle_switch_radio[type=\"radio\"]:disabled:not(:checked) + label {\r\n    position: relative;\r\n    cursor: pointer;\r\n    line-height: 20px;\r\n    display: inline-block;\r\n    color: $grey;\r\n    padding: 4px 0 4px 0px;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.toggle_switch {\r\n\tdisplay: flex;\r\n    flex-direction: row;\r\n    -webkit-flex-direction: row;\r\n    justify-content: flex-start;\r\n    flex-wrap:nowrap;\r\n    -webkit-flex-wrap:nowrap;\r\n    align-items:stretch;\r\n    -webkit-align-items:stretch;\r\n    width: 100%;\r\n    min-height:0;\r\n\r\n    background-color:rgba($black,0.05);\r\n    @include border-radius(20px);\r\n\t@include box-sizing(border-box);\r\n\r\n\r\n\t.toggle_switch_option {\r\n\t\tflex-grow:1;\r\n\t}\r\n}",".dropzone {\r\n  // min-height: 400px;\r\n  padding-top: 5rem;\r\n  @include box-sizing(border-box);\r\n  padding: 4.5rem 1rem;\r\n  position: relative;\r\n  border: 3px dashed $border-color;\r\n\r\n  &.dz-drag-hover {\r\n    // border: 3px dashed $green;\r\n  }\r\n\r\n  &.dz-started {\r\n    // border: 3px solid $green;\r\n  }\r\n\r\n  .dz-default {\r\n    &.dz-message {\r\n    }\r\n  }\r\n\r\n  .dz-message {\r\n    text-align: center;\r\n\r\n    .dz_msg_icon {\r\n      // margin-top: 60px;\r\n      color: $navy;\r\n      span {\r\n        vertical-align: text-bottom;\r\n        // font-size: 100px;\r\n      }\r\n    }\r\n\r\n    .dz_msg_instruction {\r\n      color: $navy;\r\n      font-size: 1.4rem;\r\n      font-weight: 500;\r\n      line-height: 140%;\r\n      // margin-bottom: 30px;\r\n    }\r\n\r\n    .dz_msg_helper {\r\n      line-height: 140%;\r\n      margin-bottom: 10px;\r\n    }\r\n\r\n    .dz_msg_button {\r\n      button {\r\n      }\r\n    }\r\n  }\r\n\r\n  .dz-preview {\r\n    .dz-details {\r\n      text-align: center;\r\n      .dz-filename {\r\n        display: inline-block;\r\n      }\r\n\r\n      .dz-size {\r\n        display: inline-block;\r\n      }\r\n\r\n      img {\r\n        display: none;\r\n      }\r\n    }\r\n\r\n    .dz-progress {\r\n      .dz-upload {\r\n      }\r\n    }\r\n\r\n    .dz-success-mark {\r\n      display: inline-block;\r\n      text-align: center;\r\n      display: none;\r\n    }\r\n\r\n    .dz-error-mark {\r\n      display: inline-block;\r\n      text-align: center;\r\n      display: none;\r\n    }\r\n\r\n    .dz-error-message {\r\n      color: $red;\r\n      line-height: 140%;\r\n      margin-top: 20px;\r\n      text-align: center;\r\n    }\r\n  }\r\n}\r\n","[tooltip]{\r\n  position:relative;\r\n}\r\n\r\n[tooltip]::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top:-6px;\r\n    left:50%;\r\n    transform: translateX(-50%);\r\n    border-width: 4px 6px 0 6px;\r\n    border-style: solid;\r\n    border-color: rgba($black,0.9) transparent transparent     transparent;\r\n    z-index: 100;\r\n    @include opacity(0);\r\n}\r\n[tooltip]::after {\r\n    content: attr(tooltip);\r\n    position: absolute;\r\n    left:50%;\r\n    top:-6px;\r\n    transform: translateX(-50%)   translateY(-100%);\r\n    background: rgba($black,0.9);\r\n    text-align: center;\r\n    color: $white;\r\n    padding:5px 5px;\r\n    font-size: 0.8rem;\r\n    line-height: 140%;\r\n    min-width: 140px;\r\n    border-radius: 4px;\r\n    pointer-events: none;\r\n    @include opacity(0);\r\n    z-index: 101;\r\n}\r\n\r\n\r\n[tooltip-position='left']::before{\r\n  left:0%;\r\n  top:50%;\r\n  margin-left:-12px;\r\n  transform:translatey(-50%) rotate(-90deg) \r\n}\r\n[tooltip-position='top']::before{\r\n  left:50%;\r\n}\r\n[tooltip-position='bottom']::before{\r\n  top:100%;\r\n  margin-top:8px;\r\n  transform: translateX(-50%) translatey(-100%) rotate(-180deg)\r\n}\r\n[tooltip-position='right']::before{\r\n  left:100%;\r\n  top:50%;\r\n  margin-left:1px;\r\n  transform:translatey(-50%) rotate(90deg)\r\n}\r\n[tooltip-position='left']::after{\r\n  left:0%;\r\n  top:50%;\r\n  margin-left:-8px;\r\n  transform: translateX(-100%)   translateY(-50%);\r\n}\r\n[tooltip-position='top']::after{\r\n  left:50%;\r\n}\r\n[tooltip-position='bottom']::after{\r\n  top:100%;\r\n  margin-top:8px;\r\n  transform: translateX(-50%) translateY(0%);\r\n}\r\n[tooltip-position='right']::after{\r\n  left:100%;\r\n  top:50%;\r\n  margin-left:8px;\r\n  transform: translateX(0%)   translateY(-50%);\r\n}\r\n\r\n\r\n\r\n[tooltip]:hover::after,\r\n[tooltip]:hover::before {\r\n   @include opacity(1);\r\n}","/*\r\n\r\n    HELPERS\r\n\r\n*/\r\n\r\n.link {\r\n  cursor: pointer;\r\n}\r\n\r\n.full-size {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.display-content {\r\n  display: contents;\r\n}\r\n\r\n.page-container,\r\n.fill {\r\n  height: 100%;\r\n  width: 100%;\r\n  display: contents;\r\n}\r\n\r\n.bold {\r\n  font-weight: bold;\r\n}\r\n\r\n.hidden,\r\n.invisible {\r\n  display: none;\r\n}\r\n\r\n.relative {\r\n  position: relative;\r\n}\r\n\r\n.absolute {\r\n  position: absolute;\r\n}\r\n\r\n.fixed {\r\n  position: fixed;\r\n}\r\n\r\n.flex {\r\n  display: flex;\r\n}\r\n\r\n.fill {\r\n  min-height: 100%;\r\n  height: 100%;\r\n}\r\n\r\n// Borders\r\n.border--left {\r\n  border-left: 1px solid $border_color;\r\n}\r\n\r\n.border--right {\r\n  border-right: 1px solid $border_color;\r\n}\r\n\r\n.border--bottom {\r\n  border-bottom: 1px solid $border_color;\r\n}\r\n\r\n.border--top {\r\n  border-top: 1px solid $border_color;\r\n}\r\n\r\n.border--all {\r\n  border: 1px solid $border_color;\r\n}\r\n\r\n.shadow {\r\n  content: '';\r\n  position: relative;\r\n  display: inline-block;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 10px;\r\n  -webkit-box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\r\n  -moz-box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\r\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\r\n  z-index: 1000000;\r\n  border: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.top-inner-shadow {\r\n  &:before {\r\n    @extend .shadow;\r\n    top: -11px;\r\n  }\r\n}\r\n\r\n// .bottom-inner-shadow {\r\n//   &:after {\r\n//     @extend .shadow;\r\n//     bottom: -15px;\r\n//   }\r\n// }\r\n","#login_container {\r\n\tmax-width: 400px;\r\n\tpadding: 20px;\r\n\t@include box-sizing(border-box);\r\n\t@include border-radius(3px);\r\n\t@include box-shadow(0 2px 5px rgba($black,0.4), 0 0px 50px rgba($black,0.1));\r\n\tbackground-color: $white;\r\n\tmargin:40px auto;\r\n}",".product_suite_container {\r\n\ttext-align: center;\r\n\tmargin-top: 20px;\r\n}\r\n.product_suit_options {\r\n\tmax-width: 720px;\r\n\tmargin:0 auto;\r\n}\r\n\r\n\r\nul#product_suite {\r\n\twidth: 100%;\r\n\tfloat: left;\r\n\tmargin:0;\r\n\tpadding:0;\r\n\tlist-style: none; \r\n\r\n\t>li {\r\n\t\tfloat: left;\r\n\t\twidth: 25%;\r\n\t\ttext-align: center;\r\n\t\tpadding: 10px;\r\n\t\t@include box-sizing(border-box);\r\n\r\n\t\t// This is for the launch Page\r\n\t\t.btn_product {\r\n\t\t\tdisplay: block;\r\n\t\t\ttext-decoration: none;\r\n\t\t\t@include border-radius(4px);\r\n\t\t\ttext-align: center;\r\n\t\t\tpadding: 20px;\r\n\t\t\tcolor: inherit;\r\n\t\t\twidth: 160px;\r\n\t\t\tbackground-color: $white;\r\n\t\t\t@include box-sizing(border-box);\r\n\t\t    @include border-radius(3px);\r\n\t\t    box-shadow: 0 1px 4px rgba($black, 0.3);\r\n\r\n\t\t\t&:hover, &:focus {\r\n\t\t    \tbox-shadow: 0 1px 4px rgba($black, 0.3), 0 1px 20px rgba($black, 0.3);\r\n\r\n\t\t\t\t.application_icon {\r\n\t\t\t\t\tbackground-color: $blue;\r\n\t\t\t\t\tcolor: $white;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.application_name {\r\n\t\t\t\t\tcolor: $blue;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t&.btn_normal:disabled {\r\n\t\t\t\tbackground-color: $lighter_grey !important;\r\n\t\t\t\t@include opacity(1);\r\n\t\t\t\tbox-shadow: none !important;\r\n\r\n\t\t\t\t&:hover,\r\n\t\t\t\t&:focus {\r\n\t\t\t\t\tbackground-color: $lighter_grey !important;\r\n\t\t\t\t\t@include opacity(1);\r\n\t\t\t\t\tbox-shadow: none !important;\r\n\r\n\t\t\t\t\t.application_icon {\r\n\t\t\t\t\t\tbackground-color: rgba($black,0.05);\r\n\t\t\t\t\t\tcolor: inherit;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\t.application_name {\r\n\t\t\t\t\t\tcolor: inherit;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t.application_icon {\r\n\t\t\t\tdisplay: block;\r\n\t\t\t\tpadding: 10px;\r\n\t\t\t\t@include border-radius(50px);\r\n\t\t\t\tbackground-color: rgba($black,0.05);\r\n\t\t\t\twidth: 50px;\r\n\t\t\t\t@include box-sizing (border-box);\r\n\t\t\t\tmargin: 0 auto 10px;\r\n\r\n\t\t\t\tspan {\r\n\t\t\t\t\tline-height: 30px;\r\n\t\t\t\t\twidth: 30px;\r\n\t\t\t\t\ttext-align: center;\r\n\t\t\t\t\tfont-size: 24px;\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t\tvertical-align: top;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t.application_name {\r\n\t\t\t\ttext-align: center;\r\n\t\t\t\tdisplay: block;\r\n\t\t\t\tline-height: 15px;\r\n\t\t\t\tmin-height: 30px;\r\n\t\t\t\tfont-size: 0.8rem;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n","[data-simplebar] {\r\n    position: relative;\r\n    flex-direction: column;\r\n    flex-wrap: wrap;\r\n    justify-content: flex-start;\r\n    align-content: flex-start;\r\n    align-items: flex-start;\r\n    width: inherit;\r\n    height: inherit;\r\n    max-width: inherit;\r\n    max-height: inherit;\r\n}\r\n\r\n.simplebar-wrapper {\r\n    overflow: hidden;\r\n    width: inherit;\r\n    height: inherit;\r\n    max-width: inherit;\r\n    max-height: inherit;\r\n}\r\n\r\n.simplebar-mask {\r\n    direction: inherit;\r\n    position: absolute;\r\n    overflow: hidden;\r\n    padding: 0;\r\n    margin: 0;\r\n    left: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    right: 0;\r\n    width: auto !important;\r\n    height: auto !important;\r\n    z-index: 0;\r\n}\r\n\r\n.simplebar-offset {\r\n    direction: inherit !important;\r\n    box-sizing: inherit !important;\r\n    resize: none !important;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    bottom: 0;\r\n    right: 0;\r\n    padding: 0;\r\n    margin: 0;\r\n    -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.simplebar-content {\r\n    direction: inherit;\r\n    box-sizing: border-box !important;\r\n    position: relative;\r\n    display: block;\r\n    height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */\r\n    width: auto;\r\n    visibility: visible;\r\n    // overflow: auto; /* Scroll on this element otherwise element can't have a padding applied properly */\r\n    max-width: 100%; /* Not required for horizontal scroll to trigger */\r\n    max-height: 100%; /* Needed for vertical scroll to trigger */\r\n}\r\n\r\n.simplebar-placeholder {\r\n    max-height: 100%;\r\n    max-width: 100%;\r\n    width: 100%;\r\n    pointer-events: none;\r\n}\r\n\r\n.simplebar-height-auto-observer-wrapper {\r\n    box-sizing: inherit !important;\r\n    height: 100%;\r\n    width: inherit;\r\n    max-width: 1px;\r\n    position: relative;\r\n    float: left;\r\n    max-height: 1px;\r\n    overflow: hidden;\r\n    z-index: -1;\r\n    padding: 0;\r\n    margin: 0;\r\n    pointer-events: none;\r\n    flex-grow: inherit;\r\n    flex-shrink: 0;\r\n    flex-basis: 0;\r\n}\r\n\r\n.simplebar-height-auto-observer {\r\n    box-sizing: inherit;\r\n    display: block;\r\n    opacity: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    height: 1000%;\r\n    width: 1000%;\r\n    min-height: 1px;\r\n    min-width: 1px;\r\n    overflow: hidden;\r\n    pointer-events: none;\r\n    z-index: -1;\r\n}\r\n\r\n.simplebar-track {\r\n    z-index: 1;\r\n    position: absolute;\r\n    right: 0;\r\n    bottom: 0;\r\n    pointer-events: none;\r\n}\r\n\r\n.simplebar-scrollbar {\r\n    position: absolute;\r\n    right: 2px;\r\n    width: 7px;\r\n    min-height: 10px;\r\n}\r\n\r\n.simplebar-scrollbar:before {\r\n    position: absolute;\r\n    content: \"\";\r\n    background: $black;\r\n    border-radius: 7px;\r\n    left: 0;\r\n    right: 0;\r\n    opacity: 0;\r\n    transition: opacity 0.2s linear;\r\n}\r\n\r\n.simplebar-track .simplebar-scrollbar.simplebar-visible:before {\r\n    /* When hovered, remove all transitions from drag handle */\r\n    opacity: 0.5;\r\n    transition: opacity 0s linear;\r\n}\r\n\r\n.simplebar-track.simplebar-vertical {\r\n    top: 0;\r\n    width: 11px;\r\n}\r\n\r\n.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {\r\n    top: 2px;\r\n    bottom: 2px;\r\n}\r\n\r\n.simplebar-track.simplebar-horizontal {\r\n    left: 0;\r\n    height: 11px;\r\n}\r\n\r\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {\r\n    height: 100%;\r\n    left: 2px;\r\n    right: 2px;\r\n}\r\n\r\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar {\r\n    right: auto;\r\n    left: 0;\r\n    top: 8px;\r\n    height: 3px;\r\n    min-height: 0;\r\n    min-width: 10px;\r\n    width: auto;\r\n}\r\n\r\n/* Rtl support */\r\n[data-simplebar-direction=\"rtl\"] .simplebar-track.simplebar-vertical {\r\n    right: auto;\r\n    left: 0;\r\n}\r\n\r\n.hs-dummy-scrollbar-size {\r\n    direction: rtl;\r\n    position: fixed;\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    height: 500px;\r\n    width: 500px;\r\n    overflow-y: hidden;\r\n    overflow-x: scroll;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
